import * as React from "react";
import wrapIcon from "../utils/wrapIcon";

const PersonSupportRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.53 4a4 4 0 11-.14 3.72A1.5 1.5 0 015.5 8H5v.26c0 .19.07.36.2.5A.75.75 0 115.67 10 1.74 1.74 0 014 8.26V4.5c0-.28.23-.5.5-.5h2.03zM7 6.13a3 3 0 100-.24v.24zm-1-.26v-.85H5v2h.5a.5.5 0 00.5-.5v-.37a4.08 4.08 0 010-.28zM3 13a2 2 0 012-2h10a2 2 0 012 2c0 1.7-.83 2.97-2.13 3.8A9.14 9.14 0 0110 18a9.14 9.14 0 01-4.87-1.2A4.35 4.35 0 013 13zm2-1a1 1 0 00-1 1c0 1.3.62 2.28 1.67 2.95A8.16 8.16 0 0010 17c1.74 0 3.26-.36 4.33-1.05A3.36 3.36 0 0016 13a1 1 0 00-1-1H5z",
    fill: primaryFill
  }));
};

export const PersonSupportRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonSupportRegularIcon({}), 'PersonSupportRegular');

const PersonSwapFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9 2a4 4 0 100 8 4 4 0 000-8zm-5 9a2 2 0 00-2 2c0 1.7.83 2.97 2.13 3.8A9.14 9.14 0 009 18c.29 0 .57 0 .85-.03l-1.41-1.4a1.5 1.5 0 010-2.13l2-2A1.5 1.5 0 0112.9 14h1.18a1.5 1.5 0 011.65-1.98A2 2 0 0014 11H4zm7.85 6.85a.5.5 0 01-.7 0l-2-2a.5.5 0 010-.7l2-2a.5.5 0 01.7.7L10.71 15h5.58l-1.14-1.15a.5.5 0 01.7-.7l2 2c.2.2.2.5 0 .7l-2 2a.5.5 0 01-.7-.7L16.29 16h-5.58l1.14 1.15c.2.2.2.5 0 .7z",
    fill: primaryFill
  }));
};

export const PersonSwapFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonSwapFilledIcon({}), 'PersonSwapFilled');

const PersonSwapRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9 2a4 4 0 100 8 4 4 0 000-8zM6 6a3 3 0 116 0 3 3 0 01-6 0zm-2 5a2 2 0 00-2 2c0 1.7.83 2.97 2.13 3.8A9.14 9.14 0 009 18c.29 0 .57 0 .85-.03L8.88 17a8.07 8.07 0 01-4.2-1.05A3.36 3.36 0 013 13a1 1 0 011-1h10a1 1 0 01.67.25c.32-.21.7-.3 1.07-.23A2 2 0 0014 11H4zm7.85 6.85a.5.5 0 01-.7 0l-2-2a.5.5 0 010-.7l2-2a.5.5 0 01.7.7L10.71 15h5.58l-1.14-1.15a.5.5 0 01.7-.7l2 2c.2.2.2.5 0 .7l-2 2a.5.5 0 01-.7-.7L16.29 16h-5.58l1.14 1.15c.2.2.2.5 0 .7z",
    fill: primaryFill
  }));
};

export const PersonSwapRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonSwapRegularIcon({}), 'PersonSwapRegular');

const PersonSyncFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9 2a4 4 0 100 8 4 4 0 000-8zm-5 9a2 2 0 00-2 2c0 1.7.83 2.97 2.13 3.8A9.14 9.14 0 009 18c.41 0 .82-.02 1.21-.06a5.48 5.48 0 01.05-6.94H4zm6 3.5a4.5 4.5 0 109 0 4.5 4.5 0 00-9 0zm6.5-3c.28 0 .5.22.5.5v1.5a.5.5 0 01-.5.5H15a.5.5 0 010-1h.47a1.97 1.97 0 00-.94-.25 2 2 0 00-1.44.59.5.5 0 01-.71-.71 3 3 0 013.62-.48V12c0-.28.22-.5.5-.5zm-.88 5.53a3 3 0 01-2.62-.18V17a.5.5 0 01-1 0v-1.5c0-.28.22-.5.5-.5H14a.5.5 0 010 1h-.47a1.97 1.97 0 00.94.25 2 2 0 001.44-.59.5.5 0 01.71.71 3 3 0 01-1 .66z",
    fill: primaryFill
  }));
};

export const PersonSyncFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonSyncFilledIcon({}), 'PersonSyncFilled');

const PersonSyncRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9 2a4 4 0 100 8 4 4 0 000-8zM6 6a3 3 0 116 0 3 3 0 01-6 0zm-2 5a2 2 0 00-2 2c0 1.7.83 2.97 2.13 3.8A9.14 9.14 0 009 18c.41 0 .82-.02 1.21-.06A5.5 5.5 0 019.6 17 12 12 0 019 17a8.16 8.16 0 01-4.33-1.05A3.36 3.36 0 013 13a1 1 0 011-1h5.6c.18-.36.4-.7.66-1H4zm6 3.5a4.5 4.5 0 109 0 4.5 4.5 0 00-9 0zm6.5-3c.28 0 .5.22.5.5v1.5a.5.5 0 01-.5.5H15a.5.5 0 010-1h.47a1.97 1.97 0 00-.94-.25 2 2 0 00-1.44.59.5.5 0 01-.71-.71 3 3 0 013.62-.48V12c0-.28.22-.5.5-.5zm-.88 5.53a3 3 0 01-2.62-.18V17a.5.5 0 01-1 0v-1.5c0-.28.22-.5.5-.5H14a.5.5 0 010 1h-.47a1.97 1.97 0 00.94.25 2 2 0 001.44-.59.5.5 0 01.71.71 3 3 0 01-1 .66z",
    fill: primaryFill
  }));
};

export const PersonSyncRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonSyncRegularIcon({}), 'PersonSyncRegular');

const PersonTagFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 6a4 4 0 116.65 3h-.14c-.8 0-1.52.38-1.98.96A4 4 0 015 6zm4.05 5H4.01A2 2 0 002 13c0 1.7.83 2.97 2.13 3.8A9.14 9.14 0 009 18c.8 0 1.58-.07 2.31-.22l-1.6-1.63A2.52 2.52 0 019 14.4v-2.87c0-.18.02-.35.05-.52zm.95 3.4c0 .39.15.77.43 1.05l3.04 3.1c.58.59 1.52.6 2.12.03l2.95-2.84c.6-.58.62-1.55.02-2.15l-3.1-3.14a1.5 1.5 0 00-1.08-.45h-2.87c-.83 0-1.51.68-1.51 1.51v2.88zm2.75-.9a.75.75 0 110-1.5.75.75 0 010 1.5z",
    fill: primaryFill
  }));
};

export const PersonTagFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonTagFilledIcon({}), 'PersonTagFilled');

const PersonTagRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 6a4 4 0 116.65 3h-.14c-.8 0-1.52.38-1.98.96A4 4 0 015 6zm4-3a3 3 0 100 6 3 3 0 000-6zm.05 8H4.01A2 2 0 002 13c0 1.7.83 2.97 2.14 3.8A9.14 9.14 0 009 18c.8 0 1.58-.07 2.31-.22l-.85-.87c-.47.06-.95.09-1.46.09a8.16 8.16 0 01-4.33-1.05A3.36 3.36 0 013 13a1 1 0 011-1h5v-.48c0-.18.02-.35.05-.52zm.95 3.4c0 .39.15.77.43 1.05l3.04 3.1c.58.59 1.52.6 2.12.03l2.95-2.84c.6-.58.62-1.55.02-2.15l-3.1-3.14a1.5 1.5 0 00-1.08-.45h-2.87c-.83 0-1.51.68-1.51 1.51v2.88zm2.75-.9a.75.75 0 110-1.5.75.75 0 010 1.5z",
    fill: primaryFill
  }));
};

export const PersonTagRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonTagRegularIcon({}), 'PersonTagRegular');

const PersonVoiceFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M15.85 1.15a.5.5 0 00-.7.7 6.6 6.6 0 011.72 4.65 6.6 6.6 0 01-1.72 4.65.5.5 0 00.7.7 7.6 7.6 0 002.03-5.35 7.6 7.6 0 00-2.03-5.35zm-2 2a.5.5 0 00-.7.7c.63.64.97 1.62.97 2.65 0 1.03-.34 2.01-.97 2.65a.5.5 0 00.7.7 4.76 4.76 0 001.28-3.35c0-1.22-.41-2.49-1.28-3.35zM4 7a4 4 0 118 0 4 4 0 01-8 0zm-3 7a2 2 0 012-2h10a2 2 0 012 2c0 1.7-.83 2.97-2.13 3.8A9.14 9.14 0 018 19a9.14 9.14 0 01-4.87-1.2A4.35 4.35 0 011 14z",
    fill: primaryFill
  }));
};

export const PersonVoiceFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonVoiceFilledIcon({}), 'PersonVoiceFilled');

const PersonVoiceRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M15.85 1.15a.5.5 0 00-.7.7 6.6 6.6 0 011.72 4.65 6.6 6.6 0 01-1.72 4.65.5.5 0 00.7.7 7.6 7.6 0 002.03-5.35 7.6 7.6 0 00-2.03-5.35zm-2 2a.5.5 0 00-.7.7c.63.64.97 1.62.97 2.65 0 1.03-.34 2.01-.97 2.65a.5.5 0 00.7.7 4.76 4.76 0 001.28-3.35c0-1.22-.41-2.49-1.28-3.35zM4 7a4 4 0 118 0 4 4 0 01-8 0zm4-3a3 3 0 100 6 3 3 0 000-6zM1 14a2 2 0 012-2h10a2 2 0 012 2c0 1.7-.83 2.97-2.13 3.8A9.14 9.14 0 018 19a9.14 9.14 0 01-4.87-1.2A4.35 4.35 0 011 14zm2-1a1 1 0 00-1 1c0 1.3.62 2.28 1.67 2.95A8.16 8.16 0 008 18c1.74 0 3.26-.36 4.33-1.05A3.36 3.36 0 0014 14a1 1 0 00-1-1H3z",
    fill: primaryFill
  }));
};

export const PersonVoiceRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonVoiceRegularIcon({}), 'PersonVoiceRegular');

const PhoneFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.5 2C5.67 2 5 2.67 5 3.5v13c0 .83.67 1.5 1.5 1.5h7c.83 0 1.5-.67 1.5-1.5v-13c0-.83-.67-1.5-1.5-1.5h-7zM9 14h2a.5.5 0 010 1H9a.5.5 0 010-1z",
    fill: primaryFill
  }));
};

export const PhoneFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneFilledIcon({}), 'PhoneFilled');

const PhoneRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9 14a.5.5 0 000 1h2a.5.5 0 000-1H9zM7 2a2 2 0 00-2 2v12c0 1.1.9 2 2 2h6a2 2 0 002-2V4a2 2 0 00-2-2H7zM6 4a1 1 0 011-1h6a1 1 0 011 1v12a1 1 0 01-1 1H7a1 1 0 01-1-1V4z",
    fill: primaryFill
  }));
};

export const PhoneRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneRegularIcon({}), 'PhoneRegular');

const PhoneAddFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 2C4.67 2 4 2.67 4 3.5v13c0 .83.67 1.5 1.5 1.5h4.76a5.47 5.47 0 01-1.24-3H7.5a.5.5 0 010-1h1.52A5.5 5.5 0 0114 9.02V3.5c0-.83-.67-1.5-1.5-1.5h-7zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V14h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V15h1.5a.5.5 0 000-1H15v-1.5z",
    fill: primaryFill
  }));
};

export const PhoneAddFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneAddFilledIcon({}), 'PhoneAddFilled');

const PhoneAddRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 3.5C4 2.67 4.67 2 5.5 2h7c.83 0 1.5.67 1.5 1.5v5.52c-.34.03-.68.1-1 .19V3.5a.5.5 0 00-.5-.5h-7a.5.5 0 00-.5.5v13c0 .28.22.5.5.5h4.1c.18.36.4.7.66 1H5.5A1.5 1.5 0 014 16.5v-13zM9.02 14a5.57 5.57 0 000 1H7.5a.5.5 0 010-1h1.52zm9.98.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V14h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V15h1.5a.5.5 0 000-1H15v-1.5z",
    fill: primaryFill
  }));
};

export const PhoneAddRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneAddRegularIcon({}), 'PhoneAddRegular');

const PhoneArrowRightFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 3.5C4 2.67 4.67 2 5.5 2h7c.83 0 1.5.67 1.5 1.5v5.52A5.5 5.5 0 009.02 14H7.5a.5.5 0 000 1h1.52c.1 1.13.55 2.17 1.24 3H5.5A1.5 1.5 0 014 16.5v-13zM14.5 10a4.5 4.5 0 110 9 4.5 4.5 0 010-9zm2.35 4.85a.5.5 0 00.15-.35.5.5 0 00-.15-.35l-2-2a.5.5 0 00-.7.7L15.29 14H12.5a.5.5 0 000 1h2.8l-1.15 1.15a.5.5 0 00.7.7l2-2z",
    fill: primaryFill
  }));
};

export const PhoneArrowRightFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneArrowRightFilledIcon({}), 'PhoneArrowRightFilled');

const PhoneArrowRightRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 2C4.67 2 4 2.67 4 3.5v13c0 .83.67 1.5 1.5 1.5h4.76a5.5 5.5 0 01-.66-1H5.5a.5.5 0 01-.5-.5v-13c0-.28.22-.5.5-.5h7c.28 0 .5.22.5.5v5.7c.32-.08.66-.15 1-.18V3.5c0-.83-.67-1.5-1.5-1.5h-7zM9 14.5c0-.17 0-.34.02-.5H7.5a.5.5 0 000 1h1.52a5.57 5.57 0 01-.02-.5zm5.5-4.5a4.5 4.5 0 110 9 4.5 4.5 0 010-9zm2.35 4.85a.5.5 0 00.15-.35.5.5 0 00-.15-.35l-2-2a.5.5 0 00-.7.7L15.29 14H12.5a.5.5 0 000 1h2.8l-1.15 1.15a.5.5 0 00.7.7l2-2z",
    fill: primaryFill
  }));
};

export const PhoneArrowRightRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneArrowRightRegularIcon({}), 'PhoneArrowRightRegular');

const PhoneCheckmarkFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M18 5.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.15-1.85a.5.5 0 00-.7 0L12.5 6.29l-.65-.64a.5.5 0 00-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 000-.7zM6.5 2h2.76A5.5 5.5 0 0015 10.8v5.7c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 015 16.5v-13C5 2.67 5.67 2 6.5 2zM8 14.5c0 .28.22.5.5.5h3a.5.5 0 000-1h-3a.5.5 0 00-.5.5z",
    fill: primaryFill
  }));
};

export const PhoneCheckmarkFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneCheckmarkFilledIcon({}), 'PhoneCheckmarkFilled');

const PhoneCheckmarkRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M18 5.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.15-1.85a.5.5 0 00-.7 0L12.5 6.29l-.65-.64a.5.5 0 00-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 000-.7zM9.25 2H6.5C5.67 2 5 2.67 5 3.5v13c0 .83.67 1.5 1.5 1.5h7c.83 0 1.5-.67 1.5-1.5v-5.7c-.32.08-.66.15-1 .18v5.52a.5.5 0 01-.5.5h-7a.5.5 0 01-.5-.5v-13c0-.28.22-.5.5-.5h2.1c.18-.36.4-.7.66-1zM8 14.5c0-.28.22-.5.5-.5h3a.5.5 0 010 1h-3a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const PhoneCheckmarkRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneCheckmarkRegularIcon({}), 'PhoneCheckmarkRegular');

const PhoneDesktopFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 2a2 2 0 00-2 2v3h2.5A2.5 2.5 0 019 9.5V13h3v2H9v1h5.5a.5.5 0 000-1H13v-2h3a2 2 0 002-2V4a2 2 0 00-2-2H6zM3.5 8C2.67 8 2 8.67 2 9.5v7c0 .83.67 1.5 1.5 1.5h3c.83 0 1.5-.67 1.5-1.5v-7C8 8.67 7.33 8 6.5 8h-3zm.5 7.5c0-.28.22-.5.5-.5h1a.5.5 0 010 1h-1a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const PhoneDesktopFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneDesktopFilledIcon({}), 'PhoneDesktopFilled');

const PhoneDesktopRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 3h10a1 1 0 011 1v7a1 1 0 01-1 1H9v1h3v2H9v1h5.5a.5.5 0 000-1H13v-2h3a2 2 0 002-2V4a2 2 0 00-2-2H6a2 2 0 00-2 2v3h1V4a1 1 0 011-1zM4.5 15a.5.5 0 000 1h1a.5.5 0 000-1h-1zM2 9.5C2 8.67 2.67 8 3.5 8h3C7.33 8 8 8.67 8 9.5v7c0 .83-.67 1.5-1.5 1.5h-3A1.5 1.5 0 012 16.5v-7zM3.5 9a.5.5 0 00-.5.5v7c0 .28.22.5.5.5h3a.5.5 0 00.5-.5v-7a.5.5 0 00-.5-.5h-3z",
    fill: primaryFill
  }));
};

export const PhoneDesktopRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneDesktopRegularIcon({}), 'PhoneDesktopRegular');

const PhoneDesktopAddFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M19 5.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V5h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V6h1.5a.5.5 0 000-1H15V3.5zm-.5 7.5c1.33 0 2.55-.47 3.5-1.26V11a2 2 0 01-2 2h-3v2h1.5a.5.5 0 010 1H9v-1h3v-2H9V9.5A2.5 2.5 0 006.5 7H4V4c0-1.1.9-2 2-2h4.26a5.5 5.5 0 004.24 9zm-11-3C2.67 8 2 8.67 2 9.5v7c0 .83.67 1.5 1.5 1.5h3c.83 0 1.5-.67 1.5-1.5v-7C8 8.67 7.33 8 6.5 8h-3zm.5 7.5c0-.28.22-.5.5-.5h1a.5.5 0 010 1h-1a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const PhoneDesktopAddFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneDesktopAddFilledIcon({}), 'PhoneDesktopAddFilled');

const PhoneDesktopAddRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M19 5.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V5h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V6h1.5a.5.5 0 000-1H15V3.5zm2 7.5v-.6c.36-.18.7-.4 1-.66V11a2 2 0 01-2 2h-3v2h1.5a.5.5 0 010 1H9v-1h3v-2H9v-1h7a1 1 0 001-1zm-6.74-9c-.26.3-.48.64-.66 1H6a1 1 0 00-1 1v3H4V4c0-1.1.9-2 2-2h4.26zM4 15.5c0-.28.22-.5.5-.5h1a.5.5 0 010 1h-1a.5.5 0 01-.5-.5zm-2-6C2 8.67 2.67 8 3.5 8h3C7.33 8 8 8.67 8 9.5v7c0 .83-.67 1.5-1.5 1.5h-3A1.5 1.5 0 012 16.5v-7zM3.5 9a.5.5 0 00-.5.5v7c0 .28.22.5.5.5h3a.5.5 0 00.5-.5v-7a.5.5 0 00-.5-.5h-3z",
    fill: primaryFill
  }));
};

export const PhoneDesktopAddRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneDesktopAddRegularIcon({}), 'PhoneDesktopAddRegular');

const PhoneDismissFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 2C4.67 2 4 2.67 4 3.5v13c0 .83.67 1.5 1.5 1.5h4.76a5.47 5.47 0 01-1.24-3H7.5a.5.5 0 010-1h1.52A5.5 5.5 0 0114 9.02V3.5c0-.83-.67-1.5-1.5-1.5h-7zm9 17a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm1.85-6.35c.2.2.2.5 0 .7l-1.14 1.15 1.14 1.15a.5.5 0 01-.7.7l-1.15-1.14-1.15 1.14a.5.5 0 01-.7-.7l1.14-1.15-1.14-1.15a.5.5 0 01.7-.7l1.15 1.14 1.15-1.14c.2-.2.5-.2.7 0z",
    fill: primaryFill
  }));
};

export const PhoneDismissFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneDismissFilledIcon({}), 'PhoneDismissFilled');

const PhoneDismissRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 2C4.67 2 4 2.67 4 3.5v13c0 .83.67 1.5 1.5 1.5h4.76a5.5 5.5 0 01-.66-1H5.5a.5.5 0 01-.5-.5v-13c0-.28.22-.5.5-.5h7c.28 0 .5.22.5.5v5.7c.32-.08.66-.15 1-.18V3.5c0-.83-.67-1.5-1.5-1.5h-7zM9 14.5c0-.17 0-.34.02-.5H7.5a.5.5 0 000 1h1.52a5.57 5.57 0 01-.02-.5zm10 0a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.65-1.15a.5.5 0 00-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 00-.7.7l1.14 1.15-1.14 1.15a.5.5 0 00.7.7l1.15-1.14 1.15 1.14a.5.5 0 00.7-.7l-1.14-1.15 1.14-1.15z",
    fill: primaryFill
  }));
};

export const PhoneDismissRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneDismissRegularIcon({}), 'PhoneDismissRegular');

const PhoneEraserFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.58 1.44a1.5 1.5 0 012.12 0l1.86 1.86a1.5 1.5 0 010 2.12l-5.14 5.14a1.5 1.5 0 01-2.12 0L9.44 8.7a1.5 1.5 0 010-2.12l5.14-5.14zm-4.43 5.84a.5.5 0 000 .71L12 9.85c.2.2.51.2.7 0l1.3-1.29L11.44 6l-1.3 1.3zM12.6 2H5.5C4.67 2 4 2.67 4 3.5v13c0 .83.67 1.5 1.5 1.5h7c.83 0 1.5-.67 1.5-1.5v-5.11a2.5 2.5 0 01-3.4-.12L8.72 9.4a2.5 2.5 0 010-3.54L12.6 2zm-2.1 12.5a.5.5 0 01-.5.5H8a.5.5 0 010-1h2c.28 0 .5.22.5.5z",
    fill: primaryFill
  }));
};

export const PhoneEraserFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneEraserFilledIcon({}), 'PhoneEraserFilled');

const PhoneEraserRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.58 1.44a1.5 1.5 0 012.12 0l1.86 1.86a1.5 1.5 0 010 2.12l-5.14 5.14a1.5 1.5 0 01-2.12 0L9.44 8.7a1.5 1.5 0 010-2.12l5.14-5.14zm-4.43 5.84a.5.5 0 000 .71L12 9.85c.2.2.51.2.7 0l1.3-1.29L11.44 6l-1.3 1.3zm2.38-5.2A2 2 0 0012 2H6a2 2 0 00-2 2v12c0 1.1.9 2 2 2h6a2 2 0 002-2v-4.61c-.3.26-.64.43-1 .53V16a1 1 0 01-1 1H6a1 1 0 01-1-1V4a1 1 0 011-1h5.6l.93-.93zM7.5 14.5c0-.28.22-.5.5-.5h2a.5.5 0 010 1H8a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const PhoneEraserRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneEraserRegularIcon({}), 'PhoneEraserRegular');

const PhoneKeyFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.5 2C5.67 2 5 2.67 5 3.5v13c0 .83.67 1.5 1.5 1.5H9v-1c0-.41.16-.78.44-1.06l.94-.94H9a.5.5 0 010-1h2c.1 0 .2.03.29.1l.73-.74a3.72 3.72 0 01.31-1.98A4.1 4.1 0 0115 9.13V3.5c0-.83-.67-1.5-1.5-1.5h-7zm4 17a.48.48 0 01-.35-.15.48.48 0 01-.15-.35V17c0-.14.05-.25.15-.35l2.94-2.94a3.74 3.74 0 01-.09-.77c0-.4.08-.79.24-1.14a3.1 3.1 0 011.61-1.57 2.94 2.94 0 013.27.64A3 3 0 0115 15.84V16.52a.65.65 0 01-.08.24.5.5 0 01-.15.17.46.46 0 01-.27.07H14c0 .24 0 .43-.02.56a.46.46 0 01-.11.3.47.47 0 01-.3.12L13 18v.27c0 .08 0 .17-.02.25a.86.86 0 01-.06.24.37.37 0 01-.15.17.57.57 0 01-.27.07h-2zm7-6.75c0-.2-.07-.39-.22-.53a.72.72 0 00-.53-.22c-.2 0-.39.07-.53.22a.72.72 0 00-.22.53c0 .2.07.39.22.53.14.15.32.22.53.22.2 0 .39-.07.53-.22a.72.72 0 00.22-.53z",
    fill: primaryFill
  }));
};

export const PhoneKeyFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneKeyFilledIcon({}), 'PhoneKeyFilled');

const PhoneKeyRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7 2a2 2 0 00-2 2v12c0 1.1.9 2 2 2h2v-1H7a1 1 0 01-1-1V4a1 1 0 011-1h6a1 1 0 011 1v5.54a3.97 3.97 0 011-.4V4a2 2 0 00-2-2H7zm3.38 13l.91-.9A.5.5 0 0011 14H9a.5.5 0 000 1h1.38zm.12 4a.48.48 0 01-.35-.15.48.48 0 01-.15-.35V17c0-.14.05-.25.15-.35l2.94-2.94a3.74 3.74 0 01-.09-.77c0-.4.08-.79.24-1.14a3.1 3.1 0 011.61-1.57 2.94 2.94 0 013.27.64A3 3 0 0115 15.84V16.52a.65.65 0 01-.08.24.5.5 0 01-.15.17.46.46 0 01-.27.07H14c0 .24 0 .43-.02.56a.46.46 0 01-.11.3.47.47 0 01-.3.12L13 18v.27c0 .08 0 .17-.02.25a.86.86 0 01-.06.24.37.37 0 01-.15.17.57.57 0 01-.27.07h-2zm7-6.75c0-.2-.07-.39-.22-.53a.72.72 0 00-.53-.22c-.2 0-.39.07-.53.22a.72.72 0 00-.22.53c0 .2.07.39.22.53.14.15.32.22.53.22.2 0 .39-.07.53-.22a.72.72 0 00.22-.53z",
    fill: primaryFill
  }));
};

export const PhoneKeyRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneKeyRegularIcon({}), 'PhoneKeyRegular');

const PhoneLaptopFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 4.5C3 3.67 3.67 3 4.5 3h11c.83 0 1.5.67 1.5 1.5v7c0 .83-.67 1.5-1.5 1.5H10V8a2 2 0 00-2-2H3V4.5zM10 15h7.5a.5.5 0 000-1H10v1zM2 8.5C2 7.67 2.67 7 3.5 7h4C8.33 7 9 7.67 9 8.5v8c0 .83-.67 1.5-1.5 1.5h-4A1.5 1.5 0 012 16.5v-8zM5 15a.5.5 0 000 1h1a.5.5 0 000-1H5z",
    fill: primaryFill
  }));
};

export const PhoneLaptopFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneLaptopFilledIcon({}), 'PhoneLaptopFilled');

const PhoneLaptopRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 4.5C3 3.67 3.67 3 4.5 3h11c.83 0 1.5.67 1.5 1.5v7c0 .83-.67 1.5-1.5 1.5H10v-1h5.5a.5.5 0 00.5-.5v-7a.5.5 0 00-.5-.5h-11a.5.5 0 00-.5.5V6H3V4.5zM10 15h7.5a.5.5 0 000-1H10v1zm-5 0a.5.5 0 000 1h1a.5.5 0 000-1H5zM2 8.5C2 7.67 2.67 7 3.5 7h4C8.33 7 9 7.67 9 8.5v8c0 .83-.67 1.5-1.5 1.5h-4A1.5 1.5 0 012 16.5v-8zM3.5 8a.5.5 0 00-.5.5v8c0 .28.22.5.5.5h4a.5.5 0 00.5-.5v-8a.5.5 0 00-.5-.5h-4z",
    fill: primaryFill
  }));
};

export const PhoneLaptopRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneLaptopRegularIcon({}), 'PhoneLaptopRegular');

const PhoneLinkSetupFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 3.5C5 2.67 5.67 2 6.5 2h7c.83 0 1.5.67 1.5 1.5v5.52A5.5 5.5 0 0010.26 18H6.5A1.5 1.5 0 015 16.5v-13zm7.07 7.94a2 2 0 01-1.44 2.48l-.46.12a4.73 4.73 0 00.01 1.01l.35.09A2 2 0 0112 17.66l-.13.42c.26.2.54.38.84.52l.32-.35a2 2 0 012.91 0l.34.36c.3-.13.57-.3.82-.5l-.15-.55a2 2 0 011.43-2.48l.46-.12a4.73 4.73 0 00-.01-1.01l-.35-.09A2 2 0 0117 11.34l.13-.42c-.26-.2-.54-.38-.84-.52l-.32.35a2 2 0 01-2.91 0l-.34-.36c-.3.13-.57.3-.82.5l.16.55zm2.43 4.06a1 1 0 110-2 1 1 0 010 2z",
    fill: primaryFill
  }));
};

export const PhoneLinkSetupFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneLinkSetupFilledIcon({}), 'PhoneLinkSetupFilled');

const PhoneLinkSetupRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7 2a2 2 0 00-2 2v12c0 1.1.9 2 2 2h3.26a5.5 5.5 0 01-.66-1H7a1 1 0 01-1-1V4a1 1 0 011-1h6a1 1 0 011 1v5.02a5.57 5.57 0 011 0V4a2 2 0 00-2-2H7zm5.07 9.44a2 2 0 01-1.44 2.48l-.46.12a4.73 4.73 0 00.01 1.01l.35.09A2 2 0 0112 17.66l-.13.42c.26.2.54.38.84.52l.32-.35a2 2 0 012.91 0l.34.36c.3-.13.57-.3.82-.5l-.15-.55a2 2 0 011.43-2.48l.46-.12a4.73 4.73 0 00-.01-1.01l-.35-.09A2 2 0 0117 11.34l.13-.42c-.26-.2-.54-.38-.84-.52l-.32.35a2 2 0 01-2.91 0l-.34-.36c-.3.13-.57.3-.82.5l.16.55zm2.43 4.06a1 1 0 110-2 1 1 0 010 2z",
    fill: primaryFill
  }));
};

export const PhoneLinkSetupRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneLinkSetupRegularIcon({}), 'PhoneLinkSetupRegular');

const PhoneLockFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 3.5C5 2.67 5.67 2 6.5 2h7c.83 0 1.5.67 1.5 1.5v5.54A3 3 0 0011.5 12v.06A2 2 0 0010 14H8.5a.5.5 0 000 1H10v3H6.5A1.5 1.5 0 015 16.5v-13zm7.5 8.5v1H12a1 1 0 00-1 1v4a1 1 0 001 1h5a1 1 0 001-1v-4a1 1 0 00-1-1h-.5v-1a2 2 0 10-4 0zm1 1v-1a1 1 0 112 0v1h-2zm1 2.25a.75.75 0 110 1.5.75.75 0 010-1.5z",
    fill: primaryFill
  }));
};

export const PhoneLockFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneLockFilledIcon({}), 'PhoneLockFilled');

const PhoneLockRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 4c0-1.1.9-2 2-2h6a2 2 0 012 2v5.04a3.02 3.02 0 00-1 0V4a1 1 0 00-1-1H7a1 1 0 00-1 1v12a1 1 0 001 1h3v1H7a2 2 0 01-2-2V4zm3.5 10H10v1H8.5a.5.5 0 010-1zm4-2v1H12a1 1 0 00-1 1v4a1 1 0 001 1h5a1 1 0 001-1v-4a1 1 0 00-1-1h-.5v-1a2 2 0 10-4 0zm1 1v-1a1 1 0 112 0v1h-2zm1 2.25a.75.75 0 110 1.5.75.75 0 010-1.5z",
    fill: primaryFill
  }));
};

export const PhoneLockRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneLockRegularIcon({}), 'PhoneLockRegular');

const PhonePageHeaderFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 4c0-1.1.9-2 2-2h6a2 2 0 012 2v1H5V4zm0 2v10c0 1.1.9 2 2 2h6a2 2 0 002-2V6H5z",
    fill: primaryFill
  }));
};

export const PhonePageHeaderFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhonePageHeaderFilledIcon({}), 'PhonePageHeaderFilled');

const PhonePageHeaderRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7 2a2 2 0 00-2 2v12c0 1.1.9 2 2 2h6a2 2 0 002-2V4a2 2 0 00-2-2H7zM6 5h8v11a1 1 0 01-1 1H7a1 1 0 01-1-1V5z",
    fill: primaryFill
  }));
};

export const PhonePageHeaderRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhonePageHeaderRegularIcon({}), 'PhonePageHeaderRegular');

const PhonePaginationFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 4c0-1.1.9-2 2-2h6a2 2 0 012 2v12a2 2 0 01-2 2H7a2 2 0 01-2-2V4zm3 11a.5.5 0 100-1 .5.5 0 000 1zm2 0a.5.5 0 100-1 .5.5 0 000 1zm2.5-.5a.5.5 0 10-1 0 .5.5 0 001 0z",
    fill: primaryFill
  }));
};

export const PhonePaginationFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhonePaginationFilledIcon({}), 'PhonePaginationFilled');

const PhonePaginationRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8 15a.5.5 0 100-1 .5.5 0 000 1zm2.5-.5a.5.5 0 11-1 0 .5.5 0 011 0zm1.5.5a.5.5 0 100-1 .5.5 0 000 1zM7 2a2 2 0 00-2 2v12c0 1.1.9 2 2 2h6a2 2 0 002-2V4a2 2 0 00-2-2H7zM6 4a1 1 0 011-1h6a1 1 0 011 1v12a1 1 0 01-1 1H7a1 1 0 01-1-1V4z",
    fill: primaryFill
  }));
};

export const PhonePaginationRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhonePaginationRegularIcon({}), 'PhonePaginationRegular');

const PhoneScreenTimeFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 2C4.67 2 4 2.67 4 3.5v13c0 .83.67 1.5 1.5 1.5h4.76a5.47 5.47 0 01-1.24-3H7.5a.5.5 0 010-1h1.52A5.5 5.5 0 0114 9.02V3.5c0-.83-.67-1.5-1.5-1.5h-7zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zM14.5 12a.5.5 0 00-.5.5v2c0 .28.22.5.5.5H16a.5.5 0 000-1h-1v-1.5a.5.5 0 00-.5-.5z",
    fill: primaryFill
  }));
};

export const PhoneScreenTimeFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneScreenTimeFilledIcon({}), 'PhoneScreenTimeFilled');

const PhoneScreenTimeRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 2C4.67 2 4 2.67 4 3.5v13c0 .83.67 1.5 1.5 1.5h4.76a5.5 5.5 0 01-.66-1H5.5a.5.5 0 01-.5-.5v-13c0-.28.22-.5.5-.5h7c.28 0 .5.22.5.5v5.7c.32-.08.66-.15 1-.18V3.5c0-.83-.67-1.5-1.5-1.5h-7zM9 14.5c0 .17 0 .34.02.5H7.5a.5.5 0 010-1h1.52l-.02.5zm10 0a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zM14.5 12a.5.5 0 00-.5.5v2c0 .28.22.5.5.5H16a.5.5 0 000-1h-1v-1.5a.5.5 0 00-.5-.5z",
    fill: primaryFill
  }));
};

export const PhoneScreenTimeRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneScreenTimeRegularIcon({}), 'PhoneScreenTimeRegular');

const PhoneShakeFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M15.37 2.93a.5.5 0 11.5-.86 4.25 4.25 0 011.63 5.66.5.5 0 01-.88-.47 3.25 3.25 0 00-1.25-4.33zm-1 1.74a.5.5 0 11.5-.87c1.02.59 1.4 1.86.91 2.9a.5.5 0 01-.9-.42c.27-.58.06-1.29-.5-1.61zm-9.74 12.4a.5.5 0 11-.5.86 4.25 4.25 0 01-1.63-5.66.5.5 0 11.88.46 3.25 3.25 0 001.25 4.33zm1-1.74a.5.5 0 11-.5.87 2.25 2.25 0 01-.92-2.9.5.5 0 01.9.42c-.26.58-.05 1.28.52 1.61zm4.54-12.26a1.95 1.95 0 012.4 1.4l2.37 8.97a2.04 2.04 0 01-1.42 2.48l-3.69 1a1.95 1.95 0 01-2.4-1.4L5.08 6.57a2.04 2.04 0 011.42-2.49l3.68-1zm-.49 11.3c.07.27.34.43.6.36l1.79-.48a.51.51 0 00.36-.62.49.49 0 00-.6-.36l-1.78.49a.51.51 0 00-.37.62z",
    fill: primaryFill
  }));
};

export const PhoneShakeFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneShakeFilledIcon({}), 'PhoneShakeFilled');

const PhoneShakeRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M15.37 2.93a.5.5 0 11.5-.86 4.25 4.25 0 011.63 5.66.5.5 0 01-.88-.47 3.25 3.25 0 00-1.25-4.33zm-1 1.74a.5.5 0 11.5-.87c1.02.59 1.4 1.86.91 2.9a.5.5 0 01-.9-.42c.27-.58.06-1.29-.5-1.61zm-9.74 12.4a.5.5 0 11-.5.86 4.25 4.25 0 01-1.63-5.66.5.5 0 11.88.46 3.25 3.25 0 001.25 4.33zm1-1.74a.5.5 0 11-.5.87 2.25 2.25 0 01-.92-2.9.5.5 0 01.9.42c-.26.58-.05 1.28.52 1.61zm5.97-10.6a.96.96 0 00-1.17-.7l-3.7 1.01c-.52.14-.84.7-.7 1.25l2.37 8.98c.14.53.67.83 1.18.7l3.68-1.01c.53-.15.85-.7.7-1.25L11.6 4.73zm-1.43-1.66a1.95 1.95 0 012.4 1.4l2.36 8.97a2.04 2.04 0 01-1.41 2.48l-3.69 1a1.95 1.95 0 01-2.4-1.4L5.07 6.57a2.04 2.04 0 011.41-2.49l3.69-1zm-.49 11.3a.51.51 0 01.36-.61l1.79-.48c.26-.08.53.08.6.35.07.27-.1.54-.36.62l-1.78.48a.49.49 0 01-.6-.35z",
    fill: primaryFill
  }));
};

export const PhoneShakeRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneShakeRegularIcon({}), 'PhoneShakeRegular');

const PhoneSpanInFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7 2a2 2 0 00-2 2v3.09a1.5 1.5 0 011.56.35l2 2a1.5 1.5 0 010 2.12l-2 2a1.5 1.5 0 01-1.56.35V16c0 1.1.9 2 2 2h6a2 2 0 002-2v-2.09a1.5 1.5 0 01-1.56-.35l-2-2a1.5 1.5 0 010-2.12l2-2A1.5 1.5 0 0115 7.09V4a2 2 0 00-2-2H7zm7.85 6.15c.2.2.2.5 0 .7L13.71 10h2.79a.5.5 0 010 1h-2.8l1.15 1.15a.5.5 0 01-.7.7l-2-2a.5.5 0 010-.7l2-2c.2-.2.5-.2.7 0zm-9.7.7a.5.5 0 11.7-.7l2 2c.2.2.2.5 0 .7l-2 2a.5.5 0 01-.7-.7L6.29 11H3.5a.5.5 0 010-1h2.8L5.14 8.85z",
    fill: primaryFill
  }));
};

export const PhoneSpanInFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneSpanInFilledIcon({}), 'PhoneSpanInFilled');

const PhoneSpanInRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 4c0-1.1.9-2 2-2h6a2 2 0 012 2v3.09a1.5 1.5 0 00-1 0V4a1 1 0 00-1-1H7a1 1 0 00-1 1v3.09a1.5 1.5 0 00-1 0V4zm0 9.91V16c0 1.1.9 2 2 2h6a2 2 0 002-2v-2.09a1.5 1.5 0 01-1 0V16a1 1 0 01-1 1H7a1 1 0 01-1-1v-2.09a1.5 1.5 0 01-1 0zm2.85-3.06l-2 2a.5.5 0 01-.7-.7L6.29 11H3.5a.5.5 0 010-1h2.8L5.14 8.85a.5.5 0 11.7-.7l2 2a.5.5 0 01.15.35.5.5 0 01-.14.35zm6.3-2.7l-2 2a.5.5 0 00-.15.35.5.5 0 00.15.35l2 2a.5.5 0 00.7-.7L13.71 11h2.79a.5.5 0 000-1h-2.8l1.15-1.15a.5.5 0 00-.7-.7z",
    fill: primaryFill
  }));
};

export const PhoneSpanInRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneSpanInRegularIcon({}), 'PhoneSpanInRegular');

const PhoneSpanOutFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7 2a2 2 0 00-2 2v3.09A1.5 1.5 0 016.91 9h.59a1.5 1.5 0 110 3h-.59A1.5 1.5 0 015 13.91V16c0 1.1.9 2 2 2h6a2 2 0 002-2v-2.09A1.5 1.5 0 0113.09 12h-.59a1.5 1.5 0 010-3h.59A1.5 1.5 0 0115 7.09V4a2 2 0 00-2-2H7zm7.85 6.15a.5.5 0 00-.7.7L15.29 10H12.5a.5.5 0 000 1h2.8l-1.15 1.15a.5.5 0 00.7.7l2-2a.5.5 0 00.15-.35.5.5 0 00-.15-.35l-2-2zM4.71 10l1.14-1.15h.01a.5.5 0 00-.71-.7l-2 2a.5.5 0 00-.15.35.5.5 0 00.15.35l2 2a.5.5 0 00.7-.7L4.71 11H7.5a.5.5 0 00.5-.5.5.5 0 00-.5-.5H4.7z",
    fill: primaryFill
  }));
};

export const PhoneSpanOutFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneSpanOutFilledIcon({}), 'PhoneSpanOutFilled');

const PhoneSpanOutRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 4c0-1.1.9-2 2-2h6a2 2 0 012 2v3.09a1.5 1.5 0 00-1 0V4a1 1 0 00-1-1H7a1 1 0 00-1 1v3.09a1.5 1.5 0 00-1 0V4zm0 9.91c.32.12.68.12 1 0V16a1 1 0 001 1h6a1 1 0 001-1v-2.09c.32.12.68.12 1 0V16a2 2 0 01-2 2H7a2 2 0 01-2-2v-2.09zm-1.85-3.76l2-2a.5.5 0 11.7.7L4.71 10H7.5a.5.5 0 010 1H4.7l1.15 1.15a.5.5 0 01-.7.7l-2-2A.5.5 0 013 10.5a.5.5 0 01.14-.35zm11.7 2.7l2-2a.5.5 0 00.15-.35.5.5 0 00-.15-.35l-2-2a.5.5 0 00-.7.7L15.29 10H12.5a.5.5 0 000 1h2.8l-1.15 1.15a.5.5 0 00.7.7z",
    fill: primaryFill
  }));
};

export const PhoneSpanOutRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneSpanOutRegularIcon({}), 'PhoneSpanOutRegular');

const PhoneSpeakerFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 2C4.67 2 4 2.67 4 3.5v13c0 .83.67 1.5 1.5 1.5h4.99A1.5 1.5 0 019 16.5V15H8a.5.5 0 010-1h1.09c.2-.58.76-1 1.41-1h.38l1.56-1.56a1.5 1.5 0 011.56-.35V3.5c0-.83-.67-1.5-1.5-1.5h-7zm8.2 10.04c.18.08.3.26.3.46v6a.5.5 0 01-.85.35L11.29 17h-.79a.5.5 0 01-.5-.5v-2c0-.28.22-.5.5-.5h.8l1.85-1.85a.5.5 0 01.54-.11zm3.95.16c.12.16.29.45.44.87.26.68.41 1.5.41 2.43 0 .94-.15 1.75-.4 2.43-.16.42-.33.7-.45.87a.5.5 0 01-.85-.52l.12-.19a5.9 5.9 0 00.58-2.6 5.9 5.9 0 00-.58-2.58l-.07-.11a.5.5 0 01.8-.6zm-1.43 1.77c-.1-.3-.2-.55-.27-.7a.5.5 0 10-.9.45 4.6 4.6 0 01.45 1.78 3.94 3.94 0 01-.37 1.6l-.08.18a.5.5 0 10.9.44 5.5 5.5 0 00.55-2.22c0-.5-.1-1.02-.28-1.53z",
    fill: primaryFill
  }));
};

export const PhoneSpeakerFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneSpeakerFilledIcon({}), 'PhoneSpeakerFilled');

const PhoneSpeakerRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8 14a.5.5 0 000 1h1v-.5c0-.18.03-.34.09-.5H8zm-2 3h3.09c.2.58.75 1 1.4 1H6a2 2 0 01-2-2V4c0-1.1.9-2 2-2h6a2 2 0 012 2v7.09a1.5 1.5 0 00-1 0V4a1 1 0 00-1-1H6a1 1 0 00-1 1v12a1 1 0 001 1zm7.7-4.96c.18.08.3.26.3.46v6a.5.5 0 01-.85.35L11.29 17h-.79a.5.5 0 01-.5-.5v-2c0-.28.22-.5.5-.5h.8l1.85-1.85a.5.5 0 01.54-.11zm3.95.16c.12.16.29.45.44.87.26.68.41 1.5.41 2.43 0 .94-.15 1.75-.4 2.43-.16.42-.33.7-.45.87a.5.5 0 01-.85-.52l.12-.19a5.9 5.9 0 00.58-2.6 5.9 5.9 0 00-.58-2.58l-.07-.11a.5.5 0 01.8-.6zm-1.43 1.77c-.1-.3-.2-.55-.27-.7a.5.5 0 10-.9.45 4.6 4.6 0 01.45 1.78 3.94 3.94 0 01-.37 1.6l-.08.18a.5.5 0 10.9.44 5.5 5.5 0 00.55-2.22c0-.5-.1-1.02-.28-1.53z",
    fill: primaryFill
  }));
};

export const PhoneSpeakerRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneSpeakerRegularIcon({}), 'PhoneSpeakerRegular');

const PhoneStatusBarFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 4c0-1.1.9-2 2-2h6a2 2 0 012 2v12a2 2 0 01-2 2H7a2 2 0 01-2-2V4zm2.5 0a.5.5 0 000 1h5a.5.5 0 000-1h-5z",
    fill: primaryFill
  }));
};

export const PhoneStatusBarFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneStatusBarFilledIcon({}), 'PhoneStatusBarFilled');

const PhoneStatusBarRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.5 4a.5.5 0 000 1h5a.5.5 0 000-1h-5zM7 2a2 2 0 00-2 2v12c0 1.1.9 2 2 2h6a2 2 0 002-2V4a2 2 0 00-2-2H7zM6 4a1 1 0 011-1h6a1 1 0 011 1v12a1 1 0 01-1 1H7a1 1 0 01-1-1V4z",
    fill: primaryFill
  }));
};

export const PhoneStatusBarRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneStatusBarRegularIcon({}), 'PhoneStatusBarRegular');

const PhoneTabletFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 4.8C4 3.8 4.84 3 5.84 3h10.32c1 0 1.84.8 1.84 1.8v7.4c0 1-.84 1.8-1.84 1.8H10v-2h2.5a.5.5 0 000-1H10V8a2 2 0 00-2-2H4V4.8zM3.5 7C2.67 7 2 7.67 2 8.5v8c0 .83.67 1.5 1.5 1.5h4c.83 0 1.5-.67 1.5-1.5v-8C9 7.67 8.33 7 7.5 7h-4zm1 8.5c0-.28.22-.5.5-.5h1a.5.5 0 010 1H5a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const PhoneTabletFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneTabletFilledIcon({}), 'PhoneTabletFilled');

const PhoneTabletRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.84 4a.83.83 0 00-.84.8V6H4V4.8C4 3.8 4.84 3 5.84 3h10.32c1 0 1.84.8 1.84 1.8v7.4c0 1-.84 1.8-1.84 1.8H10v-1h6.16c.48 0 .84-.37.84-.8V4.8c0-.43-.36-.8-.84-.8H5.84zM10 12h2.5a.5.5 0 000-1H10v1zm-5 3a.5.5 0 000 1h1a.5.5 0 000-1H5zM2 8.5C2 7.67 2.67 7 3.5 7h4C8.33 7 9 7.67 9 8.5v8c0 .83-.67 1.5-1.5 1.5h-4A1.5 1.5 0 012 16.5v-8zM3.5 8a.5.5 0 00-.5.5v8c0 .28.22.5.5.5h4a.5.5 0 00.5-.5v-8a.5.5 0 00-.5-.5h-4z",
    fill: primaryFill
  }));
};

export const PhoneTabletRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneTabletRegularIcon({}), 'PhoneTabletRegular');

const PhoneUpdateFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 3.5C5 2.67 5.67 2 6.5 2h7c.83 0 1.5.67 1.5 1.5v13c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 015 16.5v-13zm5.5 3a.5.5 0 00-1 0v5.8l-1.15-1.15a.5.5 0 00-.7.7l2 2c.2.2.5.2.7 0l2-2a.5.5 0 00-.7-.7l-1.15 1.14V6.5z",
    fill: primaryFill
  }));
};

export const PhoneUpdateFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneUpdateFilledIcon({}), 'PhoneUpdateFilled');

const PhoneUpdateRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 6c.28 0 .5.22.5.5v5.8l1.15-1.15a.5.5 0 01.7.7l-2 2A.5.5 0 0110 14a.5.5 0 01-.35-.15l-2-2a.5.5 0 01.7-.7l1.15 1.14V6.5c0-.28.22-.5.5-.5zM5 3.5C5 2.67 5.67 2 6.5 2h7c.83 0 1.5.67 1.5 1.5v13c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 015 16.5v-13zM6.5 3a.5.5 0 00-.5.5v13c0 .28.22.5.5.5h7a.5.5 0 00.5-.5v-13a.5.5 0 00-.5-.5h-7z",
    fill: primaryFill
  }));
};

export const PhoneUpdateRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneUpdateRegularIcon({}), 'PhoneUpdateRegular');

const PhoneUpdateCheckmarkFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 16c0 1.1.9 2 2 2h3.26a5.48 5.48 0 01-.76-5.8v-5L8.35 8.36a.5.5 0 11-.7-.7l2-2c.2-.2.5-.2.7 0l2 2a.5.5 0 01-.7.7L10.5 7.21v3.52a5.48 5.48 0 014.5-1.7V4a2 2 0 00-2-2H7a2 2 0 00-2 2v12zm14-1.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.15-1.85a.5.5 0 00-.7 0l-2.65 2.64-.65-.64a.5.5 0 00-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 000-.7z",
    fill: primaryFill
  }));
};

export const PhoneUpdateCheckmarkFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneUpdateCheckmarkFilledIcon({}), 'PhoneUpdateCheckmarkFilled');

const PhoneUpdateCheckmarkRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 16a1 1 0 001 1h2.6c.18.36.4.7.66 1H7a2 2 0 01-2-2V4c0-1.1.9-2 2-2h6a2 2 0 012 2v5.02a5.57 5.57 0 00-1 0V4a1 1 0 00-1-1H7a1 1 0 00-1 1v12zm3.5-3.8c.25-.54.6-1.04 1-1.47V7.2l1.15 1.14a.5.5 0 00.7-.7l-2-2a.5.5 0 00-.7 0l-2 2a.5.5 0 10.7.7L9.5 7.21v5zm9.5 2.3a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.15-1.85a.5.5 0 00-.7 0l-2.65 2.64-.65-.64a.5.5 0 00-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 000-.7z",
    fill: primaryFill
  }));
};

export const PhoneUpdateCheckmarkRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneUpdateCheckmarkRegularIcon({}), 'PhoneUpdateCheckmarkRegular');

const PhoneVerticalScrollFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 3.5C5 2.67 5.67 2 6.5 2h7c.83 0 1.5.67 1.5 1.5v13c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 015 16.5v-13zm7.35 5.35a.5.5 0 000-.7l-2-2a.5.5 0 00-.7 0l-2 2a.5.5 0 10.7.7L10 7.21l1.65 1.64c.2.2.5.2.7 0zm-4.7 2.3a.5.5 0 000 .7l2 2c.2.2.5.2.7 0l2-2a.5.5 0 00-.7-.7L10 12.79l-1.65-1.64a.5.5 0 00-.7 0z",
    fill: primaryFill
  }));
};

export const PhoneVerticalScrollFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneVerticalScrollFilledIcon({}), 'PhoneVerticalScrollFilled');

const PhoneVerticalScrollRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.65 11.15c.2-.2.5-.2.7 0L10 12.79l1.65-1.64a.5.5 0 01.7.7l-2 2a.5.5 0 01-.7 0l-2-2a.5.5 0 010-.7zm4-2.3a.5.5 0 00.7-.7l-2-2a.5.5 0 00-.7 0l-2 2a.5.5 0 10.7.7L10 7.21l1.65 1.64zM5 3.5C5 2.67 5.67 2 6.5 2h7c.83 0 1.5.67 1.5 1.5v13c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 015 16.5v-13zM6.5 3a.5.5 0 00-.5.5v13c0 .28.22.5.5.5h7a.5.5 0 00.5-.5v-13a.5.5 0 00-.5-.5h-7z",
    fill: primaryFill
  }));
};

export const PhoneVerticalScrollRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneVerticalScrollRegularIcon({}), 'PhoneVerticalScrollRegular');

const PhoneVibrateFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 4c0-1.1.9-2 2-2h6a2 2 0 012 2v12a2 2 0 01-2 2H7a2 2 0 01-2-2V4zm3.5 10.5a.5.5 0 000 1h3a.5.5 0 000-1h-3zM2.92 7.22a.5.5 0 00-.84.56l.38.57c.29.42.32.97.1 1.43-.4.78-.34 1.7.14 2.43l.38.57a.5.5 0 10.84-.56l-.38-.57a1.43 1.43 0 01-.1-1.43c.4-.78.34-1.7-.14-2.43l-.38-.57zm13.3-.14a.5.5 0 01.7.14l.38.57c.48.73.54 1.65.15 2.43-.23.46-.2 1 .09 1.43l.38.57a.5.5 0 11-.84.56l-.38-.57a2.43 2.43 0 01-.15-2.43c.23-.46.2-1-.09-1.43l-.38-.57a.5.5 0 01.14-.7z",
    fill: primaryFill
  }));
};

export const PhoneVibrateFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneVibrateFilledIcon({}), 'PhoneVibrateFilled');

const PhoneVibrateRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.5 14.5a.5.5 0 000 1h3a.5.5 0 000-1h-3zM7 2a2 2 0 00-2 2v12c0 1.1.9 2 2 2h6a2 2 0 002-2V4a2 2 0 00-2-2H7zM6 4a1 1 0 011-1h6a1 1 0 011 1v12a1 1 0 01-1 1H7a1 1 0 01-1-1V4zM2.92 7.22a.5.5 0 00-.84.56l.38.57c.29.42.32.97.1 1.43-.4.78-.34 1.7.14 2.43l.38.57a.5.5 0 10.84-.56l-.38-.57a1.43 1.43 0 01-.1-1.43c.4-.78.34-1.7-.14-2.43l-.38-.57zm13.3-.14a.5.5 0 01.7.14l.38.57c.48.73.54 1.65.15 2.43-.23.46-.2 1 .09 1.43l.38.57a.5.5 0 11-.84.56l-.38-.57a2.43 2.43 0 01-.15-2.43c.23-.46.2-1-.09-1.43l-.38-.57a.5.5 0 01.14-.7z",
    fill: primaryFill
  }));
};

export const PhoneVibrateRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneVibrateRegularIcon({}), 'PhoneVibrateRegular');

const PhotoFilterFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.26 13.74a6 6 0 117.48-7.48 6 6 0 11-7.48 7.48zM3.5 8A4.5 4.5 0 006 12.03V12a6 6 0 016.03-6A4.5 4.5 0 003.5 8zm4.47 6A4.5 4.5 0 1014 7.97V8a6 6 0 01-6 6h-.03z",
    fill: primaryFill
  }));
};

export const PhotoFilterFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhotoFilterFilledIcon({}), 'PhotoFilterFilled');

const PhotoFilterRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 8a6 6 0 004.26 5.74 6 6 0 107.48-7.48A6 6 0 002 8zm6-5a5 5 0 014.6 3.03L12 6a6 6 0 00-5.97 6.6A5 5 0 018 3zm9 9a5 5 0 01-9.6 1.97L8 14a6 6 0 005.97-6.6A5 5 0 0117 12z",
    fill: primaryFill
  }));
};

export const PhotoFilterRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhotoFilterRegularIcon({}), 'PhotoFilterRegular');

const PiFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.4 4.78c-.17.32-.18.76-.12 1.07a.75.75 0 11-1.47.3c-.1-.52-.11-1.34.26-2.06.41-.79 1.22-1.34 2.47-1.34H16.5a.75.75 0 010 1.5h-2.25v9.42c0 1.5.45 1.89.7 2 .32.15.8.08 1.21-.13a.75.75 0 01.68 1.34c-.6.3-1.6.58-2.53.15-1.01-.47-1.56-1.61-1.56-3.36V4.25H8.24a90.75 90.75 0 01-.6 6.32 44.66 44.66 0 01-.61 3.55 12.38 12.38 0 01-.86 2.72.75.75 0 11-1.34-.68c.26-.5.5-1.33.73-2.36.23-1.03.42-2.21.58-3.42.31-2.28.5-4.62.6-6.13h-2.2c-.74 0-1.01.28-1.14.53z",
    fill: primaryFill
  }));
};

export const PiFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PiFilledIcon({}), 'PiFilled');

const PiRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.18 4.67a2 2 0 00-.14 1.23.5.5 0 11-.98.2 3 3 0 01.23-1.9C2.66 3.5 3.38 3 4.54 3H16.5a.5.5 0 110 1H14v9.67c0 1.54.47 2.05.84 2.23.42.2 1 .09 1.43-.14a.5.5 0 11.46.9c-.56.28-1.49.53-2.32.14-.88-.41-1.41-1.42-1.41-3.13V4H8v.03a90.2 90.2 0 01-.62 6.51 44.43 44.43 0 01-.6 3.52c-.23 1.06-.5 2-.83 2.66a.5.5 0 11-.9-.44c.27-.55.53-1.39.76-2.43.22-1.03.42-2.22.58-3.44.33-2.42.53-4.92.6-6.41H4.55c-.83 0-1.18.33-1.36.67z",
    fill: primaryFill
  }));
};

export const PiRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PiRegularIcon({}), 'PiRegular');

const PictureInPictureFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.75 3A2.75 2.75 0 002 5.75v6.5A2.75 2.75 0 004.75 15H9v-2.5a2.5 2.5 0 012.5-2.5h6c.17 0 .34.02.5.05v-4.3A2.75 2.75 0 0015.25 3H4.75zM18 11.09a1.5 1.5 0 00-.5-.09h-6c-.83 0-1.5.67-1.5 1.5v4c0 .83.67 1.5 1.5 1.5h6c.83 0 1.5-.67 1.5-1.5v-4c0-.65-.42-1.2-1-1.41z",
    fill: primaryFill
  }));
};

export const PictureInPictureFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PictureInPictureFilledIcon({}), 'PictureInPictureFilled');

const PictureInPictureRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 5.75A2.75 2.75 0 014.75 3h10.5A2.75 2.75 0 0118 5.75V10h-1V5.75C17 4.78 16.22 4 15.25 4H4.75C3.78 4 3 4.78 3 5.75v6.5c0 .97.78 1.75 1.75 1.75H9v1H4.75A2.75 2.75 0 012 12.25v-6.5zM11.5 11c-.83 0-1.5.67-1.5 1.5v4c0 .83.67 1.5 1.5 1.5h6c.83 0 1.5-.67 1.5-1.5v-4c0-.83-.67-1.5-1.5-1.5h-6z",
    fill: primaryFill
  }));
};

export const PictureInPictureRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PictureInPictureRegularIcon({}), 'PictureInPictureRegular');

const PictureInPictureEnterFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.75 3A2.75 2.75 0 002 5.75v6.5A2.75 2.75 0 004.75 15H9v-2.5a2.5 2.5 0 012.5-2.5h6c.17 0 .34.02.5.05v-4.3A2.75 2.75 0 0015.25 3H4.75zm.6 2.65L8 8.29V6.5a.5.5 0 011 0v3a.5.5 0 01-.5.5h-3a.5.5 0 010-1h1.8L4.64 6.35a.5.5 0 11.7-.7zM18 11.09a1.5 1.5 0 00-.5-.09h-6c-.83 0-1.5.67-1.5 1.5v4c0 .83.67 1.5 1.5 1.5h6c.83 0 1.5-.67 1.5-1.5v-4c0-.65-.42-1.2-1-1.41z",
    fill: primaryFill
  }));
};

export const PictureInPictureEnterFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PictureInPictureEnterFilledIcon({}), 'PictureInPictureEnterFilled');

const PictureInPictureEnterRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 5.75A2.75 2.75 0 014.75 3h10.5A2.75 2.75 0 0118 5.75V10h-1V5.75C17 4.78 16.22 4 15.25 4H4.75C3.78 4 3 4.78 3 5.75v6.5c0 .97.78 1.75 1.75 1.75H9v1H4.75A2.75 2.75 0 012 12.25v-6.5zM11.5 11c-.83 0-1.5.67-1.5 1.5v4c0 .83.67 1.5 1.5 1.5h6c.83 0 1.5-.67 1.5-1.5v-4c0-.83-.67-1.5-1.5-1.5h-6zM4.65 5.65c.2-.2.5-.2.7 0L8 8.29V6.5a.5.5 0 011 0v3a.5.5 0 01-.5.5h-3a.5.5 0 010-1h1.8L4.64 6.35a.5.5 0 010-.7z",
    fill: primaryFill
  }));
};

export const PictureInPictureEnterRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PictureInPictureEnterRegularIcon({}), 'PictureInPictureEnterRegular');

const PictureInPictureExitFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.5 9c.83 0 1.5-.67 1.5-1.5v-4C10 2.67 9.33 2 8.5 2h-6C1.67 2 1 2.67 1 3.5v4A1.5 1.5 0 002.5 9h6zm0 1h-6c-.17 0-.34-.02-.5-.05v4.3A2.75 2.75 0 004.75 17h10.5A2.75 2.75 0 0018 14.25v-6.5A2.75 2.75 0 0015.25 5H11v2.5A2.5 2.5 0 018.5 10zm3.85.65L15 13.29V11.5a.5.5 0 011 0v3a.5.5 0 01-.5.5h-3a.5.5 0 010-1h1.8l-2.65-2.65a.5.5 0 01.7-.7z",
    fill: primaryFill
  }));
};

export const PictureInPictureExitFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PictureInPictureExitFilledIcon({}), 'PictureInPictureExitFilled');

const PictureInPictureExitRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.5 9c.83 0 1.5-.67 1.5-1.5v-4C10 2.67 9.33 2 8.5 2h-6C1.67 2 1 2.67 1 3.5v4c0 .65.42 1.2 1 1.41l.02.01c.15.05.31.08.48.08h6zm6.75-3H11V5h4.25A2.75 2.75 0 0118 7.75v6.5A2.75 2.75 0 0115.25 17H4.75A2.75 2.75 0 012 14.25v-4.3c.16.03.33.05.5.05H3v4.25c0 .97.78 1.75 1.75 1.75h10.5c.97 0 1.75-.78 1.75-1.75v-6.5C17 6.78 16.22 6 15.25 6zM14 12.3l-2.65-2.65a.5.5 0 00-.7.7L13.29 13H11.5a.5.5 0 000 1h3a.5.5 0 00.5-.5v-3a.5.5 0 00-1 0v1.8z",
    fill: primaryFill
  }));
};

export const PictureInPictureExitRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PictureInPictureExitRegularIcon({}), 'PictureInPictureExitRegular');

const PillFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11.15 3.15a4.04 4.04 0 115.7 5.7l-8 8a4.04 4.04 0 11-5.7-5.7l8-8zm5 .7a3.04 3.04 0 00-4.3 0L8.21 7.5l4.29 4.3 3.65-3.65a3.04 3.04 0 000-4.3zm-7.3 10.3a.5.5 0 00-.7 0l-1.5 1.5a.91.91 0 01-1.3 0 .5.5 0 00-.85.35c0 .14.06.27.15.36.75.74 1.96.74 2.7 0l1.5-1.5a.5.5 0 000-.71z",
    fill: primaryFill
  }));
};

export const PillFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PillFilledIcon({}), 'PillFilled');

const PillRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.85 13.15c.2.2.2.5 0 .7l-1.5 1.5c-.74.75-1.95.75-2.7 0A.5.5 0 015 14.5a.5.5 0 01.35.15c.36.35.94.35 1.3 0l1.5-1.5c.2-.2.5-.2.7 0zm2.3-10a4.04 4.04 0 115.7 5.7l-8 8a4.04 4.04 0 11-5.7-5.7l8-8zm5 .7a3.04 3.04 0 00-4.3 0L8.21 7.5l4.29 4.3 3.65-3.65a3.04 3.04 0 000-4.3zm-4.36 8.65L7.5 8.2l-3.65 3.65a3.04 3.04 0 004.3 4.3l3.64-3.65z",
    fill: primaryFill
  }));
};

export const PillRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PillRegularIcon({}), 'PillRegular');

const PinFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13.33 2.62a2 2 0 00-3.2.52L8.38 6.6a1.5 1.5 0 01-.78.72L4 8.75a1 1 0 00-.33 1.64l2.61 2.6L3 16.3v.7h.7L7 13.72l2.61 2.6a1 1 0 001.64-.33l1.43-3.59c.14-.34.4-.62.72-.78l3.46-1.73a2 2 0 00.52-3.2l-4.05-4.06z",
    fill: primaryFill
  }));
};

export const PinFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PinFilledIcon({}), 'PinFilled');

const PinRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.12 3.14a2 2 0 013.2-.52l4.06 4.05a2 2 0 01-.52 3.2l-3.46 1.74a1.5 1.5 0 00-.72.78L11.25 16a1 1 0 01-1.64.33L7 13.7 3.7 17H3v-.7L6.3 13l-2.62-2.61a1 1 0 01.34-1.64L7.6 7.32c.34-.14.62-.4.78-.72l1.73-3.46zm2.5.18a1 1 0 00-1.6.26L9.29 7.04a2.5 2.5 0 01-1.31 1.2L4.39 9.69l5.93 5.93 1.43-3.59a2.5 2.5 0 011.2-1.3l3.46-1.74a1 1 0 00.26-1.6l-4.05-4.06z",
    fill: primaryFill
  }));
};

export const PinRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PinRegularIcon({}), 'PinRegular');

const PinOffFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.85 2.15a.5.5 0 10-.7.7L6.9 7.6 4.02 8.75a1 1 0 00-.34 1.64L6.3 13 3 16.3v.7h.7L7 13.7l2.61 2.62a1 1 0 001.64-.34l1.15-2.88 4.75 4.75a.5.5 0 00.7-.7l-15-15zm14.01 7.73l-3.24 1.62L8.5 6.38l1.62-3.24a2 2 0 013.2-.52l4.06 4.05a2 2 0 01-.52 3.2z",
    fill: primaryFill
  }));
};

export const PinOffFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PinOffFilledIcon({}), 'PinOffFilled');

const PinOffRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.85 2.15a.5.5 0 10-.7.7L6.9 7.6 4.02 8.75a1 1 0 00-.34 1.64L6.3 13 3 16.3v.7h.7L7 13.7l2.61 2.62a1 1 0 001.64-.34l1.15-2.88 4.75 4.75a.5.5 0 00.7-.7l-15-15zm8.78 10.18l-1.31 3.28-5.93-5.93 3.28-1.3 3.96 3.95zm1.33-1.62l-.08.04.74.75 3.24-1.62a2 2 0 00.52-3.2l-4.05-4.06a2 2 0 00-3.2.52L8.5 6.38l.75.74.04-.08 1.73-3.45a1 1 0 011.6-.26l4.05 4.05a1 1 0 01-.26 1.6l-3.45 1.73z",
    fill: primaryFill
  }));
};

export const PinOffRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PinOffRegularIcon({}), 'PinOffRegular');

const PipelineFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 5.5a1.5 1.5 0 013 0v9a1.5 1.5 0 01-3 0v-9zm13 0v9a1.5 1.5 0 003 0v-9a1.5 1.5 0 00-3 0zM14 14V6H6v8h8z",
    fill: primaryFill
  }));
};

export const PipelineFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PipelineFilledIcon({}), 'PipelineFilled');

const PipelineRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 5.5a1.5 1.5 0 113 0V6h10v-.5a1.5 1.5 0 013 0v9a1.5 1.5 0 01-3 0V14H5v.5a1.5 1.5 0 01-3 0v-9zm2 0a.5.5 0 00-1 0v9a.5.5 0 001 0v-9zM15 7H5v6h10V7zm2-1.5a.5.5 0 00-1 0v9a.5.5 0 001 0v-9z",
    fill: primaryFill
  }));
};

export const PipelineRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PipelineRegularIcon({}), 'PipelineRegular');

const PipelineAddFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 5.5a1.5 1.5 0 013 0v9a1.5 1.5 0 01-3 0v-9zm12 3.52A5.5 5.5 0 009.02 14H6V6h8v3.02zm1-3.52v3.52c1.13.1 2.17.55 3 1.24V5.5a1.5 1.5 0 00-3 0zm4 9a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V14h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V15h1.5a.5.5 0 000-1H15v-1.5z",
    fill: primaryFill
  }));
};

export const PipelineAddFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PipelineAddFilledIcon({}), 'PipelineAddFilled');

const PipelineAddRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 5.5a1.5 1.5 0 113 0V6h10v-.5a1.5 1.5 0 013 0v4.76a5.5 5.5 0 00-1-.66V5.5a.5.5 0 00-1 0v3.7c-.32-.08-.66-.15-1-.18V7H5v6h4.2c-.08.32-.15.66-.18 1H5v.5a1.5 1.5 0 01-3 0v-9zm2 0a.5.5 0 00-1 0v9a.5.5 0 001 0v-9zm15 9a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V14h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V15h1.5a.5.5 0 000-1H15v-1.5z",
    fill: primaryFill
  }));
};

export const PipelineAddRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PipelineAddRegularIcon({}), 'PipelineAddRegular');

const PipelineArrowCurveDownFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 21 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M1 5.5a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0zm6.4.9l-.9.9V5.74A2.75 2.75 0 003.75 3H3.5a.5.5 0 100 1h.25c.97 0 1.75.78 1.75 1.75v1.54l-.9-.9a.5.5 0 00-.7.71l1.75 1.76a.5.5 0 00.7 0L8.12 7.1a.5.5 0 10-.7-.7zM2 9.74a5.48 5.48 0 003 1.24v3.52a1.5 1.5 0 01-3 0V9.74zM10.98 6A5.5 5.5 0 016 10.98V14h8V6h-3.02zm5.52-2c-.83 0-1.5.67-1.5 1.5v9a1.5 1.5 0 003 0v-9c0-.83-.67-1.5-1.5-1.5z",
    fill: primaryFill
  }));
};

export const PipelineArrowCurveDownFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PipelineArrowCurveDownFilledIcon({}), 'PipelineArrowCurveDownFilled');

const PipelineArrowCurveDownRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.98 6c-.03.34-.1.68-.18 1H15v6H5v-2.02c-.35-.03-.68-.1-1-.19v3.71a.5.5 0 01-1 0v-4.1c-.37-.19-.7-.4-1-.66v4.76a1.5 1.5 0 003 0V14h10v.5a1.5 1.5 0 003 0v-9a1.5 1.5 0 00-3 0V6h-4.02zm5.52-1c.28 0 .5.22.5.5v9a.5.5 0 01-1 0v-9c0-.28.22-.5.5-.5zm-11-4a4.5 4.5 0 100 9 4.5 4.5 0 000-9zm2.6 5.4c.2.2.2.5 0 .7L6.37 8.85a.5.5 0 01-.7 0L3.9 7.1a.5.5 0 11.7-.7l.9.9V5.74C5.5 4.78 4.72 4 3.75 4H3.5a.5.5 0 110-1h.25A2.75 2.75 0 016.5 5.75v1.54l.9-.9c.2-.19.51-.19.7 0z",
    fill: primaryFill
  }));
};

export const PipelineArrowCurveDownRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PipelineArrowCurveDownRegularIcon({}), 'PipelineArrowCurveDownRegular');

const PipelinePlayFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 5.5a1.5 1.5 0 013 0v9a1.5 1.5 0 01-3 0v-9zm12 3.52A5.5 5.5 0 009.02 14H6V6h8v3.02zm1-3.52v3.52c1.13.1 2.17.55 3 1.24V5.5a1.5 1.5 0 00-3 0zm4 9a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.29-.44l-2.97-1.65a.5.5 0 00-.74.44v3.3c0 .38.41.62.74.44l2.97-1.65a.5.5 0 000-.88z",
    fill: primaryFill
  }));
};

export const PipelinePlayFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PipelinePlayFilledIcon({}), 'PipelinePlayFilled');

const PipelinePlayRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 5.5a1.5 1.5 0 113 0V6h10v-.5a1.5 1.5 0 013 0v4.76a5.5 5.5 0 00-1-.66V5.5a.5.5 0 00-1 0v3.7c-.32-.08-.66-.15-1-.18V7H5v6h4.2c-.08.32-.15.66-.18 1H5v.5a1.5 1.5 0 01-3 0v-9zm2 0a.5.5 0 00-1 0v9a.5.5 0 001 0v-9zm15 9a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.29-.44l-2.97-1.65a.5.5 0 00-.74.44v3.3c0 .38.41.62.74.44l2.97-1.65a.5.5 0 000-.88z",
    fill: primaryFill
  }));
};

export const PipelinePlayRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PipelinePlayRegularIcon({}), 'PipelinePlayRegular');

const PivotFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 5.5v9A2.5 2.5 0 005.5 17h4.59a1.5 1.5 0 01.35-1.56l1-1a1.5 1.5 0 012.47.56h.59a.5.5 0 00.5-.5v-.59a1.5 1.5 0 01-.56-2.47l1-1a1.5 1.5 0 011.56-.35V5.5A2.5 2.5 0 0014.5 3h-9A2.5 2.5 0 003 5.5zM6 5h1a1 1 0 011 1v1a1 1 0 01-1 1H6a1 1 0 01-1-1V6a1 1 0 011-1zm3 1a1 1 0 011-1h4a1 1 0 011 1v1a1 1 0 01-1 1h-4a1 1 0 01-1-1V6zM7 9a1 1 0 011 1v4a1 1 0 01-1 1H6a1 1 0 01-1-1v-4a1 1 0 011-1h1zm9.85 2.15a.5.5 0 00-.7 0l-1 1a.5.5 0 00.7.7l.15-.14v1.79c0 .83-.67 1.5-1.5 1.5h-1.8l.15-.15a.5.5 0 00-.7-.7l-1 1a.5.5 0 000 .7l1 1a.5.5 0 00.7-.7l-.14-.15h1.79a2.5 2.5 0 002.5-2.5v-1.8l.15.15a.5.5 0 00.7-.7l-1-1z",
    fill: primaryFill
  }));
};

export const PivotFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PivotFilledIcon({}), 'PivotFilled');

const PivotRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 4C4.67 4 4 4.67 4 5.5v9c0 .83.67 1.5 1.5 1.5h4.59a1.5 1.5 0 000 1H5.5A2.5 2.5 0 013 14.5v-9A2.5 2.5 0 015.5 3h9A2.5 2.5 0 0117 5.5v4.59a1.5 1.5 0 00-1 0V5.5c0-.83-.67-1.5-1.5-1.5h-9zM6 5a1 1 0 00-1 1v1a1 1 0 001 1h1a1 1 0 001-1V6a1 1 0 00-1-1H6zm4 0a1 1 0 00-1 1v1a1 1 0 001 1h4a1 1 0 001-1V6a1 1 0 00-1-1h-4zM6 9a1 1 0 00-1 1v4a1 1 0 001 1h1a1 1 0 001-1v-4a1 1 0 00-1-1H6zm10.85 2.15a.5.5 0 00-.7 0l-1 1a.5.5 0 00.7.7l.15-.14v1.79c0 .83-.67 1.5-1.5 1.5h-1.8l.15-.15a.5.5 0 00-.7-.7l-1 1a.5.5 0 000 .7l1 1a.5.5 0 00.7-.7l-.14-.15h1.79a2.5 2.5 0 002.5-2.5v-1.8l.15.15a.5.5 0 00.7-.7l-1-1z",
    fill: primaryFill
  }));
};

export const PivotRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PivotRegularIcon({}), 'PivotRegular');

const PlayFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17.22 8.68a1.5 1.5 0 010 2.63l-10 5.5A1.5 1.5 0 015 15.5v-11A1.5 1.5 0 017.22 3.2l10 5.5z",
    fill: primaryFill
  }));
};

export const PlayFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PlayFilledIcon({}), 'PlayFilled');

const PlayRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17.22 8.69a1.5 1.5 0 010 2.62l-10 5.5A1.5 1.5 0 015 15.5v-11A1.5 1.5 0 017.22 3.2l10 5.5zm-.48 1.75a.5.5 0 000-.88l-10-5.5A.5.5 0 006 4.5v11c0 .38.4.62.74.44l10-5.5z",
    fill: primaryFill
  }));
};

export const PlayRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PlayRegularIcon({}), 'PlayRegular');

const PlayCircleFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 10a8 8 0 1116 0 8 8 0 01-16 0zm6-2.17v4.34c0 .57.63.94 1.13.65l4.12-2.39a.5.5 0 000-.86L9.13 7.18A.75.75 0 008 7.83z",
    fill: primaryFill
  }));
};

export const PlayCircleFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PlayCircleFilledIcon({}), 'PlayCircleFilled');

const PlayCircleRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.13 7.18A.75.75 0 008 7.83v4.34c0 .57.63.94 1.13.65l4.12-2.39a.5.5 0 000-.86L9.13 7.18zM2 10a8 8 0 1116 0 8 8 0 01-16 0zm8-7a7 7 0 100 14 7 7 0 000-14z",
    fill: primaryFill
  }));
};

export const PlayCircleRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PlayCircleRegularIcon({}), 'PlayCircleRegular');

const PlaySettingsFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17.22 8.68a1.5 1.5 0 010 2.63L12 14.2A5.5 5.5 0 005 9.2V4.5a1.5 1.5 0 012.23-1.32l10 5.5zM4.06 11.44a2 2 0 01-1.43 2.48l-.46.12a4.7 4.7 0 00.01 1.01l.35.09A2 2 0 014 17.66l-.13.42c.26.2.54.38.84.52l.32-.35a2 2 0 012.91 0l.34.36c.3-.13.57-.3.82-.5l-.16-.55a2 2 0 011.44-2.48l.46-.12a4.7 4.7 0 00-.01-1.01l-.35-.09A2 2 0 019 11.34l.13-.42c-.26-.2-.54-.38-.84-.52l-.32.35a2 2 0 01-2.91 0l-.34-.36c-.3.13-.57.3-.82.5l.15.55zM6.5 15.5a1 1 0 110-2 1 1 0 010 2z",
    fill: primaryFill
  }));
};

export const PlaySettingsFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PlaySettingsFilledIcon({}), 'PlaySettingsFilled');

const PlaySettingsRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17.22 8.69a1.5 1.5 0 010 2.62l-5.23 2.88a5.5 5.5 0 00-.16-1.05l4.9-2.7a.5.5 0 000-.88l-9.99-5.5A.5.5 0 006 4.5v4.52c-.34.03-.68.1-1 .19V4.5a1.5 1.5 0 012.22-1.32l10 5.5zM4.06 11.44a2 2 0 01-1.43 2.48l-.46.12a4.7 4.7 0 00.01 1.01l.35.09A2 2 0 014 17.66l-.13.42c.26.2.54.38.84.52l.32-.35a2 2 0 012.91 0l.34.36c.3-.13.57-.3.82-.5l-.16-.55a2 2 0 011.44-2.48l.46-.12a4.7 4.7 0 00-.01-1.01l-.35-.09A2 2 0 019 11.34l.13-.42c-.26-.2-.54-.38-.84-.52l-.32.35a2 2 0 01-2.91 0l-.34-.36c-.3.13-.57.3-.82.5l.15.55zM6.5 15.5a1 1 0 110-2 1 1 0 010 2z",
    fill: primaryFill
  }));
};

export const PlaySettingsRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PlaySettingsRegularIcon({}), 'PlaySettingsRegular');

const PlugConnectedFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17.78 3.28a.75.75 0 00-1.06-1.06l-2.45 2.45a4.04 4.04 0 00-5.12.48l-.3.3a1.49 1.49 0 000 2.1l3.6 3.6c.58.59 1.52.59 2.1 0l.3-.3a4.04 4.04 0 00.48-5.12l2.45-2.45zM7.55 8.85a1.49 1.49 0 00-2.1 0l-.3.3a4.04 4.04 0 00-.48 5.12l-2.45 2.45a.75.75 0 101.06 1.06l2.45-2.45a4.04 4.04 0 005.12-.48l.3-.3c.59-.58.59-1.52 0-2.1l-3.6-3.6z",
    fill: primaryFill
  }));
};

export const PlugConnectedFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PlugConnectedFilledIcon({}), 'PlugConnectedFilled');

const PlugConnectedRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17.85 2.85a.5.5 0 00-.7-.7L14.48 4.8a4.04 4.04 0 00-5.33.34l-.3.3a1.49 1.49 0 000 2.1l3.6 3.6c.58.59 1.52.59 2.1 0l.3-.3a4.04 4.04 0 00.34-5.33l2.66-2.67zm-4 7.6c-.2.19-.5.19-.7 0l-3.6-3.6c-.19-.2-.19-.5 0-.7l.3-.3a3.04 3.04 0 014.3 4.3l-.3.3zm-6.3-1.6a1.49 1.49 0 00-2.1 0l-.3.3a4.04 4.04 0 00-.34 5.33l-2.66 2.67a.5.5 0 00.7.7l2.67-2.66a4.04 4.04 0 005.33-.34l.3-.3c.59-.58.59-1.52 0-2.1l-3.6-3.6zm-1.4.7c.2-.19.5-.19.7 0l3.6 3.6c.19.2.19.5 0 .7l-.3.3a3.04 3.04 0 11-4.3-4.3l.3-.3z",
    fill: primaryFill
  }));
};

export const PlugConnectedRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PlugConnectedRegularIcon({}), 'PlugConnectedRegular');

const PlugConnectedAddFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17.78 3.28a.75.75 0 00-1.06-1.06l-2.45 2.45a4.04 4.04 0 00-5.12.48l-.3.3a1.49 1.49 0 000 2.1l2.46 2.47a5.48 5.48 0 014.55-.85 4.04 4.04 0 00-.53-3.44l2.45-2.45zM7.55 8.85l2.47 2.46a5.48 5.48 0 00-.85 4.55 4.04 4.04 0 01-3.44-.53l-2.45 2.45a.75.75 0 01-1.06-1.06l2.45-2.45a4.04 4.04 0 01.48-5.12l.3-.3a1.49 1.49 0 012.1 0zm9.45 9.4a4.5 4.5 0 11-5-7.5 4.5 4.5 0 015 7.5zm-2.15-6.1a.5.5 0 00-.85.35V14h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V15h1.5a.5.5 0 000-1H15v-1.5a.5.5 0 00-.15-.35z",
    fill: primaryFill
  }));
};

export const PlugConnectedAddFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PlugConnectedAddFilledIcon({}), 'PlugConnectedAddFilled');

const PlugConnectedAddRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17.96 2.3a.5.5 0 00-.82-.15l-2.7 2.7a4.04 4.04 0 00-5.33.33l-.6.61a1.05 1.05 0 000 1.49l2.76 2.76c.28-.2.58-.37.89-.52L9.52 6.88a.5.5 0 010-.7l.3-.3a3.03 3.03 0 014.29 0v.02a3.04 3.04 0 01.73 3.11c.34.02.68.07 1 .16a4.03 4.03 0 00-.69-3.62l2.7-2.7a.5.5 0 00.11-.54zM7.28 8.5l2.77 2.77c-.2.28-.38.57-.53.88L6.9 9.52a.49.49 0 00-.7 0l-.3.3a3.04 3.04 0 000 4.29h.01a3.03 3.03 0 003.11.73c.02.34.07.68.15 1a4.03 4.03 0 01-3.6-.69l-2.7 2.7a.5.5 0 11-.71-.7l2.7-2.7a4.03 4.03 0 01.33-5.34l.3-.3.31-.31a1.05 1.05 0 011.49 0zM17 18.24a4.5 4.5 0 11-5-7.48 4.5 4.5 0 015 7.48zm-2.15-6.1a.5.5 0 00-.85.36V14h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V15h1.5a.5.5 0 000-1H15v-1.5a.5.5 0 00-.15-.35z",
    fill: primaryFill
  }));
};

export const PlugConnectedAddRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PlugConnectedAddRegularIcon({}), 'PlugConnectedAddRegular');

const PlugConnectedCheckmarkFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17.78 3.28a.75.75 0 00-1.06-1.06l-2.45 2.45a4.04 4.04 0 00-5.12.48l-.3.3a1.49 1.49 0 000 2.1l2.46 2.47a5.48 5.48 0 014.55-.85 4.04 4.04 0 00-.53-3.44l2.45-2.45zM7.55 8.85l2.47 2.46a5.48 5.48 0 00-.85 4.55 4.04 4.04 0 01-3.44-.53l-2.45 2.45a.75.75 0 01-1.06-1.06l2.45-2.45a4.04 4.04 0 01.48-5.12l.3-.3a1.49 1.49 0 012.1 0zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.15-1.85a.5.5 0 00-.7 0l-2.65 2.64-.65-.64a.5.5 0 00-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 000-.7z",
    fill: primaryFill
  }));
};

export const PlugConnectedCheckmarkFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PlugConnectedCheckmarkFilledIcon({}), 'PlugConnectedCheckmarkFilled');

const PlugConnectedCheckmarkRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17.85 2.85a.5.5 0 00-.7-.7L14.48 4.8a4.04 4.04 0 00-5.33.34l-.3.3a1.49 1.49 0 000 2.1l2.46 2.47c.28-.2.58-.38.9-.52L9.55 6.85c-.19-.2-.19-.5 0-.7l.3-.3a3.04 3.04 0 015.01 3.16c.35.02.68.08 1 .16.37-1.23.15-2.6-.67-3.65l2.66-2.67zm-10.3 6l2.47 2.46c-.2.28-.38.58-.52.9L6.85 9.55c-.2-.19-.5-.19-.7 0l-.3.3a3.04 3.04 0 003.16 5.01c.02.35.08.68.16 1-1.23.37-2.6.15-3.65-.67l-2.67 2.66a.5.5 0 01-.7-.7l2.66-2.67a4.04 4.04 0 01.34-5.33l.3-.3a1.49 1.49 0 012.1 0zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.15-1.85a.5.5 0 00-.7 0l-2.65 2.64-.65-.64a.5.5 0 00-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 000-.7z",
    fill: primaryFill
  }));
};

export const PlugConnectedCheckmarkRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PlugConnectedCheckmarkRegularIcon({}), 'PlugConnectedCheckmarkRegular');

const PlugDisconnectedFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17.78 2.22c.3.3.3.77 0 1.06l-1.45 1.45a4.04 4.04 0 01-.48 5.12l-.3.3-.3.31c-.42.41-1.08.41-1.5 0L9.55 6.24a1.05 1.05 0 010-1.48l.6-.61a4.05 4.05 0 015.13-.48l1.45-1.45c.3-.3.77-.3 1.06 0zm-9 6.25c.3.3.3.77 0 1.06L7.51 10.8l1.69 1.7 1.27-1.28a.75.75 0 111.06 1.06l-1.28 1.28c.48.58.45 1.45-.1 2l-.3.3a4.04 4.04 0 01-5.12.47l-1.45 1.45a.75.75 0 01-1.06-1.06l1.45-1.45a4.04 4.04 0 01.48-5.12l.3-.3a1.49 1.49 0 012-.1l1.27-1.28c.3-.3.77-.3 1.06 0z",
    fill: primaryFill
  }));
};

export const PlugDisconnectedFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PlugDisconnectedFilledIcon({}), 'PlugDisconnectedFilled');

const PlugDisconnectedRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17.85 2.15c.2.2.2.5 0 .7L16.2 4.52a4.04 4.04 0 01-.34 5.33l-.3.3-.3.31c-.42.41-1.08.41-1.5 0L9.55 6.24a1.05 1.05 0 010-1.48l.6-.61a4.04 4.04 0 015.34-.34l1.67-1.66c.2-.2.5-.2.7 0zm-2.71 2.7a3.04 3.04 0 00-4.29 0l-.3.3c-.19.2-.19.5 0 .7l3.6 3.6c.2.19.5.19.7 0l.3-.3a3.04 3.04 0 000-4.29l-.01-.01zm-5.79 3.8c.2.2.2.5 0 .7L7.71 11 9 12.3l1.65-1.65a.5.5 0 01.7.7L9.71 13l.44.45c.59.58.59 1.52 0 2.1l-.3.3a4.04 4.04 0 01-5.33.34l-1.67 1.66a.5.5 0 01-.7-.7l1.66-1.67a4.04 4.04 0 01.34-5.33l.3-.3a1.49 1.49 0 012.1 0l.45.44 1.65-1.64c.2-.2.5-.2.7 0zm-4.5 6.5a3.04 3.04 0 004.3 0l.3-.3c.19-.2.19-.5 0-.7l-3.6-3.6c-.2-.19-.5-.19-.7 0l-.3.3a3.04 3.04 0 000 4.3z",
    fill: primaryFill
  }));
};

export const PlugDisconnectedRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PlugDisconnectedRegularIcon({}), 'PlugDisconnectedRegular');

const PointScanFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9 2.5a.5.5 0 00-1 0v4.02A5 5 0 003.52 11H8V6.52a5.07 5.07 0 011 0V2.5zM2.5 11h1.02a5.06 5.06 0 000 1H2.5a.5.5 0 010-1zM8 17.5v-1.02a5.07 5.07 0 001 0v1.02a.5.5 0 01-1 0zm5.48-5.5h4.02a.5.5 0 000-1h-4.02a5.07 5.07 0 010 1H9v4.48A5 5 0 0013.48 12zM8 16.48A5 5 0 013.52 12H8v4.48zM9 11h4.48A5 5 0 009 6.52V11z",
    fill: primaryFill
  }));
};

export const PointScanFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PointScanFilledIcon({}), 'PointScanFilled');

const PointScanRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.5 2c.28 0 .5.22.5.5v4.02A5 5 0 0113.48 11h4.02a.5.5 0 010 1h-4.02A5 5 0 019 16.48v1.02a.5.5 0 01-1 0v-1.02A5 5 0 013.52 12H2.5a.5.5 0 010-1h1.02A5 5 0 018 6.52V2.5c0-.28.22-.5.5-.5zM4.53 12A4 4 0 008 15.47V12H4.53zM8 11V7.53A4 4 0 004.53 11H8zm1 1v3.47A4 4 0 0012.47 12H9zm3.47-1A4 4 0 009 7.53V11h3.47z",
    fill: primaryFill
  }));
};

export const PointScanRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PointScanRegularIcon({}), 'PointScanRegular');

const PollFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2a2 2 0 00-2 2v12a2 2 0 104 0V4a2 2 0 00-2-2zm-6 8a2 2 0 00-2 2v4a2 2 0 104 0v-4a2 2 0 00-2-2zm12-4a2 2 0 00-2 2v8a2 2 0 104 0V8a2 2 0 00-2-2z",
    fill: primaryFill
  }));
};

export const PollFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PollFilledIcon({}), 'PollFilled');

const PollRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8 4a2 2 0 114 0v12a2 2 0 11-4 0V4zm2-1a1 1 0 00-1 1v12a1 1 0 102 0V4a1 1 0 00-1-1zm-8 9a2 2 0 114 0v4a2 2 0 11-4 0v-4zm2-1a1 1 0 00-1 1v4a1 1 0 102 0v-4a1 1 0 00-1-1zm12-5a2 2 0 00-2 2v8a2 2 0 104 0V8a2 2 0 00-2-2zm-1 2a1 1 0 112 0v8a1 1 0 11-2 0V8z",
    fill: primaryFill
  }));
};

export const PollRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PollRegularIcon({}), 'PollRegular');

const PortHdmiFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.85 7.44A1.5 1.5 0 015.91 7h8.18c.4 0 .78.16 1.06.44l2.41 2.41c.28.28.44.67.44 1.06v.59c0 .83-.67 1.5-1.5 1.5h-13A1.5 1.5 0 012 11.5v-.59c0-.4.16-.78.44-1.06l2.41-2.41zM6.5 9.5a.5.5 0 000 1h7a.5.5 0 000-1h-7z",
    fill: primaryFill
  }));
};

export const PortHdmiFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PortHdmiFilledIcon({}), 'PortHdmiFilled');

const PortHdmiRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.85 7.44A1.5 1.5 0 015.91 7h8.18c.4 0 .78.16 1.06.44l2.41 2.41c.28.28.44.67.44 1.06v.59c0 .83-.67 1.5-1.5 1.5h-13A1.5 1.5 0 012 11.5v-.59c0-.4.16-.78.44-1.06l2.41-2.41zM5.91 8a.5.5 0 00-.35.15l-2.41 2.41a.5.5 0 00-.15.35v.59c0 .28.22.5.5.5h13a.5.5 0 00.5-.5v-.59a.5.5 0 00-.15-.35l-2.41-2.41a.5.5 0 00-.35-.15H5.9zM6 10c0-.28.22-.5.5-.5h7a.5.5 0 010 1h-7A.5.5 0 016 10z",
    fill: primaryFill
  }));
};

export const PortHdmiRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PortHdmiRegularIcon({}), 'PortHdmiRegular');

const PortUsbAFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.5 7C3.67 7 3 7.67 3 8.5v3c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5v-3c0-.83-.67-1.5-1.5-1.5h-11zm0 1.5h11V10h-11V8.5z",
    fill: primaryFill
  }));
};

export const PortUsbAFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PortUsbAFilledIcon({}), 'PortUsbAFilled');

const PortUsbARegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.5 7C3.67 7 3 7.67 3 8.5v3c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5v-3c0-.83-.67-1.5-1.5-1.5h-11zM4 8.5c0-.28.22-.5.5-.5h11c.28 0 .5.22.5.5V10H4V8.5z",
    fill: primaryFill
  }));
};

export const PortUsbARegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PortUsbARegularIcon({}), 'PortUsbARegular');

const PositionBackwardFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 4.5A2.5 2.5 0 014.5 2h6A2.5 2.5 0 0113 4.5V6H9.5A3.5 3.5 0 006 9.5V13H4.5A2.5 2.5 0 012 10.5v-6zM9.5 7A2.5 2.5 0 007 9.5v6A2.5 2.5 0 009.5 18h6a2.5 2.5 0 002.5-2.5v-6A2.5 2.5 0 0015.5 7h-6zM8 9.5C8 8.67 8.67 8 9.5 8h6c.83 0 1.5.67 1.5 1.5v6c0 .83-.67 1.5-1.5 1.5h-6A1.5 1.5 0 018 15.5v-6z",
    fill: primaryFill
  }));
};

export const PositionBackwardFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PositionBackwardFilledIcon({}), 'PositionBackwardFilled');

const PositionBackwardRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.5 2A2.5 2.5 0 002 4.5v6A2.5 2.5 0 004.5 13H6v-1.7l-.7.7h-.8a1.5 1.5 0 01-.65-.15L6 9.71V9.5c0-.57.14-1.11.38-1.59l-3.23 3.24A1.5 1.5 0 013 10.5v-.94L9.56 3h.94c.23 0 .45.05.65.15L7.9 6.38A3.49 3.49 0 019.5 6h.2l2.15-2.15c.1.2.15.42.15.65v.8l-.7.7H13V4.5A2.5 2.5 0 0010.5 2h-6zM3 4.5C3 3.67 3.67 3 4.5 3h.65L3 5.15V4.5zm0 2.06L6.56 3h1.59L3 8.15V6.56zM7 9.5A2.5 2.5 0 019.5 7h6A2.5 2.5 0 0118 9.5v6a2.5 2.5 0 01-2.5 2.5h-6A2.5 2.5 0 017 15.5v-6zM9.5 8C8.67 8 8 8.67 8 9.5v6c0 .83.67 1.5 1.5 1.5h6c.83 0 1.5-.67 1.5-1.5v-6c0-.83-.67-1.5-1.5-1.5h-6z",
    fill: primaryFill
  }));
};

export const PositionBackwardRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PositionBackwardRegularIcon({}), 'PositionBackwardRegular');

const PositionForwardFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7 14v1.5A2.5 2.5 0 009.5 18h6a2.5 2.5 0 002.5-2.5v-6A2.5 2.5 0 0015.5 7H14v1h1.5c.83 0 1.5.67 1.5 1.5v6c0 .83-.67 1.5-1.5 1.5h-6A1.5 1.5 0 018 15.5V14H7zM2 4.5A2.5 2.5 0 014.5 2h6A2.5 2.5 0 0113 4.5v6a2.5 2.5 0 01-2.5 2.5h-6A2.5 2.5 0 012 10.5v-6z",
    fill: primaryFill
  }));
};

export const PositionForwardFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PositionForwardFilledIcon({}), 'PositionForwardFilled');

const PositionForwardRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7 14v1.5A2.5 2.5 0 009.5 18h6a2.5 2.5 0 002.5-2.5v-6A2.5 2.5 0 0015.5 7H14v1h1.5c.83 0 1.5.67 1.5 1.5v6c0 .83-.67 1.5-1.5 1.5h-6A1.5 1.5 0 018 15.5V14H7zM2 4.5A2.5 2.5 0 014.5 2h6A2.5 2.5 0 0113 4.5v6a2.5 2.5 0 01-2.5 2.5h-6A2.5 2.5 0 012 10.5v-6zM4.5 3C3.67 3 3 3.67 3 4.5v.65L5.15 3H4.5zm2.06 0L3 6.56v1.59L8.15 3H6.56zM3 10.5c0 .23.05.45.15.65l8-8A1.5 1.5 0 0010.5 3h-.94L3 9.56v.94zM4.5 12h.8L12 5.3v-.8c0-.23-.05-.45-.15-.65l-8 8c.2.1.42.15.65.15zm5.2 0h.8c.83 0 1.5-.67 1.5-1.5v-.8L9.7 12zm-1.4 0L12 8.3V6.7L6.7 12h1.6z",
    fill: primaryFill
  }));
};

export const PositionForwardRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PositionForwardRegularIcon({}), 'PositionForwardRegular');

const PositionToBackFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12 14c0-1.1.9-2 2-2h3a2 2 0 012 2v3a2 2 0 01-2 2h-3a2 2 0 01-2-2v-3zm2-1a1 1 0 00-1 1v3a1 1 0 001 1h3a1 1 0 001-1v-3a1 1 0 00-1-1h-3zM5 9h1.3C7.8 9 9 7.8 9 6.3V5h3.5A2.5 2.5 0 0115 7.5V11h-1.3a2.7 2.7 0 00-2.7 2.7V15H7.5A2.5 2.5 0 015 12.5V9zM1 3c0-1.1.9-2 2-2h3a2 2 0 012 2v3a2 2 0 01-2 2H3a2 2 0 01-2-2V3zm2-1a1 1 0 00-1 1v3a1 1 0 001 1h3a1 1 0 001-1V3a1 1 0 00-1-1H3z",
    fill: primaryFill
  }));
};

export const PositionToBackFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PositionToBackFilledIcon({}), 'PositionToBackFilled');

const PositionToBackRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12 14c0-1.1.9-2 2-2h3a2 2 0 012 2v3a2 2 0 01-2 2h-3a2 2 0 01-2-2v-3zm2-1a1 1 0 00-1 1v3a1 1 0 001 1h3a1 1 0 001-1v-3a1 1 0 00-1-1h-3zM5 9v3.5A2.5 2.5 0 007.5 15H11v-1H9.7l1.67-1.66c.23-.4.57-.74.97-.97L14 9.7V11h1V7.5A2.5 2.5 0 0012.5 5H9v1h1.3L8.62 7.66c-.23.4-.57.74-.97.97L6 10.3V9H5zm6.7-3h.8c.23 0 .45.05.65.15l-7 7A1.5 1.5 0 016 12.5v-.8L11.7 6zm-4.2 8a1.5 1.5 0 01-.65-.15l7-7c.1.2.15.42.15.65v.8L8.3 14h-.8zM1 3c0-1.1.9-2 2-2h3a2 2 0 012 2v3a2 2 0 01-2 2H3a2 2 0 01-2-2V3zm2-1a1 1 0 00-1 1v3a1 1 0 001 1h3a1 1 0 001-1V3a1 1 0 00-1-1H3z",
    fill: primaryFill
  }));
};

export const PositionToBackRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PositionToBackRegularIcon({}), 'PositionToBackRegular');

const PositionToFrontFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M1 3c0-1.1.9-2 2-2h3a2 2 0 012 2v1h-.5c-.17 0-.34.01-.5.04V3a1 1 0 00-1-1H3a1 1 0 00-1 1v3a1 1 0 001 1h1.04C4 7.16 4 7.33 4 7.5V8H3a2 2 0 01-2-2V3zm11 13v1c0 1.1.9 2 2 2h3a2 2 0 002-2v-3a2 2 0 00-2-2h-1v.5c0 .17-.01.34-.04.5H17a1 1 0 011 1v3a1 1 0 01-1 1h-3a1 1 0 01-1-1v-1.04c-.16.03-.33.04-.5.04H12zM5 7.5A2.5 2.5 0 017.5 5h5A2.5 2.5 0 0115 7.5v5a2.5 2.5 0 01-2.5 2.5h-5A2.5 2.5 0 015 12.5v-5z",
    fill: primaryFill
  }));
};

export const PositionToFrontFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PositionToFrontFilledIcon({}), 'PositionToFrontFilled');

const PositionToFrontRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 1a2 2 0 00-2 2v3c0 1.1.9 2 2 2h1v-.5c0-.17.01-.34.04-.5H3a1 1 0 01-1-1V3a1 1 0 011-1h3a1 1 0 011 1v1.04C7.16 4 7.33 4 7.5 4H8V3a2 2 0 00-2-2H3zm9 16v-1h.5c.17 0 .34-.01.5-.04V17a1 1 0 001 1h3a1 1 0 001-1v-3a1 1 0 00-1-1h-1.04c.03-.16.04-.33.04-.5V12h1a2 2 0 012 2v3a2 2 0 01-2 2h-3a2 2 0 01-2-2zM5 7.5A2.5 2.5 0 017.5 5h5A2.5 2.5 0 0115 7.5v5a2.5 2.5 0 01-2.5 2.5h-5A2.5 2.5 0 015 12.5v-5zm2.28-1.48a1.5 1.5 0 00-1.26 1.26l1.26-1.26zM6 10.29L10.3 6H8.7L6 8.7v1.6zM11.7 6L6 11.7v.8c0 .23.05.45.15.65l7-7A1.5 1.5 0 0012.5 6h-.8zm-4.2 8h.8L14 8.3v-.8c0-.23-.05-.45-.15-.65l-7 7c.2.1.42.15.65.15zm2.2 0h1.6l2.7-2.7V9.7L9.7 14zm3.02-.02a1.5 1.5 0 001.26-1.26l-1.26 1.26z",
    fill: primaryFill
  }));
};

export const PositionToFrontRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PositionToFrontRegularIcon({}), 'PositionToFrontRegular');

const PowerFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.75 2.5a.75.75 0 00-1.5 0v6a.75.75 0 001.5 0v-6zm3 1.5a.75.75 0 10-.76 1.3A6 6 0 117 5.3.75.75 0 106.25 4a7.5 7.5 0 107.5 0z",
    fill: primaryFill
  }));
};

export const PowerFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PowerFilledIcon({}), 'PowerFilled');

const PowerRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.5 2.5a.5.5 0 00-1 0v6a.5.5 0 001 0v-6zM13.74 4a.5.5 0 10-.5.87 6.5 6.5 0 11-6.49 0 .5.5 0 10-.5-.87 7.5 7.5 0 107.5 0z",
    fill: primaryFill
  }));
};

export const PowerRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PowerRegularIcon({}), 'PowerRegular');

const PredictionsFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.5 1c.28 0 .5.22.5.5 0 .46.07 1.22.47 1.84.38.6 1.08 1.14 2.53 1.14a.5.5 0 110 1 3.5 3.5 0 00-1.82.73A2.77 2.77 0 0015 8.45a.5.5 0 01-.5.5.5.5 0 01-.5-.5c0-.5-.16-1.26-.6-1.88-.44-.6-1.16-1.1-2.4-1.1a.5.5 0 01-.5-.5c0-.27.22-.5.5-.5.51 0 1.25 0 1.87-.36.57-.33 1.13-1 1.13-2.61 0-.28.22-.5.5-.5zM6.15 12.17l-.94 3.4c-.17.61.08 1.34.74 1.63 1.64.73 4.65 1.35 7.97.01a1.43 1.43 0 00.82-1.75l-.98-3.23a6.5 6.5 0 01-7.61-.06zm6.77-9.84c-.04.22-.1.38-.16.5a.97.97 0 01-.4.42c-.34.2-.82.23-1.36.23a1.5 1.5 0 100 2.98c.91 0 1.34.35 1.58.7.3.4.42.95.42 1.3a1.5 1.5 0 001.61 1.48A5.5 5.5 0 014.5 6.96a5.48 5.48 0 018.42-4.63z",
    fill: primaryFill
  }));
};

export const PredictionsFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PredictionsFilledIcon({}), 'PredictionsFilled');

const PredictionsRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.5 1c.28 0 .5.22.5.5 0 .46.07 1.22.47 1.84.38.6 1.08 1.14 2.53 1.14a.5.5 0 110 1 3.5 3.5 0 00-1.82.73A2.77 2.77 0 0015 8.45a.5.5 0 01-.5.5.5.5 0 01-.5-.5c0-.5-.16-1.26-.6-1.88-.44-.6-1.16-1.1-2.4-1.1a.5.5 0 01-.5-.5c0-.27.22-.5.5-.5.51 0 1.25 0 1.87-.36.57-.33 1.13-1 1.13-2.61 0-.28.22-.5.5-.5zm.04 2.73a2.95 2.95 0 01-1.33 1.33 3.53 3.53 0 011.33 1.48 4.2 4.2 0 011.52-1.44 3.22 3.22 0 01-1.52-1.37zm-7.26 6.8A4.46 4.46 0 0110 2.5c.9 0 1.74.26 2.44.72a.99.99 0 00.32-.38c.06-.12.12-.28.16-.5A5.5 5.5 0 004.5 6.96c0 1.67.75 3.16 1.93 4.16l-1.22 4.44c-.17.62.08 1.35.74 1.64 1.64.73 4.65 1.35 7.97.01a1.43 1.43 0 00.82-1.75l-1.26-4.17a.49.49 0 00-.03-.07c.45-.36.85-.8 1.16-1.28a1.53 1.53 0 01-1.01-.3 4.5 4.5 0 01-6.32.89zm5.3 1.26l1.2 3.96c.07.24-.05.46-.23.54a9.36 9.36 0 01-7.19 0c-.14-.06-.24-.24-.18-.47l1.12-4.1a5.5 5.5 0 005.28.07z",
    fill: primaryFill
  }));
};

export const PredictionsRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PredictionsRegularIcon({}), 'PredictionsRegular');

const PremiumFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 2.75a.75.75 0 00-.66.39l-2.75 5c-.15.27-.11.6.08.84l7.25 8.75a.75.75 0 001.16 0l7.25-8.75c.2-.24.23-.57.08-.84l-2.75-5a.75.75 0 00-.66-.39h-9zM4.16 7.5l1.78-3.25h1.5L6.31 7.5H4.16zM6.14 9l1.93 4.75L4.14 9h2zM10 14.48L7.76 9h4.39l-2.16 5.48zM7.89 7.5l1.14-3.25h1.95l1.2 3.25H7.88zm5.88 0l-1.2-3.25h1.49l1.78 3.25h-2.07zm0 1.5h2.1l-4.01 4.83L13.76 9z",
    fill: primaryFill
  }));
};

export const PremiumFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PremiumFilledIcon({}), 'PremiumFilled');

const PremiumRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 3a.5.5 0 00-.43.24l-3 5a.5.5 0 00.05.58l7.5 9a.5.5 0 00.76 0l7.5-9a.5.5 0 00.05-.58l-3-5A.5.5 0 0014.5 3h-9zM3.38 8l2.4-4h1.98l-1.6 4H3.38zm2.78 1l2.26 5.83L3.57 9h2.59zM10 16.12L7.23 9h5.54L10 16.12zM7.24 8l1.6-4h2.32l1.6 4H7.24zm6.6 0l-1.6-4h1.98l2.4 4h-2.78zm0 1h2.6l-4.86 5.83L13.84 9z",
    fill: primaryFill
  }));
};

export const PremiumRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PremiumRegularIcon({}), 'PremiumRegular');

const PremiumPersonFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 2.75a.75.75 0 00-.66.39l-2.75 5c-.15.27-.11.6.08.84l7.25 8.75a.75.75 0 001.16 0l.48-.59a3.27 3.27 0 01-.06-.64c0-1.3 1-2.38 2.27-2.49a2.99 2.99 0 01.17-4.19l.32-.82h4.05l.02-.02c.2-.24.23-.57.08-.84l-2.75-5a.75.75 0 00-.66-.39h-9zM4.16 7.5l1.78-3.25h1.5L6.31 7.5H4.16zM6.14 9l1.93 4.75L4.14 9h2zM10 14.48L7.76 9h4.39l-2.16 5.48zM7.89 7.5l1.14-3.25h1.95l1.2 3.25H7.88zm5.88 0l-1.2-3.25h1.49l1.78 3.25h-2.07zM17.5 12a2 2 0 11-4 0 2 2 0 014 0zm1.5 4.5c0 1.25-1 2.5-3.5 2.5S12 17.75 12 16.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5z",
    fill: primaryFill
  }));
};

export const PremiumPersonFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PremiumPersonFilledIcon({}), 'PremiumPersonFilled');

const PremiumPersonRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 3a.5.5 0 00-.43.24l-3 5a.5.5 0 00.05.58l7.49 9a.5.5 0 00.86-.13L13.84 9h3.9l.14-.18a.5.5 0 00.05-.58l-3-5A.5.5 0 0014.5 3h-9zm7.27 6L10 16.12 7.23 9h5.54zM3.38 8l2.4-4h1.98l-1.6 4H3.38zm2.78 1l2.26 5.83L3.57 9h2.59zm1.08-1l1.6-4h2.32l1.6 4H7.24zm6.6 0l-1.6-4h1.98l2.4 4h-2.78zm1.66 6a2 2 0 100-4 2 2 0 000 4zm0 5c2.5 0 3.5-1.25 3.5-2.5 0-.83-.67-1.5-1.5-1.5h-4c-.83 0-1.5.67-1.5 1.5 0 1.25 1 2.5 3.5 2.5z",
    fill: primaryFill
  }));
};

export const PremiumPersonRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PremiumPersonRegularIcon({}), 'PremiumPersonRegular');

const PresenceAvailableFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 20a10 10 0 100-20 10 10 0 000 20zm4.2-11.8l-4.5 4.5a1 1 0 01-1.4 0l-2-2a1 1 0 111.4-1.4L9 10.58l3.8-3.8a1 1 0 111.4 1.42z",
    fill: primaryFill
  }));
};

export const PresenceAvailableFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PresenceAvailableFilledIcon({}), 'PresenceAvailableFilled');

const PresenceAvailableRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 0a10 10 0 100 20 10 10 0 000-20zM2 10a8 8 0 1116 0 8 8 0 01-16 0zm12.2-3.2a1 1 0 010 1.4l-4.5 4.5a1 1 0 01-1.4 0l-2-2a1 1 0 011.4-1.4L9 10.58l3.8-3.8a1 1 0 011.4 0z",
    fill: primaryFill
  }));
};

export const PresenceAvailableRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PresenceAvailableRegularIcon({}), 'PresenceAvailableRegular');

const PresenceAwayFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 20a10 10 0 100-20 10 10 0 000 20zm0-14V9.6l2.7 2.7a1 1 0 01-1.4 1.42l-3-3A1 1 0 018 10V6a1 1 0 112 0z",
    fill: primaryFill
  }));
};

export const PresenceAwayFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PresenceAwayFilledIcon({}), 'PresenceAwayFilled');

const PresenceBlockedRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M20 10a10 10 0 10-20 0 10 10 0 0020 0zm-2 0a8 8 0 01-12.9 6.32L16.31 5.09A7.97 7.97 0 0118 10zm-3.1-6.32L3.69 14.91A8 8 0 0114.91 3.68z",
    fill: primaryFill
  }));
};

export const PresenceBlockedRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PresenceBlockedRegularIcon({}), 'PresenceBlockedRegular');

const PresenceBusyFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M20 10a10 10 0 11-20 0 10 10 0 0120 0z",
    fill: primaryFill
  }));
};

export const PresenceBusyFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PresenceBusyFilledIcon({}), 'PresenceBusyFilled');

const PresenceDndFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 20a10 10 0 100-20 10 10 0 000 20zM7 9h6a1 1 0 110 2H7a1 1 0 110-2z",
    fill: primaryFill
  }));
};

export const PresenceDndFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PresenceDndFilledIcon({}), 'PresenceDndFilled');

const PresenceDndRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 0a10 10 0 100 20 10 10 0 000-20zM2 10a8 8 0 1116 0 8 8 0 01-16 0zm4 0a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1z",
    fill: primaryFill
  }));
};

export const PresenceDndRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PresenceDndRegularIcon({}), 'PresenceDndRegular');

const PresenceOfflineRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13.7 6.3a1 1 0 010 1.4L11.42 10l2.3 2.3a1 1 0 01-1.42 1.4L10 11.42l-2.3 2.3a1 1 0 01-1.4-1.42L8.58 10l-2.3-2.3a1 1 0 011.42-1.4L10 8.58l2.3-2.3a1 1 0 011.4 0zM0 10a10 10 0 1120 0 10 10 0 01-20 0zm10-8a8 8 0 100 16 8 8 0 000-16z",
    fill: primaryFill
  }));
};

export const PresenceOfflineRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PresenceOfflineRegularIcon({}), 'PresenceOfflineRegular');

const PresenceOofRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.7 7.7A1 1 0 109.28 6.3l-3 3a1 1 0 000 1.41l3 3a1 1 0 101.42-1.41l-1.3-1.3H13a1 1 0 100-2H9.4l1.3-1.29zM10 0a10 10 0 100 20 10 10 0 000-20zM2 10a8 8 0 1116 0 8 8 0 01-16 0z",
    fill: primaryFill
  }));
};

export const PresenceOofRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PresenceOofRegularIcon({}), 'PresenceOofRegular');

const PresenceUnknownRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2a8 8 0 100 16 8 8 0 000-16zM0 10a10 10 0 1120 0 10 10 0 01-20 0z",
    fill: primaryFill
  }));
};

export const PresenceUnknownRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PresenceUnknownRegularIcon({}), 'PresenceUnknownRegular');

const PresenterFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12 4a2 2 0 11-4 0 2 2 0 014 0zM7 14.78v1.72c0 .83.67 1.5 1.5 1.5h3c.83 0 1.5-.67 1.5-1.5v-1.72a.5.5 0 01.15-.36l3.7-3.56a.5.5 0 00-.34-.86H3.49a.5.5 0 00-.35.86l3.7 3.56c.1.1.16.23.16.36zM8.5 7C7.67 7 7 7.67 7 8.5V9h6v-.5c0-.83-.67-1.5-1.5-1.5h-3z",
    fill: primaryFill
  }));
};

export const PresenterFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PresenterFilledIcon({}), 'PresenterFilled');

const PresenterRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 6a2 2 0 100-4 2 2 0 000 4zm0-1a1 1 0 110-2 1 1 0 010 2zM8.5 8a.5.5 0 00-.5.5V9H7v-.5C7 7.67 7.67 7 8.5 7h3c.83 0 1.5.67 1.5 1.5V9h-1v-.5a.5.5 0 00-.5-.5h-3zM7 14.78v1.72c0 .83.67 1.5 1.5 1.5h3c.83 0 1.5-.67 1.5-1.5v-1.72a.5.5 0 01.15-.36l3.7-3.56a.5.5 0 00-.34-.86H3.49a.5.5 0 00-.35.86l3.7 3.56c.1.1.16.23.16.36zm1 1.72v-1.72c0-.4-.17-.8-.46-1.08L4.74 11h10.53l-2.81 2.7c-.3.29-.46.68-.46 1.08v1.72a.5.5 0 01-.5.5h-3a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const PresenterRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PresenterRegularIcon({}), 'PresenterRegular');

const PresenterOffFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.15 7.85c-.1.2-.15.42-.15.65V9h1.3l1 1H3.5a.5.5 0 00-.36.86l3.7 3.56c.1.1.16.23.16.36v1.72c0 .83.67 1.5 1.5 1.5h3c.83 0 1.5-.67 1.5-1.5v-1.72a.5.5 0 01.15-.36l.29-.27 3.7 3.7a.5.5 0 00.71-.7l-10-10-5-5a.5.5 0 10-.7.7l5 5zm9.7 3.01l-1.97 1.9L12.12 10h4.39a.5.5 0 01.35.86zM13 9h-1.88l-2-2h2.38c.83 0 1.5.67 1.5 1.5V9zm-3-3a2 2 0 100-4 2 2 0 000 4z",
    fill: primaryFill
  }));
};

export const PresenterOffFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PresenterOffFilledIcon({}), 'PresenterOffFilled');

const PresenterOffRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7 8.5c0-.23.05-.45.15-.65l-5-5a.5.5 0 11.7-.7l15 15a.5.5 0 01-.7.7l-3.71-3.7-.29.27a.5.5 0 00-.15.36v1.72c0 .83-.67 1.5-1.5 1.5h-3A1.5 1.5 0 017 16.5v-1.72a.5.5 0 00-.15-.36l-3.7-3.56a.5.5 0 01.34-.86h5.8l-1-1H7v-.5zm3.3 2.5H4.72l2.81 2.7c.3.29.46.68.46 1.08v1.72c0 .28.22.5.5.5h3a.5.5 0 00.5-.5v-1.72c0-.4.17-.8.46-1.08l.27-.26L10.3 11zM12 4a2 2 0 11-4 0 2 2 0 014 0zm-1 0a1 1 0 10-2 0 1 1 0 002 0zm-.88 4h1.38c.28 0 .5.22.5.5V9h1v-.5c0-.83-.67-1.5-1.5-1.5H9.12l1 1zm4.76 4.76l-.7-.7L15.26 11h-2.15l-1-1h4.39a.5.5 0 01.35.86l-1.98 1.9z",
    fill: primaryFill
  }));
};

export const PresenterOffRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PresenterOffRegularIcon({}), 'PresenterOffRegular');

const PreviewLinkFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 6v2h10V6H5zm7 5v3h3v-3h-3zM2 5.75A2.75 2.75 0 014.75 3h10.5A2.75 2.75 0 0118 5.75v8.5A2.75 2.75 0 0115.25 17H4.75A2.75 2.75 0 012 14.25v-8.5zm2-.25v3c0 .27.22.5.5.5h11a.5.5 0 00.5-.5v-3a.5.5 0 00-.5-.5h-11a.5.5 0 00-.5.5zm7 5v4c0 .28.22.5.5.5h4a.5.5 0 00.5-.5v-4a.5.5 0 00-.5-.5h-4a.5.5 0 00-.5.5zm-6.5 0a.5.5 0 000 1h5a.5.5 0 000-1h-5zM4 14c0 .28.22.5.5.5h5a.5.5 0 000-1h-5a.5.5 0 00-.5.5z",
    fill: primaryFill
  }));
};

export const PreviewLinkFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PreviewLinkFilledIcon({}), 'PreviewLinkFilled');

const PreviewLinkRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 5.5c0-.28.22-.5.5-.5h11c.28 0 .5.22.5.5v3a.5.5 0 01-.5.5h-11a.5.5 0 01-.5-.5v-3zM5 6v2h10V6H5zm6.5 4a.5.5 0 00-.5.5v4c0 .28.22.5.5.5h4a.5.5 0 00.5-.5v-4a.5.5 0 00-.5-.5h-4zm.5 4v-3h3v3h-3zm-8-3c0-.28.22-.5.5-.5h5a.5.5 0 010 1h-5A.5.5 0 014 11zm.5 2.5a.5.5 0 000 1h5a.5.5 0 000-1h-5zM2 5.5A2.5 2.5 0 014.5 3h11A2.5 2.5 0 0118 5.5v9a2.5 2.5 0 01-2.5 2.5h-11A2.5 2.5 0 012 14.5v-9zM4.5 4C3.67 4 3 4.67 3 5.5v9c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5v-9c0-.83-.67-1.5-1.5-1.5h-11z",
    fill: primaryFill
  }));
};

export const PreviewLinkRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PreviewLinkRegularIcon({}), 'PreviewLinkRegular');

const PreviousFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 4.25c0-1-1.12-1.6-1.95-1.04l-8.5 5.71c-.73.5-.73 1.57 0 2.07l8.5 5.8c.83.56 1.95-.03 1.95-1.04V4.25zM3 3.5a.5.5 0 011 0v13a.5.5 0 01-1 0v-13z",
    fill: primaryFill
  }));
};

export const PreviousFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PreviousFilledIcon({}), 'PreviousFilled');

const PreviousRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 3.5a.5.5 0 011 0v13a.5.5 0 01-1 0v-13zm14 .75c0-1-1.12-1.6-1.95-1.04l-8.5 5.71c-.73.5-.73 1.57 0 2.07l8.5 5.8c.83.56 1.95-.03 1.95-1.04V4.25zm-1.39-.2c.17-.12.39 0 .39.2v11.5c0 .2-.22.32-.4.2l-8.49-5.78a.25.25 0 010-.42l8.5-5.7z",
    fill: primaryFill
  }));
};

export const PreviousRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PreviousRegularIcon({}), 'PreviousRegular');

const PrintFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 4.5C5 3.67 5.67 3 6.5 3h7c.83 0 1.5.67 1.5 1.5V5h.5A2.5 2.5 0 0118 7.5v5c0 .83-.67 1.5-1.5 1.5H15v1.5c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 015 15.5V14H3.5A1.5 1.5 0 012 12.5v-5A2.5 2.5 0 014.5 5H5v-.5zm9 0a.5.5 0 00-.5-.5h-7a.5.5 0 00-.5.5V5h8v-.5zm-8 7v4c0 .28.22.5.5.5h7a.5.5 0 00.5-.5v-4a.5.5 0 00-.5-.5h-7a.5.5 0 00-.5.5z",
    fill: primaryFill
  }));
};

export const PrintFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PrintFilledIcon({}), 'PrintFilled');

const PrintRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 4.5C5 3.67 5.67 3 6.5 3h7c.83 0 1.5.67 1.5 1.5V5h.5A2.5 2.5 0 0118 7.5v5c0 .83-.67 1.5-1.5 1.5H15v1.5c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 015 15.5V14H3.5A1.5 1.5 0 012 12.5v-5A2.5 2.5 0 014.5 5H5v-.5zM6 5h8v-.5a.5.5 0 00-.5-.5h-7a.5.5 0 00-.5.5V5zm-1 8v-1.5c0-.83.67-1.5 1.5-1.5h7c.83 0 1.5.67 1.5 1.5V13h1.5a.5.5 0 00.5-.5v-5c0-.83-.67-1.5-1.5-1.5h-11C3.67 6 3 6.67 3 7.5v5c0 .28.22.5.5.5H5zm1.5-2a.5.5 0 00-.5.5v4c0 .28.22.5.5.5h7a.5.5 0 00.5-.5v-4a.5.5 0 00-.5-.5h-7z",
    fill: primaryFill
  }));
};

export const PrintRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PrintRegularIcon({}), 'PrintRegular');

const PrintAddFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M19 5.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V5h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V6h1.5a.5.5 0 000-1H15V3.5zm-.5 7.5c1.33 0 2.55-.47 3.5-1.26v3.76c0 .83-.67 1.5-1.5 1.5H15v1.5c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 015 16.5V15H3.5A1.5 1.5 0 012 13.5v-5A2.5 2.5 0 014.5 6H5v-.5C5 4.67 5.67 4 6.5 4h2.7c-.08.32-.15.66-.18 1H6.5a.5.5 0 00-.5.5V6h3.02c.26 2.8 2.61 5 5.48 5zM6 12.5v4c0 .28.22.5.5.5h7a.5.5 0 00.5-.5v-4a.5.5 0 00-.5-.5h-7a.5.5 0 00-.5.5z",
    fill: primaryFill
  }));
};

export const PrintAddFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PrintAddFilledIcon({}), 'PrintAddFilled');

const PrintAddRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M19 5.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V5h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V6h1.5a.5.5 0 000-1H15V3.5zm2 10v-3.1c.36-.18.7-.4 1-.66v3.76c0 .83-.67 1.5-1.5 1.5H15v1.5c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 015 16.5V15H3.5A1.5 1.5 0 012 13.5v-5A2.5 2.5 0 014.5 6H5v-.5C5 4.67 5.67 4 6.5 4h2.7c-.08.32-.15.66-.18 1H6.5a.5.5 0 00-.5.5V6h3.02c.03.34.1.68.19 1H4.5C3.67 7 3 7.67 3 8.5v5c0 .28.22.5.5.5H5v-1.5c0-.83.67-1.5 1.5-1.5h7c.83 0 1.5.67 1.5 1.5V14h1.5a.5.5 0 00.5-.5zM6.5 12a.5.5 0 00-.5.5v4c0 .28.22.5.5.5h7a.5.5 0 00.5-.5v-4a.5.5 0 00-.5-.5h-7z",
    fill: primaryFill
  }));
};

export const PrintAddRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PrintAddRegularIcon({}), 'PrintAddRegular');

const ProductionFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 3.5c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v3a.5.5 0 01-.5.5h-3a.5.5 0 01-.5-.5v-3zm6.5-.5a.5.5 0 00-.5.5v3c0 .28.22.5.5.5h3a.5.5 0 00.5-.5v-3a.5.5 0 00-.5-.5h-3zm.5 3V4h2v2h-2zM2 12a4 4 0 014-4h8a4 4 0 010 8H6a4 4 0 01-4-4zm5 0a1 1 0 10-2 0 1 1 0 002 0zm4 0a1 1 0 10-2 0 1 1 0 002 0zm3 1a1 1 0 100-2 1 1 0 000 2z",
    fill: primaryFill
  }));
};

export const ProductionFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ProductionFilledIcon({}), 'ProductionFilled');

const ProductionRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 3.5c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v3a.5.5 0 01-.5.5h-3a.5.5 0 01-.5-.5v-3zm6.5-.5a.5.5 0 00-.5.5v3c0 .28.22.5.5.5h3a.5.5 0 00.5-.5v-3a.5.5 0 00-.5-.5h-3zm.5 3V4h2v2h-2zm-6 7a1 1 0 100-2 1 1 0 000 2zm5-1a1 1 0 11-2 0 1 1 0 012 0zm3 1a1 1 0 100-2 1 1 0 000 2zM2 12a4 4 0 014-4h8a4 4 0 010 8H6a4 4 0 01-4-4zm4-3a3 3 0 100 6h8a3 3 0 100-6H6z",
    fill: primaryFill
  }));
};

export const ProductionRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ProductionRegularIcon({}), 'ProductionRegular');

const ProductionCheckmarkFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 3.5c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v3a.5.5 0 01-.5.5h-3a.5.5 0 01-.5-.5v-3zm6.5-.5a.5.5 0 00-.5.5v3c0 .28.22.5.5.5h3a.5.5 0 00.5-.5v-3a.5.5 0 00-.5-.5h-3zm.5 3V4h2v2h-2zM6 8a4 4 0 100 8h3.2a5.5 5.5 0 01.1-3.29A1 1 0 0110 11a1 1 0 01.23.03 5.49 5.49 0 017.1-1.25A4 4 0 0014 8H6zm0 5a1 1 0 110-2 1 1 0 010 2zm13 1.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.85-1.85l-2.65 2.64-.65-.64a.5.5 0 00-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 00-.7-.7z",
    fill: primaryFill
  }));
};

export const ProductionCheckmarkFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ProductionCheckmarkFilledIcon({}), 'ProductionCheckmarkFilled');

const ProductionCheckmarkRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 3.5c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v3a.5.5 0 01-.5.5h-3a.5.5 0 01-.5-.5v-3zm6.5-.5a.5.5 0 00-.5.5v3c0 .28.22.5.5.5h3a.5.5 0 00.5-.5v-3a.5.5 0 00-.5-.5h-3zm.5 3V4h2v2h-2zM2 12a4 4 0 014-4h8a4 4 0 013.33 1.78A5.47 5.47 0 0014 9H6a3 3 0 100 6h3.02c.03.34.1.68.19 1H6a4 4 0 01-4-4zm8-1a1 1 0 01.23.03 5.5 5.5 0 00-.93 1.68A1 1 0 0110 11zm-4 2a1 1 0 100-2 1 1 0 000 2zm13 1.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.85-1.85l-2.65 2.64-.65-.64a.5.5 0 00-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 00-.7-.7z",
    fill: primaryFill
  }));
};

export const ProductionCheckmarkRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ProductionCheckmarkRegularIcon({}), 'ProductionCheckmarkRegular');

const ProhibitedFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-1.5 0c0-1.52-.53-2.93-1.4-4.04L5.96 15.1A6.5 6.5 0 0016.5 10zM4.9 14.04l9.14-9.14a6.5 6.5 0 00-9.13 9.13z",
    fill: primaryFill
  }));
};

export const ProhibitedFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ProhibitedFilledIcon({}), 'ProhibitedFilled');

const ProhibitedRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-1 0c0-1.75-.64-3.36-1.7-4.58l-9.88 9.87A7 7 0 0017 10zM4.7 14.58l9.88-9.87a7 7 0 00-9.87 9.87z",
    fill: primaryFill
  }));
};

export const ProhibitedRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ProhibitedRegularIcon({}), 'ProhibitedRegular');

const ProhibitedMultipleFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9 2a7 7 0 110 14A7 7 0 019 2zm3.32 2.62a5.5 5.5 0 00-7.7 7.7l7.7-7.7zm1.06 1.06l-7.7 7.7a5.5 5.5 0 007.7-7.7zM9 17a8 8 0 007.75-10 7 7 0 01-9.74 9.74c.63.17 1.3.26 1.99.26z",
    fill: primaryFill
  }));
};

export const ProhibitedMultipleFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ProhibitedMultipleFilledIcon({}), 'ProhibitedMultipleFilled');

const ProhibitedMultipleRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 9a7 7 0 1114 0A7 7 0 012 9zm7-6a6 6 0 00-4.58 9.87l8.45-8.45A5.98 5.98 0 009 3zm0 12a6 6 0 004.58-9.87l-8.45 8.45A5.98 5.98 0 009 15zm2 3a6.97 6.97 0 01-4-1.25 8.01 8.01 0 003.07.18 6 6 0 006.86-6.86 8.07 8.07 0 00-.18-3.06A7 7 0 0111 18z",
    fill: primaryFill
  }));
};

export const ProhibitedMultipleRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ProhibitedMultipleRegularIcon({}), 'ProhibitedMultipleRegular');

const ProhibitedNoteFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M18 10.17A8.02 8.02 0 0010 2a8 8 0 00-.84 15.96A3 3 0 019 17v-.58a6.47 6.47 0 01-3.04-1.32l1.57-1.57 7.57-7.57A6.47 6.47 0 0116.5 10h.5a3 3 0 011 .17zM14.04 4.9L4.9 14.04a6.5 6.5 0 019.13-9.13zM10 13c0-1.1.9-2 2-2h5a2 2 0 012 2v4a2 2 0 01-2 2h-5a2 2 0 01-2-2v-4zm6.5 3h-4a.5.5 0 100 1h4a.5.5 0 100-1zm-4-3a.5.5 0 100 1h4a.5.5 0 100-1h-4z",
    fill: primaryFill
  }));
};

export const ProhibitedNoteFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ProhibitedNoteFilledIcon({}), 'ProhibitedNoteFilled');

const ProhibitedNoteRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M18 10v.17a3 3 0 00-1-.17c0-1.75-.64-3.36-1.7-4.58l-9.88 9.87A6.97 6.97 0 009 16.93V17a3 3 0 00.16.96A8 8 0 1118 10zM4.7 14.58l9.88-9.87a7 7 0 00-9.87 9.87zM12 11a2 2 0 00-2 2v4c0 1.1.9 2 2 2h5a2 2 0 002-2v-4a2 2 0 00-2-2h-5zm.5 5h4a.5.5 0 110 1h-4a.5.5 0 110-1zm-.5-2.5c0-.28.22-.5.5-.5h4a.5.5 0 110 1h-4a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const ProhibitedNoteRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ProhibitedNoteRegularIcon({}), 'ProhibitedNoteRegular');

const ProjectionScreenFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 3a1 1 0 000 2v6a3 3 0 003 3h3.5v2h-2a.5.5 0 000 1h5a.5.5 0 000-1h-2v-2H14a3 3 0 003-3V5a1 1 0 100-2H3z",
    fill: primaryFill
  }));
};

export const ProjectionScreenFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ProjectionScreenFilledIcon({}), 'ProjectionScreenFilled');

const ProjectionScreenRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 3a1 1 0 000 2v6a3 3 0 003 3h3.5v2h-2a.5.5 0 000 1h5a.5.5 0 000-1h-2v-2H14a3 3 0 003-3V5a1 1 0 100-2H3zm1 2h12v6a2 2 0 01-2 2H6a2 2 0 01-2-2V5z",
    fill: primaryFill
  }));
};

export const ProjectionScreenRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ProjectionScreenRegularIcon({}), 'ProjectionScreenRegular');

const ProjectionScreenDismissFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M19 5.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.65-1.15a.5.5 0 00-.7-.7L14.5 4.79l-1.15-1.14a.5.5 0 00-.7.7l1.14 1.15-1.14 1.15a.5.5 0 00.7.7l1.15-1.14 1.15 1.14a.5.5 0 00.7-.7L15.21 5.5l1.14-1.15zM14.5 11c.9 0 1.75-.22 2.5-.6v.6a3 3 0 01-3 3h-3.5v2h2a.5.5 0 010 1h-5a.5.5 0 010-1h2v-2H6a3 3 0 01-3-3V5a1 1 0 010-2h6.6a5.5 5.5 0 004.9 8z",
    fill: primaryFill
  }));
};

export const ProjectionScreenDismissFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ProjectionScreenDismissFilledIcon({}), 'ProjectionScreenDismissFilled');

const ProjectionScreenDismissRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M19 5.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.65-1.15a.5.5 0 00-.7-.7L14.5 4.79l-1.15-1.14a.5.5 0 00-.7.7l1.14 1.15-1.14 1.15a.5.5 0 00.7.7l1.15-1.14 1.15 1.14a.5.5 0 00.7-.7L15.21 5.5l1.14-1.15zM16 11v-.2c.35-.1.68-.24 1-.4v.6a3 3 0 01-3 3h-3.5v2h2a.5.5 0 010 1h-5a.5.5 0 010-1h2v-2H6a3 3 0 01-3-3V5a1 1 0 010-2h6.6a5.47 5.47 0 00-.58 2H4v6c0 1.1.9 2 2 2h8a2 2 0 002-2z",
    fill: primaryFill
  }));
};

export const ProjectionScreenDismissRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ProjectionScreenDismissRegularIcon({}), 'ProjectionScreenDismissRegular');

const ProtocolHandlerFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.59 5.41L2.4 8.6a2 2 0 000 2.82L5.6 14.6a2 2 0 002.82 0l3.18-3.18a2 2 0 000-2.82L8.4 5.4a2 2 0 00-2.82 0zm6 9.18l-.88-.88 1.58-1.59a3 3 0 000-4.24l-1.58-1.59.88-.88a2 2 0 012.82 0L17.6 8.6a2 2 0 010 2.82L14.4 14.6a2 2 0 01-2.82 0z",
    fill: primaryFill
  }));
};

export const ProtocolHandlerFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ProtocolHandlerFilledIcon({}), 'ProtocolHandlerFilled');

const ProtocolHandlerRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.59 5.41L2.4 8.6a2 2 0 000 2.82L5.6 14.6a2 2 0 002.82 0l3.18-3.18a2 2 0 000-2.82L8.4 5.4a2 2 0 00-2.82 0zM3.12 9.3L6.3 6.12a1 1 0 011.42 0l3.17 3.17a1 1 0 010 1.42L7.7 13.88a1 1 0 01-1.42 0L3.12 10.7a1 1 0 010-1.42zm8.47 5.3l-.88-.88.7-.71.88.88a1 1 0 001.42 0l3.17-3.17a1 1 0 000-1.42L13.7 6.12a1 1 0 00-1.42 0l-.88.88-.7-.7.88-.89a2 2 0 012.82 0L17.6 8.6a2 2 0 010 2.82L14.4 14.6a2 2 0 01-2.82 0z",
    fill: primaryFill
  }));
};

export const ProtocolHandlerRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ProtocolHandlerRegularIcon({}), 'ProtocolHandlerRegular');

const PulseFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.01 3c.33 0 .62.23.71.55l2.82 10.07 2.24-7.1a.75.75 0 011.4-.07L15.5 9.5h1.76a.75.75 0 010 1.5H15a.75.75 0 01-.69-.45l-.7-1.65-2.4 7.58a.75.75 0 01-1.43-.03L6.97 6.41l-1.25 4.06A.75.75 0 015 11H2.75a.75.75 0 010-1.5h1.7l1.83-5.97c.1-.32.4-.53.73-.53z",
    fill: primaryFill
  }));
};

export const PulseFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PulseFilledIcon({}), 'PulseFilled');

const PulseRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7 3a.5.5 0 01.48.37l3.05 11.3 2.5-8.31a.5.5 0 01.94-.04L15.35 10h2.15a.5.5 0 010 1H15a.5.5 0 01-.47-.32l-.98-2.62-2.57 8.58a.5.5 0 01-.96-.01L6.99 5.37l-1.5 5.27A.5.5 0 015 11H2.5a.5.5 0 010-1h2.12l1.9-6.64A.5.5 0 017 3z",
    fill: primaryFill
  }));
};

export const PulseRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PulseRegularIcon({}), 'PulseRegular');

const PulseSquareFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 5c0-1.1.9-2 2-2h10a2 2 0 012 2v10a2 2 0 01-2 2H5a2 2 0 01-2-2V5zm5.97 1.33a.5.5 0 00-.94 0L6.65 10H5.5a.5.5 0 000 1H7c.2 0 .4-.13.47-.32l1.02-2.73 2.04 5.72a.5.5 0 00.92.05L12.8 11h1.69a.5.5 0 000-1h-2a.5.5 0 00-.45.28l-.97 1.95-2.1-5.9z",
    fill: primaryFill
  }));
};

export const PulseSquareFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PulseSquareFilledIcon({}), 'PulseSquareFilled');

const PulseSquareRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.97 6.33a.5.5 0 00-.94 0L6.65 10H5.5a.5.5 0 000 1H7c.2 0 .4-.13.47-.32l1.02-2.73 2.04 5.72a.5.5 0 00.92.05L12.8 11h1.69a.5.5 0 000-1h-2a.5.5 0 00-.45.28l-.97 1.95-2.1-5.9zM5 3a2 2 0 00-2 2v10c0 1.1.9 2 2 2h10a2 2 0 002-2V5a2 2 0 00-2-2H5zM4 5a1 1 0 011-1h10a1 1 0 011 1v10a1 1 0 01-1 1H5a1 1 0 01-1-1V5z",
    fill: primaryFill
  }));
};

export const PulseSquareRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PulseSquareRegularIcon({}), 'PulseSquareRegular');

const PuzzleCubeFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13 17h1.5a2.5 2.5 0 002.5-2.5V13h-4v4zm0-5V8h4v4h-4zm-1 0H8V8h4v4zm-4 1h4v4H8v-4zm-1-1V8H3v4h4zm-4 1h4v4H5.5A2.5 2.5 0 013 14.5V13zm10-6h4V5.5A2.5 2.5 0 0014.5 3H13v4zm-1-4v4H8V3h4z",
    fill: primaryFill
  }));
};

export const PuzzleCubeFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PuzzleCubeFilledIcon({}), 'PuzzleCubeFilled');

const PuzzleCubeRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 14.5V7h4V3h7.5A2.5 2.5 0 0117 5.5v9a2.5 2.5 0 01-2.5 2.5h-9A2.5 2.5 0 013 14.5zM8 4v3h4V4H8zm5 0v3h3V5.5c0-.83-.67-1.5-1.5-1.5H13zm3 4h-3v4h3V8zm0 5h-3v3h1.5c.83 0 1.5-.67 1.5-1.5V13zm-4 3v-3H8v3h4zm-5 0v-3H4v1.5c0 .83.67 1.5 1.5 1.5H7zm-3-4h3V8H4v4zm8-4H8v4h4V8z",
    fill: primaryFill
  }));
};

export const PuzzleCubeRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PuzzleCubeRegularIcon({}), 'PuzzleCubeRegular');

const PuzzleCubePieceFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M15.8 1.29a1 1 0 011.4 0l1.51 1.5a1 1 0 010 1.42l-1.5 1.5a1 1 0 01-1.42 0l-1.5-1.5a1 1 0 010-1.42l1.5-1.5zM5.5 17H7v-4H3v1.5A2.5 2.5 0 005.5 17zM7 8v4H3V8h4zm5 4H8V8h4v4zm-4 1h4v4H8v-4zm5-5v4h4V8h-4zm0 5h4v1.5a2.5 2.5 0 01-2.5 2.5H13v-4zM3 7h4V3H5.5A2.5 2.5 0 003 5.5V7zm5 0V3h4v4H8z",
    fill: primaryFill
  }));
};

export const PuzzleCubePieceFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PuzzleCubePieceFilledIcon({}), 'PuzzleCubePieceFilled');

const PuzzleCubePieceRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17.2 1.29a1 1 0 00-1.4 0l-1.5 1.5a1 1 0 000 1.42l1.5 1.5a1 1 0 001.4 0l1.51-1.5a1 1 0 000-1.42l-1.5-1.5zM15 3.5L16.5 2 18 3.5 16.5 5 15 3.5zM13 3H5.5A2.5 2.5 0 003 5.5v9A2.5 2.5 0 005.5 17h9a2.5 2.5 0 002.5-2.5V7h-4V3zM5.36 16A1.5 1.5 0 014 14.5V13h3v3H5.36zM8 13h4v3H8v-3zm8 1.64A1.5 1.5 0 0114.5 16H13v-3h3V14.64zM8 8h4v4H8V8zm5 4V8h3v4h-3zM8 4h4v3H8V4zM5.5 4H7v3H4V5.36A1.5 1.5 0 015.5 4zM4 12V8h3v4H4z",
    fill: primaryFill
  }));
};

export const PuzzleCubePieceRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PuzzleCubePieceRegularIcon({}), 'PuzzleCubePieceRegular');

const PuzzlePieceFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11 2a2 2 0 012 2v.06h3a1 1 0 011 1V8h-1a2 2 0 00-2 1.85V10a2 2 0 001.85 2H17v3.06a1 1 0 01-1 1h-3v.09a2 2 0 01-4-.1H6a1 1 0 01-1-1V12a2 2 0 110-4V5.06a1 1 0 011-1h3V4c0-1.1.9-2 2-2z",
    fill: primaryFill
  }));
};

export const PuzzlePieceFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PuzzlePieceFilledIcon({}), 'PuzzlePieceFilled');

const PuzzlePieceRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11.1 2c-1.07.08-1.94.9-2.08 1.94V4H6.35A1.5 1.5 0 005 5.5v2.27h-.06A2.25 2.25 0 003 10v.16c.08 1.06.9 1.93 1.94 2.07H5v2.42A1.5 1.5 0 006.5 16h2.02v.06A2.25 2.25 0 0010.75 18h.16a2.25 2.25 0 002.07-1.94V16h2.52c.83 0 1.5-.67 1.5-1.5v-3.25h-1.87A1.25 1.25 0 0114 10v-.12c.06-.63.6-1.13 1.25-1.13H17V5.36A1.5 1.5 0 0015.5 4h-2.02v-.06A2.25 2.25 0 0011.25 2h-.15zm.15 1c.69 0 1.25.56 1.25 1.25V5h3l.1.01a.5.5 0 01.4.5v2.24h-.75c-1.17 0-2.15.9-2.24 2.07l-.01.16c0 1.2.9 2.17 2.07 2.26l.16.01H16v2.25a.5.5 0 01-.5.5H12v.75a1.25 1.25 0 01-2.5 0V15h-3a.5.5 0 01-.5-.5v-3.25h-.75a1.25 1.25 0 010-2.5H6V5.5c0-.27.23-.5.5-.5H10v-.75c0-.69.56-1.25 1.25-1.25z",
    fill: primaryFill
  }));
};

export const PuzzlePieceRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PuzzlePieceRegularIcon({}), 'PuzzlePieceRegular');

const PuzzlePieceShieldFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 15.06V12.7c.18.08.36.15.55.21.29.1.61.1.9 0a6.77 6.77 0 003.39-2.38A6.63 6.63 0 0011 6.58V4.04l-.02-.19v-.04A1.4 1.4 0 009.5 2.67 2 2 0 0113 4v.06h3a1 1 0 011 1V8h-1a2 2 0 00-2 1.85V10a2 2 0 001.85 2H17v3.06a1 1 0 01-1 1h-3v.09a2 2 0 01-4-.1H6a1 1 0 01-1-1zM8 3.35a4.06 4.06 0 001.6.32c.2 0 .35.14.4.33v2.58c0 2.69-1.31 4.51-3.87 5.4a.38.38 0 01-.26 0A6.66 6.66 0 014 11c-.39-.3-.72-.63-.99-1a5.5 5.5 0 01-1-3.15L2 6.58v-2.5a.4.4 0 01.4-.41 4.5 4.5 0 003.32-1.55.39.39 0 01.56 0C6.82 2.7 7.4 3.1 8 3.35z",
    fill: primaryFill
  }));
};

export const PuzzlePieceShieldFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PuzzlePieceShieldFilledIcon({}), 'PuzzlePieceShieldFilled');

const PuzzlePieceShieldRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 14.5v-1.79a9 9 0 00.54.21c.15.05.3.08.46.08v1.5c0 .28.22.5.5.5h3v.75a1.25 1.25 0 002.5 0V15h3.5a.5.5 0 00.5-.5v-2.25H15.06A2.25 2.25 0 0113 9.97v-.16a2.25 2.25 0 012.25-2.07H16V5.5a.5.5 0 00-.41-.49H12.5v-.76a1.25 1.25 0 00-1.85-1.1c-.24-.28-.59-.47-1-.48.37-.38.88-.63 1.44-.66l.16-.01c1.14 0 2.08.85 2.23 1.94V4h2.02c.78 0 1.42.6 1.5 1.36v3.39h-1.75c-.65 0-1.2.5-1.25 1.13V10c0 .65.5 1.2 1.13 1.24l.12.01H17v3.25c0 .83-.67 1.5-1.5 1.5h-2.52v.06a2.25 2.25 0 01-2.08 1.93l-.15.01a2.25 2.25 0 01-2.23-1.94V16H6.5A1.5 1.5 0 015 14.65v-.15zM8 3.35a4.06 4.06 0 001.6.32c.2 0 .35.14.4.33v2.58c0 2.69-1.31 4.51-3.87 5.4a.38.38 0 01-.26 0A6.66 6.66 0 014 11c-.39-.3-.72-.63-.99-1a5.5 5.5 0 01-1-3.15L2 6.58v-2.5a.4.4 0 01.4-.41 4.5 4.5 0 003.32-1.55.39.39 0 01.56 0C6.82 2.7 7.4 3.1 8 3.35z",
    fill: primaryFill
  }));
};

export const PuzzlePieceShieldRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PuzzlePieceShieldRegularIcon({}), 'PuzzlePieceShieldRegular');

const QrCodeFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13 11h-2v2h2v2h-2v2h2v-2h2v2h2v-2h-2v-2h2v-2h-2v2h-2v-2zM5 5h2v2H5V5zm0-2a2 2 0 00-2 2v2c0 1.1.9 2 2 2h2a2 2 0 002-2V5a2 2 0 00-2-2H5zm-.75 1.75c0-.28.22-.5.5-.5h2.5c.28 0 .5.22.5.5v2.5a.5.5 0 01-.5.5h-2.5a.5.5 0 01-.5-.5v-2.5zM5 13h2v2H5v-2zm0-2a2 2 0 00-2 2v2c0 1.1.9 2 2 2h2a2 2 0 002-2v-2a2 2 0 00-2-2H5zm-.75 1.75c0-.28.22-.5.5-.5h2.5c.28 0 .5.22.5.5v2.5a.5.5 0 01-.5.5h-2.5a.5.5 0 01-.5-.5v-2.5zM13 5h2v2h-2V5zm0-2a2 2 0 00-2 2v2c0 1.1.9 2 2 2h2a2 2 0 002-2V5a2 2 0 00-2-2h-2zm-.75 1.75c0-.28.22-.5.5-.5h2.5c.28 0 .5.22.5.5v2.5a.5.5 0 01-.5.5h-2.5a.5.5 0 01-.5-.5v-2.5z",
    fill: primaryFill
  }));
};

export const QrCodeFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/QrCodeFilledIcon({}), 'QrCodeFilled');

const QrCodeRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11 15h2v2h-2v-2zm4 0h2v2h-2v-2zm-4-4h2v2h-2v-2zm2 2h2v2h-2v-2zm2-2h2v2h-2v-2zM3 5c0-1.1.9-2 2-2h2a2 2 0 012 2v2a2 2 0 01-2 2H5a2 2 0 01-2-2V5zm2-1a1 1 0 00-1 1v2a1 1 0 001 1h2a1 1 0 001-1V5a1 1 0 00-1-1H5zm0 1h2v2H5V5zm-2 8c0-1.1.9-2 2-2h2a2 2 0 012 2v2a2 2 0 01-2 2H5a2 2 0 01-2-2v-2zm2-1a1 1 0 00-1 1v2a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 00-1-1H5zm0 1h2v2H5v-2zm6-8c0-1.1.9-2 2-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V5zm2-1a1 1 0 00-1 1v2a1 1 0 001 1h2a1 1 0 001-1V5a1 1 0 00-1-1h-2zm0 1h2v2h-2V5z",
    fill: primaryFill
  }));
};

export const QrCodeRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/QrCodeRegularIcon({}), 'QrCodeRegular');

const QuestionFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 3a4 4 0 00-4 4 .75.75 0 001.5 0A2.5 2.5 0 0110 4.5 2.5 2.5 0 0112.5 7c0 .6-.16.97-.37 1.27a5 5 0 01-.97.92c-.4.33-.9.73-1.28 1.3-.39.58-.63 1.3-.63 2.26v.5a.75.75 0 001.5 0v-.5c0-.67.16-1.1.38-1.43.23-.35.55-.62.97-.96l.06-.05c.38-.3.84-.67 1.2-1.17C13.74 8.6 14 7.9 14 7a4 4 0 00-4-4zm0 14a1 1 0 100-2 1 1 0 000 2z",
    fill: primaryFill
  }));
};

export const QuestionFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/QuestionFilledIcon({}), 'QuestionFilled');

const QuestionRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 3a4 4 0 00-4 4 .5.5 0 001 0 3 3 0 016 0c0 1.25-.7 1.86-1.58 2.62l-.03.03c-.86.73-1.89 1.62-1.89 3.35v.5a.5.5 0 001 0V13c0-1.25.7-1.86 1.58-2.62l.03-.03C12.97 9.62 14 8.73 14 7a4 4 0 00-4-4zm0 14a.75.75 0 100-1.5.75.75 0 000 1.5z",
    fill: primaryFill
  }));
};

export const QuestionRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/QuestionRegularIcon({}), 'QuestionRegular');

const QuestionCircleFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2a8 8 0 110 16 8 8 0 010-16zm0 11.5a.75.75 0 100 1.5.75.75 0 000-1.5zm0-8A2.5 2.5 0 007.5 8a.5.5 0 001 0 1.5 1.5 0 112.63.98l-.1.11-.12.1-.25.19A3.2 3.2 0 009.5 12a.5.5 0 001 0c0-.76.2-1.25.53-1.61l.08-.08.08-.07.09-.07.22-.17.15-.12A2.5 2.5 0 0010 5.5z",
    fill: primaryFill
  }));
};

export const QuestionCircleFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/QuestionCircleFilledIcon({}), 'QuestionCircleFilled');

const QuestionCircleRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2a8 8 0 110 16 8 8 0 010-16zm0 1a7 7 0 100 14 7 7 0 000-14zm0 10.5a.75.75 0 110 1.5.75.75 0 010-1.5zm0-8a2.5 2.5 0 011.65 4.38l-.15.12-.22.17-.09.07-.16.15c-.33.36-.53.85-.53 1.61a.5.5 0 01-1 0 3.2 3.2 0 011.16-2.62l.25-.19.12-.1A1.5 1.5 0 0010 6.5c-.83 0-1.5.67-1.5 1.5a.5.5 0 01-1 0A2.5 2.5 0 0110 5.5z",
    fill: primaryFill
  }));
};

export const QuestionCircleRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/QuestionCircleRegularIcon({}), 'QuestionCircleRegular');

const RadarFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.28 3.24l-1.09 1.1a6.5 6.5 0 101.4 10.26.75.75 0 011.07 1.06 8 8 0 11-1.38-12.42zm-3.3 3.3l1.17-1.17a5.1 5.1 0 101.46 8.24.75.75 0 10-1.06-1.06 3.6 3.6 0 11-1.56-6.01zm4.8-2.32c.3.3.3.77 0 1.06l-4.33 4.33a1.5 1.5 0 11-1.06-1.06l4.33-4.33c.3-.3.77-.3 1.06 0zm1.47 9.03a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM16.5 7.5a.75.75 0 100-1.5.75.75 0 000 1.5zm1.5 3.75a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm-.75-1.75a.75.75 0 100-1.5.75.75 0 000 1.5zM15 11.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm-.75-1.75a.75.75 0 100-1.5.75.75 0 000 1.5z",
    fill: primaryFill
  }));
};

export const RadarFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/RadarFilledIcon({}), 'RadarFilled');

const RadarRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.5 3.38l-.72.72a7 7 0 101.17 10.85.5.5 0 01.7.7A8 8 0 1114.5 3.39zm-2.94 2.94l.75-.75a5 5 0 101.23 7.97.5.5 0 10-.71-.71 4 4 0 11-1.27-6.51zm4.3-2.17c.19.2.19.5 0 .7l-4.9 4.9a1 1 0 11-.7-.72l4.89-4.88c.2-.2.5-.2.7 0zM17 13.5a.5.5 0 11-1 0 .5.5 0 011 0zM16.5 7a.5.5 0 100-1 .5.5 0 000 1zm1.5 4.25a.5.5 0 11-1 0 .5.5 0 011 0zm-.5-2a.5.5 0 100-1 .5.5 0 000 1zm-2.5 2a.5.5 0 11-1 0 .5.5 0 011 0zm-.5-2a.5.5 0 100-1 .5.5 0 000 1z",
    fill: primaryFill
  }));
};

export const RadarRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/RadarRegularIcon({}), 'RadarRegular');

const RadarCheckmarkFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.28 3.24l-1.09 1.1a6.5 6.5 0 00-9.66 5.02 5.5 5.5 0 00-1.53.9 8 8 0 0112.28-7.01zM9.75 18c.37-.46.67-.97.89-1.53a6.47 6.47 0 003.96-1.87.75.75 0 011.06 1.06A7.98 7.98 0 019.75 18zM11 14.5c0 .17 0 .34-.02.5a5.08 5.08 0 002.63-1.4.75.75 0 10-1.06-1.05c-.47.47-1.04.78-1.64.93.06.33.09.67.09 1.02zM5.5 9c.35 0 .69.03 1.02.1a3.58 3.58 0 014.47-2.56l1.16-1.17A5.1 5.1 0 005 9.02L5.5 9zm3 .9c.64.41 1.19.96 1.6 1.6a1.5 1.5 0 001.35-1.89l4.33-4.33a.75.75 0 00-1.06-1.06l-4.33 4.33A1.5 1.5 0 008.5 9.9zm8.75 3.35a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM16.5 7.5a.75.75 0 100-1.5.75.75 0 000 1.5zm1.5 3.75a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm-.75-1.75a.75.75 0 100-1.5.75.75 0 000 1.5zM15 11.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm-.75-1.75a.75.75 0 100-1.5.75.75 0 000 1.5zm-4.25 5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.15-1.85a.5.5 0 00-.7 0L4.5 15.29l-.65-.64a.5.5 0 00-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 000-.7z",
    fill: primaryFill
  }));
};

export const RadarCheckmarkFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/RadarCheckmarkFilledIcon({}), 'RadarCheckmarkFilled');

const RadarCheckmarkRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.5 3.38l-.72.72A7 7 0 003 9.6c-.36.18-.7.4-1 .65a8 8 0 0112.5-6.87zM9.75 18c.25-.31.47-.65.66-1.01a6.97 6.97 0 004.54-2.04.5.5 0 01.7.7A7.98 7.98 0 019.76 18zM11 14.5l-.01.4a4.98 4.98 0 002.55-1.36.5.5 0 10-.71-.71c-.54.53-1.18.88-1.86 1.05.02.2.03.41.03.62zM5.5 9l.62.03a3.98 3.98 0 015.44-2.71l.75-.75A5 5 0 005.1 9L5.5 9zm3.54 1.3c.24.2.46.42.67.66a1 1 0 001.26-1.22l4.88-4.89a.5.5 0 00-.7-.7l-4.9 4.88a1 1 0 00-1.2 1.26zM17 13.5a.5.5 0 11-1 0 .5.5 0 011 0zM16.5 7a.5.5 0 100-1 .5.5 0 000 1zm1.5 4.25a.5.5 0 11-1 0 .5.5 0 011 0zm-.5-2a.5.5 0 100-1 .5.5 0 000 1zm-2.5 2a.5.5 0 11-1 0 .5.5 0 011 0zm-.5-2a.5.5 0 100-1 .5.5 0 000 1zM10 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.15-1.85a.5.5 0 00-.7 0L4.5 15.29l-.65-.64a.5.5 0 00-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 000-.7z",
    fill: primaryFill
  }));
};

export const RadarCheckmarkRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/RadarCheckmarkRegularIcon({}), 'RadarCheckmarkRegular');

const RadarRectangleMultipleFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.28 3.24l-1.09 1.1A6.5 6.5 0 003.58 11H2.06a7.99 7.99 0 0112.22-7.76zM10 17v-.5c1.66 0 3.33-.63 4.6-1.9a.75.75 0 011.06 1.06A7.98 7.98 0 019.83 18a3 3 0 00.17-1zm0-2.5v.6c1.3 0 2.61-.5 3.6-1.5a.75.75 0 10-1.05-1.05 3.6 3.6 0 01-2.86 1.04c.2.25.31.57.31.91zM6.5 11h.04A3.6 3.6 0 0111 6.54l1.16-1.17A5.1 5.1 0 005 11h1.5zm9.28-6.78c.3.3.3.77 0 1.06l-4.33 4.33a1.5 1.5 0 11-1.06-1.06l4.33-4.33c.3-.3.77-.3 1.06 0zm1.47 9.03a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM16.5 7.5a.75.75 0 100-1.5.75.75 0 000 1.5zm1.5 3.75a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm-.75-1.75a.75.75 0 100-1.5.75.75 0 000 1.5zM15 11.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm-.75-1.75a.75.75 0 100-1.5.75.75 0 000 1.5zM1.5 12a.5.5 0 00-.5.5v4c0 .28.22.5.5.5h5a.5.5 0 00.5-.5v-4a.5.5 0 00-.5-.5h-5zm7 2c.28 0 .5.22.5.5V17a2 2 0 01-2 2H3.5a.5.5 0 010-1H7a1 1 0 001-1v-2.5c0-.28.22-.5.5-.5z",
    fill: primaryFill
  }));
};

export const RadarRectangleMultipleFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/RadarRectangleMultipleFilledIcon({}), 'RadarRectangleMultipleFilled');

const RadarRectangleMultipleRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.5 3.38l-.72.72A7 7 0 003.08 11H2.05A7.99 7.99 0 0114.5 3.38zM9.83 18a3 3 0 00.17-1c1.8 0 3.58-.68 4.95-2.05a.5.5 0 01.7.7A7.98 7.98 0 019.84 18zm.17-3.5v.5c1.28 0 2.56-.49 3.54-1.46a.5.5 0 10-.71-.71c-.8.8-1.86 1.2-2.92 1.17.06.16.09.32.09.5zM5.1 11h1.03a4 4 0 015.43-4.68l.75-.75A5 5 0 005.1 11zm10.75-6.85c.2.2.2.5 0 .7l-4.88 4.9a1 1 0 11-.71-.72l4.89-4.88c.2-.2.5-.2.7 0zM17 13.5a.5.5 0 11-1 0 .5.5 0 011 0zM16.5 7a.5.5 0 100-1 .5.5 0 000 1zm1.5 4.25a.5.5 0 11-1 0 .5.5 0 011 0zm-.5-2a.5.5 0 100-1 .5.5 0 000 1zm-2.5 2a.5.5 0 11-1 0 .5.5 0 011 0zm-.5-2a.5.5 0 100-1 .5.5 0 000 1zM1.5 12a.5.5 0 00-.5.5v4c0 .28.22.5.5.5h5a.5.5 0 00.5-.5v-4a.5.5 0 00-.5-.5h-5zm7 2c.28 0 .5.22.5.5V17a2 2 0 01-2 2H3.5a.5.5 0 010-1H7a1 1 0 001-1v-2.5c0-.28.22-.5.5-.5z",
    fill: primaryFill
  }));
};

export const RadarRectangleMultipleRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/RadarRectangleMultipleRegularIcon({}), 'RadarRectangleMultipleRegular');

const RadioButtonFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 15a5 5 0 100-10 5 5 0 000 10zm0-13a8 8 0 100 16 8 8 0 000-16zm-7 8a7 7 0 1114 0 7 7 0 01-14 0z",
    fill: primaryFill
  }));
};

export const RadioButtonFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/RadioButtonFilledIcon({}), 'RadioButtonFilled');

const RadioButtonRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 3a7 7 0 100 14 7 7 0 000-14zm-8 7a8 8 0 1116 0 8 8 0 01-16 0z",
    fill: primaryFill
  }));
};

export const RadioButtonRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/RadioButtonRegularIcon({}), 'RadioButtonRegular');

const RamFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 7h2.5v3H5V7zm6.5 0v3h-3V7h3zm1 3H15V7h-2.5v3zm3.54-6c.26 0 .5.05.74.16A2.06 2.06 0 0118 5.96V11a2 2 0 01-1 1.73v1.77a1.45 1.45 0 01-.44 1.05c-.13.14-.3.25-.48.33-.19.09-.38.13-.58.12h-4a.48.48 0 01-.35-.15L10 14.7l-1.15 1.15c-.1.1-.21.15-.35.15h-4a1.45 1.45 0 01-1.05-.44c-.14-.13-.25-.3-.33-.48A1.32 1.32 0 013 14.5v-1.77c-.3-.17-.55-.42-.73-.73A2.06 2.06 0 012 11V5.96c0-.26.05-.5.16-.74A2.06 2.06 0 013.96 4h12.08zm-.66 2.08A.95.95 0 0015 6H5a.85.85 0 00-.4.08c-.12.06-.22.13-.31.22A1 1 0 004 7v3c0 .15.03.28.08.4.04.12.12.22.2.31.1.09.21.16.33.21.12.05.25.08.39.08h10c.14 0 .27-.02.4-.08.12-.06.22-.13.31-.22A1 1 0 0016 10V7a1 1 0 00-.3-.71 1.1 1.1 0 00-.32-.21z",
    fill: primaryFill
  }));
};

export const RamFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/RamFilledIcon({}), 'RamFilled');

const RamRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M16.04 4c.26 0 .5.05.74.16A2.06 2.06 0 0118 5.96V11a2 2 0 01-1 1.73v1.77a1.45 1.45 0 01-.44 1.05c-.13.14-.3.25-.48.33-.19.09-.38.13-.58.12h-4a.48.48 0 01-.35-.15L10 14.7l-1.15 1.15c-.1.1-.21.15-.35.15h-4a1.45 1.45 0 01-1.05-.44c-.14-.13-.25-.3-.33-.48A1.32 1.32 0 013 14.5v-1.77c-.3-.17-.55-.42-.73-.73A2.06 2.06 0 012 11V5.96c0-.26.05-.5.16-.74A2.06 2.06 0 013.96 4h12.08zM17 6a.95.95 0 00-.08-.38 1.1 1.1 0 00-.2-.32A1 1 0 0016 5H3.99a.97.97 0 00-.7.29c-.1.09-.16.2-.22.32A.85.85 0 003 6v5c0 .14.03.27.08.4.05.11.12.22.2.31.1.1.2.16.32.21.12.05.25.07.4.08h12a.97.97 0 00.7-.29c.1-.09.16-.2.22-.32A.85.85 0 0017 11V6zm-2 0c.14 0 .26.03.38.08s.23.12.32.2A1 1 0 0116 7v3.01a.97.97 0 01-.29.7c-.09.1-.2.16-.32.22A.85.85 0 0115 11H5a.97.97 0 01-.4-.08 1.1 1.1 0 01-.31-.2.85.85 0 01-.21-.32A1.2 1.2 0 014 10V7a.97.97 0 01.29-.7c.09-.1.2-.16.32-.22A.85.85 0 015 6h10zM7.5 7H5v3h2.5V7zm4 3V7h-3v3h3zm1 0H15V7h-2.5v3zm3.5 3H4v1.5c0 .14.05.25.15.35.1.1.21.15.35.15h3.8l1.35-1.35c.1-.1.21-.15.35-.15.14 0 .25.05.35.15L11.71 15h3.79c.14 0 .25-.05.35-.15.1-.1.15-.21.15-.35V13z",
    fill: primaryFill
  }));
};

export const RamRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/RamRegularIcon({}), 'RamRegular');

const RatingMatureFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 6a3 3 0 013-3h8a3 3 0 013 3v8a3 3 0 01-3 3H6a3 3 0 01-3-3V6zm4.92 1.24A.5.5 0 007 7.5v5a.5.5 0 101 0V9.24l1.58 2.53a.5.5 0 00.84 0L12 9.24v3.26a.5.5 0 101 0v-5a.5.5 0 00-.92-.26L10 10.56 7.92 7.24z",
    fill: primaryFill
  }));
};

export const RatingMatureFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/RatingMatureFilledIcon({}), 'RatingMatureFilled');

const RatingMatureRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.92 7.24A.5.5 0 007 7.5v5a.5.5 0 101 0V9.24l1.58 2.53a.5.5 0 00.84 0L12 9.24v3.26a.5.5 0 101 0v-5a.5.5 0 00-.92-.26L10 10.56 7.92 7.24zM6 3a3 3 0 00-3 3v8a3 3 0 003 3h8a3 3 0 003-3V6a3 3 0 00-3-3H6zM4 6c0-1.1.9-2 2-2h8a2 2 0 012 2v8a2 2 0 01-2 2H6a2 2 0 01-2-2V6z",
    fill: primaryFill
  }));
};

export const RatingMatureRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/RatingMatureRegularIcon({}), 'RatingMatureRegular');

const RatioOneToOneFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.75 4A2.75 2.75 0 002 6.75v6.5A2.75 2.75 0 004.75 16h10.5A2.75 2.75 0 0018 13.25v-6.5A2.75 2.75 0 0015.25 4H4.75zM7 7.5v5a.5.5 0 01-1 0V8.3l-.28.15a.5.5 0 11-.44-.9l1-.5A.5.5 0 017 7.5zm7 0v5a.5.5 0 11-1 0V8.3l-.28.15a.5.5 0 11-.44-.9l1-.5a.5.5 0 01.72.45zm-4 1a.5.5 0 11-1 0 .5.5 0 011 0zM9.5 12a.5.5 0 110-1 .5.5 0 010 1z",
    fill: primaryFill
  }));
};

export const RatioOneToOneFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/RatioOneToOneFilledIcon({}), 'RatioOneToOneFilled');

const RatioOneToOneRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.76 7.07c.15.1.24.26.24.43v5a.5.5 0 01-1 0V8.3l-.28.15a.5.5 0 11-.44-.9l1-.5a.5.5 0 01.48.02zM14 7.5a.5.5 0 00-.72-.45l-1 .5a.5.5 0 10.44.9L13 8.3v4.19a.5.5 0 001 0v-5zm-4 1a.5.5 0 11-1 0 .5.5 0 011 0zM9.5 12a.5.5 0 100-1 .5.5 0 000 1zM2 6.75A2.75 2.75 0 014.75 4h10.5A2.75 2.75 0 0118 6.75v6.5A2.75 2.75 0 0115.25 16H4.75A2.75 2.75 0 012 13.25v-6.5zM4.75 5C3.78 5 3 5.78 3 6.75v6.5c0 .97.78 1.75 1.75 1.75h10.5c.97 0 1.75-.78 1.75-1.75v-6.5C17 5.78 16.22 5 15.25 5H4.75z",
    fill: primaryFill
  }));
};

export const RatioOneToOneRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/RatioOneToOneRegularIcon({}), 'RatioOneToOneRegular');

const ReOrderDotsHorizontalFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14 6.5a1.5 1.5 0 103 0 1.5 1.5 0 00-3 0zm-5 0a1.5 1.5 0 103 0 1.5 1.5 0 00-3 0zM5.5 8a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm8.5 5.5a1.5 1.5 0 103 0 1.5 1.5 0 00-3 0zM10.5 15a1.5 1.5 0 110-3 1.5 1.5 0 010 3zM4 13.5a1.5 1.5 0 103 0 1.5 1.5 0 00-3 0z",
    fill: primaryFill
  }));
};

export const ReOrderDotsHorizontalFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ReOrderDotsHorizontalFilledIcon({}), 'ReOrderDotsHorizontalFilled');

const ReOrderDotsHorizontalRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M15 7a1 1 0 102 0 1 1 0 00-2 0zM9 7a1 1 0 102 0 1 1 0 00-2 0zM4 8a1 1 0 110-2 1 1 0 010 2zm11 5a1 1 0 102 0 1 1 0 00-2 0zm-5 1a1 1 0 110-2 1 1 0 010 2zm-7-1a1 1 0 102 0 1 1 0 00-2 0z",
    fill: primaryFill
  }));
};

export const ReOrderDotsHorizontalRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ReOrderDotsHorizontalRegularIcon({}), 'ReOrderDotsHorizontalRegular');

const ReOrderDotsVerticalFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.5 6a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm0 5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM8 14.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM13.5 6a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM15 9.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM13.5 16a1.5 1.5 0 100-3 1.5 1.5 0 000 3z",
    fill: primaryFill
  }));
};

export const ReOrderDotsVerticalFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ReOrderDotsVerticalFilledIcon({}), 'ReOrderDotsVerticalFilled');

const ReOrderDotsVerticalRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7 5a1 1 0 100-2 1 1 0 000 2zm0 6a1 1 0 100-2 1 1 0 000 2zm1 5a1 1 0 11-2 0 1 1 0 012 0zm5-11a1 1 0 100-2 1 1 0 000 2zm1 5a1 1 0 11-2 0 1 1 0 012 0zm-1 7a1 1 0 100-2 1 1 0 000 2z",
    fill: primaryFill
  }));
};

export const ReOrderDotsVerticalRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ReOrderDotsVerticalRegularIcon({}), 'ReOrderDotsVerticalRegular');

const ReadAloudFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11.84 2.14c.2-.36.66-.5 1.02-.3a9.94 9.94 0 015.39 8.08.75.75 0 11-1.5.16 8.45 8.45 0 00-4.6-6.92.75.75 0 01-.3-1.02zM8.7 4.22a.75.75 0 00-1.38 0l-4.5 11a.75.75 0 001.38.56l1.45-3.53h4.72l1.45 3.53a.75.75 0 001.38-.56l-4.5-11zm1.06 6.53h-3.5L8 6.48l1.75 4.27zm2.62-6.4a.75.75 0 00-.74 1.3c1.52.87 2.4 2.4 2.63 3.96a.75.75 0 101.48-.22 6.92 6.92 0 00-3.37-5.04z",
    fill: primaryFill
  }));
};

export const ReadAloudFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ReadAloudFilledIcon({}), 'ReadAloudFilled');

const ReadAloudRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12.06 2.26a.5.5 0 01.68-.2A9.7 9.7 0 0118 9.94a.5.5 0 01-1 .12 8.7 8.7 0 00-4.74-7.12.5.5 0 01-.2-.68zm-3.6 2.05a.5.5 0 00-.92 0l-4.5 11a.5.5 0 10.92.38l1.54-3.76V12h5v-.07l1.54 3.76a.5.5 0 10.92-.38l-4.5-11zM10.12 11H5.88L8 5.82 10.12 11zm2.13-6.43a.5.5 0 00-.5.86 5.67 5.67 0 012.76 4.14.5.5 0 00.98-.14 6.67 6.67 0 00-3.24-4.86z",
    fill: primaryFill
  }));
};

export const ReadAloudRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ReadAloudRegularIcon({}), 'ReadAloudRegular');

const ReadingListFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.5 5.5a1 1 0 011.84-.56.75.75 0 001.24-.83A2.5 2.5 0 104.6 8h10.67a.75.75 0 000-1.5H4.5a1 1 0 01-1-1zM9.75 4a.75.75 0 000 1.5h7.5a.75.75 0 000-1.5h-7.5zm-4 5a.75.75 0 000 1.5h11.5a.75.75 0 100-1.5H5.75zM2 12.25c0-.41.34-.75.75-.75h12.5a.75.75 0 010 1.5H2.75a.75.75 0 01-.75-.75zM5.75 14a.75.75 0 000 1.5h11.5a.75.75 0 100-1.5H5.75z",
    fill: primaryFill
  }));
};

export const ReadingListFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ReadingListFilledIcon({}), 'ReadingListFilled');

const ReadingListRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 6.25a1.25 1.25 0 012.3-.7.5.5 0 10.82-.55 2.25 2.25 0 10-1.74 3.5H15.5a.5.5 0 000-1H4.38a.5.5 0 00-.06 0A1.25 1.25 0 013 6.25zM8.5 5a.5.5 0 000 1h9a.5.5 0 000-1h-9zm-3 5a.5.5 0 000 1h12a.5.5 0 000-1h-12zM2 13c0-.28.22-.5.5-.5h12a.5.5 0 010 1h-12A.5.5 0 012 13zm3.5 2a.5.5 0 000 1h12a.5.5 0 100-1h-12z",
    fill: primaryFill
  }));
};

export const ReadingListRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ReadingListRegularIcon({}), 'ReadingListRegular');

const ReadingListAddFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.5 5.5a1 1 0 011.84-.56.75.75 0 001.24-.83A2.5 2.5 0 104.6 8h10.67a.75.75 0 000-1.5H4.5a1 1 0 01-1-1zM9.75 4a.75.75 0 000 1.5h7.5a.75.75 0 000-1.5h-7.5zm-4 5a.75.75 0 000 1.5h4.98A5.48 5.48 0 0114.5 9H5.75zm-3 2.5h7.14c-.3.46-.53.96-.68 1.5H2.75a.75.75 0 010-1.5zm3 2.5h3.27a5.57 5.57 0 00.07 1.5H5.75a.75.75 0 010-1.5zm13.25.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V14h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 101 0V15h1.5a.5.5 0 100-1H15v-1.5z",
    fill: primaryFill
  }));
};

export const ReadingListAddFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ReadingListAddFilledIcon({}), 'ReadingListAddFilled');

const ReadingListAddRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 5.25a1.25 1.25 0 012.3-.7.5.5 0 10.82-.55 2.25 2.25 0 10-1.74 3.5H15.5a.5.5 0 000-1H4.38a.5.5 0 00-.06 0A1.25 1.25 0 013 5.25zM8.5 4a.5.5 0 000 1h9a.5.5 0 000-1h-9zm-3 5a.5.5 0 000 1h5.84c.9-.63 1.98-1 3.16-1h-9zm-3 2.5h7.39c-.2.31-.38.65-.52 1H2.5a.5.5 0 010-1zm3 2.5h3.52a5.57 5.57 0 000 1H5.5a.5.5 0 010-1zm13.5.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V14h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V15h1.5a.5.5 0 000-1H15v-1.5z",
    fill: primaryFill
  }));
};

export const ReadingListAddRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ReadingListAddRegularIcon({}), 'ReadingListAddRegular');

const ReadingModeMobileFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 3.5C4 2.67 4.67 2 5.5 2h9c.83 0 1.5.67 1.5 1.5v13c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 014 16.5v-13zm2 3c0 .28.22.5.5.5h7a.5.5 0 000-1h-7a.5.5 0 00-.5.5zM6.5 8a.5.5 0 000 1h7a.5.5 0 000-1h-7zM6 10.5c0 .28.22.5.5.5h4a.5.5 0 000-1h-4a.5.5 0 00-.5.5z",
    fill: primaryFill
  }));
};

export const ReadingModeMobileFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ReadingModeMobileFilledIcon({}), 'ReadingModeMobileFilled');

const ReadingModeMobileRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.5 6a.5.5 0 000 1h7a.5.5 0 000-1h-7zM6 8.5c0-.28.22-.5.5-.5h7a.5.5 0 010 1h-7a.5.5 0 01-.5-.5zm.5 1.5a.5.5 0 000 1h4a.5.5 0 000-1h-4zM4 3.5C4 2.67 4.67 2 5.5 2h9c.83 0 1.5.67 1.5 1.5v13c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 014 16.5v-13zM5.5 3a.5.5 0 00-.5.5v13c0 .28.22.5.5.5h9a.5.5 0 00.5-.5v-13a.5.5 0 00-.5-.5h-9z",
    fill: primaryFill
  }));
};

export const ReadingModeMobileRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ReadingModeMobileRegularIcon({}), 'ReadingModeMobileRegular');

const RealEstateFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 3a1 1 0 012 0h13a1 1 0 110 2H4v12.5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5V3zm3 3.5c0-.28.22-.5.5-.5h11c.28 0 .5.22.5.5v7a2.5 2.5 0 01-2.5 2.5h-7A2.5 2.5 0 015 13.5v-7zm3 7c0 .28.22.5.5.5h1a.5.5 0 00.5-.5v-1c0-.28.22-.5.5-.5h1c.28 0 .5.22.5.5v1c0 .28.22.5.5.5h1a.5.5 0 00.5-.5v-2.55a1 1 0 00-.34-.75l-2.33-2.07a.5.5 0 00-.66 0L8.34 10.2a1 1 0 00-.34.75v2.55z",
    fill: primaryFill
  }));
};

export const RealEstateFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/RealEstateFilledIcon({}), 'RealEstateFilled');

const RealEstateRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.5 2C2.67 2 2 2.67 2 3.5v13.75c0 .41.34.75.75.75h1.5c.41 0 .75-.34.75-.75v-2.01c.53.47 1.23.76 2 .76h7a3 3 0 003-3V6v-.08A1.5 1.5 0 0016.5 3H4.91c-.2-.58-.76-1-1.41-1zM16 6v7a2 2 0 01-2 2H7a2 2 0 01-2-2V6h11zm.5-1H4v12H3V3.5a.5.5 0 011 0V4h12.5a.5.5 0 010 1zm-9 5.45V13c0 .28.22.5.5.5h1a.5.5 0 00.5-.5v-1c0-.27.22-.5.5-.5h1c.28 0 .5.23.5.5v1c0 .28.22.5.5.5h1a.5.5 0 00.5-.5v-2.55a1 1 0 00-.34-.74l-2.33-2.08a.5.5 0 00-.66 0L7.84 9.71a1 1 0 00-.34.74z",
    fill: primaryFill
  }));
};

export const RealEstateRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/RealEstateRegularIcon({}), 'RealEstateRegular');

const ReceiptFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 5c0-1.1.9-2 2-2h7a2 2 0 012 2v7h3v2a3 3 0 01-3 3H6a3 3 0 01-3-3V5zm11 11a2 2 0 002-2v-1h-2v3zM6.5 6a.5.5 0 000 1h4a.5.5 0 000-1h-4zm0 3a.5.5 0 000 1h4a.5.5 0 000-1h-4zm0 3a.5.5 0 000 1h2a.5.5 0 000-1h-2z",
    fill: primaryFill
  }));
};

export const ReceiptFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ReceiptFilledIcon({}), 'ReceiptFilled');

const ReceiptRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 5c0-1.1.9-2 2-2h7a2 2 0 012 2v7h3v2a3 3 0 01-3 3H6a3 3 0 01-3-3V5zm11 8v3a2 2 0 002-2v-1h-2zm-1 3V5a1 1 0 00-1-1H5a1 1 0 00-1 1v9c0 1.1.9 2 2 2h7zM6 6.5c0-.28.22-.5.5-.5h4a.5.5 0 010 1h-4a.5.5 0 01-.5-.5zm0 3c0-.28.22-.5.5-.5h4a.5.5 0 010 1h-4a.5.5 0 01-.5-.5zm0 3c0-.28.22-.5.5-.5h2a.5.5 0 010 1h-2a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const ReceiptRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ReceiptRegularIcon({}), 'ReceiptRegular');

const ReceiptAddFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 4c0-1.1.9-2 2-2h7a2 2 0 012 2v7h3v2a3 3 0 01-3 3h-4.2A5.5 5.5 0 004 9.2V4zm11 11a2 2 0 002-2v-1h-2v3zM7.5 5a.5.5 0 000 1h4a.5.5 0 000-1h-4zm0 2a.5.5 0 000 1h4a.5.5 0 000-1h-4zm2.5 7.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V14H3.5a.5.5 0 000 1H5v1.5a.5.5 0 001 0V15h1.5a.5.5 0 000-1H6v-1.5z",
    fill: primaryFill
  }));
};

export const ReceiptAddFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ReceiptAddFilledIcon({}), 'ReceiptAddFilled');

const ReceiptAddRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 2a2 2 0 00-2 2v5.2c.32-.08.66-.15 1-.18V4a1 1 0 011-1h7a1 1 0 011 1v11h-3.02c-.03.34-.1.68-.19 1H15a3 3 0 003-3v-2h-3V4a2 2 0 00-2-2H6zm9 13v-3h2v1a2 2 0 01-2 2zM7.5 5a.5.5 0 000 1h4a.5.5 0 000-1h-4zM7 7.5c0-.28.22-.5.5-.5h4a.5.5 0 010 1h-4a.5.5 0 01-.5-.5zm3 7a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V14H3.5a.5.5 0 000 1H5v1.5a.5.5 0 001 0V15h1.5a.5.5 0 000-1H6v-1.5z",
    fill: primaryFill
  }));
};

export const ReceiptAddRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ReceiptAddRegularIcon({}), 'ReceiptAddRegular');

const ReceiptBagFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 2a2 2 0 00-2 2v4a3 3 0 011 .17A3 3 0 019 11v.09c.58.2 1 .76 1 1.41V16h5a3 3 0 003-3v-2h-3V4a2 2 0 00-2-2H6zm11 11a2 2 0 01-2 2v-3h2v1zM7 5.5c0-.28.22-.5.5-.5h4a.5.5 0 010 1h-4a.5.5 0 01-.5-.5zm0 2c0-.28.22-.5.5-.5h4a.5.5 0 010 1h-4a.5.5 0 01-.5-.5zM5 9.27A2 2 0 002 11v1h-.5a.5.5 0 00-.5.5V17c0 1.1.9 2 2 2h4a2 2 0 002-2v-4.5a.5.5 0 00-.5-.5H8v-1a2 2 0 00-3-1.73zM5 11v1H3v-1a1 1 0 112 0zm1 0a2 2 0 00-.25-.97A1 1 0 017 11v1H6v-1z",
    fill: primaryFill
  }));
};

export const ReceiptBagFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ReceiptBagFilledIcon({}), 'ReceiptBagFilled');

const ReceiptBagRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 4c0-1.1.9-2 2-2h7a2 2 0 012 2v7h3v2a3 3 0 01-3 3h-5v-1h4V4a1 1 0 00-1-1H6a1 1 0 00-1 1v4.17A3 3 0 004 8V4zm11 8v3a2 2 0 002-2v-1h-2zM7 5.5c0-.28.22-.5.5-.5h4a.5.5 0 010 1h-4a.5.5 0 01-.5-.5zM7.5 7a.5.5 0 000 1h4a.5.5 0 000-1h-4zM5 9.27A2 2 0 002 11v1h-.5a.5.5 0 00-.5.5V17c0 1.1.9 2 2 2h4a2 2 0 002-2v-4.5a.5.5 0 00-.5-.5H8v-1a2 2 0 00-3-1.73zM5 11v1H3v-1a1 1 0 112 0zm1 0a2 2 0 00-.25-.97A1 1 0 017 11v1H6v-1z",
    fill: primaryFill
  }));
};

export const ReceiptBagRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ReceiptBagRegularIcon({}), 'ReceiptBagRegular');

const ReceiptCubeFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 4c0-1.1.9-2 2-2h7a2 2 0 012 2v7h3v2a3 3 0 01-3 3h-4.5v-4.38a1 1 0 00-.55-.9l-4-2a1 1 0 00-.9 0L4 9.25V4zm11 11a2 2 0 002-2v-1h-2v3zM7.5 5a.5.5 0 000 1h4a.5.5 0 000-1h-4zm0 2a.5.5 0 000 1h4a.5.5 0 000-1h-4zm-6 8.88v-3.76a1 1 0 01.55-.9l3-1.5a1 1 0 01.9 0l3 1.5a1 1 0 01.55.9v3.76a1 1 0 01-.55.9l-3 1.5a1 1 0 01-.9 0l-3-1.5a1 1 0 01-.55-.9zm1.04-3.57a.5.5 0 00.27.65L5 13.9v2.61a.5.5 0 001 0v-2.61l2.2-.93a.5.5 0 00-.4-.92L5.5 13l-2.3-.97a.5.5 0 00-.66.27z",
    fill: primaryFill
  }));
};

export const ReceiptCubeFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ReceiptCubeFilledIcon({}), 'ReceiptCubeFilled');

const ReceiptCubeRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 2a2 2 0 00-2 2v5.25l1-.5V4a1 1 0 011-1h7a1 1 0 011 1v11h-3.5v1H15a3 3 0 003-3v-2h-3V4a2 2 0 00-2-2H6zm9 13v-3h2v1a2 2 0 01-2 2zM7.5 5a.5.5 0 000 1h4a.5.5 0 000-1h-4zM7 7.5c0-.28.22-.5.5-.5h4a.5.5 0 010 1h-4a.5.5 0 01-.5-.5zm-5.5 8.38v-3.76a1 1 0 01.55-.9l3-1.5a1 1 0 01.9 0l3 1.5a1 1 0 01.55.9v3.76a1 1 0 01-.55.9l-3 1.5a1 1 0 01-.9 0l-3-1.5a1 1 0 01-.55-.9zm1.04-3.57a.5.5 0 00.27.65L5 13.9v2.61a.5.5 0 001 0v-2.61l2.2-.93a.5.5 0 00-.4-.92L5.5 13l-2.3-.97a.5.5 0 00-.66.27z",
    fill: primaryFill
  }));
};

export const ReceiptCubeRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ReceiptCubeRegularIcon({}), 'ReceiptCubeRegular');

const ReceiptMoneyFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 4c0-1.1.9-2 2-2h7a2 2 0 012 2v7h3v2a3 3 0 01-3 3h-4v-2.5A2.5 2.5 0 008.5 11H4V4zm11 11a2 2 0 002-2v-1h-2v3zM7.5 5a.5.5 0 000 1h4a.5.5 0 000-1h-4zm0 2a.5.5 0 000 1h4a.5.5 0 000-1h-4zm1 5c.83 0 1.5.67 1.5 1.5v3c0 .83-.67 1.5-1.5 1.5h-6A1.5 1.5 0 011 16.5v-3c0-.83.67-1.5 1.5-1.5h6zm.5 4.5v-1c-.83 0-1.5.67-1.5 1.5h1c0-.28.22-.5.5-.5zm0-3a.5.5 0 01-.5-.5h-1c0 .83.67 1.5 1.5 1.5v-1zM2.5 13a.5.5 0 01-.5.5v1c.83 0 1.5-.67 1.5-1.5h-1zM2 16.5c.28 0 .5.22.5.5h1c0-.83-.67-1.5-1.5-1.5v1zm3.5-3a1.5 1.5 0 100 3 1.5 1.5 0 000-3z",
    fill: primaryFill
  }));
};

export const ReceiptMoneyFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ReceiptMoneyFilledIcon({}), 'ReceiptMoneyFilled');

const ReceiptMoneyRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 2a2 2 0 00-2 2v7h1V4a1 1 0 011-1h7a1 1 0 011 1v11h-3v1h4a3 3 0 003-3v-2h-3V4a2 2 0 00-2-2H6zm11 11a2 2 0 01-2 2v-3h2v1zM7.5 5a.5.5 0 000 1h4a.5.5 0 000-1h-4zM7 7.5c0-.28.22-.5.5-.5h4a.5.5 0 010 1h-4a.5.5 0 01-.5-.5zM8.5 12c.83 0 1.5.67 1.5 1.5v3c0 .83-.67 1.5-1.5 1.5h-6A1.5 1.5 0 011 16.5v-3c0-.83.67-1.5 1.5-1.5h6zm.5 4.5v-1c-.83 0-1.5.67-1.5 1.5h1c0-.28.22-.5.5-.5zm0-3a.5.5 0 01-.5-.5h-1c0 .83.67 1.5 1.5 1.5v-1zM2.5 13a.5.5 0 01-.5.5v1c.83 0 1.5-.67 1.5-1.5h-1zM2 16.5c.28 0 .5.22.5.5h1c0-.83-.67-1.5-1.5-1.5v1zm3.5-3a1.5 1.5 0 100 3 1.5 1.5 0 000-3z",
    fill: primaryFill
  }));
};

export const ReceiptMoneyRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ReceiptMoneyRegularIcon({}), 'ReceiptMoneyRegular');

const ReceiptPlayFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 4c0-1.1.9-2 2-2h7a2 2 0 012 2v7h3v2a3 3 0 01-3 3h-4.2A5.5 5.5 0 004 9.2V4zm11 11a2 2 0 002-2v-1h-2v3zM7.5 5a.5.5 0 000 1h4a.5.5 0 000-1h-4zm0 3a.5.5 0 000 1h4a.5.5 0 000-1h-4zm2.5 6.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-6-1.6v3.2c0 .4.43.63.76.42l2.56-1.6a.5.5 0 000-.84l-2.56-1.6a.5.5 0 00-.76.42z",
    fill: primaryFill
  }));
};

export const ReceiptPlayFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ReceiptPlayFilledIcon({}), 'ReceiptPlayFilled');

const ReceiptPlayRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 4c0-1.1.9-2 2-2h7a2 2 0 012 2v7h3v2a3 3 0 01-3 3h-4.2c.08-.32.15-.66.18-1H14V4a1 1 0 00-1-1H6a1 1 0 00-1 1v5.02c-.34.03-.68.1-1 .19V4zm11 8v3a2 2 0 002-2v-1h-2zM7 5.5c0-.28.22-.5.5-.5h4a.5.5 0 010 1h-4a.5.5 0 01-.5-.5zm0 3c0-.28.22-.5.5-.5h4a.5.5 0 010 1h-4a.5.5 0 01-.5-.5zm3 6a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-6-1.6v3.2c0 .4.43.63.76.42l2.56-1.6a.5.5 0 000-.84l-2.56-1.6a.5.5 0 00-.76.42z",
    fill: primaryFill
  }));
};

export const ReceiptPlayRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ReceiptPlayRegularIcon({}), 'ReceiptPlayRegular');

const ReceiptSearchFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 5c0-1.1.9-2 2-2h7a2 2 0 012 2v7h3v2a3 3 0 01-3 3h-2.08c-.08-.2-.2-.4-.36-.56l-2-2A4.5 4.5 0 009.25 10h1.25a.5.5 0 000-1H8.33A4.5 4.5 0 003 8.76V5zm11 11a2 2 0 002-2v-1h-2v3zM6.5 6a.5.5 0 000 1h4a.5.5 0 000-1h-4zm1.1 9.3a3.48 3.48 0 01-4.27-.06 3.5 3.5 0 114.97-.64l2.56 2.54a.5.5 0 01-.71.71L7.6 15.3zm-3.49-.72a2.5 2.5 0 102.78-4.16 2.5 2.5 0 00-2.78 4.16z",
    fill: primaryFill
  }));
};

export const ReceiptSearchFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ReceiptSearchFilledIcon({}), 'ReceiptSearchFilled');

const ReceiptSearchRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 8.76V5c0-.26.05-.52.16-.76.1-.23.24-.45.42-.64A1.9 1.9 0 014.96 3h7.08c.26 0 .52.05.76.16.23.11.44.26.62.44s.33.4.42.63c.1.25.16.5.16.77v7h3v2.06c0 .39-.08.77-.23 1.12-.31.7-.88 1.27-1.58 1.58-.36.15-.74.24-1.13.24h-2.14c-.08-.2-.2-.4-.36-.56l-.44-.44H13V5a.95.95 0 00-.08-.38 1.11 1.11 0 00-.2-.32A1.01 1.01 0 0012 4H4.99a.97.97 0 00-.7.29c-.1.1-.17.2-.22.32A.86.86 0 004 5v3.26c-.35.12-.69.3-1 .5zM14.04 16c.25 0 .5-.05.74-.16.47-.2.85-.58 1.06-1.05.1-.24.16-.5.16-.75V13h-2v3h.04zm-4.8-6h1.26a.5.5 0 100-1H8.33c.36.29.67.62.92 1zM6.5 7a.5.5 0 010-1h4a.5.5 0 010 1h-4zm1.1 8.3a3.48 3.48 0 01-4.27-.06 3.5 3.5 0 114.97-.64l2.56 2.54a.5.5 0 01-.71.71L7.6 15.3zm-3.49-.72a2.5 2.5 0 102.78-4.16 2.5 2.5 0 00-2.78 4.16z",
    fill: primaryFill
  }));
};

export const ReceiptSearchRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ReceiptSearchRegularIcon({}), 'ReceiptSearchRegular');

const RecordFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 10a8 8 0 1116 0 8 8 0 01-16 0zm8 4.5a4.5 4.5 0 100-9 4.5 4.5 0 000 9z",
    fill: primaryFill
  }));
};

export const RecordFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/RecordFilledIcon({}), 'RecordFilled');

const RecordRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 14.5a4.5 4.5 0 100-9 4.5 4.5 0 000 9zM10 2a8 8 0 100 16 8 8 0 000-16zm-7 8a7 7 0 1114 0 7 7 0 01-14 0z",
    fill: primaryFill
  }));
};

export const RecordRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/RecordRegularIcon({}), 'RecordRegular');

const RecordStopFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 18a8 8 0 100-16 8 8 0 000 16zM8 7h4a1 1 0 011 1v4a1 1 0 01-1 1H8a1 1 0 01-1-1V8a1 1 0 011-1z",
    fill: primaryFill
  }));
};

export const RecordStopFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/RecordStopFilledIcon({}), 'RecordStopFilled');

const RecordStopRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 3a7 7 0 100 14 7 7 0 000-14zm-8 7a8 8 0 1116 0 8 8 0 01-16 0zm5-2a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1H8a1 1 0 01-1-1V8z",
    fill: primaryFill
  }));
};

export const RecordStopRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/RecordStopRegularIcon({}), 'RecordStopRegular');

const RectangleLandscapeFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 4a3 3 0 00-3 3v6a3 3 0 003 3h10a3 3 0 003-3V7a3 3 0 00-3-3H5z",
    fill: primaryFill
  }));
};

export const RectangleLandscapeFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/RectangleLandscapeFilledIcon({}), 'RectangleLandscapeFilled');

const RectangleLandscapeRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 7a3 3 0 013-3h10a3 3 0 013 3v6a3 3 0 01-3 3H5a3 3 0 01-3-3V7zm3-2a2 2 0 00-2 2v6c0 1.1.9 2 2 2h10a2 2 0 002-2V7a2 2 0 00-2-2H5z",
    fill: primaryFill
  }));
};

export const RectangleLandscapeRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/RectangleLandscapeRegularIcon({}), 'RectangleLandscapeRegular');

const RectanglePortraitLocationTargetFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 2a2 2 0 00-2 2v12c0 1.1.9 2 2 2h5.7a4.5 4.5 0 01-1.43-2.02 1.5 1.5 0 010-2.96 4.49 4.49 0 012.75-2.75 1.5 1.5 0 012.96 0H16V4a2 2 0 00-2-2H6zm9.06 13.33a1 1 0 11-1.12-1.66 1 1 0 011.12 1.66zM17.95 14h.55a.5.5 0 010 1h-.55A3.49 3.49 0 0115 17.95v.55a.5.5 0 01-1 0v-.55A3.49 3.49 0 0111.05 15h-.55a.5.5 0 010-1h.55A3.49 3.49 0 0114 11.05v-.55a.5.5 0 011 0v.55A3.49 3.49 0 0117.95 14zm-3.2 2.99a2.5 2.5 0 10-.5-4.98 2.5 2.5 0 00.5 4.98z",
    fill: primaryFill
  }));
};

export const RectanglePortraitLocationTargetFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/RectanglePortraitLocationTargetFilledIcon({}), 'RectanglePortraitLocationTargetFilled');

const RectanglePortraitLocationTargetRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 4c0-1.1.9-2 2-2h8a2 2 0 012 2v6.27h-.02A1.5 1.5 0 0015 9.09V4a1 1 0 00-1-1H6a1 1 0 00-1 1v12a1 1 0 001 1h4.78a4.5 4.5 0 00.92 1H6a2 2 0 01-2-2V4zm11.06 11.33a1 1 0 11-1.12-1.66 1 1 0 011.12 1.66zM17.95 14h.55a.5.5 0 010 1h-.55A3.49 3.49 0 0115 17.95v.55a.5.5 0 01-1 0v-.55A3.49 3.49 0 0111.05 15h-.55a.5.5 0 010-1h.55A3.49 3.49 0 0114 11.05v-.55a.5.5 0 011 0v.55A3.49 3.49 0 0117.95 14zm-3.2 2.99a2.5 2.5 0 10-.5-4.98 2.5 2.5 0 00.5 4.98z",
    fill: primaryFill
  }));
};

export const RectanglePortraitLocationTargetRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/RectanglePortraitLocationTargetRegularIcon({}), 'RectanglePortraitLocationTargetRegular');

const RemoteFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M16.97 15.03a.75.75 0 101.06-1.06L12.56 8.5l5.47-5.47a.75.75 0 00-1.06-1.06l-6 6c-.3.3-.3.77 0 1.06l6 6zM3.03 4.97a.75.75 0 00-1.06 1.06l5.47 5.47-5.47 5.47a.75.75 0 101.06 1.06l6-6c.3-.3.3-.77 0-1.06l-6-6z",
    fill: primaryFill
  }));
};

export const RemoteFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/RemoteFilledIcon({}), 'RemoteFilled');

const RemoteRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17.15 14.85a.5.5 0 00.7-.7L12.21 8.5l5.64-5.65a.5.5 0 00-.7-.7l-6 6a.5.5 0 000 .7l6 6zm-14.3-9.7a.5.5 0 10-.7.7l5.64 5.65-5.64 5.65a.5.5 0 00.7.7l6-6a.5.5 0 000-.7l-6-6z",
    fill: primaryFill
  }));
};

export const RemoteRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/RemoteRegularIcon({}), 'RemoteRegular');

const RenameFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.5 2a.5.5 0 000 1h1v14h-1a.5.5 0 000 1h3a.5.5 0 000-1h-1V3h1a.5.5 0 000-1h-3zm-4 2h4v12h-4A2.5 2.5 0 012 13.5v-7A2.5 2.5 0 014.5 4zm11 12h-4V4h4A2.5 2.5 0 0118 6.5v7a2.5 2.5 0 01-2.5 2.5z",
    fill: primaryFill
  }));
};

export const RenameFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/RenameFilledIcon({}), 'RenameFilled');

const RenameRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.5 2a.5.5 0 000 1h1v14h-1a.5.5 0 000 1h3a.5.5 0 000-1h-1V3h1a.5.5 0 000-1h-3zm-4 2h4v1h-4C3.67 5 3 5.67 3 6.5v7c0 .83.67 1.5 1.5 1.5h4v1h-4A2.5 2.5 0 012 13.5v-7A2.5 2.5 0 014.5 4zm11 11h-4v1h4a2.5 2.5 0 002.5-2.5v-7A2.5 2.5 0 0015.5 4h-4v1h4c.83 0 1.5.67 1.5 1.5v7c0 .83-.67 1.5-1.5 1.5z",
    fill: primaryFill
  }));
};

export const RenameRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/RenameRegularIcon({}), 'RenameRegular');

const ReorderFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.75 7.75a.75.75 0 000 1.5h14.5a.75.75 0 000-1.5H2.75zm0 3a.75.75 0 000 1.5h14.5a.75.75 0 000-1.5H2.75z",
    fill: primaryFill
  }));
};

export const ReorderFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ReorderFilledIcon({}), 'ReorderFilled');

const ReorderRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.5 8a.5.5 0 000 1h15a.5.5 0 000-1h-15zm0 3a.5.5 0 000 1h15a.5.5 0 000-1h-15z",
    fill: primaryFill
  }));
};

export const ReorderRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ReorderRegularIcon({}), 'ReorderRegular');

const ReplayFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 6.5v-3a.5.5 0 011 0v1.2a7.98 7.98 0 017.94-2.46A8 8 0 112 9.48a.5.5 0 111 .07A6.97 6.97 0 003 10a7 7 0 101.25-4H6a.5.5 0 010 1H3.5a.5.5 0 01-.5-.5zm4.5 1.47c0-.93.98-1.54 1.81-1.12l4.04 2.03c.92.47.92 1.77 0 2.24l-4.04 2.03a1.25 1.25 0 01-1.81-1.12V7.97z",
    fill: primaryFill
  }));
};

export const ReplayFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ReplayFilledIcon({}), 'ReplayFilled');

const ReplayRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 6.5v-3a.5.5 0 011 0v1.2a7.98 7.98 0 017.94-2.46A8 8 0 112 9.48a.5.5 0 111 .07A6.97 6.97 0 003 10a7 7 0 101.25-4H6a.5.5 0 010 1H3.5a.5.5 0 01-.5-.5zm4.5 1.47c0-.93.98-1.54 1.81-1.12l4.04 2.03c.92.47.92 1.77 0 2.24l-4.04 2.03a1.25 1.25 0 01-1.81-1.12V7.97zm1.36-.23a.25.25 0 00-.36.23v4.06c0 .19.2.31.36.23l4.04-2.04a.25.25 0 000-.44L8.86 7.74z",
    fill: primaryFill
  }));
};

export const ReplayRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ReplayRegularIcon({}), 'ReplayRegular');

const ResizeFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.25 2A3.25 3.25 0 002 5.25v3a.75.75 0 001.5 0v-3c0-.97.78-1.75 1.75-1.75h3a.75.75 0 000-1.5h-3zm6.5 0a.75.75 0 000 1.5h3c.97 0 1.75.78 1.75 1.75v3a.75.75 0 001.5 0v-3C18 3.45 16.54 2 14.75 2h-3zm-9 9c.41 0 .75.34.75.75v3c0 .97.78 1.75 1.75 1.75h3a.75.75 0 010 1.5h-3A3.25 3.25 0 012 14.75v-3c0-.41.34-.75.75-.75zm15.25.75a.75.75 0 00-1.5 0v3c0 .97-.78 1.75-1.75 1.75h-3a.75.75 0 000 1.5h3c1.8 0 3.25-1.46 3.25-3.25v-3z",
    fill: primaryFill
  }));
};

export const ResizeFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ResizeFilledIcon({}), 'ResizeFilled');

const ResizeRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 2a3 3 0 00-3 3v3.5a.5.5 0 001 0V5c0-1.1.9-2 2-2h3.5a.5.5 0 000-1H5zm6.5 0a.5.5 0 000 1H15a2 2 0 012 2v3.5a.5.5 0 001 0V5a3 3 0 00-3-3h-3.5zm-9 9c.28 0 .5.22.5.5V15c0 1.1.9 2 2 2h3.5a.5.5 0 010 1H5a3 3 0 01-3-3v-3.5c0-.28.22-.5.5-.5zm15.5.5a.5.5 0 00-1 0V15a2 2 0 01-2 2h-3.5a.5.5 0 000 1H15a3 3 0 003-3v-3.5z",
    fill: primaryFill
  }));
};

export const ResizeRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ResizeRegularIcon({}), 'ResizeRegular');

const ResizeImageFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.25 2A3.25 3.25 0 002 5.25v3a.75.75 0 001.5 0v-3c0-.97.78-1.75 1.75-1.75h3a.75.75 0 000-1.5h-3zm6.5 0a.75.75 0 000 1.5h3c.97 0 1.75.78 1.75 1.75v3a.75.75 0 001.5 0v-3C18 3.45 16.54 2 14.75 2h-3zM18 11.75a.75.75 0 00-1.5 0v3c0 .97-.78 1.75-1.75 1.75h-3a.75.75 0 000 1.5h3c1.8 0 3.25-1.46 3.25-3.25v-3zM1 12.5A2.5 2.5 0 013.5 10h4a2.5 2.5 0 012.5 2.5v4c0 .5-.15.98-.41 1.38l-3.03-3.03a1.5 1.5 0 00-2.12 0L1.4 17.88C1.15 17.48 1 17 1 16.5v-4zm7 .25a.75.75 0 10-1.5 0 .75.75 0 001.5 0zm-5.88 5.84c.4.26.87.41 1.38.41h4c.51 0 .98-.15 1.38-.41l-3.03-3.03a.5.5 0 00-.7 0L2.12 18.6z",
    fill: primaryFill
  }));
};

export const ResizeImageFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ResizeImageFilledIcon({}), 'ResizeImageFilled');

const ResizeImageRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 2a3 3 0 00-3 3v3.5a.5.5 0 001 0V5c0-1.1.9-2 2-2h3.5a.5.5 0 000-1H5zm6.5 0a.5.5 0 000 1H15a2 2 0 012 2v3.5a.5.5 0 001 0V5a3 3 0 00-3-3h-3.5zm6.5 9.5a.5.5 0 00-1 0V15a2 2 0 01-2 2h-3.5a.5.5 0 000 1H15a3 3 0 003-3v-3.5zm-17 1A2.5 2.5 0 013.5 10h4a2.5 2.5 0 012.5 2.5v4c0 .5-.15.98-.41 1.38l-3.03-3.03a1.5 1.5 0 00-2.12 0L1.4 17.88C1.15 17.48 1 17 1 16.5v-4zm7 .25a.75.75 0 10-1.5 0 .75.75 0 001.5 0zm-5.88 5.84c.4.26.87.41 1.38.41h4c.51 0 .98-.15 1.38-.41l-3.03-3.03a.5.5 0 00-.7 0L2.12 18.6z",
    fill: primaryFill
  }));
};

export const ResizeImageRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ResizeImageRegularIcon({}), 'ResizeImageRegular');

const ResizeLargeFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 4C4.67 4 4 4.67 4 5.5v1a.5.5 0 01-1 0v-1A2.5 2.5 0 015.5 3h1a.5.5 0 010 1h-1zm1 1C5.67 5 5 5.67 5 6.5v7c0 .83.67 1.5 1.5 1.5h7c.83 0 1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5h-7zm8-1c.83 0 1.5.67 1.5 1.5v1a.5.5 0 001 0v-1A2.5 2.5 0 0014.5 3h-1a.5.5 0 000 1h1zm0 12c.83 0 1.5-.67 1.5-1.5v-1a.5.5 0 011 0v1a2.5 2.5 0 01-2.5 2.5h-1a.5.5 0 010-1h1zm-9 0A1.5 1.5 0 014 14.5v-1.25a.5.5 0 00-1 0v1.25A2.5 2.5 0 005.5 17h1.25a.5.5 0 000-1H5.5z",
    fill: primaryFill
  }));
};

export const ResizeLargeFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ResizeLargeFilledIcon({}), 'ResizeLargeFilled');

const ResizeLargeRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 4C4.67 4 4 4.67 4 5.5v1a.5.5 0 01-1 0v-1A2.5 2.5 0 015.5 3h1a.5.5 0 010 1h-1zM16 5.5c0-.83-.67-1.5-1.5-1.5h-1a.5.5 0 010-1h1A2.5 2.5 0 0117 5.5v1a.5.5 0 01-1 0v-1zm0 9c0 .83-.67 1.5-1.5 1.5h-1a.5.5 0 000 1h1a2.5 2.5 0 002.5-2.5v-1a.5.5 0 00-1 0v1zm-12 0c0 .83.67 1.5 1.5 1.5h1.25a.5.5 0 010 1H5.5A2.5 2.5 0 013 14.5v-1.25a.5.5 0 011 0v1.25zM6.5 5C5.67 5 5 5.67 5 6.5v7c0 .83.67 1.5 1.5 1.5h7c.83 0 1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5h-7zM6 6.5c0-.28.22-.5.5-.5h7c.28 0 .5.22.5.5v7a.5.5 0 01-.5.5h-7a.5.5 0 01-.5-.5v-7z",
    fill: primaryFill
  }));
};

export const ResizeLargeRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ResizeLargeRegularIcon({}), 'ResizeLargeRegular');

const ResizeSmallFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 4C4.67 4 4 4.67 4 5.5v1a.5.5 0 01-1 0v-1A2.5 2.5 0 015.5 3h1a.5.5 0 010 1h-1zm3 3C7.67 7 7 7.67 7 8.5v3c0 .83.67 1.5 1.5 1.5h3c.83 0 1.5-.67 1.5-1.5v-3c0-.83-.67-1.5-1.5-1.5h-3zm6-3c.83 0 1.5.67 1.5 1.5v1a.5.5 0 001 0v-1A2.5 2.5 0 0014.5 3h-1a.5.5 0 000 1h1zm0 12c.83 0 1.5-.67 1.5-1.5v-1a.5.5 0 011 0v1a2.5 2.5 0 01-2.5 2.5h-1a.5.5 0 010-1h1zm-9 0A1.5 1.5 0 014 14.5v-1.25a.5.5 0 00-1 0v1.25A2.5 2.5 0 005.5 17h1.25a.5.5 0 000-1H5.5z",
    fill: primaryFill
  }));
};

export const ResizeSmallFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ResizeSmallFilledIcon({}), 'ResizeSmallFilled');

const ResizeSmallRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 4C4.67 4 4 4.67 4 5.5v1a.5.5 0 01-1 0v-1A2.5 2.5 0 015.5 3h1a.5.5 0 010 1h-1zM16 5.5c0-.83-.67-1.5-1.5-1.5h-1a.5.5 0 010-1h1A2.5 2.5 0 0117 5.5v1a.5.5 0 01-1 0v-1zm0 9c0 .83-.67 1.5-1.5 1.5h-1a.5.5 0 000 1h1a2.5 2.5 0 002.5-2.5v-1a.5.5 0 00-1 0v1zm-12 0c0 .83.67 1.5 1.5 1.5h1.25a.5.5 0 010 1H5.5A2.5 2.5 0 013 14.5v-1.25a.5.5 0 011 0v1.25zM8.5 7C7.67 7 7 7.67 7 8.5v3c0 .83.67 1.5 1.5 1.5h3c.83 0 1.5-.67 1.5-1.5v-3c0-.83-.67-1.5-1.5-1.5h-3zM8 8.5c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v3a.5.5 0 01-.5.5h-3a.5.5 0 01-.5-.5v-3z",
    fill: primaryFill
  }));
};

export const ResizeSmallRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ResizeSmallRegularIcon({}), 'ResizeSmallRegular');

const ResizeTableFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 2a3 3 0 00-3 3v2.35c.29-.32.62-.6 1-.81V5c0-1.1.9-2 2-2h3.5a.5.5 0 000-1H5zm10 16h-2.35c.32-.29.6-.62.81-1H15a2 2 0 002-2v-3.5a.5.5 0 011 0V15a3 3 0 01-3 3zM11.5 2a.5.5 0 000 1H15a2 2 0 012 2v3.5a.5.5 0 001 0V5a3 3 0 00-3-3h-3.5zM5 7a3 3 0 00-3 3h3V7zm0 4v3H2v-3h3zm0 4H2a3 3 0 003 3v-3zm1 0h3v3H6v-3zm0-1h3v-3H6v3zm4 1h3a3 3 0 01-3 3v-3zm0-4v3h3v-3h-3zm0-1V7a3 3 0 013 3h-3zM6 7h3v3H6V7z",
    fill: primaryFill
  }));
};

export const ResizeTableFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ResizeTableFilledIcon({}), 'ResizeTableFilled');

const ResizeTableRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 2a3 3 0 00-3 3v2.35c.29-.32.62-.6 1-.81V5c0-1.1.9-2 2-2h3.5a.5.5 0 000-1H5zm10 16h-2.35c.32-.29.6-.62.81-1H15a2 2 0 002-2v-3.5a.5.5 0 011 0V15a3 3 0 01-3 3zM11.5 2a.5.5 0 000 1H15a2 2 0 012 2v3.5a.5.5 0 001 0V5a3 3 0 00-3-3h-3.5zM5 7a3 3 0 00-3 3v5a3 3 0 003 3h5a3 3 0 003-3v-5a3 3 0 00-3-3H5zm-2 3c0-1.1.9-2 2-2v2H3zm3 0V8h3v2H6zm4 0V8a2 2 0 012 2h-2zm-4 1h3v3H6v-3zm4 0h2v3h-2v-3zm-4 4h3v2H6v-2zm6 0a2 2 0 01-2 2v-2h2zm-9-4h2v3H3v-3zm0 4h2v2a2 2 0 01-2-2z",
    fill: primaryFill
  }));
};

export const ResizeTableRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ResizeTableRegularIcon({}), 'ResizeTableRegular');

const ResizeVideoFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.25 2A3.25 3.25 0 002 5.25v3a.75.75 0 001.5 0v-3c0-.97.78-1.75 1.75-1.75h3a.75.75 0 000-1.5h-3zm6.5 0a.75.75 0 000 1.5h3c.97 0 1.75.78 1.75 1.75v3a.75.75 0 001.5 0v-3C18 3.45 16.54 2 14.75 2h-3zM18 11.75a.75.75 0 00-1.5 0v3c0 .97-.78 1.75-1.75 1.75h-3a.75.75 0 000 1.5h3c1.8 0 3.25-1.46 3.25-3.25v-3zM3.5 10h4a2.5 2.5 0 012.5 2.5v4A2.5 2.5 0 017.5 19h-4A2.5 2.5 0 011 16.5v-4A2.5 2.5 0 013.5 10zm.72 2.55a.5.5 0 00-.72.45v3a.5.5 0 00.72.45l3-1.5a.5.5 0 000-.9l-3-1.5z",
    fill: primaryFill
  }));
};

export const ResizeVideoFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ResizeVideoFilledIcon({}), 'ResizeVideoFilled');

const ResizeVideoRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 2a3 3 0 00-3 3v3.5a.5.5 0 001 0V5c0-1.1.9-2 2-2h3.5a.5.5 0 000-1H5zm6.5 0a.5.5 0 000 1H15a2 2 0 012 2v3.5a.5.5 0 001 0V5a3 3 0 00-3-3h-3.5zm6.5 9.5a.5.5 0 00-1 0V15a2 2 0 01-2 2h-3.5a.5.5 0 000 1H15a3 3 0 003-3v-3.5zM3.5 10A2.5 2.5 0 001 12.5v4A2.5 2.5 0 003.5 19h4a2.5 2.5 0 002.5-2.5v-4A2.5 2.5 0 007.5 10h-4zm.72 2.55l3 1.5a.5.5 0 010 .9l-3 1.5A.5.5 0 013.5 16v-3a.5.5 0 01.72-.45z",
    fill: primaryFill
  }));
};

export const ResizeVideoRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ResizeVideoRegularIcon({}), 'ResizeVideoRegular');

const RewardFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M15.53 3c.82 0 1.5.67 1.5 1.5v1.4c0 .93-.53 1.8-1.37 2.22l-4.19 2.14a3.54 3.54 0 11-2.92 0L4.36 8.12a2.5 2.5 0 01-1.35-2.04L3 5.9V4.5C3 3.67 3.67 3 4.5 3h11.03zM10 10.95a2.54 2.54 0 100 5.07 2.54 2.54 0 000-5.07zM12.61 4h-5.2v4.55l2.38 1.22a.5.5 0 00.45 0l2.38-1.22V4z",
    fill: primaryFill
  }));
};

export const RewardFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/RewardFilledIcon({}), 'RewardFilled');

const RewardRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M15.53 3c.83 0 1.5.67 1.5 1.5v1.4c0 .94-.53 1.8-1.37 2.22l-4.18 2.14a3.54 3.54 0 11-2.93 0L4.36 8.12a2.5 2.5 0 01-1.35-2.04V4.5C3 3.67 3.66 3 4.5 3h11.02zM10 10.95a2.54 2.54 0 100 5.08 2.54 2.54 0 000-5.08zM12.55 4H7.47V8.6L9.8 9.77a.5.5 0 00.45 0l2.31-1.18V4zM6.47 4H4.5a.5.5 0 00-.5.5v1.54c.06.5.36.96.82 1.2l1.65.84V4zm9.06 0h-1.98v4.08l1.66-.85c.5-.25.82-.77.82-1.33V4.5a.5.5 0 00-.5-.5z",
    fill: primaryFill
  }));
};

export const RewardRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/RewardRegularIcon({}), 'RewardRegular');

const RewindFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 5.49a1 1 0 00-1.6-.8l-5.87 4.3c-.68.5-.68 1.52 0 2.02l5.88 4.31a1 1 0 001.59-.8v-3.17l5.4 3.97a1 1 0 001.6-.8V5.48a1 1 0 00-1.6-.8L10 8.64V5.49zm-1.6-.8l.3.39z",
    fill: primaryFill
  }));
};

export const RewindFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/RewindFilledIcon({}), 'RewindFilled');

const RewindRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 5.49a1 1 0 00-1.6-.8l-5.87 4.3c-.68.5-.68 1.52 0 2.02l5.88 4.31a1 1 0 001.59-.8v-3.17l5.4 3.97a1 1 0 001.6-.8V5.48a1 1 0 00-1.6-.8L10 8.64V5.49zm-6.88 4.3L9 5.5v9.02l-5.88-4.3a.25.25 0 010-.41zm7 0L16 5.5v9.02l-5.88-4.3a.25.25 0 010-.41z",
    fill: primaryFill
  }));
};

export const RewindRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/RewindRegularIcon({}), 'RewindRegular');

const RhombusFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.89 4.3A2 2 0 016.76 3H17a2 2 0 011.87 2.7l-3.76 10a2 2 0 01-1.87 1.3H3a2 2 0 01-1.87-2.7l3.76-10z",
    fill: primaryFill
  }));
};

export const RhombusFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/RhombusFilledIcon({}), 'RhombusFilled');

const RhombusRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.89 4.3A2 2 0 016.76 3H17a2 2 0 011.87 2.7l-3.76 10a2 2 0 01-1.87 1.3H3a2 2 0 01-1.87-2.7l3.76-10zM6.76 4a1 1 0 00-.93.65l-3.76 10A1 1 0 003 16h10.24a1 1 0 00.93-.65l3.76-10A1 1 0 0017 4H6.76z",
    fill: primaryFill
  }));
};

export const RhombusRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/RhombusRegularIcon({}), 'RhombusRegular');

const RibbonFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M16 8A6 6 0 114 8a6 6 0 0112 0zm-6 7c1.49 0 2.87-.46 4-1.25v3.75a.5.5 0 01-.8.4L10 16l-3.2 1.9a.5.5 0 01-.8-.4v-3.75A6.97 6.97 0 0010 15z",
    fill: primaryFill
  }));
};

export const RibbonFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/RibbonFilledIcon({}), 'RibbonFilled');

const RibbonRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M16 8c0 1.78-.77 3.37-2 4.47v5.03a.5.5 0 01-.75.43L10 16.08l-3.25 1.85A.5.5 0 016 17.5v-5.03A5.98 5.98 0 0110 2a6 6 0 016 6zm-6 6c-1.1 0-2.12-.3-3-.8v3.44l2.75-1.57a.5.5 0 01.5 0L13 16.64V13.2c-.88.5-1.9.8-3 .8zm0-1a5 5 0 100-10 5 5 0 000 10z",
    fill: primaryFill
  }));
};

export const RibbonRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/RibbonRegularIcon({}), 'RibbonRegular');

const RibbonAddFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M19 5.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V5h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V6h1.5a.5.5 0 000-1H15V3.5zm-6 2c0-1.28.44-2.45 1.17-3.39A6 6 0 1014.2 11 5.5 5.5 0 019 5.5zM9 15c1.49 0 2.87-.46 4-1.25v3.75a.5.5 0 01-.8.4L9 16l-3.2 1.9a.5.5 0 01-.8-.4v-3.75A6.97 6.97 0 009 15z",
    fill: primaryFill
  }));
};

export const RibbonAddFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/RibbonAddFilledIcon({}), 'RibbonAddFilled');

const RibbonAddRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M19 5.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V5h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V6h1.5a.5.5 0 000-1H15V3.5zM9 2c.4 0 .79.04 1.17.11-.23.29-.42.6-.59.92a5 5 0 103.54 7.8c.35.09.71.14 1.08.16a6.03 6.03 0 01-1.2 1.48v5.03a.5.5 0 01-.75.43L9 16.08l-3.25 1.85A.5.5 0 015 17.5v-5.03A5.98 5.98 0 019 2zm0 12c-1.1 0-2.12-.3-3-.8v3.44l2.75-1.57a.5.5 0 01.5 0L12 16.64V13.2c-.88.5-1.9.8-3 .8z",
    fill: primaryFill
  }));
};

export const RibbonAddRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/RibbonAddRegularIcon({}), 'RibbonAddRegular');

const RibbonOffFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.62 5.33a6 6 0 008.04 8.04l.75.75A6.97 6.97 0 016 13.75v3.75a.5.5 0 00.8.4L10 16l3.2 1.9a.5.5 0 00.8-.4v-2.8l3.15 3.15a.5.5 0 00.7-.7l-15-15a.5.5 0 10-.7.7l2.47 2.48zm1.2-1.63l8.48 8.48A6 6 0 005.82 3.7z",
    fill: primaryFill
  }));
};

export const RibbonOffFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/RibbonOffFilledIcon({}), 'RibbonOffFilled');

const RibbonOffRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.62 5.33L2.15 2.85a.5.5 0 11.7-.7l15 15a.5.5 0 01-.7.7L14 14.71v2.79a.5.5 0 01-.75.43L10 16.08l-3.25 1.85A.5.5 0 016 17.5v-5.03a5.98 5.98 0 01-1.38-7.14zm8.05 8.05A5.98 5.98 0 017 13.2v3.44l2.75-1.57a.5.5 0 01.5 0L13 16.64V13.7l-.33-.33zm-.76-.76L5.38 6.1A4.98 4.98 0 0010 13c.68 0 1.32-.13 1.91-.38zM15 8c0 1.35-.53 2.57-1.4 3.47l.7.71A6 6 0 005.82 3.7l.7.7A4.98 4.98 0 0115 8z",
    fill: primaryFill
  }));
};

export const RibbonOffRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/RibbonOffRegularIcon({}), 'RibbonOffRegular');

const RibbonStarFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M16 8A6 6 0 114 8a6 6 0 0112 0zM9.85 5.1l-.72 1.55a.18.18 0 01-.14.1l-1.7.2c-.14.02-.2.2-.1.3l1.26 1.17c.05.04.07.1.05.16l-.33 1.68c-.03.15.13.26.26.19l1.49-.84a.18.18 0 01.17 0l1.5.84c.12.07.28-.04.25-.19l-.33-1.68a.17.17 0 01.05-.16l1.26-1.16a.18.18 0 00-.1-.3l-1.7-.2a.17.17 0 01-.14-.1l-.72-1.56a.17.17 0 00-.31 0zM10 15c1.49 0 2.87-.46 4-1.25v3.75a.5.5 0 01-.8.4L10 16l-3.2 1.9a.5.5 0 01-.8-.4v-3.75A6.97 6.97 0 0010 15z",
    fill: primaryFill
  }));
};

export const RibbonStarFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/RibbonStarFilledIcon({}), 'RibbonStarFilled');

const RibbonStarRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.16 5.1a.18.18 0 00-.31 0l-.72 1.55a.18.18 0 01-.14.1l-1.7.2c-.15.02-.2.2-.1.3l1.26 1.17c.05.04.07.1.05.16l-.33 1.68c-.03.15.13.26.26.19l1.49-.84a.17.17 0 01.17 0l1.5.84c.12.07.28-.04.25-.19l-.33-1.68a.18.18 0 01.05-.16l1.26-1.16a.17.17 0 00-.1-.3l-1.7-.2a.18.18 0 01-.14-.1l-.72-1.56zM16 8c0 1.78-.77 3.37-2 4.47v5.03a.5.5 0 01-.75.43L10 16.08l-3.25 1.85A.5.5 0 016 17.5v-5.03A5.98 5.98 0 0110 2a6 6 0 016 6zm-6 6c-1.1 0-2.12-.3-3-.8v3.44l2.75-1.57a.5.5 0 01.5 0L13 16.64V13.2c-.88.5-1.9.8-3 .8zm0-1a5 5 0 100-10 5 5 0 000 10z",
    fill: primaryFill
  }));
};

export const RibbonStarRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/RibbonStarRegularIcon({}), 'RibbonStarRegular');

const RoadConeFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.42 2.76A1 1 0 019.4 2h1.23a1 1 0 01.96.74L15.38 17h2.12a.5.5 0 010 1h-15a.5.5 0 010-1h2.11l.8-3h6.09a.5.5 0 000-1H5.69l.45-1.63.1-.37h4.26a.5.5 0 000-1H6.52c.68-2.48 1.35-4.96 1.9-7.24z",
    fill: primaryFill
  }));
};

export const RoadConeFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/RoadConeFilledIcon({}), 'RoadConeFilled');

const RoadConeRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.38 2a1 1 0 00-.96.74L4.62 17H2.5a.5.5 0 000 1h15a.5.5 0 000-1h-2.12l-3.8-14.26a1 1 0 00-.96-.74H9.38zM5.65 17l.8-3h5.05a.5.5 0 000-1H6.72l.53-2h3.25a.5.5 0 000-1H7.52l1.86-7h1.24l3.73 14h-8.7z",
    fill: primaryFill
  }));
};

export const RoadConeRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/RoadConeRegularIcon({}), 'RoadConeRegular');

const RocketFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.76 6.43a2 2 0 112.82 2.82 2 2 0 01-2.82-2.82zm2.11.7a1 1 0 10-1.4 1.41 1 1 0 001.4-1.4zM9.44 13.6l.6.6a1.5 1.5 0 001.71.3l1.12 1.12c.2.2.51.2.7 0L15 14.2c.86-.86.96-2.17.31-3.14l.85-.85a6.3 6.3 0 001.56-6.33 2.43 2.43 0 00-1.6-1.6A6.3 6.3 0 009.8 3.86l-.85.85A2.5 2.5 0 005.8 5L4.4 6.43a.5.5 0 000 .7L5.5 8.27a1.5 1.5 0 00.29 1.7l.61.61-1.22.73a.5.5 0 00-.1.78l2.83 2.83a.5.5 0 00.79-.1l.73-1.21zm7.32-9.42a5.3 5.3 0 01-1.3 5.33l-4 4a.5.5 0 01-.7 0l-1.07-1.07-2.12-2.12L6.5 9.24a.5.5 0 010-.7l4-4a5.3 5.3 0 015.32-1.3c.44.13.8.48.93.93zM5.81 14.91a.5.5 0 10-.71-.7l-1.77 1.76a.5.5 0 10.7.7l1.78-1.76zm-1.42-2.12c.2.2.2.5 0 .7l-.7.71a.5.5 0 11-.72-.7l.71-.71c.2-.2.51-.2.71 0zm2.83 3.53a.5.5 0 10-.7-.7l-.72.7a.5.5 0 10.71.71l.71-.7z",
    fill: primaryFill
  }));
};

export const RocketFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/RocketFilledIcon({}), 'RocketFilled');

const RocketRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.75 6.43a2 2 0 112.83 2.82 2 2 0 01-2.83-2.82zm2.12.7a1 1 0 10-1.4 1.41 1 1 0 001.4-1.4zm-1.12 7.37a1.5 1.5 0 01-1.7-.3l-.61-.6-.74 1.22a.5.5 0 01-.78.1L5.1 12.09a.5.5 0 01.1-.79l1.22-.73-.61-.6a1.5 1.5 0 01-.3-1.71L4.38 7.14a.5.5 0 010-.7l1.06-1.07a3 3 0 013.42-.59l.93-.93a6.3 6.3 0 016.33-1.56c.76.24 1.36.83 1.6 1.6a6.3 6.3 0 01-1.56 6.32l-.94.94a3 3 0 01-.58 3.41l-1.06 1.06a.5.5 0 01-.71 0l-1.12-1.12zm4.07-11.26a5.3 5.3 0 00-5.32 1.31l-.82.82-.7.7L6.86 8.2l-.4.4a.5.5 0 00.04.66l4.25 4.24c.18.18.46.2.65.05l.4-.4h.01l2.12-2.12.7-.71.82-.81a5.3 5.3 0 001.31-5.33c-.14-.45-.49-.8-.94-.94zm-3.3 10.62l.7.7.7-.7a2 2 0 00.53-1.93l-1.93 1.93zm-4.44-8.3a2 2 0 00-1.93.52l-.7.7.7.71 1.93-1.93zm.63 7.31L7.14 11.3l-.89.53 1.93 1.93.53-.89zm-2.9 2.04a.5.5 0 10-.71-.7l-1.77 1.76a.5.5 0 10.7.71l1.77-1.77zM4.38 12.8c.2.2.2.51 0 .7l-.71.72a.5.5 0 01-.7-.71l.7-.71c.2-.2.51-.2.7 0zm2.83 3.54a.5.5 0 00-.7-.71l-.72.7a.5.5 0 10.7.72l.72-.71z",
    fill: primaryFill
  }));
};

export const RocketRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/RocketRegularIcon({}), 'RocketRegular');

const RotateLeftFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12.39 12a.53.53 0 01-.54-.52c0-.29.24-.52.54-.52h.35c1.77 0 3.2-1.08 3.2-2.42 0-1.3-1.35-2.36-3.04-2.42H7.82L9.04 7.3c.2.2.2.53 0 .73a.54.54 0 01-.7.05l-.06-.05-2.12-2.08a.51.51 0 010-.73l2.12-2.08.06-.05c.21-.15.5-.13.7.05.2.2.2.53 0 .74L7.82 5.08h4.92C15.1 5.08 17 6.63 17 8.54S15.1 12 12.74 12h-.35zm-9-3c-.21 0-.39.17-.39.38v6.87c0 .41.36.75.8.75h12.8a.4.4 0 00.35-.19.37.37 0 00-.15-.51L3.6 9.05A.41.41 0 003.4 9z",
    fill: primaryFill
  }));
};

export const RotateLeftFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/RotateLeftFilledIcon({}), 'RotateLeftFilled');

const RotateLeftRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12.39 12a.53.53 0 01-.54-.52c0-.29.24-.52.54-.52h.35c1.77 0 3.2-1.08 3.2-2.42 0-1.3-1.35-2.36-3.04-2.42H7.82L9.04 7.3c.2.2.2.53 0 .73a.54.54 0 01-.7.05l-.06-.05-2.12-2.08a.51.51 0 010-.73l2.12-2.08.06-.05c.21-.15.5-.13.7.05.2.2.2.53 0 .74L7.82 5.08h4.92C15.1 5.08 17 6.63 17 8.54S15.1 12 12.74 12h-.35zM4 10.41V16h10.18L4 10.41zM3.8 17a.77.77 0 01-.8-.75V9.38c0-.21.18-.38.4-.38.07 0 .14.02.2.05l13.2 7.25c.2.1.26.33.15.51a.4.4 0 01-.35.19H3.8z",
    fill: primaryFill
  }));
};

export const RotateLeftRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/RotateLeftRegularIcon({}), 'RotateLeftRegular');

const RotateRightFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.61 12c.3 0 .54-.23.54-.52a.53.53 0 00-.54-.52h-.35c-1.77 0-3.2-1.08-3.2-2.42 0-1.3 1.35-2.36 3.04-2.42h5.08L10.96 7.3c-.2.2-.2.53 0 .73.2.18.49.2.7.05l.06-.05 2.12-2.08c.21-.2.21-.53 0-.73l-2.12-2.08-.06-.05a.54.54 0 00-.7.05c-.2.2-.2.53 0 .74l1.22 1.19H7.26C4.9 5.08 3 6.63 3 8.54S4.9 12 7.26 12h.35zm9-3c.21 0 .39.17.39.38v6.87c0 .41-.36.75-.8.75H3.4a.4.4 0 01-.35-.19.37.37 0 01.15-.51l13.2-7.25a.41.41 0 01.2-.05z",
    fill: primaryFill
  }));
};

export const RotateRightFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/RotateRightFilledIcon({}), 'RotateRightFilled');

const RotateRightRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.61 12c.3 0 .54-.23.54-.52a.53.53 0 00-.54-.52h-.35c-1.77 0-3.2-1.08-3.2-2.42 0-1.3 1.35-2.36 3.04-2.42h5.08L10.96 7.3c-.2.2-.2.53 0 .73.2.18.49.2.7.05l.06-.05 2.12-2.08c.21-.2.21-.53 0-.73l-2.12-2.08-.06-.05a.54.54 0 00-.7.05c-.2.2-.2.53 0 .74l1.22 1.19H7.26C4.9 5.08 3 6.63 3 8.54S4.9 12 7.26 12h.35zM16 10.41V16H5.82L16 10.41zm.2 6.59c.44 0 .8-.34.8-.75V9.38c0-.21-.18-.38-.4-.38a.41.41 0 00-.2.05L3.2 16.3a.37.37 0 00-.15.51c.07.12.2.19.35.19h12.8z",
    fill: primaryFill
  }));
};

export const RotateRightRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/RotateRightRegularIcon({}), 'RotateRightRegular');

const RouterFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.5 9.5a6.5 6.5 0 0113 0 .5.5 0 001 0 7.5 7.5 0 00-15 0 .5.5 0 001 0zm6.5-4a4 4 0 00-4 4 .5.5 0 01-1 0 5 5 0 0110 0 .5.5 0 01-1 0 4 4 0 00-4-4zM7.75 9.25a2.25 2.25 0 112.75 2.2V13h4a2.5 2.5 0 010 5h-9a2.5 2.5 0 010-5h4v-1.56a2.25 2.25 0 01-1.75-2.19z",
    fill: primaryFill
  }));
};

export const RouterFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/RouterFilledIcon({}), 'RouterFilled');

const RouterRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.5 9.5a6.5 6.5 0 0113 0 .5.5 0 001 0 7.5 7.5 0 00-15 0 .5.5 0 001 0zm6.5-4a4 4 0 00-4 4 .5.5 0 01-1 0 5 5 0 0110 0 .5.5 0 01-1 0 4 4 0 00-4-4zM7.75 9.25a2.25 2.25 0 112.75 2.2V13h4a2.5 2.5 0 010 5h-9a2.5 2.5 0 010-5h4v-1.56a2.25 2.25 0 01-1.75-2.19zM10 8a1.25 1.25 0 100 2.5A1.25 1.25 0 0010 8zm-4.5 6a1.5 1.5 0 000 3h9a1.5 1.5 0 000-3h-9z",
    fill: primaryFill
  }));
};

export const RouterRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/RouterRegularIcon({}), 'RouterRegular');

const RowTripleFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.5 2C3.67 2 3 2.67 3 3.5v1C3 5.33 3.67 6 4.5 6h11c.83 0 1.5-.67 1.5-1.5v-1c0-.83-.67-1.5-1.5-1.5h-11zm0 6C3.67 8 3 8.67 3 9.5v1c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5v-1c0-.83-.67-1.5-1.5-1.5h-11zm0 6c-.83 0-1.5.67-1.5 1.5v1c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5v-1c0-.83-.67-1.5-1.5-1.5h-11z",
    fill: primaryFill
  }));
};

export const RowTripleFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/RowTripleFilledIcon({}), 'RowTripleFilled');

const RowTripleRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 3.5C3 2.67 3.67 2 4.5 2h11c.83 0 1.5.67 1.5 1.5v1c0 .83-.67 1.5-1.5 1.5h-11A1.5 1.5 0 013 4.5v-1zM4.5 3a.5.5 0 00-.5.5v1c0 .28.22.5.5.5h11a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-11zM3 9.5C3 8.67 3.67 8 4.5 8h11c.83 0 1.5.67 1.5 1.5v1c0 .83-.67 1.5-1.5 1.5h-11A1.5 1.5 0 013 10.5v-1zM4.5 9a.5.5 0 00-.5.5v1c0 .28.22.5.5.5h11a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-11zm0 5c-.83 0-1.5.67-1.5 1.5v1c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5v-1c0-.83-.67-1.5-1.5-1.5h-11zM4 15.5c0-.28.22-.5.5-.5h11c.28 0 .5.22.5.5v1a.5.5 0 01-.5.5h-11a.5.5 0 01-.5-.5v-1z",
    fill: primaryFill
  }));
};

export const RowTripleRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/RowTripleRegularIcon({}), 'RowTripleRegular');

const RulerFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13.97 3.2l.03.3v13c0 .83-.67 1.5-1.5 1.5h-5A1.5 1.5 0 016 16.5v-13A1.5 1.5 0 017.5 2h5c.72 0 1.33.51 1.47 1.2zM7 14.5v1h1.5a.5.5 0 000-1H7zm0-10v1h1.5a.5.5 0 000-1H7zM7 7v1h2.5a.5.5 0 000-1H7zm0 2.5v1h1.5a.5.5 0 000-1H7zM7 12v1h2.5a.5.5 0 100-1H7z",
    fill: primaryFill
  }));
};

export const RulerFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/RulerFilledIcon({}), 'RulerFilled');

const RulerRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14 3.5c0-.83-.67-1.5-1.5-1.5h-5C6.67 2 6 2.67 6 3.5v13c0 .83.67 1.5 1.5 1.5h5c.83 0 1.5-.67 1.5-1.5v-13zM7 13h2.5a.5.5 0 000-1H7v-1.5h1.5a.5.5 0 000-1H7V8h2.5a.5.5 0 000-1H7V5.5h1.5a.5.5 0 000-1H7v-1c0-.28.22-.5.5-.5h5c.28 0 .5.22.5.5v13a.5.5 0 01-.5.5h-5a.5.5 0 01-.5-.5v-1h1.5a.5.5 0 000-1H7V13z",
    fill: primaryFill
  }));
};

export const RulerRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/RulerRegularIcon({}), 'RulerRegular');

const RunFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.31 2.04a.5.5 0 01.35-.01l6 2a.5.5 0 01.07.92h-.03a6.13 6.13 0 00-.37.22c-.25.15-.58.36-.91.62a5.8 5.8 0 00-.94.87c-.22.27-.38.53-.45.78l1.86 3.72 2 1.33A2.5 2.5 0 0118 14.57v1.93a.5.5 0 01-.48.5l-.02-.5.02.5h-.04a6.42 6.42 0 01-.47 0 21.98 21.98 0 01-5.65-.84c-3.32-.95-7.23-3.02-9.31-7.45a.5.5 0 010-.43A12.43 12.43 0 015.2 4.59a16.2 16.2 0 014.12-2.55zM17 15.47c-7.41-.6-11.41-4.2-13.55-7.58-.15.2-.28.41-.39.62 1.94 3.92 5.46 5.8 8.58 6.7A20.97 20.97 0 0017 16v-.54zM5.96 5.25l1.9 1.9a.5.5 0 01.13.42l-.48 3.4c.7.56 1.5 1.08 2.4 1.55l1.48-1.6-2.33-4.18a.5.5 0 01.6-.71l2.52.84c.13-.31.32-.6.53-.84a6.78 6.78 0 011.6-1.4l-4.8-1.6c-1.1.47-2.38 1.27-3.55 2.22zm7.8 8.7c1 .24 2.07.41 3.24.51a1.5 1.5 0 00-.67-1.14l-1.65-1.1-.92 1.73z",
    fill: primaryFill
  }));
};

export const RunFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/RunFilledIcon({}), 'RunFilled');

const RunRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.31 2.04a.5.5 0 01.35-.01l6 2a.5.5 0 01.07.92h-.03a6.13 6.13 0 00-.37.22c-.25.15-.58.36-.91.62a5.8 5.8 0 00-.94.87c-.22.27-.38.53-.45.78l1.86 3.72 2 1.33A2.5 2.5 0 0118 14.57v1.93a.5.5 0 01-.48.5l-.02-.5.02.5h-.04a6.42 6.42 0 01-.47 0 21.98 21.98 0 01-5.65-.84c-3.32-.95-7.23-3.02-9.31-7.45a.5.5 0 010-.43A12.43 12.43 0 015.2 4.59a16.2 16.2 0 014.12-2.55zM17 16v-.53c-7.41-.6-11.41-4.2-13.55-7.58-.15.2-.28.41-.39.62 1.94 3.92 5.46 5.8 8.58 6.7A20.97 20.97 0 0017 16zm-.67-2.68l-1.65-1.1-.92 1.73c1 .24 2.07.41 3.24.51a1.5 1.5 0 00-.67-1.14zm-4.18-5.41l-1.59-.53 1.88 3.38a.5.5 0 01-.07.58l-1.52 1.63c.6.27 1.23.5 1.92.71l1.17-2.19-1.8-3.58zm.03-1.04c.13-.31.32-.6.53-.84a6.78 6.78 0 011.6-1.4l-4.8-1.6c-1.1.47-2.38 1.27-3.55 2.22l1.9 1.9a.5.5 0 01.13.42l-.48 3.4c.7.56 1.5 1.08 2.4 1.55l1.48-1.6-2.33-4.18a.5.5 0 01.6-.71l2.52.84zM5.2 5.9c-.4.37-.76.75-1.1 1.13a14.82 14.82 0 002.51 3.14l.36-2.5L5.2 5.9z",
    fill: primaryFill
  }));
};

export const RunRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/RunRegularIcon({}), 'RunRegular');

const SanitizeFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.77 5.23a2.5 2.5 0 000 3.54l3.46 3.46c.11.11.23.2.35.3.04-.13.1-.25.17-.36.4-.6.9-1.02 1.49-1.27.26-.1.51-.17.76-.2V7.5a1.5 1.5 0 012.05-1.4c.07-.25.2-.48.39-.66L8.77 2.77a2.5 2.5 0 00-3.54 0L2.77 5.23zM12.5 6a.5.5 0 00-.5.5v5a.5.5 0 11-1 0v-4a.5.5 0 00-1 0v4.25a2.08 2.08 0 00-1.38.08c-.38.16-.74.44-1.04.9a.5.5 0 00.22.73 5.26 5.26 0 012.71 2.37c.55 1.03 1.6 2.17 2.99 2.17h.26A2.5 2.5 0 0016 16.62l.63-1.26a3.5 3.5 0 00.37-1.57V7.5a.5.5 0 00-1 0v4a.5.5 0 11-1 0v-5a.5.5 0 00-1 0v5a.5.5 0 11-1 0v-5a.5.5 0 00-.5-.5zm-9 6c.28 0 .5.22.5.5v.5h.5a.5.5 0 010 1H4v.5a.5.5 0 11-1 0V14h-.5a.5.5 0 110-1H3v-.5c0-.28.22-.5.5-.5zm3 3c.28 0 .5.22.5.5v.5h.5a.5.5 0 010 1H7v.5a.5.5 0 11-1 0V17h-.5a.5.5 0 110-1H6v-.5c0-.28.22-.5.5-.5z",
    fill: primaryFill
  }));
};

export const SanitizeFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SanitizeFilledIcon({}), 'SanitizeFilled');

const SanitizeRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.94 3.47L3.47 5.94a1.5 1.5 0 000 2.12l2.97 2.96c-.25.24-.45.51-.6.82L2.77 8.77a2.5 2.5 0 010-3.54l2.46-2.46a2.5 2.5 0 013.54 0L11.3 5.3c-.3.17-.55.39-.76.65L8.06 3.47a1.5 1.5 0 00-2.12 0zM15.9 7c-.2-.58-.76-1-1.41-1h-2c-.65 0-1.2.42-1.41 1H11a2 2 0 00-2 2v2.31a2.77 2.77 0 00-.56-.06c-.36 0-.77.08-1.13.35-.37.27-.65.69-.8 1.28a.5.5 0 00.3.58c1.9.81 3 2.1 3.61 3.03A3.1 3.1 0 0012.94 18h1.82A2.5 2.5 0 0017 16.62l.63-1.26a3.5 3.5 0 00.37-1.57V9a2 2 0 00-2-2h-.09zM14 7h.5c.28 0 .5.22.5.5v4a.5.5 0 101 0V8a1 1 0 011 1v4.8c0 .38-.09.76-.26 1.1l-.63 1.27c-.26.5-.78.83-1.35.83h-1.82c-.64 0-1.27-.42-1.68-1.05a9.01 9.01 0 00-3.64-3.21.91.91 0 01.28-.34.9.9 0 01.54-.15 2 2 0 01.83.2A.5.5 0 0010 12V9a1 1 0 011-1v3.5a.5.5 0 101 0v-4c0-.28.22-.5.5-.5h.5v4.5a.5.5 0 101 0V7zM3.5 12c.28 0 .5.22.5.5v.5h.5a.5.5 0 010 1H4v.5a.5.5 0 11-1 0V14h-.5a.5.5 0 110-1H3v-.5c0-.28.22-.5.5-.5zM7 15.5a.5.5 0 00-1 0v.5h-.5a.5.5 0 000 1H6v.5a.5.5 0 101 0V17h.5a.5.5 0 100-1H7v-.5z",
    fill: primaryFill
  }));
};

export const SanitizeRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SanitizeRegularIcon({}), 'SanitizeRegular');

const SaveFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 5c0-1.1.9-2 2-2h1v3.5C6 7.33 6.67 8 7.5 8h4c.83 0 1.5-.67 1.5-1.5V3h.38a2 2 0 011.41.59l1.62 1.62A2 2 0 0117 6.62V15a2 2 0 01-2 2v-5.5c0-.83-.67-1.5-1.5-1.5h-7c-.83 0-1.5.67-1.5 1.5V17a2 2 0 01-2-2V5zm9-2H7v3.5c0 .28.22.5.5.5h4a.5.5 0 00.5-.5V3zm2 8.5V17H6v-5.5c0-.28.22-.5.5-.5h7c.28 0 .5.22.5.5z",
    fill: primaryFill
  }));
};

export const SaveFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SaveFilledIcon({}), 'SaveFilled');

const SaveRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 5c0-1.1.9-2 2-2h8.38a2 2 0 011.41.59l1.62 1.62A2 2 0 0117 6.62V15a2 2 0 01-2 2H5a2 2 0 01-2-2V5zm2-1a1 1 0 00-1 1v10a1 1 0 001 1v-4.5c0-.83.67-1.5 1.5-1.5h7c.83 0 1.5.67 1.5 1.5V16a1 1 0 001-1V6.62a1 1 0 00-.3-.7L14.1 4.28a1 1 0 00-.71-.29H13v2.5c0 .83-.67 1.5-1.5 1.5h-4A1.5 1.5 0 016 6.5V4H5zm2 0v2.5c0 .28.22.5.5.5h4a.5.5 0 00.5-.5V4H7zm7 12v-4.5a.5.5 0 00-.5-.5h-7a.5.5 0 00-.5.5V16h8z",
    fill: primaryFill
  }));
};

export const SaveRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SaveRegularIcon({}), 'SaveRegular');

const SaveArrowRightFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 5c0-1.1.9-2 2-2h1v3.5C6 7.33 6.67 8 7.5 8h4c.83 0 1.5-.67 1.5-1.5V3h.38a2 2 0 011.41.59l1.62 1.62A2 2 0 0117 6.62V9.6a5.48 5.48 0 00-5.66.4H6.5c-.83 0-1.5.67-1.5 1.5V17a2 2 0 01-2-2V5zm6 9.5c0-1.33.47-2.55 1.26-3.5H6.5a.5.5 0 00-.5.5V17h3.6c-.38-.75-.6-1.6-.6-2.5zM12 3H7v3.5c0 .28.22.5.5.5h4a.5.5 0 00.5-.5V3zm7 11.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.15.35a.5.5 0 00.15-.35.5.5 0 00-.15-.35l-2-2a.5.5 0 00-.7.7L15.29 14H12.5a.5.5 0 000 1h2.8l-1.15 1.15a.5.5 0 00.7.7l2-2z",
    fill: primaryFill
  }));
};

export const SaveArrowRightFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SaveArrowRightFilledIcon({}), 'SaveArrowRightFilled');

const SaveArrowRightRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 5c0-1.1.9-2 2-2h8.38a2 2 0 011.41.59l1.62 1.62A2 2 0 0117 6.62V9.6c-.32-.16-.65-.3-1-.4V6.63a1 1 0 00-.3-.7L14.1 4.28a1 1 0 00-.71-.29H13v2.5c0 .83-.67 1.5-1.5 1.5h-4A1.5 1.5 0 016 6.5V4H5a1 1 0 00-1 1v10a1 1 0 001 1v-4.5c0-.83.67-1.5 1.5-1.5h4.84c-.4.28-.77.62-1.08 1H6.5a.5.5 0 00-.5.5V16h3.2c.1.35.24.68.4 1H5a2 2 0 01-2-2V5zm4-1v2.5c0 .28.22.5.5.5h4a.5.5 0 00.5-.5V4H7zm12 10.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.15.35a.5.5 0 00.15-.35.5.5 0 00-.15-.35l-2-2a.5.5 0 00-.7.7L15.29 14H12.5a.5.5 0 000 1h2.8l-1.15 1.15a.5.5 0 00.7.7l2-2z",
    fill: primaryFill
  }));
};

export const SaveArrowRightRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SaveArrowRightRegularIcon({}), 'SaveArrowRightRegular');

const SaveEditFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 3a2 2 0 00-2 2v10c0 1.1.9 2 2 2v-5.5c0-.83.67-1.5 1.5-1.5h6.44l1.16-1.16a2.87 2.87 0 012.9-.7V6.61a2 2 0 00-.59-1.41L14.8 3.59A2 2 0 0013.38 3H13v3.5c0 .83-.67 1.5-1.5 1.5h-4A1.5 1.5 0 016 6.5V3H5zm6.94 8l-2.67 2.67c-.4.41-.7.92-.84 1.49l-.37 1.5c-.03.11-.05.23-.06.34H6v-5.5c0-.28.22-.5.5-.5h5.44zM7 3h5v3.5a.5.5 0 01-.5.5h-4a.5.5 0 01-.5-.5V3zm7.8 6.55l-4.82 4.83a2.2 2.2 0 00-.58 1.02l-.37 1.5a.89.89 0 001.08 1.07l1.5-.37c.38-.1.73-.3 1.01-.58l4.83-4.83a1.87 1.87 0 00-2.64-2.64z",
    fill: primaryFill
  }));
};

export const SaveEditFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SaveEditFilledIcon({}), 'SaveEditFilled');

const SaveEditRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 3a2 2 0 00-2 2v10c0 1.1.9 2 2 2h3l.06-.35.16-.65H6v-4.5c0-.28.22-.5.5-.5h5.44l1-1H6.5c-.83 0-1.5.67-1.5 1.5V16a1 1 0 01-1-1V5a1 1 0 011-1h1v2.5C6 7.33 6.67 8 7.5 8h4c.83 0 1.5-.67 1.5-1.5V4h.38a1 1 0 01.7.3l1.63 1.61a1 1 0 01.29.71V8c.34-.01.68.03 1 .13v-1.5a2 2 0 00-.59-1.42L14.8 3.59A2 2 0 0013.38 3H5zm2 3.5V4h5v2.5a.5.5 0 01-.5.5h-4a.5.5 0 01-.5-.5zm7.8 3.05l-4.82 4.83a2.2 2.2 0 00-.58 1.02l-.37 1.5a.89.89 0 001.08 1.07l1.5-.37c.38-.1.73-.3 1.01-.58l4.83-4.83a1.87 1.87 0 00-2.64-2.64z",
    fill: primaryFill
  }));
};

export const SaveEditRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SaveEditRegularIcon({}), 'SaveEditRegular');

const SaveImageFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 2a2 2 0 00-2 2v10c0 1.1.9 2 2 2v-5.5C5 9.67 5.67 9 6.5 9h10c.17 0 .34.01.5.04V5.62a2 2 0 00-.59-1.41L14.8 2.59A2 2 0 0013.38 2H13v3.5c0 .83-.67 1.5-1.5 1.5h-4A1.5 1.5 0 016 5.5V2H5zm5.05 8A3.49 3.49 0 009 12.5V16H6v-5.5c0-.28.22-.5.5-.5h3.55zM12 2H7v3.5c0 .28.22.5.5.5h4a.5.5 0 00.5-.5V2zm-2 10.5a2.5 2.5 0 012.5-2.5h4a2.5 2.5 0 012.5 2.5v4c0 .5-.15.98-.41 1.38l-3.03-3.03a1.5 1.5 0 00-2.12 0l-3.03 3.03c-.26-.4-.41-.87-.41-1.38v-4zm7 .25a.75.75 0 10-1.5 0 .75.75 0 001.5 0zm-5.88 5.84c.4.26.87.41 1.38.41h4c.5 0 .98-.15 1.38-.41l-3.03-3.03a.5.5 0 00-.7 0l-3.03 3.03z",
    fill: primaryFill
  }));
};

export const SaveImageFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SaveImageFilledIcon({}), 'SaveImageFilled');

const SaveImageRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 6.13v2.9a3.53 3.53 0 00-.5-.03H16V6.13a.97.97 0 00-.29-.72L13.6 3.3A.96.96 0 0013 3V5.5a1.45 1.45 0 01-.44 1.06c-.14.13-.3.24-.48.32-.18.08-.38.12-.58.12h-4a1.45 1.45 0 01-1.05-.44 1.6 1.6 0 01-.33-.48A1.33 1.33 0 016 5.5V3H5a.97.97 0 00-.7.29c-.1.1-.17.2-.22.32A.86.86 0 004 4v10c0 .13.03.27.08.4.05.1.12.22.2.31.1.1.2.17.32.21.13.05.26.08.4.08v-4.5a1.45 1.45 0 01.44-1.05c.14-.14.3-.25.48-.33.18-.08.38-.12.58-.12h6c-.96 0-1.82.38-2.45 1H6.5a.5.5 0 00-.5.5V15h3v1H5c-.26 0-.52-.05-.76-.16a2.2 2.2 0 01-.64-.42 1.9 1.9 0 01-.6-1.38V4c0-.26.05-.52.16-.76.1-.24.24-.45.42-.64A1.9 1.9 0 014.96 2h7.92c.26 0 .52.05.76.15.25.1.47.25.65.44L16.4 4.7c.19.19.34.4.43.65.1.24.16.5.16.77zM7 3v2.5a.5.5 0 00.5.5h4a.5.5 0 00.5-.5V3H7zm3 9.5a2.5 2.5 0 012.5-2.5h4a2.5 2.5 0 012.5 2.5v4c0 .5-.15.98-.41 1.38l-3.03-3.03a1.5 1.5 0 00-2.12 0l-3.03 3.03c-.26-.4-.41-.87-.41-1.38v-4zm7 .25a.75.75 0 10-1.5 0 .75.75 0 001.5 0zm-5.88 5.84c.4.26.87.41 1.38.41h4c.5 0 .98-.15 1.38-.41l-3.03-3.03a.5.5 0 00-.7 0l-3.03 3.03z",
    fill: primaryFill
  }));
};

export const SaveImageRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SaveImageRegularIcon({}), 'SaveImageRegular');

const SaveMultipleFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 5.5V3H5a2 2 0 00-2 2v8c0 1.1.9 2 2 2v-4.5C5 9.67 5.67 9 6.5 9h5c.83 0 1.5.67 1.5 1.5V15a2 2 0 002-2V6.62a2 2 0 00-.59-1.41L12.8 3.59A2 2 0 0011.38 3H11v2.5c0 .83-.67 1.5-1.5 1.5h-2A1.5 1.5 0 016 5.5zm1 0V3h3v2.5a.5.5 0 01-.5.5h-2a.5.5 0 01-.5-.5zm5 9.5H6v-4.5c0-.28.22-.5.5-.5h5c.28 0 .5.22.5.5V15zm-3.5 2c-.95 0-1.82-.38-2.45-1h7.45a2.5 2.5 0 002.5-2.5V6.05c.62.63 1 1.5 1 2.45v5a3.5 3.5 0 01-3.5 3.5h-5z",
    fill: primaryFill
  }));
};

export const SaveMultipleFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SaveMultipleFilledIcon({}), 'SaveMultipleFilled');

const SaveMultipleRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 3a2 2 0 00-2 2v8c0 1.1.9 2 2 2h8a2 2 0 002-2V6.62a2 2 0 00-.59-1.41L12.8 3.59A2 2 0 0011.38 3H5zM4 5a1 1 0 011-1h1v1.5C6 6.33 6.67 7 7.5 7h2c.83 0 1.5-.67 1.5-1.5V4h.38a1 1 0 01.7.3l1.63 1.61a1 1 0 01.29.71V13a1 1 0 01-1 1v-3.5c0-.83-.67-1.5-1.5-1.5h-5C5.67 9 5 9.67 5 10.5V14a1 1 0 01-1-1V5zm3 .5V4h3v1.5a.5.5 0 01-.5.5h-2a.5.5 0 01-.5-.5zm5 5V14H6v-3.5c0-.28.22-.5.5-.5h5c.28 0 .5.22.5.5zM8.5 17c-.95 0-1.82-.38-2.45-1h7.45a2.5 2.5 0 002.5-2.5V6.05c.62.63 1 1.5 1 2.45v5a3.5 3.5 0 01-3.5 3.5h-5z",
    fill: primaryFill
  }));
};

export const SaveMultipleRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SaveMultipleRegularIcon({}), 'SaveMultipleRegular');

const SaveSearchFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 5c0-1.1.9-2 2-2h1v3.5C6 7.33 6.67 8 7.5 8h4c.83 0 1.5-.67 1.5-1.5V3h.38a2 2 0 011.41.59l1.62 1.62A2 2 0 0117 6.62V15a2 2 0 01-2 2v-5.5c0-.83-.67-1.5-1.5-1.5H9.33a4.5 4.5 0 00-6.33.67V5zm7.56 10.44L12.12 17H14v-5.5a.5.5 0 00-.5-.5h-3.26a4.5 4.5 0 01.32 4.44zM12 3H7v3.5c0 .28.22.5.5.5h4a.5.5 0 00.5-.5V3zm-2 10.5c0 .79-.26 1.51-.7 2.1l2.55 2.55a.5.5 0 01-.7.7L8.6 16.3a3.5 3.5 0 111.4-2.8zm-6 0a2.5 2.5 0 105 0 2.5 2.5 0 00-5 0z",
    fill: primaryFill
  }));
};

export const SaveSearchFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SaveSearchFilledIcon({}), 'SaveSearchFilled');

const SaveSearchRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 5c0-1.1.9-2 2-2h8.38a2 2 0 011.41.59l1.62 1.62A2 2 0 0117 6.62V15a2 2 0 01-2 2h-2.88l-1-1H14v-4.5a.5.5 0 00-.5-.5h-3.26a4.53 4.53 0 00-.91-1h4.17c.83 0 1.5.67 1.5 1.5V16a1 1 0 001-1V6.62a1 1 0 00-.3-.7L14.1 4.28a1 1 0 00-.71-.29H13v2.5c0 .83-.67 1.5-1.5 1.5h-4A1.5 1.5 0 016 6.5V4H5a1 1 0 00-1 1v4.76a4.52 4.52 0 00-1 .91V5zm4-1v2.5c0 .28.22.5.5.5h4a.5.5 0 00.5-.5V4H7zm3 9.5c0 .79-.26 1.51-.7 2.1l2.55 2.55a.5.5 0 01-.7.7L8.6 16.3a3.5 3.5 0 111.4-2.8zm-6 0a2.5 2.5 0 105 0 2.5 2.5 0 00-5 0z",
    fill: primaryFill
  }));
};

export const SaveSearchRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SaveSearchRegularIcon({}), 'SaveSearchRegular');

const SaveSyncFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 5c0-1.1.9-2 2-2h1v3.5C6 7.33 6.67 8 7.5 8h4c.83 0 1.5-.67 1.5-1.5V3h.38a2 2 0 011.41.59l1.62 1.62A2 2 0 0117 6.62V9.6a5.48 5.48 0 00-5.66.4H6.5c-.83 0-1.5.67-1.5 1.5V17a2 2 0 01-2-2V5zm6 9.5c0-1.33.47-2.55 1.26-3.5H6.5a.5.5 0 00-.5.5V17h3.6c-.38-.75-.6-1.6-.6-2.5zM12 3H7v3.5c0 .28.22.5.5.5h4a.5.5 0 00.5-.5V3zm-2 11.5a4.5 4.5 0 109 0 4.5 4.5 0 00-9 0zm6.5-3c.28 0 .5.22.5.5v1.5a.5.5 0 01-.5.5H15a.5.5 0 010-1h.47a1.97 1.97 0 00-.94-.25 2 2 0 00-1.44.59.5.5 0 01-.71-.71 3 3 0 013.62-.48V12c0-.28.22-.5.5-.5zm-.88 5.53a3 3 0 01-2.62-.18V17a.5.5 0 01-1 0v-1.5c0-.28.22-.5.5-.5H14a.5.5 0 010 1h-.47a1.97 1.97 0 00.94.25 2 2 0 001.44-.59.5.5 0 01.71.71 3 3 0 01-1 .66z",
    fill: primaryFill
  }));
};

export const SaveSyncFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SaveSyncFilledIcon({}), 'SaveSyncFilled');

const SaveSyncRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 5c0-1.1.9-2 2-2h8.38a2 2 0 011.41.59l1.62 1.62A2 2 0 0117 6.62V9.6c-.32-.16-.65-.3-1-.4V6.63a1 1 0 00-.3-.7L14.1 4.28a1 1 0 00-.71-.29H13v2.5c0 .83-.67 1.5-1.5 1.5h-4A1.5 1.5 0 016 6.5V4H5a1 1 0 00-1 1v10a1 1 0 001 1v-4.5c0-.83.67-1.5 1.5-1.5h4.84c-.4.28-.77.62-1.08 1H6.5a.5.5 0 00-.5.5V16h3.2c.1.35.24.68.4 1H5a2 2 0 01-2-2V5zm4-1v2.5c0 .28.22.5.5.5h4a.5.5 0 00.5-.5V4H7zm3 10.5a4.5 4.5 0 109 0 4.5 4.5 0 00-9 0zm6.5-3c.28 0 .5.22.5.5v1.5a.5.5 0 01-.5.5H15a.5.5 0 010-1h.47a1.97 1.97 0 00-.94-.25 2 2 0 00-1.44.59.5.5 0 01-.71-.71 3 3 0 013.62-.48V12c0-.28.22-.5.5-.5zm-.88 5.53a3 3 0 01-2.62-.18V17a.5.5 0 01-1 0v-1.5c0-.28.22-.5.5-.5H14a.5.5 0 010 1h-.47a1.97 1.97 0 00.94.25 2 2 0 001.44-.59.5.5 0 01.71.71 3 3 0 01-1 .66z",
    fill: primaryFill
  }));
};

export const SaveSyncRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SaveSyncRegularIcon({}), 'SaveSyncRegular');

const SavingsFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.65 4.06l.18.02a4.5 4.5 0 00-.7 3.2c.15.98.91 1.6 1.6 1.87l3.03 1.26c.68.29 1.65.39 2.46-.2a4.5 4.5 0 001.49-1.86c.19.58.29 1.23.29 1.96 0 1.75-.54 2.98-1.09 3.78a4.95 4.95 0 01-.91 1v1.41c0 .83-.67 1.5-1.5 1.5h-1.38c-.62 0-1.12-.5-1.12-1.12a.12.12 0 00-.12-.11h-1.76a.12.12 0 00-.12.11C10 17.5 9.5 18 8.88 18H7.5A1.5 1.5 0 016 16.5v-.54l-.16-.1c-.28-.18-.69-.5-1.2-1-.62-.64-1-1.34-1.2-1.8-.07-.17-.2-.27-.33-.3-.64-.1-1.11-.65-1.11-1.3V9.95c0-.63.45-1.17 1.08-1.27.11-.02.24-.13.3-.3a4.4 4.4 0 011-1.71A6.63 6.63 0 016 5.47v-2.3c0-.36.23-.61.48-.71.25-.1.58-.08.83.15.29.28.68.63 1.11.92.44.3.87.5 1.23.53zM6.75 9.5a.75.75 0 100-1.5.75.75 0 000 1.5zm10.29-2.46a3.5 3.5 0 01-1.4 2.36c-.43.31-1 .3-1.5.09l-3.03-1.26c-.48-.2-.88-.56-.98-1.05l-.02-.07a3.5 3.5 0 116.93-.07z",
    fill: primaryFill
  }));
};

export const SavingsFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SavingsFilledIcon({}), 'SavingsFilled');

const SavingsRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M16.95 9.54c.03.24.05.5.05.77 0 1.53-.46 2.56-.91 3.2a3.96 3.96 0 01-.85.89.5.5 0 00-.24.43v1.67a.5.5 0 01-.5.5h-1.38a.12.12 0 01-.12-.12c0-.61-.5-1.11-1.12-1.11h-1.76c-.62 0-1.12.5-1.12 1.11 0 .07-.05.12-.12.12H7.5a.5.5 0 01-.5-.5v-.85a.5.5 0 00-.34-.47l-.04-.02a6.37 6.37 0 01-1.26-1.01 4.99 4.99 0 01-1-1.49c-.19-.42-.57-.8-1.09-.88a.33.33 0 01-.27-.32V9.95c0-.14.1-.26.24-.29.55-.09.94-.51 1.1-.97.12-.4.36-.93.75-1.32a5.64 5.64 0 011.58-1.1l.02-.02A.5.5 0 007 5.79v-2.1c.25.22.55.46.87.67.43.3.95.56 1.48.66.12-.33.28-.65.48-.94l-.18-.02a2.9 2.9 0 01-1.23-.53 8.47 8.47 0 01-1.11-.92.77.77 0 00-.83-.15.76.76 0 00-.48.7v2.32a6.9 6.9 0 00-1.63 1.19 4.4 4.4 0 00-.99 1.7c-.06.18-.19.29-.3.3A1.3 1.3 0 002 9.96v1.5c0 .66.47 1.2 1.1 1.32.13.02.27.12.34.3.2.45.58 1.15 1.2 1.78A7.34 7.34 0 006 15.96v.54c0 .83.67 1.5 1.5 1.5h1.38c.62 0 1.12-.5 1.12-1.12 0-.06.05-.11.12-.11h1.76c.07 0 .12.05.12.11 0 .62.5 1.12 1.12 1.12h1.38c.83 0 1.5-.67 1.5-1.5v-1.42c.04-.03.1-.07.14-.12.22-.2.5-.48.77-.87A6.48 6.48 0 0018 10.3c0-.73-.1-1.38-.3-1.96-.18.43-.43.84-.75 1.2zm-.15-4.3a3.5 3.5 0 01-1.17 4.16c-.43.31-1 .29-1.49.09L11.1 8.23c-.49-.2-.9-.6-.99-1.12a3.5 3.5 0 016.7-1.88zm-1.76 3.35a2.5 2.5 0 10-3.94-1.63c0 .03.03.08.09.15.06.06.16.14.3.2l3.04 1.25c.13.06.26.08.35.08.09 0 .13-.03.16-.05zm-8.29.91a.75.75 0 100-1.5.75.75 0 000 1.5z",
    fill: primaryFill
  }));
};

export const SavingsRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SavingsRegularIcon({}), 'SavingsRegular');

const ScaleFillFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 5c0-1.1.9-2 2-2h10a2 2 0 012 2v10a2 2 0 01-2 2H5a2 2 0 01-2-2V5zm3.3 1.04a.5.5 0 00-.3.46v2a.5.5 0 001 0v-.8l1.15 1.15a.5.5 0 10.7-.7L7.71 7h.79a.5.5 0 000-1h-2a.5.5 0 00-.2.04zM6 11.5v2a.5.5 0 00.14.35.5.5 0 00.36.15h2a.5.5 0 000-1h-.8l1.15-1.15a.5.5 0 00-.7-.7L7 12.29v-.79a.5.5 0 00-1 0zm7.85-5.36A.5.5 0 0013.5 6h-2a.5.5 0 000 1h.8l-1.15 1.15a.5.5 0 00.7.7L13 7.71v.79a.5.5 0 001 0v-2a.5.5 0 00-.14-.35zm-.16 7.82a.5.5 0 00.3-.46v-2a.5.5 0 00-.99 0v.8l-1.15-1.15a.5.5 0 00-.7.7L12.29 13h-.79a.5.5 0 000 1h2a.5.5 0 00.2-.04z",
    fill: primaryFill
  }));
};

export const ScaleFillFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ScaleFillFilledIcon({}), 'ScaleFillFilled');

const ScaleFillRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 6.5a.5.5 0 01.14-.35A.5.5 0 016.5 6h2a.5.5 0 010 1h-.8l1.15 1.15a.5.5 0 11-.7.7L7 7.71v.79a.5.5 0 01-1 0v-2zm.04 7.2a.5.5 0 01-.04-.2v-2a.5.5 0 011 0v.8l1.15-1.15a.5.5 0 01.7.7L7.71 13h.79a.5.5 0 010 1h-2a.5.5 0 01-.46-.3zm7.65-7.66a.5.5 0 01.3.46v2a.5.5 0 01-.99 0v-.8l-1.15 1.15a.5.5 0 01-.7-.7L12.29 7h-.79a.5.5 0 010-1h2a.5.5 0 01.2.04zm.16 7.82a.5.5 0 01-.35.14h-2a.5.5 0 010-1h.8l-1.15-1.15a.5.5 0 01.7-.7L13 12.29v-.79a.5.5 0 011 0v2a.5.5 0 01-.14.35zM3 5c0-1.1.9-2 2-2h10a2 2 0 012 2v10a2 2 0 01-2 2H5a2 2 0 01-2-2V5zm2-1a1 1 0 00-1 1v10a1 1 0 001 1h10a1 1 0 001-1V5a1 1 0 00-1-1H5z",
    fill: primaryFill
  }));
};

export const ScaleFillRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ScaleFillRegularIcon({}), 'ScaleFillRegular');

const ScaleFitFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 6v8c0 1.1.9 2 2 2h12a2 2 0 002-2V6a2 2 0 00-2-2H4a2 2 0 00-2 2zm11.12 6.08a.5.5 0 01.05-.7l1-.88H11.5a.5.5 0 010-1h2.67l-1-.87a.5.5 0 01.66-.76l2 1.75a.5.5 0 010 .76l-2 1.75a.5.5 0 01-.7-.05zM6.88 7.92a.5.5 0 01-.05.7l-1 .88H8.5a.5.5 0 010 1H5.83l1 .87a.5.5 0 01-.66.76l-2-1.75a.5.5 0 010-.76l2-1.75a.5.5 0 01.7.05z",
    fill: primaryFill
  }));
};

export const ScaleFitFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ScaleFitFilledIcon({}), 'ScaleFitFilled');

const ScaleFitRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.88 7.92a.5.5 0 01-.05.7l-1 .88H8.5a.5.5 0 010 1H5.83l1 .87a.5.5 0 11-.66.76l-2-1.75a.5.5 0 010-.76l2-1.75a.5.5 0 01.7.05zm7.29 2.58l-1 .87a.5.5 0 00.66.76l2-1.75a.5.5 0 000-.76l-2-1.75a.5.5 0 00-.66.76l1 .87H11.5a.5.5 0 000 1h2.67zM2 6c0-1.1.9-2 2-2h12a2 2 0 012 2v8a2 2 0 01-2 2H4a2 2 0 01-2-2V6zm2-1a1 1 0 00-1 1v8a1 1 0 001 1h12a1 1 0 001-1V6a1 1 0 00-1-1H4z",
    fill: primaryFill
  }));
};

export const ScaleFitRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ScaleFitRegularIcon({}), 'ScaleFitRegular');

const ScanFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.7 3.5L7.02 8.19l-.18.33-1.65-2.87A6.48 6.48 0 019.7 3.51zM8.28 9l.03-.05a2 2 0 013.43.05l.03.06a2 2 0 01-.03 1.94l-.03.05A2 2 0 018.27 11l-.03-.06A2 2 0 018.27 9zm-1.35 2.67l.2.33h-3.3a6.5 6.5 0 01.41-5l2.7 4.67zM10 13.5l.3-.01-1.66 2.87a6.5 6.5 0 01-4.12-2.86H10zm2.99-1.68l.18-.33 1.65 2.87a6.48 6.48 0 01-4.53 2.13l2.7-4.67zm.09-3.49a3.52 3.52 0 00-.2-.33h3.3a6.5 6.5 0 01-.41 5l-2.7-4.67zM10 6.5l-.3.01 1.66-2.87a6.5 6.5 0 014.12 2.86H10zM10 2a8 8 0 100 16 8 8 0 000-16z",
    fill: primaryFill
  }));
};

export const ScanFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ScanFilledIcon({}), 'ScanFilled');

const ScanRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.91 5.19a6.98 6.98 0 015.65-2.17L7.4 8.5c-.1.18-.19.36-.25.56L4.91 5.2zm-.67.83l3.12 5.4a3 3 0 00.4.58H3.3a7 7 0 01.95-5.98zM8.27 11l-.04-.06A2 2 0 0111.73 9l.04.06A2 2 0 018.27 11zm1.12-3.94l2.23-3.87c2.08.5 3.8 1.92 4.7 3.81H10c-.21 0-.42.02-.61.06zm2.85.94h4.47a7 7 0 01-.95 5.98l-3.12-5.4c-.1-.2-.25-.4-.4-.58zm.61 2.94l2.24 3.87a6.98 6.98 0 01-5.65 2.17l3.16-5.48c.1-.18.19-.36.25-.56zm-2.24 2L8.38 16.8A7.01 7.01 0 013.68 13H10c.21 0 .42-.02.61-.06zM10 2a8 8 0 100 16 8 8 0 000-16z",
    fill: primaryFill
  }));
};

export const ScanRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ScanRegularIcon({}), 'ScanRegular');

const ScanCameraFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 6.25C3 4.45 4.46 3 6.25 3H7.6a.75.75 0 110 1.5H6.25c-.97 0-1.75.78-1.75 1.75V7.6a.75.75 0 11-1.5 0V6.25zm8.65-2.5c0-.41.34-.75.75-.75h1.35C15.55 3 17 4.46 17 6.25V7.6a.75.75 0 01-1.5 0V6.25c0-.97-.78-1.75-1.75-1.75H12.4a.75.75 0 01-.75-.75zm-7.9 7.9c.41 0 .75.34.75.75v1.35c0 .97.78 1.75 1.75 1.75H7.6a.75.75 0 010 1.5H6.25A3.25 3.25 0 013 13.75V12.4c0-.41.34-.75.75-.75zm12.5 0c.41 0 .75.34.75.75v1.35c0 1.8-1.46 3.25-3.25 3.25H12.4a.75.75 0 010-1.5h1.35c.97 0 1.75-.78 1.75-1.75V12.4c0-.41.34-.75.75-.75zM10 11a1 1 0 100-2 1 1 0 000 2zm-4 1V9a1 1 0 011-1h1l.7-1.05a1 1 0 01.84-.45h.92a1 1 0 01.84.45L12 8h1a1 1 0 011 1v3a1 1 0 01-1 1H7a1 1 0 01-1-1zm6-2a2 2 0 10-4 0 2 2 0 004 0z",
    fill: primaryFill
  }));
};

export const ScanCameraFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ScanCameraFilledIcon({}), 'ScanCameraFilled');

const ScanCameraRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 6a3 3 0 013-3h1.5a.5.5 0 010 1H6a2 2 0 00-2 2v1.5a.5.5 0 01-1 0V6zm9-2.5c0-.28.22-.5.5-.5H14a3 3 0 013 3v1.5a.5.5 0 01-1 0V6a2 2 0 00-2-2h-1.5a.5.5 0 01-.5-.5zM3.5 12c.28 0 .5.22.5.5V14c0 1.1.9 2 2 2h1.5a.5.5 0 010 1H6a3 3 0 01-3-3v-1.5c0-.28.22-.5.5-.5zm13 0c.28 0 .5.22.5.5V14a3 3 0 01-3 3h-1.5a.5.5 0 010-1H14a2 2 0 002-2v-1.5c0-.28.22-.5.5-.5zM10 11a1 1 0 100-2 1 1 0 000 2zm-4 1V9a1 1 0 011-1h1l.7-1.05a1 1 0 01.84-.45h.92a1 1 0 01.84.45L12 8h1a1 1 0 011 1v3a1 1 0 01-1 1H7a1 1 0 01-1-1zm6-2a2 2 0 10-4 0 2 2 0 004 0z",
    fill: primaryFill
  }));
};

export const ScanCameraRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ScanCameraRegularIcon({}), 'ScanCameraRegular');

const ScanDashFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.25 3A3.25 3.25 0 003 6.25V7.6a.75.75 0 101.5 0V6.25c0-.97.78-1.75 1.75-1.75H7.6a.75.75 0 100-1.5H6.25zm6.15 0a.75.75 0 000 1.5h1.35c.97 0 1.75.78 1.75 1.75V7.6a.75.75 0 001.5 0V6.25C17 4.45 15.54 3 13.75 3H12.4zm-7.9 9.4a.75.75 0 00-1.5 0v1.35C3 15.55 4.46 17 6.25 17H7.6a.75.75 0 000-1.5H6.25c-.97 0-1.75-.78-1.75-1.75V12.4zm12.5 0a.75.75 0 00-1.5 0v1.35c0 .97-.78 1.75-1.75 1.75H12.4a.75.75 0 000 1.5h1.35c1.8 0 3.25-1.46 3.25-3.25V12.4zM6.75 9.25a.75.75 0 000 1.5h6.5a.75.75 0 000-1.5h-6.5z",
    fill: primaryFill
  }));
};

export const ScanDashFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ScanDashFilledIcon({}), 'ScanDashFilled');

const ScanDashRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 3a3 3 0 00-3 3v1.5a.5.5 0 001 0V6c0-1.1.9-2 2-2h1.5a.5.5 0 000-1H6zm6.5 0a.5.5 0 000 1H14a2 2 0 012 2v1.5a.5.5 0 001 0V6a3 3 0 00-3-3h-1.5zM4 12.5a.5.5 0 00-1 0V14a3 3 0 003 3h1.5a.5.5 0 000-1H6a2 2 0 01-2-2v-1.5zm13 0a.5.5 0 00-1 0V14a2 2 0 01-2 2h-1.5a.5.5 0 000 1H14a3 3 0 003-3v-1.5zm-10.5-3a.5.5 0 000 1h7a.5.5 0 000-1h-7z",
    fill: primaryFill
  }));
};

export const ScanDashRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ScanDashRegularIcon({}), 'ScanDashRegular');

const ScanObjectFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 4.5C3 3.67 3.67 3 4.5 3h2a.5.5 0 000-1h-2A2.5 2.5 0 002 4.5v2a.5.5 0 001 0v-2zm14 11c0 .83-.67 1.5-1.5 1.5h-2a.5.5 0 000 1h2a2.5 2.5 0 002.5-2.5v-2a.5.5 0 00-1 0v2zM15.5 3c.83 0 1.5.67 1.5 1.5v2a.5.5 0 001 0v-2A2.5 2.5 0 0015.5 2h-2a.5.5 0 000 1h2zM3 15.5c0 .83.67 1.5 1.5 1.5h2a.5.5 0 010 1h-2A2.5 2.5 0 012 15.5v-2a.5.5 0 011 0v2zm8.23-8.6a1.5 1.5 0 00-2.46 0l-2.6 3.75A1.5 1.5 0 007.42 13h5.18a1.5 1.5 0 001.23-2.35L11.23 6.9z",
    fill: primaryFill
  }));
};

export const ScanObjectFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ScanObjectFilledIcon({}), 'ScanObjectFilled');

const ScanObjectRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.5 3C3.67 3 3 3.67 3 4.5v2a.5.5 0 01-1 0v-2A2.5 2.5 0 014.5 2h2a.5.5 0 010 1h-2zm11 14c.83 0 1.5-.67 1.5-1.5v-2a.5.5 0 011 0v2a2.5 2.5 0 01-2.5 2.5h-2a.5.5 0 010-1h2zM17 4.5c0-.83-.67-1.5-1.5-1.5h-2a.5.5 0 010-1h2A2.5 2.5 0 0118 4.5v2a.5.5 0 01-1 0v-2zM4.5 17A1.5 1.5 0 013 15.5v-2a.5.5 0 00-1 0v2A2.5 2.5 0 004.5 18h2a.5.5 0 000-1h-2zm6.73-10.1a1.5 1.5 0 00-2.46 0l-2.6 3.75A1.5 1.5 0 007.42 13h5.18a1.5 1.5 0 001.23-2.35L11.23 6.9zm-1.64.57a.5.5 0 01.82 0l2.6 3.75a.5.5 0 01-.42.78H7.41a.5.5 0 01-.41-.78l2.59-3.75z",
    fill: primaryFill
  }));
};

export const ScanObjectRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ScanObjectRegularIcon({}), 'ScanObjectRegular');

const ScanTableFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 4.5c-.83 0-1.5.67-1.5 1.5v1.75a.75.75 0 01-1.5 0V6a3 3 0 013-3h1.75a.75.75 0 010 1.5H6zM6 8c0-1.1.9-2 2-2h4a2 2 0 012 2H6zm0 1v3c0 1.1.9 2 2 2h4a2 2 0 002-2V9H6zm6.25-6a.75.75 0 000 1.5H14c.83 0 1.5.67 1.5 1.5v1.75a.75.75 0 001.5 0V6a3 3 0 00-3-3h-1.75zm-8.5 8.5c.41 0 .75.34.75.75V14c0 .83.67 1.5 1.5 1.5h1.75a.75.75 0 010 1.5H6a3 3 0 01-3-3v-1.75c0-.41.34-.75.75-.75zm13.25.75a.75.75 0 00-1.5 0V14c0 .83-.67 1.5-1.5 1.5h-1.75a.75.75 0 000 1.5H14a3 3 0 003-3v-1.75z",
    fill: primaryFill
  }));
};

export const ScanTableFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ScanTableFilledIcon({}), 'ScanTableFilled');

const ScanTableRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 4a2 2 0 00-2 2v1.5a.5.5 0 01-1 0V6a3 3 0 013-3h1.5a.5.5 0 010 1H6zm2 2a2 2 0 00-2 2v4c0 1.1.9 2 2 2h4a2 2 0 002-2V8a2 2 0 00-2-2H8zm5 2H7a1 1 0 011-1h4a1 1 0 011 1zM7 9h6v3a1 1 0 01-1 1H8a1 1 0 01-1-1V9zm5.5-6a.5.5 0 000 1H14a2 2 0 012 2v1.5a.5.5 0 001 0V6a3 3 0 00-3-3h-1.5zm-9 9c.28 0 .5.22.5.5V14c0 1.1.9 2 2 2h1.5a.5.5 0 010 1H6a3 3 0 01-3-3v-1.5c0-.28.22-.5.5-.5zm13.5.5a.5.5 0 00-1 0V14a2 2 0 01-2 2h-1.5a.5.5 0 000 1H14a3 3 0 003-3v-1.5z",
    fill: primaryFill
  }));
};

export const ScanTableRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ScanTableRegularIcon({}), 'ScanTableRegular');

const ScanTextFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 4.5c-.83 0-1.5.67-1.5 1.5v1.75a.75.75 0 01-1.5 0V6a3 3 0 013-3h1.75a.75.75 0 010 1.5H6zm0 2.25c0-.41.34-.75.75-.75h6.5a.75.75 0 010 1.5h-6.5A.75.75 0 016 6.75zm0 3c0-.41.34-.75.75-.75h6.5a.75.75 0 010 1.5h-6.5A.75.75 0 016 9.75zM6.75 12a.75.75 0 000 1.5h3.5a.75.75 0 000-1.5h-3.5zm5.5-9a.75.75 0 000 1.5H14c.83 0 1.5.67 1.5 1.5v1.75a.75.75 0 001.5 0V6a3 3 0 00-3-3h-1.75zm-8.5 8.5c.41 0 .75.34.75.75V14c0 .83.67 1.5 1.5 1.5h1.75a.75.75 0 010 1.5H6a3 3 0 01-3-3v-1.75c0-.41.34-.75.75-.75zm13.25.75a.75.75 0 00-1.5 0V14c0 .83-.67 1.5-1.5 1.5h-1.75a.75.75 0 000 1.5H14a3 3 0 003-3v-1.75z",
    fill: primaryFill
  }));
};

export const ScanTextFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ScanTextFilledIcon({}), 'ScanTextFilled');

const ScanTextRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 4a2 2 0 00-2 2v1.5a.5.5 0 01-1 0V6a3 3 0 013-3h1.5a.5.5 0 010 1H6zm0 2.5c0-.28.22-.5.5-.5h7a.5.5 0 010 1h-7a.5.5 0 01-.5-.5zm0 3c0-.28.22-.5.5-.5h7a.5.5 0 010 1h-7a.5.5 0 01-.5-.5zm.5 2.5a.5.5 0 000 1h4a.5.5 0 000-1h-4zm6-9a.5.5 0 000 1H14a2 2 0 012 2v1.5a.5.5 0 001 0V6a3 3 0 00-3-3h-1.5zm-9 9c.28 0 .5.22.5.5V14c0 1.1.9 2 2 2h1.5a.5.5 0 010 1H6a3 3 0 01-3-3v-1.5c0-.28.22-.5.5-.5zm13.5.5a.5.5 0 00-1 0V14a2 2 0 01-2 2h-1.5a.5.5 0 000 1H14a3 3 0 003-3v-1.5z",
    fill: primaryFill
  }));
};

export const ScanTextRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ScanTextRegularIcon({}), 'ScanTextRegular');

const ScanThumbUpFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 4.5C3 3.67 3.67 3 4.5 3h2a.5.5 0 000-1h-2A2.5 2.5 0 002 4.5v2a.5.5 0 001 0v-2zm14 11c0 .83-.67 1.5-1.5 1.5h-2a.5.5 0 000 1h2a2.5 2.5 0 002.5-2.5v-2a.5.5 0 00-1 0v2zM15.5 3c.83 0 1.5.67 1.5 1.5v2a.5.5 0 001 0v-2A2.5 2.5 0 0015.5 2h-2a.5.5 0 000 1h2zM3 15.5c0 .83.67 1.5 1.5 1.5h2a.5.5 0 010 1h-2A2.5 2.5 0 012 15.5v-2a.5.5 0 011 0v2zM9.52 5.4c.2-.47.8-1.08 1.63-.85.54.14.92.46 1.13.9.19.39.22.81.23 1.15 0 .36-.06.76-.14 1.1h.28c1.2 0 2.13 1.13 1.77 2.3l-.92 3a2.2 2.2 0 01-2.74 1.4l-3.6-1.08a1.82 1.82 0 01-1.19-1.07l-.35-.89c-.32-.83.03-1.74.8-2.18l1.24-.7.03-.02c.04-.04.12-.1.22-.21.2-.22.5-.6.79-1.2l.36-.71c.18-.33.3-.58.46-.94z",
    fill: primaryFill
  }));
};

export const ScanThumbUpFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ScanThumbUpFilledIcon({}), 'ScanThumbUpFilled');

const ScanThumbUpRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 4.5C3 3.67 3.67 3 4.5 3h2a.5.5 0 000-1h-2A2.5 2.5 0 002 4.5v2a.5.5 0 001 0v-2zm14 11c0 .83-.67 1.5-1.5 1.5h-2a.5.5 0 000 1h2a2.5 2.5 0 002.5-2.5v-2a.5.5 0 00-1 0v2zM15.5 3c.83 0 1.5.67 1.5 1.5v2a.5.5 0 001 0v-2A2.5 2.5 0 0015.5 2h-2a.5.5 0 000 1h2zM3 15.5c0 .83.67 1.5 1.5 1.5h2a.5.5 0 010 1h-2A2.5 2.5 0 012 15.5v-2a.5.5 0 011 0v2zm8.15-10.95c-.83-.23-1.43.38-1.63.85-.15.36-.28.61-.45.94l-.37.71a4.98 4.98 0 01-1.04 1.43l-1.24.7a1.76 1.76 0 00-.8 2.18l.35.9c.2.51.65.9 1.18 1.06l3.61 1.08A2.2 2.2 0 0013.5 13l.92-3c.36-1.17-.56-2.3-1.77-2.3h-.28c.08-.34.14-.74.14-1.1-.01-.34-.04-.76-.23-1.15a1.68 1.68 0 00-1.13-.9zm-4.24 5.5l1.24-.7a.5.5 0 00.04-.02h.01v-.01l.02-.01.1-.08A5.97 5.97 0 009.6 7.5l.35-.69c.17-.32.32-.61.5-1.02.03-.08.1-.17.19-.23a.3.3 0 01.26-.04c.26.07.4.2.48.38.09.18.12.43.13.73 0 .28-.06.64-.15.99-.03.16-.08.31-.12.45a.5.5 0 00.48.65h.93c.6 0 .96.53.82 1l-.92 2.99a1.2 1.2 0 01-1.5.75l-3.61-1.09a.82.82 0 01-.54-.48L6.55 11a.76.76 0 01.36-.94z",
    fill: primaryFill
  }));
};

export const ScanThumbUpRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ScanThumbUpRegularIcon({}), 'ScanThumbUpRegular');

const ScanThumbUpOffFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.41 3.12C2.15 3.52 2 4 2 4.5v2a.5.5 0 001 0v-2c0-.23.05-.45.15-.65l4.57 4.58a1.42 1.42 0 01-.06.05l-1.24.7a1.76 1.76 0 00-.8 2.18l.35.9c.2.51.65.9 1.18 1.06l3.61 1.08c.85.26 1.75-.01 2.3-.63l3.09 3.08c-.2.1-.42.15-.65.15h-2a.5.5 0 000 1h2c.5 0 .98-.15 1.38-.41l.27.26a.5.5 0 00.7-.7l-15-15a.5.5 0 10-.7.7l.26.27zm6.45 3.62l5.02 5.02.54-1.76c.36-1.17-.56-2.3-1.77-2.3h-.28c.08-.34.14-.74.14-1.1-.01-.34-.04-.76-.23-1.15a1.68 1.68 0 00-1.13-.9c-.83-.23-1.43.38-1.63.85-.15.36-.28.61-.45.94a37 37 0 00-.21.4zM17 14.88l.98.97.02-.35v-2a.5.5 0 00-1 0v1.38zM4.15 2.02l.97.98H6.5a.5.5 0 000-1h-2c-.12 0-.24 0-.35.02zM15.5 3c.83 0 1.5.67 1.5 1.5v2a.5.5 0 001 0v-2A2.5 2.5 0 0015.5 2h-2a.5.5 0 000 1h2zM3 15.5c0 .83.67 1.5 1.5 1.5h2a.5.5 0 010 1h-2A2.5 2.5 0 012 15.5v-2a.5.5 0 011 0v2z",
    fill: primaryFill
  }));
};

export const ScanThumbUpOffFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ScanThumbUpOffFilledIcon({}), 'ScanThumbUpOffFilled');

const ScanThumbUpOffRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.41 3.12C2.15 3.52 2 4 2 4.5v2a.5.5 0 001 0v-2c0-.23.05-.45.15-.65l4.57 4.58a1.42 1.42 0 01-.06.05l-1.24.7a1.76 1.76 0 00-.8 2.18l.35.9c.2.51.65.9 1.18 1.06l3.61 1.08c.85.26 1.75-.01 2.3-.63l3.09 3.08c-.2.1-.42.15-.65.15h-2a.5.5 0 000 1h2c.5 0 .98-.15 1.38-.41l.27.26a.5.5 0 00.7-.7l-15-15a.5.5 0 10-.7.7l.26.27zm9.94 9.94c-.29.36-.8.54-1.3.39l-3.61-1.09a.82.82 0 01-.54-.48L6.55 11a.76.76 0 01.36-.94l1.24-.7a.5.5 0 00.04-.02h.01v-.01l.02-.01a1.79 1.79 0 00.21-.17l3.92 3.92zm-3.5-6.32l.75.74.35-.68c.17-.32.32-.61.5-1.02.03-.08.1-.17.19-.23a.3.3 0 01.26-.04c.26.07.4.2.48.38.09.18.12.43.13.73 0 .28-.06.64-.15.99-.03.16-.08.31-.12.45a.5.5 0 00.48.65h.93c.6 0 .96.53.82 1l-.39 1.25.8.8.54-1.76c.36-1.17-.56-2.3-1.77-2.3h-.28c.08-.34.14-.74.14-1.1-.01-.34-.04-.76-.23-1.15a1.68 1.68 0 00-1.13-.9c-.83-.23-1.43.38-1.63.85-.15.36-.28.61-.45.94l-.21.4zM17 14.88l.98.97.02-.35v-2a.5.5 0 00-1 0v1.38zM4.15 2.02l.97.98H6.5a.5.5 0 000-1h-2c-.12 0-.24 0-.35.02zM15.5 3c.83 0 1.5.67 1.5 1.5v2a.5.5 0 001 0v-2A2.5 2.5 0 0015.5 2h-2a.5.5 0 000 1h2zM3 15.5c0 .83.67 1.5 1.5 1.5h2a.5.5 0 010 1h-2A2.5 2.5 0 012 15.5v-2a.5.5 0 011 0v2z",
    fill: primaryFill
  }));
};

export const ScanThumbUpOffRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ScanThumbUpOffRegularIcon({}), 'ScanThumbUpOffRegular');

const ScanTypeFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.75 3.5c-.69 0-1.25.56-1.25 1.25v1.5a.75.75 0 01-1.5 0v-1.5A2.75 2.75 0 014.75 2h1.5a.75.75 0 010 1.5h-1.5zm0 13c-.69 0-1.25-.56-1.25-1.25v-1.5a.75.75 0 00-1.5 0v1.5A2.75 2.75 0 004.75 18h1.5a.75.75 0 000-1.5h-1.5zM16.5 4.75c0-.69-.56-1.25-1.25-1.25h-1.5a.75.75 0 010-1.5h1.5A2.75 2.75 0 0118 4.75v1.5a.75.75 0 01-1.5 0v-1.5zM15.25 16.5c.69 0 1.25-.56 1.25-1.25v-1.5a.75.75 0 011.5 0v1.5A2.75 2.75 0 0115.25 18h-1.5a.75.75 0 010-1.5h1.5zM6.5 5a.75.75 0 00-.75.75v1a.75.75 0 001.5 0V6.5h2v7H9A.75.75 0 009 15h2a.75.75 0 000-1.5h-.25v-7h2v.25a.75.75 0 001.5 0v-1A.75.75 0 0013.5 5h-7z",
    fill: primaryFill
  }));
};

export const ScanTypeFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ScanTypeFilledIcon({}), 'ScanTypeFilled');

const ScanTypeRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.5 3C3.67 3 3 3.67 3 4.5v2a.5.5 0 01-1 0v-2A2.5 2.5 0 014.5 2h2a.5.5 0 010 1h-2zM5 17a2 2 0 01-2-2v-1.5a.5.5 0 00-1 0V15a3 3 0 003 3h1.5a.5.5 0 000-1H5zM17 4.5c0-.83-.67-1.5-1.5-1.5h-2a.5.5 0 010-1h2A2.5 2.5 0 0118 4.5v2a.5.5 0 01-1 0v-2zM15 17a2 2 0 002-2v-1.5a.5.5 0 011 0V15a3 3 0 01-3 3h-1.5a.5.5 0 010-1H15zM6.5 5a.5.5 0 00-.5.5v1a.5.5 0 001 0V6h2.5v8H9a.5.5 0 000 1h2a.5.5 0 000-1h-.5V6H13v.5a.5.5 0 001 0v-1a.5.5 0 00-.5-.5h-7z",
    fill: primaryFill
  }));
};

export const ScanTypeRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ScanTypeRegularIcon({}), 'ScanTypeRegular');

const ScanTypeCheckmarkFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.75 3.5c-.69 0-1.25.56-1.25 1.25v1.5a.75.75 0 01-1.5 0v-1.5A2.75 2.75 0 014.75 2h1.5a.75.75 0 010 1.5h-1.5zm0 13c-.69 0-1.25-.56-1.25-1.25v-1.5a.75.75 0 00-1.5 0v1.5A2.75 2.75 0 004.75 18h1.5a.75.75 0 000-1.5h-1.5zM16.5 4.75c0-.69-.56-1.25-1.25-1.25h-1.5a.75.75 0 010-1.5h1.5A2.75 2.75 0 0118 4.75v1.5a.75.75 0 01-1.5 0v-1.5zM6.5 5a.75.75 0 00-.75.75v1a.75.75 0 001.5 0V6.5h2v6.36a5.5 5.5 0 011.5-2.38V6.5h2v.25a.75.75 0 001.5 0v-1A.75.75 0 0013.5 5h-7zm1.25 8.5h1.34a5.53 5.53 0 00-.07 1.5H7.75a.75.75 0 010-1.5zm11.25 1a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-5.5.8l-.65-.65a.5.5 0 00-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 00-.7-.7l-2.65 2.64z",
    fill: primaryFill
  }));
};

export const ScanTypeCheckmarkFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ScanTypeCheckmarkFilledIcon({}), 'ScanTypeCheckmarkFilled');

const ScanTypeCheckmarkRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.5 3C3.67 3 3 3.67 3 4.5v2a.5.5 0 01-1 0v-2A2.5 2.5 0 014.5 2h2a.5.5 0 010 1h-2zM5 17a2 2 0 01-2-2v-1.5a.5.5 0 00-1 0V15a3 3 0 003 3h1.5a.5.5 0 000-1H5zM17 4.5c0-.83-.67-1.5-1.5-1.5h-2a.5.5 0 010-1h2A2.5 2.5 0 0118 4.5v2a.5.5 0 01-1 0v-2zM6.5 5a.5.5 0 00-.5.5v1a.5.5 0 001 0V6h2.5v6.2c.25-.54.6-1.04 1-1.47V6H13v.5a.5.5 0 001 0v-1a.5.5 0 00-.5-.5h-7zM8 14h1.02a5.57 5.57 0 000 1H8a.5.5 0 010-1zm11 .5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.85-1.85l-2.65 2.64-.65-.64a.5.5 0 00-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 00-.7-.7z",
    fill: primaryFill
  }));
};

export const ScanTypeCheckmarkRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ScanTypeCheckmarkRegularIcon({}), 'ScanTypeCheckmarkRegular');

const ScanTypeOffFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.48 3.2c-.3.43-.48.97-.48 1.55v1.5a.75.75 0 001.5 0v-1.5c0-.16.03-.32.09-.46l2.16 2.17v.29a.75.75 0 001 .7l2.5 2.5v3.55H9A.75.75 0 009 15h2a.75.75 0 000-1.5h-.25v-2.04l4.96 4.95c-.14.06-.3.09-.46.09h-1.5a.75.75 0 000 1.5h1.5c.58 0 1.12-.18 1.56-.48l.34.33a.5.5 0 00.7-.7l-.33-.34-1.1-1.1L5.94 5.24 4.29 3.6l-1.1-1.1-.34-.34a.5.5 0 10-.7.7l.33.34zM18 15.24c0 .2-.02.39-.06.57l-1.44-1.44v-.63a.75.75 0 011.5 0v1.5zM10.75 6.5v2.13l-1.5-1.5V6.5h-.63L7.12 5h6.38c.41 0 .75.34.75.75v1a.75.75 0 01-1.5 0V6.5h-2zm-4.5-3h-.63L4.18 2.06c.18-.04.37-.06.57-.06h1.5a.75.75 0 010 1.5zm-1.5 13c-.69 0-1.25-.56-1.25-1.25v-1.5a.75.75 0 00-1.5 0v1.5A2.75 2.75 0 004.75 18h1.5a.75.75 0 000-1.5h-1.5zM16.5 4.75c0-.69-.56-1.25-1.25-1.25h-1.5a.75.75 0 010-1.5h1.5A2.75 2.75 0 0118 4.75v1.5a.75.75 0 01-1.5 0v-1.5z",
    fill: primaryFill
  }));
};

export const ScanTypeOffFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ScanTypeOffFilledIcon({}), 'ScanTypeOffFilled');

const ScanTypeOffRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.41 3.12C2.15 3.52 2 4 2 4.5v2a.5.5 0 001 0v-2c0-.23.05-.45.15-.65l6.35 6.36V14H9a.5.5 0 100 1h2a.5.5 0 000-1h-.5v-2.8l5.52 5.52A2 2 0 0115 17h-1.5a.5.5 0 100 1H15c.65 0 1.25-.2 1.74-.55l.4.4a.5.5 0 00.71-.7l-.4-.41-.73-.72L6.03 5.32 3.85 3.15l-.73-.74-.27-.26a.5.5 0 10-.7.7l.26.27zM18 15a3 3 0 01-.1.78l-.9-.9V13.5a.5.5 0 111 0V15zm-7.5-9v2.38l-1-1V6H8.12l-1-1h6.38c.28 0 .5.22.5.5v1a.5.5 0 01-1 0V6h-2.5zm-4-3H5.12l-.97-.98L4.5 2h2a.5.5 0 010 1zM5 17a2 2 0 01-2-2v-1.5a.5.5 0 10-1 0V15a3 3 0 003 3h1.5a.5.5 0 000-1H5zM17 4.5c0-.83-.67-1.5-1.5-1.5h-2a.5.5 0 010-1h2A2.5 2.5 0 0118 4.5v2a.5.5 0 01-1 0v-2z",
    fill: primaryFill
  }));
};

export const ScanTypeOffRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ScanTypeOffRegularIcon({}), 'ScanTypeOffRegular');

const ScratchpadFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.5 2C3.67 2 3 2.67 3 3.5v13c0 .83.67 1.5 1.5 1.5H12v-.7A5.5 5.5 0 018 12H6.5a.5.5 0 010-1h1.59c.2-.58.76-1 1.41-1v-.5h-3a.5.5 0 010-1h3c0-.53.1-1.04.3-1.5H6.5a.5.5 0 010-1h3.88a4 4 0 016.62.56V3.5c0-.83-.67-1.5-1.5-1.5h-11zm9 3.5a3 3 0 00-3 3v3a3 3 0 106 0v-3a3 3 0 00-3-3zm-4 5.5c.28 0 .5.22.5.5v.5a3.5 3.5 0 107 0v-.5a.5.5 0 011 0v.5a4.5 4.5 0 01-4 4.47V18a.5.5 0 01-1 0v-1.53A4.5 4.5 0 019 12v-.5c0-.28.22-.5.5-.5z",
    fill: primaryFill
  }));
};

export const ScratchpadFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ScratchpadFilledIcon({}), 'ScratchpadFilled');

const ScratchpadRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.5 2C3.67 2 3 2.67 3 3.5v13c0 .83.67 1.5 1.5 1.5H12v-.7a5.46 5.46 0 01-.8-.3H4.5a.5.5 0 01-.5-.5v-13c0-.28.22-.5.5-.5h11c.28 0 .5.22.5.5v1.88c.4.32.75.72 1 1.18V3.5c0-.83-.67-1.5-1.5-1.5h-11zM8 11.5c0-.18.03-.34.09-.5H6.5a.5.5 0 000 1H8v-.5zm-1.5-3h3v1h-3a.5.5 0 010-1zM9.8 7a4 4 0 01.58-1H6.5a.5.5 0 000 1h3.3zm3.7-1.5a3 3 0 00-3 3v3a3 3 0 106 0v-3a3 3 0 00-3-3zm-2 3a2 2 0 114 0v3a2 2 0 11-4 0v-3zm-1.5 3a.5.5 0 00-1 0v.5a4.5 4.5 0 004 4.47V18a.5.5 0 001 0v-1.53A4.5 4.5 0 0018 12v-.5a.5.5 0 00-1 0v.5a3.5 3.5 0 11-7 0v-.5z",
    fill: primaryFill
  }));
};

export const ScratchpadRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ScratchpadRegularIcon({}), 'ScratchpadRegular');

const ScreenCutFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 6a1 1 0 011-1h.5a.5.5 0 100-1H4a2 2 0 00-2 2v.5a.5.5 0 101 0V6z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M4 14a1 1 0 01-1-1v-.5a.5.5 0 00-1 0v.5c0 1.1.9 2 2 2h.25a.5.5 0 000-1H4z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M2.5 8c.28 0 .5.22.5.5v2a.5.5 0 11-1 0v-2c0-.28.22-.5.5-.5z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M17 6a1 1 0 00-1-1h-.5a.5.5 0 010-1h.5a2 2 0 012 2v.5a.5.5 0 01-1 0V6z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M17 13a1 1 0 01-1 1h-.25a.5.5 0 000 1H16a2 2 0 002-2v-.5a.5.5 0 00-1 0v.5z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M17 8.5a.5.5 0 011 0v2a.5.5 0 11-1 0v-2z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M6 4.5c0-.28.22-.5.5-.5H9a.5.5 0 010 1H6.5a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M11 4a.5.5 0 000 1h2.5a.5.5 0 000-1H11z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M5 6a1 1 0 00-1 1v5a1 1 0 001 1h2.7l.5-.74-1.96-2.93a1.5 1.5 0 112.5-1.66L10 9.55l1.25-1.88a1.5 1.5 0 012.5 1.66l-1.95 2.93.5.74H15a1 1 0 001-1V7a1 1 0 00-1-1H5z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M7.22 8.09a.5.5 0 00-.14.69l2.31 3.48-1.23 1.85a2 2 0 00-2.51 2.64 2 2 0 103.34-2.08l1-1.51L11 14.67a2 2 0 10.84-.55l-1.24-1.86-.6-.9L7.9 8.23a.5.5 0 00-.7-.14zM12.5 17a1 1 0 110-2 1 1 0 010 2zm-5 0a1 1 0 110-2 1 1 0 010 2z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M10.6 10.45l.6.9 1.72-2.57a.5.5 0 00-.14-.7.5.5 0 00-.7.15l-1.48 2.22z",
    fill: primaryFill
  }));
};

export const ScreenCutFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ScreenCutFilledIcon({}), 'ScreenCutFilled');

const ScreenCutRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 5a1 1 0 00-1 1v.5a.5.5 0 11-1 0V6c0-1.1.9-2 2-2h.5a.5.5 0 010 1H4z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M3 13a1 1 0 001 1h.25a.5.5 0 010 1H4a2 2 0 01-2-2v-.5a.5.5 0 011 0v.5z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M3 8.5a.5.5 0 00-1 0v2a.5.5 0 101 0v-2z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M16 5a1 1 0 011 1v.5a.5.5 0 001 0V6a2 2 0 00-2-2h-.5a.5.5 0 000 1h.5z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M16 14a1 1 0 001-1v-.5a.5.5 0 011 0v.5a2 2 0 01-2 2h-.25a.5.5 0 010-1H16z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M17.5 8a.5.5 0 00-.5.5v2a.5.5 0 101 0v-2a.5.5 0 00-.5-.5z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M6.5 4a.5.5 0 000 1H9a.5.5 0 100-1H6.5z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M10.5 4.5c0-.28.22-.5.5-.5h2.5a.5.5 0 010 1H11a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M7.22 8.09a.5.5 0 00-.14.69l2.31 3.48-1.23 1.85a2 2 0 00-2.51 2.64 2 2 0 103.34-2.08l1-1.51L11 14.67a2 2 0 10.84-.55l-1.24-1.86-.6-.9L7.9 8.23a.5.5 0 00-.7-.14zM12.5 17a1 1 0 110-2 1 1 0 010 2zm-5 0a1 1 0 110-2 1 1 0 010 2z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M10.6 10.45l.6.9 1.72-2.57a.5.5 0 00-.14-.7.5.5 0 00-.7.15l-1.48 2.22z",
    fill: primaryFill
  }));
};

export const ScreenCutRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ScreenCutRegularIcon({}), 'ScreenCutRegular');

const ScreenPersonFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 4a3 3 0 00-3 3v6a3 3 0 003 3h6.05a2.5 2.5 0 012.22-1.99A2.99 2.99 0 0115.5 9a3 3 0 012.5 1.34V7a3 3 0 00-3-3H5zm12.5 8a2 2 0 11-4 0 2 2 0 014 0zm1.5 4.5c0 1.25-1 2.5-3.5 2.5S12 17.75 12 16.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5z",
    fill: primaryFill
  }));
};

export const ScreenPersonFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ScreenPersonFilledIcon({}), 'ScreenPersonFilled');

const ScreenPersonRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.75 4A2.75 2.75 0 002 6.75v6.5A2.75 2.75 0 004.75 16h6.3c.07-.37.23-.7.45-1H4.75C3.78 15 3 14.22 3 13.25v-6.5C3 5.78 3.78 5 4.75 5h10.5c.97 0 1.75.78 1.75 1.75V9.4c.4.23.74.56 1 .94V6.75A2.75 2.75 0 0015.25 4H4.75zm12.75 8a2 2 0 11-4 0 2 2 0 014 0zm1.5 4.5c0 1.25-1 2.5-3.5 2.5S12 17.75 12 16.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5z",
    fill: primaryFill
  }));
};

export const ScreenPersonRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ScreenPersonRegularIcon({}), 'ScreenPersonRegular');

const ScreenSearchFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 6.75A2.75 2.75 0 014.75 4h10.5A2.75 2.75 0 0118 6.75v6.5A2.75 2.75 0 0115.25 16h-5.13l-1.56-1.56A4.5 4.5 0 002 8.76V6.75zM4.5 16c.79 0 1.51-.26 2.1-.7l2.55 2.55a.5.5 0 10.7-.7L7.3 14.6A3.5 3.5 0 104.5 16zm0-1a2.5 2.5 0 110-5 2.5 2.5 0 010 5z",
    fill: primaryFill
  }));
};

export const ScreenSearchFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ScreenSearchFilledIcon({}), 'ScreenSearchFilled');

const ScreenSearchRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 6.75A2.75 2.75 0 014.75 4h10.5A2.75 2.75 0 0118 6.75v6.5A2.75 2.75 0 0115.25 16h-5.13l-1-1h6.13c.97 0 1.75-.78 1.75-1.75v-6.5C17 5.78 16.22 5 15.25 5H4.75C3.78 5 3 5.78 3 6.75v1.5c-.36.13-.7.3-1 .5v-2zM4.5 16c.79 0 1.51-.26 2.1-.7l2.55 2.55a.5.5 0 10.7-.7L7.3 14.6A3.5 3.5 0 104.5 16zm0-1a2.5 2.5 0 110-5 2.5 2.5 0 010 5z",
    fill: primaryFill
  }));
};

export const ScreenSearchRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ScreenSearchRegularIcon({}), 'ScreenSearchRegular');

const ScreenshotFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 3h10a2 2 0 012 2v10a2 2 0 01-2 2H5a2 2 0 01-2-2V5c0-1.1.9-2 2-2zm1.5 2C5.67 5 5 5.67 5 6.5v2a.5.5 0 001 0v-2c0-.28.22-.5.5-.5h2a.5.5 0 000-1h-2zm5 0a.5.5 0 000 1h2c.28 0 .5.22.5.5v2a.5.5 0 001 0v-2c0-.83-.67-1.5-1.5-1.5h-2zM6 11.5a.5.5 0 00-1 0v2c0 .83.67 1.5 1.5 1.5h2a.5.5 0 000-1h-2a.5.5 0 01-.5-.5v-2zm9 0a.5.5 0 00-1 0v2a.5.5 0 01-.5.5h-2a.5.5 0 000 1h2c.83 0 1.5-.67 1.5-1.5v-2z",
    fill: primaryFill
  }));
};

export const ScreenshotFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ScreenshotFilledIcon({}), 'ScreenshotFilled');

const ScreenshotRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.5 5C5.67 5 5 5.67 5 6.5v2a.5.5 0 001 0v-2c0-.28.22-.5.5-.5h2a.5.5 0 000-1h-2zm5 0a.5.5 0 000 1h2c.28 0 .5.22.5.5v2a.5.5 0 001 0v-2c0-.83-.67-1.5-1.5-1.5h-2zM6 11.5a.5.5 0 00-1 0v2c0 .83.67 1.5 1.5 1.5h2a.5.5 0 000-1h-2a.5.5 0 01-.5-.5v-2zm9 0a.5.5 0 00-1 0v2a.5.5 0 01-.5.5h-2a.5.5 0 000 1h2c.83 0 1.5-.67 1.5-1.5v-2zM3 5c0-1.1.9-2 2-2h10a2 2 0 012 2v10a2 2 0 01-2 2H5a2 2 0 01-2-2V5zm1 0v10a1 1 0 001 1h10a1 1 0 001-1V5a1 1 0 00-1-1H5a1 1 0 00-1 1z",
    fill: primaryFill
  }));
};

export const ScreenshotRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ScreenshotRegularIcon({}), 'ScreenshotRegular');

const SearchFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.5 3a5.5 5.5 0 014.38 8.82l4.15 4.15a.75.75 0 01-.98 1.13l-.08-.07-4.15-4.15A5.5 5.5 0 118.5 3zm0 1.5a4 4 0 100 8 4 4 0 000-8z",
    fill: primaryFill
  }));
};

export const SearchFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SearchFilledIcon({}), 'SearchFilled');

const SearchRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.5 3a5.5 5.5 0 014.23 9.02l4.12 4.13a.5.5 0 01-.63.76l-.07-.06-4.13-4.12A5.5 5.5 0 118.5 3zm0 1a4.5 4.5 0 100 9 4.5 4.5 0 000-9z",
    fill: primaryFill
  }));
};

export const SearchRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SearchRegularIcon({}), 'SearchRegular');

const SearchInfoFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14 8.5a5.5 5.5 0 10-1.98 4.23l4.13 4.12.07.06a.5.5 0 00.63-.76l-4.12-4.13A5.48 5.48 0 0014 8.5zM8.5 7a.5.5 0 110-1 .5.5 0 010 1zM9 8.5v2a.5.5 0 01-1 0v-2a.5.5 0 011 0z",
    fill: primaryFill
  }));
};

export const SearchInfoFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SearchInfoFilledIcon({}), 'SearchInfoFilled');

const SearchInfoRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.5 3a5.5 5.5 0 014.23 9.02l4.12 4.13a.5.5 0 01-.63.76l-.07-.06-4.13-4.12A5.5 5.5 0 118.5 3zm0 1a4.5 4.5 0 100 9 4.5 4.5 0 000-9zm0 4c.28 0 .5.22.5.5v2a.5.5 0 01-1 0v-2c0-.28.22-.5.5-.5zM9 6.5a.5.5 0 11-1 0 .5.5 0 011 0z",
    fill: primaryFill
  }));
};

export const SearchInfoRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SearchInfoRegularIcon({}), 'SearchInfoRegular');

const SearchSettingsFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.5 3a5.5 5.5 0 014.38 8.82l4.15 4.15a.75.75 0 01-.98 1.13l-.08-.07-4.15-4.15c-.28.22-.6.41-.92.57-.1-.5-.27-.99-.5-1.43a4 4 0 10-5.86-2.94c-.5.1-1 .25-1.44.47A5.5 5.5 0 018.5 3zm-5.44 8.44a2 2 0 01-1.43 2.48l-.46.12a4.7 4.7 0 00.01 1.01l.35.09A2 2 0 013 17.66l-.13.42c.26.2.54.38.84.52l.32-.35a2 2 0 012.91 0l.34.36c.3-.13.57-.3.82-.5l-.16-.55a2 2 0 011.44-2.48l.46-.12a4.7 4.7 0 00-.01-1.01l-.35-.09A2 2 0 018 11.34l.13-.42c-.26-.2-.54-.38-.84-.52l-.32.35a2 2 0 01-2.91 0l-.34-.36c-.3.13-.57.3-.82.5l.15.55zM5.5 15.5a1 1 0 110-2 1 1 0 010 2z",
    fill: primaryFill
  }));
};

export const SearchSettingsFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SearchSettingsFilledIcon({}), 'SearchSettingsFilled');

const SearchSettingsRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.5 3a5.5 5.5 0 014.23 9.02l4.12 4.13a.5.5 0 01-.63.76l-.07-.06-4.13-4.12a5.5 5.5 0 01-1.12.72 5.45 5.45 0 00-.29-.98A4.5 4.5 0 104.05 9.2c-.33.1-.65.21-.95.36A5.5 5.5 0 018.5 3zm-5.44 8.44a2 2 0 01-1.43 2.48l-.46.12a4.7 4.7 0 00.01 1.01l.35.09A2 2 0 013 17.66l-.13.42c.26.2.54.38.84.52l.32-.35a2 2 0 012.91 0l.34.36c.3-.13.57-.3.82-.5l-.16-.55a2 2 0 011.44-2.48l.46-.12a4.7 4.7 0 00-.01-1.01l-.35-.09A2 2 0 018 11.34l.13-.42c-.26-.2-.54-.38-.84-.52l-.32.35a2 2 0 01-2.91 0l-.34-.36c-.3.13-.57.3-.82.5l.15.55zM5.5 15.5a1 1 0 110-2 1 1 0 010 2z",
    fill: primaryFill
  }));
};

export const SearchSettingsRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SearchSettingsRegularIcon({}), 'SearchSettingsRegular');

const SearchShieldFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.5 3a5.5 5.5 0 014.38 8.82l4.15 4.15a.75.75 0 01-.98 1.13l-.08-.07-4.15-4.15c-.54.41-1.15.72-1.82.91V12.21a4 4 0 10-5.48-4.12c-.2.07-.37.18-.52.34-.32.33-.63.58-.96.78A5.5 5.5 0 018.5 3zM7 10.35a4.63 4.63 0 01-1-.59c-.24-.18-.48-.4-.72-.64a.39.39 0 00-.56 0 4.5 4.5 0 01-3.32 1.55.4.4 0 00-.4.41v2.77c.03.8.18 1.51.44 2.15A4.81 4.81 0 003 18c.52.4 1.15.73 1.87.98.09.03.17.03.26 0C7.69 18.09 9 16.27 9 13.58V11a.4.4 0 00-.4-.33 4.23 4.23 0 01-1.6-.32z",
    fill: primaryFill
  }));
};

export const SearchShieldFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SearchShieldFilledIcon({}), 'SearchShieldFilled');

const SearchShieldRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.5 3a5.5 5.5 0 014.23 9.02l4.12 4.13a.5.5 0 01-.63.76l-.07-.06-4.13-4.12c-.58.48-1.27.85-2.02 1.06v-1.05a4.5 4.5 0 10-6-4.31c-.32.33-.63.58-.96.78A5.5 5.5 0 018.5 3zM7 10.35a4.63 4.63 0 01-1-.59c-.24-.18-.48-.4-.72-.64a.39.39 0 00-.56 0 4.5 4.5 0 01-3.32 1.55.4.4 0 00-.4.41v2.77c.03.8.18 1.51.44 2.15A4.81 4.81 0 003 18c.52.4 1.15.73 1.87.98.09.03.17.03.26 0C7.69 18.09 9 16.27 9 13.58V11a.4.4 0 00-.4-.33 4.23 4.23 0 01-1.6-.32z",
    fill: primaryFill
  }));
};

export const SearchShieldRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SearchShieldRegularIcon({}), 'SearchShieldRegular');

const SearchSquareFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9 11.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5zM3 6a3 3 0 013-3h8a3 3 0 013 3v8a3 3 0 01-3 3H6a3 3 0 01-3-3V6zm6 6.5c.79 0 1.51-.26 2.1-.7l2.55 2.55a.5.5 0 10.7-.7L11.8 11.1A3.5 3.5 0 109 12.5z",
    fill: primaryFill
  }));
};

export const SearchSquareFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SearchSquareFilledIcon({}), 'SearchSquareFilled');

const SearchSquareRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9 12.5c.79 0 1.51-.26 2.1-.7l2.55 2.55a.5.5 0 10.7-.7L11.8 11.1A3.5 3.5 0 109 12.5zm0-1a2.5 2.5 0 110-5 2.5 2.5 0 010 5zM6 3a3 3 0 00-3 3v8a3 3 0 003 3h8a3 3 0 003-3V6a3 3 0 00-3-3H6zM4 6c0-1.1.9-2 2-2h8a2 2 0 012 2v8a2 2 0 01-2 2H6a2 2 0 01-2-2V6z",
    fill: primaryFill
  }));
};

export const SearchSquareRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SearchSquareRegularIcon({}), 'SearchSquareRegular');

const SearchVisualFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 6.25C3 4.45 4.46 3 6.25 3h1a.75.75 0 010 1.5h-1c-.97 0-1.75.78-1.75 1.75v1a.75.75 0 01-1.5 0v-1zm14 7.5c0 1.8-1.46 3.25-3.25 3.25h-1a.75.75 0 010-1.5h1c.97 0 1.75-.78 1.75-1.75v-1a.75.75 0 011.5 0v1zm0-7.5C17 4.45 15.54 3 13.75 3h-1a.75.75 0 000 1.5h1c.97 0 1.75.78 1.75 1.75v1a.75.75 0 001.5 0v-1zM6.25 17A3.25 3.25 0 013 13.75v-1a.75.75 0 011.5 0v1c0 .97.78 1.75 1.75 1.75h1a.75.75 0 010 1.5h-1zM10 12a2 2 0 100-4 2 2 0 000 4zM7 8a1 1 0 100-2 1 1 0 000 2z",
    fill: primaryFill
  }));
};

export const SearchVisualFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SearchVisualFilledIcon({}), 'SearchVisualFilled');

const SearchVisualRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14 3a3 3 0 013 3v1.5a.5.5 0 01-1 0V6a2 2 0 00-2-2h-1.5a.5.5 0 010-1H14zM6 3a3 3 0 00-3 3v1.5a.5.5 0 001 0V6c0-1.1.9-2 2-2h1.5a.5.5 0 000-1H6zm8 14a3 3 0 003-3v-1.5a.5.5 0 00-1 0V14a2 2 0 01-2 2h-1.5a.5.5 0 000 1H14zM3 14a3 3 0 003 3h1.5a.5.5 0 000-1H6a2 2 0 01-2-2v-1.5a.5.5 0 00-1 0V14zm7-2a2 2 0 100-4 2 2 0 000 4zm0-1a1 1 0 110-2 1 1 0 010 2zM6.5 7.25a.75.75 0 100-1.5.75.75 0 000 1.5z",
    fill: primaryFill
  }));
};

export const SearchVisualRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SearchVisualRegularIcon({}), 'SearchVisualRegular');

const SelectAllOffFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 2a2 2 0 00-2 2v10c0 1.1.9 2 2 2h10a2 2 0 002-2V4a2 2 0 00-2-2H4zm.27 15c.34.6.99 1 1.73 1h8a4 4 0 004-4V6a2 2 0 00-1-1.73V14a3 3 0 01-3 3H4.27z",
    fill: primaryFill
  }));
};

export const SelectAllOffFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SelectAllOffFilledIcon({}), 'SelectAllOffFilled');

const SelectAllOffRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 2a2 2 0 00-2 2v10c0 1.1.9 2 2 2h10a2 2 0 002-2V4a2 2 0 00-2-2H4zM3 4a1 1 0 011-1h10a1 1 0 011 1v10a1 1 0 01-1 1H4a1 1 0 01-1-1V4zm1.27 13c.34.6.99 1 1.73 1h8a4 4 0 004-4V6a2 2 0 00-1-1.73V14a3 3 0 01-3 3H4.27z",
    fill: primaryFill
  }));
};

export const SelectAllOffRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SelectAllOffRegularIcon({}), 'SelectAllOffRegular');

const SelectAllOnFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 4c0-1.1.9-2 2-2h10a2 2 0 012 2v10a2 2 0 01-2 2H4a2 2 0 01-2-2V4zm10.33 2.62a.5.5 0 00-.7.05l-3.15 3.6-1.63-1.62a.5.5 0 10-.7.7l2 2a.5.5 0 00.73-.02l3.5-4a.5.5 0 00-.05-.7zM4.27 17c.34.6.99 1 1.73 1h8a4 4 0 004-4V6a2 2 0 00-1-1.73V14a3 3 0 01-3 3H4.27z",
    fill: primaryFill
  }));
};

export const SelectAllOnFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SelectAllOnFilledIcon({}), 'SelectAllOnFilled');

const SelectAllOnRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 4c0-1.1.9-2 2-2h10a2 2 0 012 2v10a2 2 0 01-2 2H4a2 2 0 01-2-2V4zm2-1a1 1 0 00-1 1v10a1 1 0 001 1h10a1 1 0 001-1V4a1 1 0 00-1-1H4zm2 15a2 2 0 01-1.73-1H14a3 3 0 003-3V4.27c.6.34 1 .99 1 1.73v8a4 4 0 01-4 4H6zm6.38-10.67a.5.5 0 00-.76-.66l-3.14 3.6-1.63-1.62a.5.5 0 10-.7.7l2 2a.5.5 0 00.73-.02l3.5-4z",
    fill: primaryFill
  }));
};

export const SelectAllOnRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SelectAllOnRegularIcon({}), 'SelectAllOnRegular');

const SelectObjectFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 4.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm11 0a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm-11 11a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm11 0a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM7 4.75c0-.41.34-.75.75-.75h4.5a.75.75 0 010 1.5h-4.5A.75.75 0 017 4.75zm0 10.5c0-.41.34-.75.75-.75h4.5a.75.75 0 010 1.5h-4.5a.75.75 0 01-.75-.75zm-3-7.5a.75.75 0 011.5 0v4.5a.75.75 0 01-1.5 0v-4.5zm10.5 0a.75.75 0 011.5 0v4.5a.75.75 0 01-1.5 0v-4.5z",
    fill: primaryFill
  }));
};

export const SelectObjectFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SelectObjectFilledIcon({}), 'SelectObjectFilled');

const SelectObjectRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 4.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm11 0a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm-11 11a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm11 0a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM7 4.5c0-.28.22-.5.5-.5h5a.5.5 0 010 1h-5a.5.5 0 01-.5-.5zm0 11c0-.28.22-.5.5-.5h5a.5.5 0 010 1h-5a.5.5 0 01-.5-.5zm-3-8a.5.5 0 011 0v5a.5.5 0 01-1 0v-5zm11 0a.5.5 0 011 0v5a.5.5 0 01-1 0v-5z",
    fill: primaryFill
  }));
};

export const SelectObjectRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SelectObjectRegularIcon({}), 'SelectObjectRegular');

const SelectObjectSkewFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M15 4.5a1.5 1.5 0 103 0 1.5 1.5 0 00-3 0zm-4 11a1.5 1.5 0 103 0 1.5 1.5 0 00-3 0zM3.5 17a1.5 1.5 0 110-3 1.5 1.5 0 010 3zM6 4.5a1.5 1.5 0 103 0 1.5 1.5 0 00-3 0zm8.11.75H9.9a2.5 2.5 0 000-1.5h4.22a2.5 2.5 0 000 1.5zM3.61 13L5.98 6.5c.4.3.88.48 1.41.5l-2.37 6.52c-.4-.3-.88-.48-1.41-.5zm6.5 3.25H5.9a2.5 2.5 0 000-1.5h4.22a2.5 2.5 0 000 1.5zm2.5-3.25l2.37-6.51c.4.3.88.48 1.41.5l-2.37 6.52c-.4-.3-.88-.48-1.41-.5z",
    fill: primaryFill
  }));
};

export const SelectObjectSkewFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SelectObjectSkewFilledIcon({}), 'SelectObjectSkewFilled');

const SelectObjectSkewRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M16.49 6h.01a1.5 1.5 0 10-1.41-2l-.01.02A1.5 1.5 0 0016.48 6zm-5.4 10a1.5 1.5 0 101.42-2h-.01c-.65 0-1.2.42-1.41 1l-.01.02a1.5 1.5 0 000 .98zM3.5 17a1.5 1.5 0 110-3 1.5 1.5 0 010 3zM7.49 6a1.5 1.5 0 10.02-3 1.5 1.5 0 00-.02 3zm-3.62 7.03l2.32-6.4c.28.17.6.3.94.34l-2.32 6.4c-.28-.17-.6-.3-.94-.34zM14.05 5h-4.1a2.51 2.51 0 000-1h4.1a2.51 2.51 0 000 1zm-8.1 11h4.1a2.51 2.51 0 010-1h-4.1a2.51 2.51 0 010 1zm6.92-2.97l2.32-6.4c.28.17.6.3.94.34l-2.32 6.4c-.28-.17-.6-.3-.94-.34z",
    fill: primaryFill
  }));
};

export const SelectObjectSkewRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SelectObjectSkewRegularIcon({}), 'SelectObjectSkewRegular');

const SelectObjectSkewDismissFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M15 4.5a1.5 1.5 0 103 0 1.5 1.5 0 00-3 0zm-13 11a1.5 1.5 0 103 0 1.5 1.5 0 00-3 0zm4-11a1.5 1.5 0 103 0 1.5 1.5 0 00-3 0zm3.89.75h4.22a2.5 2.5 0 010-1.5H9.9a2.5 2.5 0 010 1.5zM3.6 13L5.98 6.5c.4.3.88.48 1.41.5l-2.37 6.52c-.4-.3-.88-.48-1.41-.5zm2.28 3.25h3.4a5.48 5.48 0 01-.28-1.5H5.89a2.5 2.5 0 010 1.5zM16.39 7l-.77 2.11a5.52 5.52 0 00-1.56-.1l.92-2.52c.4.3.88.48 1.41.5zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.65-1.15a.5.5 0 00-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 00-.7.7l1.14 1.15-1.14 1.15a.5.5 0 00.7.7l1.15-1.14 1.15 1.14a.5.5 0 00.7-.7l-1.14-1.15 1.14-1.15z",
    fill: primaryFill
  }));
};

export const SelectObjectSkewDismissFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SelectObjectSkewDismissFilledIcon({}), 'SelectObjectSkewDismissFilled');

const SelectObjectSkewDismissRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M16.49 6h.01a1.5 1.5 0 10-1.41-2l-.01.02a1.5 1.5 0 00.47 1.64c.26.21.58.34.94.34zM2 15.5a1.5 1.5 0 102.92-.48V15a1.5 1.5 0 00-1.4-1H3.5c-.83 0-1.5.67-1.5 1.5zM7.49 6h.01c.65 0 1.2-.42 1.41-1l.01-.02a1.5 1.5 0 10-2.37.68c.26.21.58.34.94.34zm-1.3.63l-2.32 6.4c.34.05.66.17.94.34l2.32-6.4a2.48 2.48 0 01-.94-.34zM14.05 5h-4.1a2.51 2.51 0 000-1h4.1a2.51 2.51 0 000 1zm.45 4c.3 0 .59.02.87.07l.76-2.1a2.48 2.48 0 01-.94-.34L14.33 9h.17zm-5.48 6c.03.34.1.68.19 1H5.95a2.51 2.51 0 000-1h3.07zm9.98-.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.65-1.15a.5.5 0 00-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 00-.7.7l1.14 1.15-1.14 1.15a.5.5 0 00.7.7l1.15-1.14 1.15 1.14a.5.5 0 00.7-.7l-1.14-1.15 1.14-1.15z",
    fill: primaryFill
  }));
};

export const SelectObjectSkewDismissRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SelectObjectSkewDismissRegularIcon({}), 'SelectObjectSkewDismissRegular');

const SelectObjectSkewEditFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M15 4.5a1.5 1.5 0 103 0 1.5 1.5 0 00-3 0zm-13 11a1.5 1.5 0 103 0 1.5 1.5 0 00-3 0zm4-11a1.5 1.5 0 103 0 1.5 1.5 0 00-3 0zm3.89.75h4.22a2.5 2.5 0 010-1.5H9.9a2.5 2.5 0 010 1.5zM3.6 13L5.98 6.5c.4.3.88.48 1.41.5l-2.37 6.52c-.4-.3-.88-.48-1.41-.5zm2.28 3.25H9.4l.02-.1c.12-.46.34-.9.65-1.26 0-.05.02-.1.03-.14H5.9a2.5 2.5 0 010 1.5zM16.39 7l-.92 2.53-.37.31-2.1 2.1 1.98-5.45c.4.3.88.48 1.41.5zm-5.41 8.38l4.83-4.83a1.87 1.87 0 112.64 2.64l-4.83 4.83a2.2 2.2 0 01-1.02.58l-1.5.37a.89.89 0 01-1.07-1.07l.37-1.5c.1-.39.3-.74.58-1.02z",
    fill: primaryFill
  }));
};

export const SelectObjectSkewEditFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SelectObjectSkewEditFilledIcon({}), 'SelectObjectSkewEditFilled');

const SelectObjectSkewEditRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M16.49 6h.01a1.5 1.5 0 10-1.41-2l-.01.02a1.5 1.5 0 00.47 1.64c.26.21.58.34.94.34zM2 15.5a1.5 1.5 0 102.92-.48V15a1.5 1.5 0 00-1.4-1H3.5c-.83 0-1.5.67-1.5 1.5zM7.49 6h.01c.65 0 1.2-.42 1.41-1l.01-.02a1.5 1.5 0 10-2.37.68c.26.21.58.34.94.34zm-1.3.63l-2.32 6.4c.34.05.66.17.94.34l2.32-6.4a2.48 2.48 0 01-.94-.34zM14.05 5h-4.1a2.51 2.51 0 000-1h4.1a2.51 2.51 0 000 1zm-.64 6.53l1.67-1.67 1.05-2.89a2.48 2.48 0 01-.94-.34l-1.78 4.9zM5.95 16h3.52c.11-.36.29-.7.52-1H5.95a2.51 2.51 0 010 1zm5.03-.62l4.83-4.83a1.87 1.87 0 112.64 2.64l-4.83 4.83a2.2 2.2 0 01-1.02.58l-1.5.37a.89.89 0 01-1.07-1.07l.37-1.5c.1-.39.3-.74.58-1.02z",
    fill: primaryFill
  }));
};

export const SelectObjectSkewEditRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SelectObjectSkewEditRegularIcon({}), 'SelectObjectSkewEditRegular');

const SendFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.72 2.05l15.36 7.57a.5.5 0 010 .9L2.72 18.07a.5.5 0 01-.7-.58l1.52-5.74a.5.5 0 01.4-.37l6.88-1.14a.25.25 0 00.19-.15l.02-.06a.25.25 0 00-.15-.27l-.06-.02L3.9 8.6a.5.5 0 01-.4-.37l-1.48-5.6a.5.5 0 01.7-.58z",
    fill: primaryFill
  }));
};

export const SendFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SendFilledIcon({}), 'SendFilled');

const SendRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.72 2.05l15.36 7.57a.5.5 0 010 .9L2.72 18.07a.5.5 0 01-.7-.58l1.97-7.43-1.97-7.44a.5.5 0 01.7-.58zm.54 1.38l1.61 6.09.07-.02H12a.5.5 0 01.09 1H5a.5.5 0 01-.1 0l-1.63 6.2 13.45-6.63L3.26 3.43z",
    fill: primaryFill
  }));
};

export const SendRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SendRegularIcon({}), 'SendRegular');

const SendClockFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.72 1.05l15.36 7.57a.5.5 0 010 .9l-.66.32a5.5 5.5 0 00-8.4 4.14l-6.3 3.1a.5.5 0 01-.7-.58l1.52-5.74a.5.5 0 01.4-.37l6.88-1.14a.25.25 0 00.19-.15l.02-.06a.25.25 0 00-.15-.27l-.06-.02L3.9 7.6a.5.5 0 01-.4-.37l-1.48-5.6a.5.5 0 01.7-.58zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zM14.5 12a.5.5 0 00-.5.5v2c0 .28.22.5.5.5H16a.5.5 0 000-1h-1v-1.5a.5.5 0 00-.5-.5z",
    fill: primaryFill
  }));
};

export const SendClockFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SendClockFilledIcon({}), 'SendClockFilled');

const SendClockRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M18.08 8.62L2.72 1.05a.5.5 0 00-.7.58l1.97 7.44-1.97 7.43a.5.5 0 00.7.58l6.3-3.1c.05-.44.14-.86.27-1.25L3.27 15.7 4.9 9.5a.5.5 0 00.09 0h7.09a.5.5 0 00-.09-1H4.94l-.07.02-1.6-6.09 13.17 6.5 1.44.68.2-.1a.5.5 0 000-.9zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zM14.5 12a.5.5 0 00-.5.5v2c0 .28.22.5.5.5H16a.5.5 0 000-1h-1v-1.5a.5.5 0 00-.5-.5z",
    fill: primaryFill
  }));
};

export const SendClockRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SendClockRegularIcon({}), 'SendClockRegular');

const SerialPortFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.33 9.07A2.5 2.5 0 014.77 6h10.46a2.5 2.5 0 012.43 3.07l-.7 3A2.5 2.5 0 0114.53 14H5.47a2.5 2.5 0 01-2.44-1.93l-.7-3zM6 9.5a.5.5 0 100-1 .5.5 0 000 1zM8.5 9a.5.5 0 10-1 0 .5.5 0 001 0zM7 11.5a.5.5 0 100-1 .5.5 0 000 1zm2.5-.5a.5.5 0 10-1 0 .5.5 0 001 0zm1.5.5a.5.5 0 100-1 .5.5 0 000 1zm2.5-.5a.5.5 0 10-1 0 .5.5 0 001 0zM10 9.5a.5.5 0 100-1 .5.5 0 000 1zm2.5-.5a.5.5 0 10-1 0 .5.5 0 001 0zm1.5.5a.5.5 0 100-1 .5.5 0 000 1z",
    fill: primaryFill
  }));
};

export const SerialPortFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SerialPortFilledIcon({}), 'SerialPortFilled');

const SerialPortRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 9.5a.5.5 0 100-1 .5.5 0 000 1zM8.5 9a.5.5 0 11-1 0 .5.5 0 011 0zM7 11.5a.5.5 0 100-1 .5.5 0 000 1zm2.5-.5a.5.5 0 11-1 0 .5.5 0 011 0zm1.5.5a.5.5 0 100-1 .5.5 0 000 1zm2.5-.5a.5.5 0 11-1 0 .5.5 0 011 0zM10 9.5a.5.5 0 100-1 .5.5 0 000 1zm2.5-.5a.5.5 0 11-1 0 .5.5 0 011 0zm1.5.5a.5.5 0 100-1 .5.5 0 000 1zM4.77 6a2.5 2.5 0 00-2.44 3.07l.7 3A2.5 2.5 0 005.47 14h9.06a2.5 2.5 0 002.43-1.93l.7-3A2.5 2.5 0 0015.23 6H4.77zM3.3 8.84A1.5 1.5 0 014.77 7h10.46c.97 0 1.68.9 1.46 1.84l-.7 3A1.5 1.5 0 0114.53 13H5.47c-.7 0-1.3-.48-1.46-1.16l-.7-3z",
    fill: primaryFill
  }));
};

export const SerialPortRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SerialPortRegularIcon({}), 'SerialPortRegular');

const ServerFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.5 2A2.5 2.5 0 005 4.5v11A2.5 2.5 0 007.5 18h5a2.5 2.5 0 002.5-2.5v-11A2.5 2.5 0 0012.5 2h-5zM7 5.5c0-.28.22-.5.5-.5h5a.5.5 0 010 1h-5a.5.5 0 01-.5-.5zm0 7c0-.28.22-.5.5-.5h5a.5.5 0 010 1h-5a.5.5 0 01-.5-.5zm0 2c0-.28.22-.5.5-.5h5a.5.5 0 010 1h-5a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const ServerFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ServerFilledIcon({}), 'ServerFilled');

const ServerRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.5 5a.5.5 0 000 1h5a.5.5 0 000-1h-5zM7 12.5c0-.28.22-.5.5-.5h5a.5.5 0 010 1h-5a.5.5 0 01-.5-.5zm.5 1.5a.5.5 0 000 1h5a.5.5 0 000-1h-5zM5 4.5A2.5 2.5 0 017.5 2h5A2.5 2.5 0 0115 4.5v11a2.5 2.5 0 01-2.5 2.5h-5A2.5 2.5 0 015 15.5v-11zM7.5 3C6.67 3 6 3.67 6 4.5v11c0 .83.67 1.5 1.5 1.5h5c.83 0 1.5-.67 1.5-1.5v-11c0-.83-.67-1.5-1.5-1.5h-5z",
    fill: primaryFill
  }));
};

export const ServerRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ServerRegularIcon({}), 'ServerRegular');

const ServerMultipleFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.5 2A2.5 2.5 0 005 4.5v11A2.5 2.5 0 007.5 18h5a2.5 2.5 0 002.5-2.5v-11A2.5 2.5 0 0012.5 2h-5zm0 3h5a.5.5 0 010 1h-5a.5.5 0 010-1zM7 12.5c0-.28.22-.5.5-.5h5a.5.5 0 010 1h-5a.5.5 0 01-.5-.5zm0 2c0-.28.22-.5.5-.5h5a.5.5 0 010 1h-5a.5.5 0 01-.5-.5zM2 7c0-1.1.9-2 2-2v10.5c0 .17.01.34.04.5H4a2 2 0 01-2-2V7zm14 8.5c0 .17-.01.34-.04.5H16a2 2 0 002-2V7a2 2 0 00-2-2v10.5z",
    fill: primaryFill
  }));
};

export const ServerMultipleFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ServerMultipleFilledIcon({}), 'ServerMultipleFilled');

const ServerMultipleRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.5 5a.5.5 0 000 1h5a.5.5 0 000-1h-5zM7 12.5c0-.28.22-.5.5-.5h5a.5.5 0 010 1h-5a.5.5 0 01-.5-.5zm.5 1.5a.5.5 0 000 1h5a.5.5 0 000-1h-5zM5 4.5A2.5 2.5 0 017.5 2h5A2.5 2.5 0 0115 4.5V5h1a2 2 0 012 2v7a2 2 0 01-2 2h-1.05a2.5 2.5 0 01-2.45 2h-5a2.5 2.5 0 01-2.45-2H4a2 2 0 01-2-2V7c0-1.1.9-2 2-2h1v-.5zM15 15h1a1 1 0 001-1V7a1 1 0 00-1-1h-1v9zM5 6H4a1 1 0 00-1 1v7a1 1 0 001 1h1V6zm2.5-3C6.67 3 6 3.67 6 4.5v11c0 .83.67 1.5 1.5 1.5h5c.83 0 1.5-.67 1.5-1.5v-11c0-.83-.67-1.5-1.5-1.5h-5z",
    fill: primaryFill
  }));
};

export const ServerMultipleRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ServerMultipleRegularIcon({}), 'ServerMultipleRegular');

const ServerPlayFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.5 2A2.5 2.5 0 005 4.5v11A2.5 2.5 0 007.5 18h2.76a5.47 5.47 0 01-1.24-3H7.5a.5.5 0 010-1h1.52c.03-.34.1-.68.19-1H7.5a.5.5 0 010-1h2.1A5.5 5.5 0 0115 9.02V4.5A2.5 2.5 0 0012.5 2h-5zM7 5.5c0-.28.22-.5.5-.5h5a.5.5 0 010 1h-5a.5.5 0 01-.5-.5zm12 9a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.29-.44l-2.97-1.65a.5.5 0 00-.74.44v3.3c0 .38.41.62.74.44l2.97-1.65a.5.5 0 000-.88z",
    fill: primaryFill
  }));
};

export const ServerPlayFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ServerPlayFilledIcon({}), 'ServerPlayFilled');

const ServerPlayRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14 9.02V4.5c0-.83-.67-1.5-1.5-1.5h-5C6.67 3 6 3.67 6 4.5v11c0 .83.67 1.5 1.5 1.5h2.1c.18.36.4.7.66 1H7.5A2.5 2.5 0 015 15.5v-11A2.5 2.5 0 017.5 2h5A2.5 2.5 0 0115 4.5v4.52a5.57 5.57 0 00-1 0zM7.5 5a.5.5 0 000 1h5a.5.5 0 000-1h-5zM7 12.5c0-.28.22-.5.5-.5h2.1c-.16.32-.3.65-.4 1H7.5a.5.5 0 01-.5-.5zm2 2c0-.17 0-.34.02-.5H7.5a.5.5 0 000 1h1.52a5.57 5.57 0 01-.02-.5zm10 0a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.29-.44l-2.97-1.65a.5.5 0 00-.74.44v3.3c0 .38.41.62.74.44l2.97-1.65a.5.5 0 000-.88z",
    fill: primaryFill
  }));
};

export const ServerPlayRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ServerPlayRegularIcon({}), 'ServerPlayRegular');

const ServiceBellFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8 5a2 2 0 114 0v.79a7 7 0 015 6.71.5.5 0 01-.5.5h-13a.5.5 0 01-.5-.5 7 7 0 015-6.71V5zm2.5 3.5c.42 0 .84 0 1.27.16.41.15.87.45 1.31 1.12a.5.5 0 00.84-.56 3.66 3.66 0 00-1.81-1.5 4.51 4.51 0 00-1.59-.22h-.02a.5.5 0 000 1zm-7 5.5a1.5 1.5 0 000 3h13a1.5 1.5 0 000-3h-13z",
    fill: primaryFill
  }));
};

export const ServiceBellFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ServiceBellFilledIcon({}), 'ServiceBellFilled');

const ServiceBellRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.5 8.5c.42 0 .84 0 1.27.16.41.15.87.45 1.31 1.12a.5.5 0 00.84-.56 3.66 3.66 0 00-1.81-1.5 4.51 4.51 0 00-1.59-.22h-.02a.5.5 0 000 1zM8 5v.79a7 7 0 00-5 6.71c0 .28.22.5.5.5h13a.5.5 0 00.5-.5 7 7 0 00-5-6.71V5a2 2 0 10-4 0zm2-1a1 1 0 011 1v.57a7.06 7.06 0 00-2 0V5a1 1 0 011-1zm0 2.5a6 6 0 015.98 5.5H4.02A6 6 0 0110 6.5zM3.5 14a1.5 1.5 0 000 3h13a1.5 1.5 0 000-3h-13zM3 15.5c0-.28.22-.5.5-.5h13a.5.5 0 010 1h-13a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const ServiceBellRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ServiceBellRegularIcon({}), 'ServiceBellRegular');

const SettingsFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M1.91 7.38A8.5 8.5 0 013.69 4.3a.5.5 0 01.54-.13l1.92.68a1 1 0 001.32-.76l.36-2a.5.5 0 01.4-.4 8.53 8.53 0 013.55 0c.2.04.35.2.38.4l.37 2a1 1 0 001.32.76l1.92-.68a.5.5 0 01.54.13 8.5 8.5 0 011.78 3.08c.06.2 0 .4-.15.54l-1.56 1.32a1 1 0 000 1.52l1.56 1.32a.5.5 0 01.15.54 8.5 8.5 0 01-1.78 3.08.5.5 0 01-.54.13l-1.92-.68a1 1 0 00-1.32.76l-.37 2a.5.5 0 01-.38.4 8.53 8.53 0 01-3.56 0 .5.5 0 01-.39-.4l-.36-2a1 1 0 00-1.32-.76l-1.92.68a.5.5 0 01-.54-.13 8.5 8.5 0 01-1.78-3.08.5.5 0 01.15-.54l1.56-1.32a1 1 0 000-1.52L2.06 7.92a.5.5 0 01-.15-.54zM8 10a2 2 0 104 0 2 2 0 00-4 0z",
    fill: primaryFill
  }));
};

export const SettingsFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SettingsFilledIcon({}), 'SettingsFilled');

const SettingsRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M1.91 7.38A8.5 8.5 0 013.69 4.3a.5.5 0 01.54-.13l1.92.68a1 1 0 001.32-.76l.36-2a.5.5 0 01.4-.4 8.53 8.53 0 013.55 0c.2.04.35.2.38.4l.37 2a1 1 0 001.32.76l1.92-.68a.5.5 0 01.54.13 8.5 8.5 0 011.78 3.08c.06.2 0 .4-.15.54l-1.56 1.32a1 1 0 000 1.52l1.56 1.32a.5.5 0 01.15.54 8.5 8.5 0 01-1.78 3.08.5.5 0 01-.54.13l-1.92-.68a1 1 0 00-1.32.76l-.37 2a.5.5 0 01-.38.4 8.53 8.53 0 01-3.56 0 .5.5 0 01-.39-.4l-.36-2a1 1 0 00-1.32-.76l-1.92.68a.5.5 0 01-.54-.13 8.5 8.5 0 01-1.78-3.08.5.5 0 01.15-.54l1.56-1.32a1 1 0 000-1.52L2.06 7.92a.5.5 0 01-.15-.54zm1.06 0l1.3 1.1a2 2 0 010 3.04l-1.3 1.1c.3.79.71 1.51 1.25 2.16l1.6-.58a2 2 0 012.63 1.53l.3 1.67a7.56 7.56 0 002.5 0l.3-1.67a2 2 0 012.64-1.53l1.6.58a7.5 7.5 0 001.24-2.16l-1.3-1.1a2 2 0 010-3.04l1.3-1.1a7.5 7.5 0 00-1.25-2.16l-1.6.58a2 2 0 01-2.63-1.53l-.3-1.67a7.55 7.55 0 00-2.5 0l-.3 1.67A2 2 0 015.81 5.8l-1.6-.58a7.5 7.5 0 00-1.24 2.16zM7.5 10a2.5 2.5 0 115 0 2.5 2.5 0 01-5 0zm1 0a1.5 1.5 0 103 0 1.5 1.5 0 00-3 0z",
    fill: primaryFill
  }));
};

export const SettingsRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SettingsRegularIcon({}), 'SettingsRegular');

const SettingsChatFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M1.91 7.38A8.5 8.5 0 013.69 4.3a.5.5 0 01.54-.13l1.92.68a1 1 0 001.32-.76l.36-2a.5.5 0 01.4-.4 8.53 8.53 0 013.55 0c.2.04.35.2.38.4l.37 2a1 1 0 001.32.76l1.92-.68a.5.5 0 01.54.13 8.5 8.5 0 011.78 3.08c.06.2 0 .4-.15.54l-1.56 1.32a1 1 0 00-.07.06 5.5 5.5 0 00-4.35.32 2 2 0 10-2.34 2.34 5.48 5.48 0 00-.13 4.81l-.43 1.4-.05.27a8.48 8.48 0 01-.79-.13.5.5 0 01-.39-.4l-.36-2a1 1 0 00-1.32-.76l-1.92.68a.5.5 0 01-.54-.13 8.5 8.5 0 01-1.78-3.08.5.5 0 01.15-.54l1.56-1.32a1 1 0 000-1.52L2.06 7.92a.5.5 0 01-.15-.54zm8.1 11.12a.4.4 0 00.52.48l1.79-.54A4.5 4.5 0 1014.5 10a4.49 4.49 0 00-2.72.92 4.48 4.48 0 00-1.21 5.77l-.55 1.78a.4.4 0 000 .03zM14.5 15a.5.5 0 010 1h-2a.5.5 0 010-1h2zm-2-2h4a.5.5 0 110 1h-4a.5.5 0 010-1z",
    fill: primaryFill
  }));
};

export const SettingsChatFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SettingsChatFilledIcon({}), 'SettingsChatFilled');

const SettingsChatRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M1.91 7.38A8.5 8.5 0 013.69 4.3a.5.5 0 01.54-.13l1.92.68a1 1 0 001.32-.76l.36-2a.5.5 0 01.4-.4 8.53 8.53 0 013.55 0c.2.04.35.2.38.4l.37 2a1 1 0 001.32.76l1.92-.68a.5.5 0 01.54.13 8.5 8.5 0 011.78 3.08c.06.2 0 .4-.15.54l-1.56 1.32a1 1 0 00-.07.06c-.33-.11-.68-.2-1.04-.25a2 2 0 01.46-.57l1.3-1.1a7.5 7.5 0 00-1.25-2.16l-1.6.58a2 2 0 01-2.63-1.53l-.3-1.67a7.55 7.55 0 00-2.5 0l-.3 1.67A2 2 0 015.81 5.8l-1.6-.58a7.5 7.5 0 00-1.24 2.16l1.3 1.1a2 2 0 010 3.04l-1.3 1.1c.3.79.71 1.51 1.25 2.16l1.6-.58a2 2 0 012.63 1.53l.3 1.67.53.07-.22.7-.05.27a8.48 8.48 0 01-.79-.13.5.5 0 01-.39-.4l-.36-2a1 1 0 00-1.32-.76l-1.92.68a.5.5 0 01-.54-.13 8.5 8.5 0 01-1.78-3.08.5.5 0 01.15-.54l1.56-1.32a1 1 0 000-1.52L2.06 7.92a.5.5 0 01-.15-.54zm8.1 11.12a.4.4 0 00.52.48l1.79-.54a4.5 4.5 0 10.13-7.94 4.48 4.48 0 00-1.89 6.19l-.24.8-.3.98a.4.4 0 000 .03zM14.5 15a.5.5 0 010 1h-2a.5.5 0 010-1h2zm2-1h-4a.5.5 0 010-1h4a.5.5 0 110 1zM10 7.5a2.5 2.5 0 012.43 1.9c-.33.14-.64.3-.93.5a1.5 1.5 0 10-1.6 1.6c-.2.29-.36.6-.5.93A2.5 2.5 0 0110 7.5z",
    fill: primaryFill
  }));
};

export const SettingsChatRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SettingsChatRegularIcon({}), 'SettingsChatRegular');

const ShapeExcludeFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 10.5v-6A2.5 2.5 0 014.5 2h6A2.5 2.5 0 0113 4.5V7H9.5A2.5 2.5 0 007 9.5V13H4.5A2.5 2.5 0 012 10.5zM7 13v2.5A2.5 2.5 0 009.5 18h6a2.5 2.5 0 002.5-2.5v-6A2.5 2.5 0 0015.5 7H13v3.5a2.5 2.5 0 01-2.5 2.5H7z",
    fill: primaryFill
  }));
};

export const ShapeExcludeFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShapeExcludeFilledIcon({}), 'ShapeExcludeFilled');

const ShapeExcludeRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 10.53V4.5A2.5 2.5 0 014.5 2h6.06A2.49 2.49 0 0113 4.5V7h2.5A2.5 2.5 0 0118 9.5v6.22A2.5 2.5 0 0115.5 18h-6A2.5 2.5 0 017 15.5V13H4.5a2.52 2.52 0 01-2.09-1.12c-.25-.38-.4-.84-.4-1.32L2 10.53zM12 8H9.5C8.67 8 8 8.67 8 9.5V12h2.5c.83 0 1.5-.67 1.5-1.5V8zM3 9.56v.94c0 .23.05.45.15.65l8-8A1.5 1.5 0 0010.5 3h-.94L3 9.56zM8.14 3H6.56L3 6.56v1.58L8.14 3zM3 5.14L5.14 3H4.5C3.67 3 3 3.67 3 4.5v.64zm8.85-1.29L8.5 7.21c.3-.14.64-.21 1-.21h.8L12 5.3v-.8c0-.23-.05-.45-.15-.65zM7.21 8.5l-3.36 3.35c.2.1.42.15.65.15h.8L7 10.3v-.8c0-.36.07-.7.2-1zM8 13.7v1.6l2.3-2.3H8.7l-.7.7zm5-3.4L15.3 8h-1.6l-.7.7v1.6zm3.4-2l-8.1 8.1c.24.32.6.53 1 .59L17 9.3a1.5 1.5 0 00-.59-1zm.6 2.4L10.7 17h1.6l4.7-4.7v-1.6zm0 3L13.7 17h1.6l1.7-1.7v-1.6z",
    fill: primaryFill
  }));
};

export const ShapeExcludeRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShapeExcludeRegularIcon({}), 'ShapeExcludeRegular');

const ShapeIntersectFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 4.5A2.5 2.5 0 014.5 2h6A2.5 2.5 0 0113 4.5V7h2.5A2.5 2.5 0 0118 9.5v6a2.5 2.5 0 01-2.5 2.5h-6A2.5 2.5 0 017 15.5V13H4.5A2.5 2.5 0 012 10.5v-6zM7 12V9.5A2.5 2.5 0 019.5 7H12V4.5c0-.83-.67-1.5-1.5-1.5h-6C3.67 3 3 3.67 3 4.5v6c0 .83.67 1.5 1.5 1.5H7zm1 1v2.5c0 .83.67 1.5 1.5 1.5h6c.83 0 1.5-.67 1.5-1.5v-6c0-.83-.67-1.5-1.5-1.5H13v2.5a2.5 2.5 0 01-2.5 2.5H8z",
    fill: primaryFill
  }));
};

export const ShapeIntersectFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShapeIntersectFilledIcon({}), 'ShapeIntersectFilled');

const ShapeIntersectRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 4.5A2.5 2.5 0 014.5 2h6A2.5 2.5 0 0113 4.5V7h2.5A2.5 2.5 0 0118 9.5v6a2.5 2.5 0 01-2.5 2.5h-6A2.5 2.5 0 017 15.5V13H4.5A2.5 2.5 0 012 10.5v-6zm10 0c0-.83-.67-1.5-1.5-1.5h-6C3.67 3 3 3.67 3 4.5v6c0 .83.67 1.5 1.5 1.5H7V9.5A2.5 2.5 0 019.5 7H12V4.5zm-4 6.2V12h.3L12 8.3V8h-1.3L8 10.7zm.02-1.42l1.26-1.26a1.5 1.5 0 00-1.26 1.26zM13 8v2.5a2.5 2.5 0 01-2.5 2.5H8v2.5c0 .83.67 1.5 1.5 1.5h6c.83 0 1.5-.67 1.5-1.5v-6c0-.83-.67-1.5-1.5-1.5H13zm-3.3 4h.8c.83 0 1.5-.67 1.5-1.5v-.8L9.7 12z",
    fill: primaryFill
  }));
};

export const ShapeIntersectRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShapeIntersectRegularIcon({}), 'ShapeIntersectRegular');

const ShapeSubtractFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.5 2A2.5 2.5 0 002 4.5v6A2.5 2.5 0 004.5 13H7v2.5A2.5 2.5 0 009.5 18h6a2.5 2.5 0 002.5-2.5v-6A2.5 2.5 0 0015.5 7H13V4.5A2.5 2.5 0 0010.5 2h-6zM8 9.5C8 8.67 8.67 8 9.5 8h6c.83 0 1.5.67 1.5 1.5v6c0 .83-.67 1.5-1.5 1.5h-6A1.5 1.5 0 018 15.5v-6z",
    fill: primaryFill
  }));
};

export const ShapeSubtractFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShapeSubtractFilledIcon({}), 'ShapeSubtractFilled');

const ShapeSubtractRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.5 2A2.5 2.5 0 002 4.5V10.56c.01.48.16.94.41 1.32l.02.02A2.52 2.52 0 004.3 13H7v2.5A2.5 2.5 0 009.5 18h6a2.5 2.5 0 002.5-2.5v-6A2.5 2.5 0 0015.5 7H13V4.5a2.52 2.52 0 00-.41-1.38l-.02-.02A2.51 2.51 0 0010.51 2H4.5zm.64 1L3 5.14V4.5C3 3.67 3.67 3 4.5 3h.64zM3 6.56L6.56 3h1.58L3 8.14V6.56zM9.56 3h.94c.23 0 .45.05.65.15l-8 8A1.5 1.5 0 013 10.5v-.94L9.56 3zm2.3.85c.09.2.14.42.14.65v.8L10.3 7h-.8c-.36 0-.7.07-1 .2l3.35-3.35zM7.2 8.5c-.14.3-.21.64-.21 1v.8L5.3 12h-.8a1.5 1.5 0 01-.65-.15L7.21 8.5zm.79 1C8 8.67 8.67 8 9.5 8h6c.83 0 1.5.67 1.5 1.5v6c0 .83-.67 1.5-1.5 1.5h-6A1.5 1.5 0 018 15.5v-6z",
    fill: primaryFill
  }));
};

export const ShapeSubtractRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShapeSubtractRegularIcon({}), 'ShapeSubtractRegular');

const ShapeUnionFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.5 2A2.5 2.5 0 002 4.5v6A2.5 2.5 0 004.5 13H7v2.5A2.5 2.5 0 009.5 18h6a2.5 2.5 0 002.5-2.5v-6A2.5 2.5 0 0015.5 7H13V4.5A2.5 2.5 0 0010.5 2h-6z",
    fill: primaryFill
  }));
};

export const ShapeUnionFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShapeUnionFilledIcon({}), 'ShapeUnionFilled');

const ShapeUnionRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.5 2A2.5 2.5 0 002 4.5v6A2.5 2.5 0 004.3 13H7v2.5A2.5 2.5 0 009.5 18h6.22a2.5 2.5 0 002.27-2.28v-.01l.01-.21v-6A2.5 2.5 0 0015.5 7H13V4.5a2.52 2.52 0 00-.5-1.5 2.5 2.5 0 00-2-1h-6zm6.65 1.15l-8 8A1.5 1.5 0 013 10.5v-.94L9.56 3h.94c.23 0 .45.05.65.15zm-7.3 8.7l8-8c.1.2.15.42.15.65v.8L5.3 12h-.8a1.5 1.5 0 01-.65-.15zM12 6.71v.79c0 .21.13.4.32.47l-4.35 4.35A.5.5 0 007.5 12h-.8L12 6.7zM13.7 8h1.6L8 15.3v-1.6L13.7 8zm2.7.3c.32.24.53.6.59 1L9.3 17a1.5 1.5 0 01-1-.59l8.1-8.1zm.6 2.4v1.6L12.3 17h-1.6l6.3-6.3zm0 3v1.6L15.3 17h-1.6l3.3-3.3zM3 8.15V6.56L6.56 3h1.58L3 8.14zm0-3V4.5C3 3.67 3.67 3 4.5 3h.64L3 5.14z",
    fill: primaryFill
  }));
};

export const ShapeUnionRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShapeUnionRegularIcon({}), 'ShapeUnionRegular');

const ShapesFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 7.5A5.5 5.5 0 0112.98 7H10.5A3.5 3.5 0 007 10.5v2.48A5.5 5.5 0 012 7.5zm8.5.5A2.5 2.5 0 008 10.5v5a2.5 2.5 0 002.5 2.5h5a2.5 2.5 0 002.5-2.5v-5A2.5 2.5 0 0015.5 8h-5z",
    fill: primaryFill
  }));
};

export const ShapesFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShapesFilledIcon({}), 'ShapesFilled');

const ShapesRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.5 3a4.5 4.5 0 00-.5 8.97v1A5.5 5.5 0 1112.98 7h-1A4.5 4.5 0 007.5 3zm3 5A2.5 2.5 0 008 10.5v5a2.5 2.5 0 002.5 2.5h5a2.5 2.5 0 002.5-2.5v-5A2.5 2.5 0 0015.5 8h-5zM9 10.5c0-.83.67-1.5 1.5-1.5h5c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5h-5A1.5 1.5 0 019 15.5v-5z",
    fill: primaryFill
  }));
};

export const ShapesRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShapesRegularIcon({}), 'ShapesRegular');

const ShareFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12.38 5.7V3.59c0-.48.53-.74.89-.47l.06.05 4.5 4.42c.2.2.23.54.05.77l-.05.07-4.5 4.42c-.34.33-.89.12-.95-.34v-2.18l-.26.03a9.25 9.25 0 00-5.19 2.5c-.39.35-.99.03-.93-.5.5-4.09 2.59-6.34 6.15-6.63l.23-.01zM5.5 4A2.5 2.5 0 003 6.5v8A2.5 2.5 0 005.5 17h8a2.5 2.5 0 002.5-2.5v-1a.5.5 0 00-1 0v1c0 .83-.67 1.5-1.5 1.5h-8A1.5 1.5 0 014 14.5v-8C4 5.67 4.67 5 5.5 5h3a.5.5 0 000-1h-3z",
    fill: primaryFill
  }));
};

export const ShareFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShareFilledIcon({}), 'ShareFilled');

const ShareRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13.33 12.84l4.5-4.42.05-.07a.59.59 0 00-.05-.77l-4.5-4.42-.06-.05c-.36-.27-.9-.01-.9.47V5.7l-.22.01C8.6 6.01 6.5 8.26 6 12.35c-.06.53.54.85.93.5a9.64 9.64 0 014.45-2.38c.24-.06.5-.1.74-.12l.26-.02v2.17c.06.46.61.67.95.34zm-1.1-6.12l1.15-.08V4.61L16.82 8l-3.44 3.39V9.23l-1.36.12c-1.7.19-3.32.87-4.83 2 .3-1.33.8-2.34 1.47-3.06a5.2 5.2 0 013.57-1.57zM5.5 4A2.5 2.5 0 003 6.5v8A2.5 2.5 0 005.5 17h8a2.5 2.5 0 002.5-2.5v-1a.5.5 0 00-1 0v1c0 .83-.67 1.5-1.5 1.5h-8A1.5 1.5 0 014 14.5v-8C4 5.67 4.67 5 5.5 5h3a.5.5 0 000-1h-3z",
    fill: primaryFill
  }));
};

export const ShareRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShareRegularIcon({}), 'ShareRegular');

const ShareAndroidFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 5.5a2.5 2.5 0 01-4.47 1.54L7.92 9.35a2.5 2.5 0 010 1.3l4.61 2.3a2.5 2.5 0 11-.45.9l-4.61-2.3a2.5 2.5 0 110-3.1l4.61-2.3A2.5 2.5 0 1117 5.5z",
    fill: primaryFill
  }));
};

export const ShareAndroidFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShareAndroidFilledIcon({}), 'ShareAndroidFilled');

const ShareAndroidRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12 5.5a2.5 2.5 0 11.53 1.54L7.92 9.35a2.5 2.5 0 010 1.3l4.61 2.3a2.5 2.5 0 11-.45.9l-4.61-2.3a2.5 2.5 0 110-3.1l4.61-2.3A2.5 2.5 0 0112 5.5zM14.5 4a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm0 9a1.5 1.5 0 100 3 1.5 1.5 0 000-3zM4 10a1.5 1.5 0 103 0 1.5 1.5 0 00-3 0z",
    fill: primaryFill
  }));
};

export const ShareAndroidRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShareAndroidRegularIcon({}), 'ShareAndroidRegular');

const ShareCloseTrayFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 16a2 2 0 01-2-2V6c0-1.1.9-2 2-2h12a2 2 0 012 2v8a2 2 0 01-2 2H4zm6-10a.5.5 0 00-.5.5v5.8l-1.65-1.65a.5.5 0 00-.7.7l2.5 2.5c.2.2.5.2.7 0l2.5-2.5a.5.5 0 00-.7-.7l-1.65 1.64V6.5A.5.5 0 0010 6z",
    fill: primaryFill
  }));
};

export const ShareCloseTrayFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShareCloseTrayFilledIcon({}), 'ShareCloseTrayFilled');

const ShareCloseTrayRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 6a.5.5 0 00-.5.5v5.8l-1.65-1.65a.5.5 0 00-.7.7l2.5 2.5c.2.2.5.2.7 0l2.5-2.5a.5.5 0 00-.7-.7l-1.65 1.64V6.5A.5.5 0 0010 6zm-8 8c0 1.1.9 2 2 2h12a2 2 0 002-2V6a2 2 0 00-2-2H4a2 2 0 00-2 2v8zm2 1a1 1 0 01-1-1V6a1 1 0 011-1h12a1 1 0 011 1v8a1 1 0 01-1 1H4z",
    fill: primaryFill
  }));
};

export const ShareCloseTrayRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShareCloseTrayRegularIcon({}), 'ShareCloseTrayRegular');

const ShareIosFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M15.75 9.25c.38 0 .7.28.74.65l.01.1v5.25A2.75 2.75 0 0113.92 18H6.25a2.75 2.75 0 01-2.74-2.58l-.01-.17V10A.75.75 0 015 9.9v5.35c0 .65.5 1.18 1.12 1.24l.13.01h7.5c.65 0 1.18-.5 1.24-1.12l.01-.13V10c0-.41.34-.75.75-.75zM5.23 6.46l4.24-4.24a.75.75 0 01.98-.07l.08.07 4.24 4.24a.75.75 0 01-.97 1.14l-.09-.08-2.96-2.96v7.69c0 .38-.28.7-.65.74L10 13a.75.75 0 01-.74-.65l-.01-.1V4.56L6.29 7.52a.75.75 0 01-.98.08l-.08-.08a.75.75 0 01-.08-.97l.08-.09 4.24-4.24-4.24 4.24z",
    fill: primaryFill
  }));
};

export const ShareIosFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShareIosFilledIcon({}), 'ShareIosFilled');

const ShareIosRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M16 9.5a.5.5 0 01.5.41V16a2.5 2.5 0 01-2.34 2.5H6a2.5 2.5 0 01-2.5-2.34V10a.5.5 0 011-.09V16c0 .78.6 1.42 1.36 1.5H14c.78 0 1.42-.6 1.5-1.36V10c0-.28.22-.5.5-.5zM5.4 6.39l4.25-4.24a.5.5 0 01.63-.06l.07.06 4.25 4.24a.5.5 0 01-.64.76l-.07-.05-3.39-3.4V13a.5.5 0 01-.41.5H10a.5.5 0 01-.5-.41V3.7L6.11 7.1a.5.5 0 01-.64.05L5.4 7.1a.5.5 0 01-.05-.64l.05-.07 4.25-4.24L5.4 6.39z",
    fill: primaryFill
  }));
};

export const ShareIosRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShareIosRegularIcon({}), 'ShareIosRegular');

const ShareScreenPersonFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 4a3 3 0 00-3 3v6a3 3 0 003 3h6.05a2.5 2.5 0 012.22-1.99A2.99 2.99 0 0115.5 9a3 3 0 012.5 1.34V7a3 3 0 00-3-3H5zm12.5 8a2 2 0 11-4 0 2 2 0 014 0zm1.5 4.5c0 1.25-1 2.5-3.5 2.5S12 17.75 12 16.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5z",
    fill: primaryFill
  }));
};

export const ShareScreenPersonFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShareScreenPersonFilledIcon({}), 'ShareScreenPersonFilled');

const ShareScreenPersonRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.75 4A2.75 2.75 0 002 6.75v6.5A2.75 2.75 0 004.75 16h6.3c.07-.37.23-.7.45-1H4.75C3.78 15 3 14.22 3 13.25v-6.5C3 5.78 3.78 5 4.75 5h10.5c.97 0 1.75.78 1.75 1.75V9.4c.4.23.74.56 1 .94V6.75A2.75 2.75 0 0015.25 4H4.75zm12.75 8a2 2 0 11-4 0 2 2 0 014 0zm1.5 4.5c0 1.25-1 2.5-3.5 2.5S12 17.75 12 16.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5z",
    fill: primaryFill
  }));
};

export const ShareScreenPersonRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShareScreenPersonRegularIcon({}), 'ShareScreenPersonRegular');

const ShareScreenPersonOverlayFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 7a3 3 0 013-3h10a3 3 0 013 3v3.34a3 3 0 10-4.73 3.67c-1.1.1-2 .92-2.22 1.99H5a3 3 0 01-3-3V7zm2 0v3a1 1 0 001 1h4a1 1 0 001-1V7a1 1 0 00-1-1H5a1 1 0 00-1 1zm13.5 5a2 2 0 11-4 0 2 2 0 014 0zm1.5 4.5c0 1.25-1 2.5-3.5 2.5S12 17.75 12 16.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5z",
    fill: primaryFill
  }));
};

export const ShareScreenPersonOverlayFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShareScreenPersonOverlayFilledIcon({}), 'ShareScreenPersonOverlayFilled');

const ShareScreenPersonOverlayRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 6.75A2.75 2.75 0 014.75 4h10.5A2.75 2.75 0 0118 6.75v3.6c-.26-.4-.6-.72-1-.95V6.75C17 5.78 16.22 5 15.25 5H4.75C3.78 5 3 5.78 3 6.75v6.5c0 .97.78 1.75 1.75 1.75h6.75c-.22.3-.38.63-.45 1h-6.3A2.75 2.75 0 012 13.25v-6.5zM15.5 14a2 2 0 100-4 2 2 0 000 4zm0 5c2.5 0 3.5-1.25 3.5-2.5 0-.83-.67-1.5-1.5-1.5h-4c-.83 0-1.5.67-1.5 1.5 0 1.25 1 2.5 3.5 2.5zM5 6a1 1 0 00-1 1v3a1 1 0 001 1h4a1 1 0 001-1V7a1 1 0 00-1-1H5z",
    fill: primaryFill
  }));
};

export const ShareScreenPersonOverlayRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShareScreenPersonOverlayRegularIcon({}), 'ShareScreenPersonOverlayRegular');

const ShareScreenPersonOverlayInsideFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 7a3 3 0 013-3h10a3 3 0 013 3v6a3 3 0 01-3 3H5a3 3 0 01-3-3V7zm3-1a1 1 0 00-1 1v3a1 1 0 001 1h3a1 1 0 001-1V7a1 1 0 00-1-1H5zm10 1.5a1.5 1.5 0 10-3 0 1.5 1.5 0 003 0zM12 10a1 1 0 00-1 1v1c0 1.1.9 2 2 2h1a2 2 0 002-2v-1a1 1 0 00-1-1h-3z",
    fill: primaryFill
  }));
};

export const ShareScreenPersonOverlayInsideFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShareScreenPersonOverlayInsideFilledIcon({}), 'ShareScreenPersonOverlayInsideFilled');

const ShareScreenPersonOverlayInsideRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13.5 9a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM11 11a1 1 0 011-1h3a1 1 0 011 1v1a2 2 0 01-2 2h-1a2 2 0 01-2-2v-1zM5 6a1 1 0 00-1 1v3a1 1 0 001 1h4a1 1 0 001-1V7a1 1 0 00-1-1H5zm-.25-2A2.75 2.75 0 002 6.75v6.5A2.75 2.75 0 004.75 16h10.5A2.75 2.75 0 0018 13.25v-6.5A2.75 2.75 0 0015.25 4H4.75zM3 6.75C3 5.78 3.78 5 4.75 5h10.5c.97 0 1.75.78 1.75 1.75v6.5c0 .97-.78 1.75-1.75 1.75H4.75C3.78 15 3 14.22 3 13.25v-6.5z",
    fill: primaryFill
  }));
};

export const ShareScreenPersonOverlayInsideRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShareScreenPersonOverlayInsideRegularIcon({}), 'ShareScreenPersonOverlayInsideRegular');

const ShareScreenPersonPFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 7a3 3 0 013-3h10a3 3 0 013 3v3.34a3 3 0 10-4.73 3.67c-1.1.1-2 .92-2.22 1.99H5a3 3 0 01-3-3V7zm4 .5v5a.5.5 0 001 0V11h1a2 2 0 100-4H6.5a.5.5 0 00-.5.5zM7 10h1a1 1 0 000-2H7v2zm10.5 2a2 2 0 11-4 0 2 2 0 014 0zm1.5 4.5c0 1.25-1 2.5-3.5 2.5S12 17.75 12 16.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5z",
    fill: primaryFill
  }));
};

export const ShareScreenPersonPFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShareScreenPersonPFilledIcon({}), 'ShareScreenPersonPFilled');

const ShareScreenPersonPRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 6.75A2.75 2.75 0 014.75 4h10.5A2.75 2.75 0 0118 6.75v3.6c-.26-.4-.6-.72-1-.95V6.75C17 5.78 16.22 5 15.25 5H4.75C3.78 5 3 5.78 3 6.75v6.5c0 .97.78 1.75 1.75 1.75h6.75c-.22.3-.38.63-.45 1h-6.3A2.75 2.75 0 012 13.25v-6.5zM15.5 14a2 2 0 100-4 2 2 0 000 4zm0 5c2.5 0 3.5-1.25 3.5-2.5 0-.83-.67-1.5-1.5-1.5h-4c-.83 0-1.5.67-1.5 1.5 0 1.25 1 2.5 3.5 2.5zm-9-12a.5.5 0 00-.5.5v5a.5.5 0 001 0V11h1a2 2 0 100-4H6.5zM8 10H7V8h1a1 1 0 010 2z",
    fill: primaryFill
  }));
};

export const ShareScreenPersonPRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShareScreenPersonPRegularIcon({}), 'ShareScreenPersonPRegular');

const ShareScreenStartFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 4a2 2 0 00-2 2v8c0 1.1.9 2 2 2h12a2 2 0 002-2V6a2 2 0 00-2-2H4zm6 10a.5.5 0 01-.5-.5V7.7L7.85 9.36a.5.5 0 11-.7-.7l2.5-2.5c.2-.2.5-.2.7 0l2.5 2.5a.5.5 0 01-.7.7L10.5 7.71v5.79a.5.5 0 01-.5.5z",
    fill: primaryFill
  }));
};

export const ShareScreenStartFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShareScreenStartFilledIcon({}), 'ShareScreenStartFilled');

const ShareScreenStartRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 14a.5.5 0 01-.5-.5V7.7L7.85 9.36a.5.5 0 11-.7-.7l2.5-2.5c.2-.2.5-.2.7 0l2.5 2.5a.5.5 0 01-.7.7L10.5 7.71v5.79a.5.5 0 01-.5.5zM2 6c0-1.1.9-2 2-2h12a2 2 0 012 2v8a2 2 0 01-2 2H4a2 2 0 01-2-2V6zm2-1a1 1 0 00-1 1v8a1 1 0 001 1h12a1 1 0 001-1V6a1 1 0 00-1-1H4z",
    fill: primaryFill
  }));
};

export const ShareScreenStartRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShareScreenStartRegularIcon({}), 'ShareScreenStartRegular');

const ShareScreenStopFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.5 4A2.5 2.5 0 002 6.5v7A2.5 2.5 0 004.5 16h11a2.5 2.5 0 002.5-2.5v-7A2.5 2.5 0 0015.5 4h-11zm2.65 3.15c.2-.2.5-.2.7 0L10 9.29l2.15-2.14a.5.5 0 01.7.7L10.71 10l2.14 2.15a.5.5 0 01-.7.7L10 10.71l-2.15 2.14a.5.5 0 01-.7-.7L9.29 10 7.15 7.85a.5.5 0 010-.7z",
    fill: primaryFill
  }));
};

export const ShareScreenStopFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShareScreenStopFilledIcon({}), 'ShareScreenStopFilled');

const ShareScreenStopRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.15 7.15c.2-.2.5-.2.7 0L10 9.29l2.15-2.14a.5.5 0 01.7.7L10.71 10l2.14 2.15a.5.5 0 01-.7.7L10 10.71l-2.15 2.14a.5.5 0 01-.7-.7L9.29 10 7.15 7.85a.5.5 0 010-.7zM2 6.5A2.5 2.5 0 014.5 4h11A2.5 2.5 0 0118 6.5v7a2.5 2.5 0 01-2.5 2.5h-11A2.5 2.5 0 012 13.5v-7zM4.5 5C3.67 5 3 5.67 3 6.5v7c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5h-11z",
    fill: primaryFill
  }));
};

export const ShareScreenStopRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShareScreenStopRegularIcon({}), 'ShareScreenStopRegular');

const ShieldFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.72 2.08a.5.5 0 01.56 0c1.94 1.3 4.03 2.1 6.3 2.43A.5.5 0 0117 5v4.5c0 3.9-2.3 6.73-6.82 8.47a.5.5 0 01-.36 0C5.31 16.23 3 13.39 3 9.5V5a.5.5 0 01.43-.5 15.05 15.05 0 006.3-2.42z",
    fill: primaryFill
  }));
};

export const ShieldFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShieldFilledIcon({}), 'ShieldFilled');

const ShieldRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.72 2.08a.5.5 0 01.56 0c1.94 1.3 4.03 2.1 6.3 2.43A.5.5 0 0117 5v4.5c0 3.9-2.3 6.73-6.82 8.47a.5.5 0 01-.36 0C5.31 16.23 3 13.39 3 9.5V5a.5.5 0 01.43-.5 15.05 15.05 0 006.3-2.42zM9.6 3.35A15.97 15.97 0 014 5.43V9.5c0 3.4 1.97 5.86 6 7.46 4.03-1.6 6-4.07 6-7.46V5.43a15.97 15.97 0 01-5.6-2.08L10 3.1l-.4.25z",
    fill: primaryFill
  }));
};

export const ShieldRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShieldRegularIcon({}), 'ShieldRegular');

const ShieldBadgeFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 5a2 2 0 00-2 2v4c0 1.1.9 2 2 2h6V9c3.23 0 3.75-.83 4.11-1.43.2-.32.36-.57.89-.57s.69.25.89.57c.2.32.43.7 1.11 1V7a2 2 0 00-2-2H4zm10.53 3.83v.02a1.63 1.63 0 01-.45.5c-.4.3-1.17.65-2.58.65a.5.5 0 00-.5.5v2c0 1.03.13 2.14.7 3.12.56 1 1.55 1.82 3.14 2.35.1.04.22.04.32 0a5.35 5.35 0 003.15-2.35c.56-.98.69-2.09.69-3.12v-2a.5.5 0 00-.5-.5c-1.41 0-2.18-.35-2.57-.65a1.63 1.63 0 01-.46-.52.5.5 0 00-.94 0zm.94 0v.01zm-.94 0v.01z",
    fill: primaryFill
  }));
};

export const ShieldBadgeFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShieldBadgeFilledIcon({}), 'ShieldBadgeFilled');

const ShieldBadgeRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 7c0-1.1.9-2 2-2h11a2 2 0 012 2v1.57a2.11 2.11 0 01-1-.82V7a1 1 0 00-1-1H4a1 1 0 00-1 1v4a1 1 0 001 1h6v1H4a2 2 0 01-2-2V7zm12.53 1.83a.5.5 0 01.95.02 1.63 1.63 0 00.45.5c.4.3 1.16.65 2.57.65.28 0 .5.22.5.5v2c0 1.03-.13 2.14-.7 3.12a5.35 5.35 0 01-3.14 2.35.5.5 0 01-.32 0 5.35 5.35 0 01-3.15-2.35A6.19 6.19 0 0111 12.5v-2a.5.5 0 01.5-.5c1.41 0 2.18-.35 2.57-.65a1.63 1.63 0 00.46-.52zm.94 0v.01zm0 0zm-.94 0v.01zm.15 1.32c-.54.4-1.38.76-2.68.84v1.51c0 .97.12 1.86.56 2.63A4.27 4.27 0 0015 16.97a4.27 4.27 0 002.44-1.84c.44-.77.56-1.66.56-2.63v-1.51a4.81 4.81 0 01-2.68-.84L15 9.87c-.1.09-.2.19-.32.28zm-.15-1.32",
    fill: primaryFill
  }));
};

export const ShieldBadgeRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShieldBadgeRegularIcon({}), 'ShieldBadgeRegular');

const ShieldCheckmarkFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.72 2.08a.5.5 0 01.56 0c1.94 1.3 4.03 2.1 6.3 2.43A.5.5 0 0117 5v4.6a5.5 5.5 0 00-6.78 8.35l-.04.02a.5.5 0 01-.36 0C5.31 16.23 3 13.39 3 9.5V5a.5.5 0 01.43-.5 15.05 15.05 0 006.3-2.42zM19 14.5a4.5 4.5 0 10-9 0 4.5 4.5 0 009 0zm-2.15-1.85c.2.2.2.5 0 .7l-3 3a.5.5 0 01-.7 0l-1-1a.5.5 0 01.7-.7l.65.64 2.65-2.64c.2-.2.5-.2.7 0z",
    fill: primaryFill
  }));
};

export const ShieldCheckmarkFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShieldCheckmarkFilledIcon({}), 'ShieldCheckmarkFilled');

const ShieldCheckmarkRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.72 2.08a.5.5 0 01.56 0c1.94 1.3 4.03 2.1 6.3 2.43A.5.5 0 0117 5v4.6c-.32-.16-.65-.3-1-.4V5.44a15.97 15.97 0 01-5.6-2.08L10 3.1l-.4.25A15.97 15.97 0 014 5.43V9.5c0 3.24 1.8 5.64 5.48 7.25.2.43.44.84.74 1.2l-.04.02a.5.5 0 01-.36 0C5.31 16.23 3 13.39 3 9.5V5a.5.5 0 01.43-.5 15.05 15.05 0 006.3-2.42zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.15-1.85a.5.5 0 00-.7 0l-2.65 2.64-.65-.64a.5.5 0 00-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 000-.7z",
    fill: primaryFill
  }));
};

export const ShieldCheckmarkRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShieldCheckmarkRegularIcon({}), 'ShieldCheckmarkRegular');

const ShieldDismissFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.28 2.08c1.94 1.3 4.03 2.1 6.3 2.43A.5.5 0 0117 5v4.5c0 3.9-2.3 6.73-6.82 8.47a.5.5 0 01-.36 0C5.31 16.23 3 13.39 3 9.5V5a.5.5 0 01.43-.5 15.05 15.05 0 006.3-2.42.5.5 0 01.55 0zM8.03 6.97a.75.75 0 00-1.06 1.06L8.94 10l-1.97 1.97a.75.75 0 101.06 1.06L10 11.06l1.97 1.97a.75.75 0 101.06-1.06L11.06 10l1.97-1.97a.75.75 0 00-1.06-1.06L10 8.94 8.03 6.97z",
    fill: primaryFill
  }));
};

export const ShieldDismissFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShieldDismissFilledIcon({}), 'ShieldDismissFilled');

const ShieldDismissRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.85 7.15a.5.5 0 10-.7.7L9.29 10l-2.14 2.15a.5.5 0 00.7.7L10 10.71l2.15 2.14a.5.5 0 00.7-.7L10.71 10l2.14-2.15a.5.5 0 00-.7-.7L10 9.29 7.85 7.15zm2.43-5.07a.5.5 0 00-.56 0 15.05 15.05 0 01-6.3 2.43A.5.5 0 003 5v4.5c0 3.9 2.3 6.73 6.82 8.47a.5.5 0 00.36 0C14.69 16.23 17 13.39 17 9.5V5a.5.5 0 00-.43-.5 15.05 15.05 0 01-6.3-2.42zM4 5.43a15.97 15.97 0 005.6-2.08l.4-.25.4.25A15.97 15.97 0 0016 5.43V9.5c0 3.4-1.97 5.86-6 7.46-4.03-1.6-6-4.07-6-7.46V5.43z",
    fill: primaryFill
  }));
};

export const ShieldDismissRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShieldDismissRegularIcon({}), 'ShieldDismissRegular');

const ShieldDismissShieldFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.28 2.08a.5.5 0 00-.56 0 15.05 15.05 0 01-6.3 2.43A.5.5 0 003 5v4.5c0 3.9 2.3 6.73 6.82 8.47a.5.5 0 00.36 0c.34-.14.68-.27 1-.42a5.82 5.82 0 01-.66-1.16 7.05 7.05 0 01-.52-2.5V11.05l-1.97 1.97a.75.75 0 01-1.06-1.06L8.94 10 6.97 8.03a.75.75 0 011.06-1.06L10 8.94l1.97-1.97a.75.75 0 111.06 1.06l-1.64 1.64h.01c.9 0 1.76-.37 2.6-1.24a1.39 1.39 0 012 0 5.06 5.06 0 001 .8V5a.5.5 0 00-.43-.5 15.05 15.05 0 01-6.3-2.42zM17 10.35a4.63 4.63 0 01-1-.59c-.24-.18-.48-.4-.72-.64a.39.39 0 00-.56 0 4.5 4.5 0 01-3.32 1.55.4.4 0 00-.4.41v2.77c.03.8.18 1.51.44 2.15A4.81 4.81 0 0013 18c.52.4 1.15.73 1.87.98.09.03.17.03.26 0 2.56-.89 3.87-2.71 3.87-5.4V11a.4.4 0 00-.4-.33 4.24 4.24 0 01-1.6-.32z",
    fill: primaryFill
  }));
};

export const ShieldDismissShieldFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShieldDismissShieldFilledIcon({}), 'ShieldDismissShieldFilled');

const ShieldDismissShieldRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.28 2.08a.5.5 0 00-.56 0 15.05 15.05 0 01-6.3 2.43A.5.5 0 003 5v4.5c0 3.9 2.3 6.73 6.82 8.47a.5.5 0 00.36 0c.34-.14.68-.27 1-.42-.2-.27-.38-.56-.52-.86-.21.1-.43.18-.66.27-4.03-1.6-6-4.07-6-7.46V5.43a15.97 15.97 0 005.6-2.08l.4-.25.4.25A15.97 15.97 0 0016 5.43v3a5.06 5.06 0 001 .8V5a.5.5 0 00-.43-.5 15.05 15.05 0 01-6.3-2.42zm-.24 8.67c.11-.47.46-.87.94-1.02l1.87-1.88a.5.5 0 00-.7-.7L10 9.29 7.85 7.15a.5.5 0 10-.7.7L9.29 10l-2.14 2.15a.5.5 0 00.7.7L10 10.71l.04.04zm6.96-.4a4.63 4.63 0 01-1-.59c-.24-.18-.48-.4-.72-.64a.39.39 0 00-.56 0 4.5 4.5 0 01-3.32 1.55.4.4 0 00-.4.41v2.77c.03.8.18 1.51.44 2.15A4.81 4.81 0 0013 18c.52.4 1.15.73 1.87.98.09.03.17.03.26 0 2.56-.89 3.87-2.71 3.87-5.4V11a.4.4 0 00-.4-.33 4.24 4.24 0 01-1.6-.32z",
    fill: primaryFill
  }));
};

export const ShieldDismissShieldRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShieldDismissShieldRegularIcon({}), 'ShieldDismissShieldRegular');

const ShieldErrorFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.28 2.08a.5.5 0 00-.56 0 15.05 15.05 0 01-6.3 2.43A.5.5 0 003 5v4.5c0 3.9 2.3 6.73 6.82 8.47a.5.5 0 00.36 0C14.69 16.23 17 13.39 17 9.5V5a.5.5 0 00-.43-.5 15.05 15.05 0 01-6.3-2.42zM10 5.75c.41 0 .75.34.75.75v5a.75.75 0 01-1.5 0v-5c0-.41.34-.75.75-.75zm.75 8a.75.75 0 11-1.5 0 .75.75 0 011.5 0z",
    fill: primaryFill
  }));
};

export const ShieldErrorFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShieldErrorFilledIcon({}), 'ShieldErrorFilled');

const ShieldErrorRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 6c.28 0 .5.22.5.5v5a.5.5 0 01-1 0v-5c0-.28.22-.5.5-.5zm0 8.5a.75.75 0 100-1.5.75.75 0 000 1.5zM9.72 2.08a.5.5 0 01.56 0c1.94 1.3 4.03 2.1 6.3 2.43A.5.5 0 0117 5v4.5c0 3.9-2.3 6.73-6.82 8.47a.5.5 0 01-.36 0C5.31 16.23 3 13.39 3 9.5V5a.5.5 0 01.43-.5 15.05 15.05 0 006.3-2.42zM9.6 3.35A15.97 15.97 0 014 5.43V9.5c0 3.4 1.97 5.86 6 7.46 4.03-1.6 6-4.07 6-7.46V5.43a15.97 15.97 0 01-5.6-2.08L10 3.1l-.4.25z",
    fill: primaryFill
  }));
};

export const ShieldErrorRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShieldErrorRegularIcon({}), 'ShieldErrorRegular');

const ShieldKeyholeFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.28 2.08a.5.5 0 00-.56 0 15.05 15.05 0 01-6.3 2.43A.5.5 0 003 5v4.5c0 3.9 2.3 6.73 6.82 8.47a.5.5 0 00.36 0C14.69 16.23 17 13.39 17 9.5V5a.5.5 0 00-.43-.5 15.05 15.05 0 01-6.3-2.42zM11.5 9c0 .65-.42 1.2-1 1.41v2.09a.5.5 0 01-1 0v-2.09a1.5 1.5 0 112-1.41z",
    fill: primaryFill
  }));
};

export const ShieldKeyholeFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShieldKeyholeFilledIcon({}), 'ShieldKeyholeFilled');

const ShieldKeyholeRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11.5 9c0 .65-.42 1.2-1 1.41v2.09a.5.5 0 01-1 0v-2.09a1.5 1.5 0 112-1.41zm-1.22-6.92a.5.5 0 00-.56 0 15.05 15.05 0 01-6.3 2.43A.5.5 0 003 5v4.5c0 3.9 2.3 6.73 6.82 8.47a.5.5 0 00.36 0C14.69 16.23 17 13.39 17 9.5V5a.5.5 0 00-.43-.5 15.05 15.05 0 01-6.3-2.42zM4 5.43a15.97 15.97 0 005.6-2.08l.4-.25.4.25A15.97 15.97 0 0016 5.43V9.5c0 3.4-1.97 5.86-6 7.46-4.03-1.6-6-4.07-6-7.46V5.43z",
    fill: primaryFill
  }));
};

export const ShieldKeyholeRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShieldKeyholeRegularIcon({}), 'ShieldKeyholeRegular');

const ShieldLockFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12.5 12v-1a2 2 0 114 0v1h.5a1 1 0 011 1v4a1 1 0 01-1 1h-5a1 1 0 01-1-1v-4a1 1 0 011-1h.5zm1-1v1h2v-1a1 1 0 10-2 0zm1.75 4a.75.75 0 10-1.5 0 .75.75 0 001.5 0zM9.72 2.08a.5.5 0 01.56 0c1.94 1.3 4.03 2.1 6.3 2.43A.5.5 0 0117 5v4.34A3 3 0 0011.5 11v.06A2 2 0 0010 13v4a2 2 0 00.24.94l-.06.03a.5.5 0 01-.36 0C5.31 16.23 3 13.39 3 9.5V5a.5.5 0 01.43-.5 15.05 15.05 0 006.3-2.42z",
    fill: primaryFill
  }));
};

export const ShieldLockFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShieldLockFilledIcon({}), 'ShieldLockFilled');

const ShieldLockRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.72 2.08a.5.5 0 01.56 0c1.94 1.3 4.03 2.1 6.3 2.43A.5.5 0 0117 5v4.34c-.26-.38-.6-.7-1-.94V5.43a15.97 15.97 0 01-5.6-2.08L10 3.1l-.4.25A15.97 15.97 0 014 5.43V9.5c0 3.4 1.97 5.86 6 7.46V17a2 2 0 00.24.94l-.06.03a.5.5 0 01-.36 0C5.31 16.23 3 13.39 3 9.5V5a.5.5 0 01.43-.5 15.05 15.05 0 006.3-2.42zM12.5 12v-1a2 2 0 114 0v1h.5a1 1 0 011 1v4a1 1 0 01-1 1h-5a1 1 0 01-1-1v-4a1 1 0 011-1h.5zm1-1v1h2v-1a1 1 0 10-2 0zm1.75 4a.75.75 0 10-1.5 0 .75.75 0 001.5 0z",
    fill: primaryFill
  }));
};

export const ShieldLockRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShieldLockRegularIcon({}), 'ShieldLockRegular');

const ShieldPersonFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.28 2.08a.5.5 0 00-.56 0 15.05 15.05 0 01-6.3 2.43A.5.5 0 003 5v4.5c0 3.9 2.3 6.73 6.82 8.47a.5.5 0 00.36 0C14.69 16.23 17 13.39 17 9.5V5a.5.5 0 00-.43-.5 15.05 15.05 0 01-6.3-2.42zM10 9.5a2 2 0 110-4 2 2 0 010 4zm0 5c-2.5 0-3.5-1.25-3.5-2.5 0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5 0 1.24-1 2.5-3.5 2.5z",
    fill: primaryFill
  }));
};

export const ShieldPersonFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShieldPersonFilledIcon({}), 'ShieldPersonFilled');

const ShieldPersonRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 9.5a2 2 0 100-4 2 2 0 000 4zm0 5c2.5 0 3.5-1.26 3.5-2.5 0-.83-.67-1.5-1.5-1.5H8c-.83 0-1.5.67-1.5 1.5 0 1.25 1 2.5 3.5 2.5zm.28-12.42a.5.5 0 00-.56 0 15.05 15.05 0 01-6.3 2.43A.5.5 0 003 5v4.5c0 3.9 2.3 6.73 6.82 8.47a.5.5 0 00.36 0C14.69 16.23 17 13.39 17 9.5V5a.5.5 0 00-.43-.5 15.05 15.05 0 01-6.3-2.42zM4 5.43a15.97 15.97 0 005.6-2.08l.4-.25.4.25A15.97 15.97 0 0016 5.43V9.5c0 3.4-1.97 5.86-6 7.46-4.03-1.6-6-4.07-6-7.46V5.43z",
    fill: primaryFill
  }));
};

export const ShieldPersonRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShieldPersonRegularIcon({}), 'ShieldPersonRegular');

const ShieldPersonAddFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.28 2.08a.5.5 0 00-.56 0 15.05 15.05 0 01-6.3 2.43A.5.5 0 003 5v4.5c0 3.9 2.3 6.73 6.82 8.47a.5.5 0 00.36 0l.04-.02A5.48 5.48 0 019 14.42c-1.77-.29-2.5-1.35-2.5-2.42 0-.83.67-1.5 1.5-1.5h2.73A5.48 5.48 0 0117 9.6V5a.5.5 0 00-.43-.5 15.05 15.05 0 01-6.3-2.42zM10 9.5a2 2 0 110-4 2 2 0 010 4zm9 5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V14h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V15h1.5a.5.5 0 000-1H15v-1.5z",
    fill: primaryFill
  }));
};

export const ShieldPersonAddFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShieldPersonAddFilledIcon({}), 'ShieldPersonAddFilled');

const ShieldPersonAddRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.28 2.08a.5.5 0 00-.56 0 15.05 15.05 0 01-6.3 2.43A.5.5 0 003 5v4.5c0 3.9 2.3 6.73 6.82 8.47a.5.5 0 00.36 0l.04-.02a5.5 5.5 0 01-.74-1.2C5.8 15.15 4 12.75 4 9.5V5.43a15.97 15.97 0 005.6-2.08l.4-.25.4.25A15.97 15.97 0 0016 5.43V9.2c.35.1.68.23 1 .39V5a.5.5 0 00-.43-.5 15.05 15.05 0 01-6.3-2.42zM9 14.42a5.48 5.48 0 011.73-3.92H8c-.83 0-1.5.67-1.5 1.5 0 1.07.73 2.13 2.5 2.42zm3-6.92a2 2 0 11-4 0 2 2 0 014 0zm7 7a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V14h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V15h1.5a.5.5 0 000-1H15v-1.5z",
    fill: primaryFill
  }));
};

export const ShieldPersonAddRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShieldPersonAddRegularIcon({}), 'ShieldPersonAddRegular');

const ShieldProhibitedFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.28 2.08a.5.5 0 00-.56 0 15.05 15.05 0 01-6.3 2.43A.5.5 0 003 5v4.5c0 3.9 2.3 6.73 6.82 8.47a.5.5 0 00.36 0l.07-.03A5.5 5.5 0 1117 9.26V5a.5.5 0 00-.43-.5 15.05 15.05 0 01-6.3-2.42zm.42 13.52l4.9-4.9a3.5 3.5 0 00-4.9 4.9zm.7.7a3.5 3.5 0 004.9-4.9l-4.9 4.9zm2.1 1.7a4.5 4.5 0 110-9 4.5 4.5 0 010 9z",
    fill: primaryFill
  }));
};

export const ShieldProhibitedFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShieldProhibitedFilledIcon({}), 'ShieldProhibitedFilled');

const ShieldProhibitedRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.28 2.08a.5.5 0 00-.56 0 15.05 15.05 0 01-6.3 2.43A.5.5 0 003 5v4.5c0 3.9 2.3 6.73 6.82 8.47a.5.5 0 00.36 0l.07-.03c-.55-.4-1.02-.9-1.38-1.48C5.6 14.86 4 12.56 4 9.5V5.43a15.97 15.97 0 005.6-2.08l.4-.25.4.25A15.97 15.97 0 0016 5.43V8.6c.36.18.7.4 1 .66V5a.5.5 0 00-.43-.5 15.05 15.05 0 01-6.3-2.42zm.42 13.52l4.9-4.9a3.5 3.5 0 00-4.9 4.9zm.7.7a3.5 3.5 0 004.9-4.9l-4.9 4.9zm2.1 1.7a4.5 4.5 0 110-9 4.5 4.5 0 010 9z",
    fill: primaryFill
  }));
};

export const ShieldProhibitedRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShieldProhibitedRegularIcon({}), 'ShieldProhibitedRegular');

const ShieldTaskFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.28 2.08a.5.5 0 00-.56 0 15.05 15.05 0 01-6.3 2.43A.5.5 0 003 5v4.5c0 3.9 2.3 6.73 6.82 8.47a.5.5 0 00.36 0C14.69 16.23 17 13.39 17 9.5V5a.5.5 0 00-.43-.5 15.05 15.05 0 01-6.3-2.42zm3.57 5.77l-4 4a.5.5 0 01-.7 0l-2-2a.5.5 0 11.7-.7l1.65 1.64 3.65-3.64a.5.5 0 01.7.7z",
    fill: primaryFill
  }));
};

export const ShieldTaskFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShieldTaskFilledIcon({}), 'ShieldTaskFilled');

const ShieldTaskRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13.85 7.85a.5.5 0 00-.7-.7L9.5 10.79 7.85 9.15a.5.5 0 00-.7.7l2 2c.2.2.5.2.7 0l4-4zm-3.57-5.77a.5.5 0 00-.56 0 15.05 15.05 0 01-6.3 2.43A.5.5 0 003 5v4.5c0 3.9 2.3 6.73 6.82 8.47a.5.5 0 00.36 0C14.69 16.23 17 13.39 17 9.5V5a.5.5 0 00-.43-.5 15.05 15.05 0 01-6.3-2.42zM4 5.43a15.97 15.97 0 005.6-2.08l.4-.25.4.25A15.97 15.97 0 0016 5.43V9.5c0 3.4-1.97 5.86-6 7.46-4.03-1.6-6-4.07-6-7.46V5.43z",
    fill: primaryFill
  }));
};

export const ShieldTaskRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShieldTaskRegularIcon({}), 'ShieldTaskRegular');

const ShiftsFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 6a3 3 0 013-3h8a3 3 0 013 3v8a3 3 0 01-3 3H6a3 3 0 01-3-3V6zm7 .5a.5.5 0 00-1 0v4c0 .28.22.5.5.5h3a.5.5 0 000-1H10V6.5z",
    fill: primaryFill
  }));
};

export const ShiftsFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShiftsFilledIcon({}), 'ShiftsFilled');

const ShiftsRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 6.5a.5.5 0 00-1 0v4c0 .28.22.5.5.5h3a.5.5 0 000-1H10V6.5zM6 3a3 3 0 00-3 3v8a3 3 0 003 3h8a3 3 0 003-3V6a3 3 0 00-3-3H6zM4 6c0-1.1.9-2 2-2h8a2 2 0 012 2v8a2 2 0 01-2 2H6a2 2 0 01-2-2V6z",
    fill: primaryFill
  }));
};

export const ShiftsRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShiftsRegularIcon({}), 'ShiftsRegular');

const Shifts30MinutesFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 7a2.5 2.5 0 100-5 2.5 2.5 0 000 5zM8 8a2 2 0 00-2 2v.5c0 .28.22.5.5.5h7a.5.5 0 00.5-.5V10a2 2 0 00-2-2H8zm-2.5 5.75a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm-.75 3.75a.75.75 0 100-1.5.75.75 0 000 1.5zm8.05-3.58c-.18.3-.3.77-.3 1.33s.12 1.03.3 1.33c.17.28.4.42.7.42.3 0 .53-.14.7-.42.18-.3.3-.77.3-1.33a2.6 2.6 0 00-.3-1.33c-.17-.28-.4-.42-.7-.42-.3 0-.53.14-.7.42zm-.85-.52c.33-.53.85-.9 1.55-.9.7 0 1.22.37 1.55.9.32.5.45 1.17.45 1.85 0 .68-.13 1.34-.45 1.85-.33.53-.85.9-1.55.9-.7 0-1.22-.37-1.55-.9a3.58 3.58 0 01-.45-1.85c0-.68.13-1.34.45-1.85zm-4.14.5c.46-.36.83-.43 1.08-.4.25.05.44.2.54.37.1.17.09.35 0 .48-.08.14-.32.35-.9.4a.5.5 0 000 1c.6.05.82.25.9.37.09.13.1.31 0 .5-.1.18-.3.33-.55.37-.25.04-.61-.02-1.07-.38a.5.5 0 10-.62.78c.62.5 1.26.68 1.85.6.57-.1 1.02-.45 1.26-.9a1.47 1.47 0 00-.33-1.85 1.47 1.47 0 00.33-1.86c-.24-.44-.7-.78-1.27-.86a2.4 2.4 0 00-1.84.6.5.5 0 00.62.78z",
    fill: primaryFill
  }));
};

export const Shifts30MinutesFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Shifts30MinutesFilledIcon({}), 'Shifts30MinutesFilled');

const Shifts30MinutesRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.5 4.5a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zM10 2a2.5 2.5 0 100 5 2.5 2.5 0 000-5zm-3 8a1 1 0 011-1h4a1 1 0 011 1v.5a.5.5 0 001 0V10a2 2 0 00-2-2H8a2 2 0 00-2 2v.5a.5.5 0 001 0V10zm-1.5 3.75a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm-.75 3.75a.75.75 0 100-1.5.75.75 0 000 1.5zm8.05-3.58c-.18.3-.3.77-.3 1.33s.12 1.03.3 1.33c.17.28.4.42.7.42.3 0 .53-.14.7-.42.18-.3.3-.77.3-1.33a2.6 2.6 0 00-.3-1.33c-.17-.28-.4-.42-.7-.42-.3 0-.53.14-.7.42zm-.85-.52c.33-.53.85-.9 1.55-.9.7 0 1.22.37 1.55.9.32.5.45 1.17.45 1.85 0 .68-.13 1.34-.45 1.85-.33.53-.85.9-1.55.9-.7 0-1.22-.37-1.55-.9a3.58 3.58 0 01-.45-1.85c0-.68.13-1.34.45-1.85zm-4.14.5c.46-.36.83-.43 1.08-.4.25.05.44.2.54.37.1.17.09.35 0 .48-.08.14-.32.35-.9.4a.5.5 0 000 1c.6.05.82.25.9.37.09.13.1.31 0 .5-.1.18-.3.33-.55.37-.25.04-.61-.02-1.07-.38a.5.5 0 10-.62.78c.62.5 1.26.68 1.85.6.57-.1 1.02-.45 1.26-.9a1.47 1.47 0 00-.33-1.85 1.47 1.47 0 00.33-1.86c-.24-.44-.7-.78-1.27-.86a2.4 2.4 0 00-1.84.6.5.5 0 00.62.78z",
    fill: primaryFill
  }));
};

export const Shifts30MinutesRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Shifts30MinutesRegularIcon({}), 'Shifts30MinutesRegular');

const ShiftsActivityFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2.7a.75.75 0 01-.67.83 6.5 6.5 0 107.14 7.14.75.75 0 111.5.16 8 8 0 11-8.8-8.8c.42-.04.79.26.83.68zm1.02-.06c.1-.4.5-.65.9-.55.38.09.75.2 1.1.35a.75.75 0 01-.55 1.39 6.55 6.55 0 00-.9-.29.75.75 0 01-.55-.9zm6.54 4.33a.75.75 0 00-1.39.56c.12.29.21.59.28.9a.75.75 0 101.46-.35c-.09-.38-.2-.75-.35-1.1zM14.3 3.93a.75.75 0 011.06-.08c.3.27.6.56.86.87a.75.75 0 01-1.15.97 6.65 6.65 0 00-.7-.7.75.75 0 01-.07-1.06zM10 5.75a.75.75 0 00-1.5 0v5c0 .41.34.75.75.75h3a.75.75 0 100-1.5H10V5.75z",
    fill: primaryFill
  }));
};

export const ShiftsActivityFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShiftsActivityFilledIcon({}), 'ShiftsActivityFilled');

const ShiftsActivityRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2.48a.5.5 0 01-.46.53 7 7 0 107.45 7.45.5.5 0 111 .07 8 8 0 11-8.52-8.51.5.5 0 01.53.46zm1 .07a.5.5 0 01.6-.4c.56.12 1.1.3 1.6.52a.5.5 0 11-.4.91c-.44-.2-.91-.34-1.4-.44a.5.5 0 01-.4-.59zm6.34 4.25a.5.5 0 10-.92.4c.2.45.34.91.44 1.4a.5.5 0 00.98-.2 7.95 7.95 0 00-.5-1.6zM14.4 3.92a.5.5 0 01.7-.07c.4.33.75.69 1.08 1.08a.5.5 0 11-.78.63c-.28-.34-.6-.66-.93-.94a.5.5 0 01-.07-.7zM10 5.5a.5.5 0 00-1 0v5c0 .28.22.5.5.5h3a.5.5 0 100-1H10V5.5z",
    fill: primaryFill
  }));
};

export const ShiftsActivityRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShiftsActivityRegularIcon({}), 'ShiftsActivityRegular');

const ShiftsAddFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 3a3 3 0 00-3 3v3.6a5.5 5.5 0 017.4 7.4H14a3 3 0 003-3V6a3 3 0 00-3-3H6zm4.5 3c.28 0 .5.22.5.5V9h1.5a.5.5 0 010 1h-2a.5.5 0 01-.5-.5v-3c0-.28.22-.5.5-.5zm-.5 8.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V14H3.5a.5.5 0 000 1H5v1.5a.5.5 0 001 0V15h1.5a.5.5 0 000-1H6v-1.5z",
    fill: primaryFill
  }));
};

export const ShiftsAddFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShiftsAddFilledIcon({}), 'ShiftsAddFilled');

const ShiftsAddRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 3a3 3 0 00-3 3v3.6c.32-.16.65-.3 1-.4V6c0-1.1.9-2 2-2h8a2 2 0 012 2v8a2 2 0 01-2 2h-3.2c-.1.35-.24.68-.4 1H14a3 3 0 003-3V6a3 3 0 00-3-3H6zm-.5 16a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm0-7c.28 0 .5.22.5.5V14h1.5a.5.5 0 010 1H6v1.5a.5.5 0 01-1 0V15H3.5a.5.5 0 010-1H5v-1.5c0-.28.22-.5.5-.5zM11 6.5a.5.5 0 00-1 0v3c0 .28.22.5.5.5h2a.5.5 0 000-1H11V6.5z",
    fill: primaryFill
  }));
};

export const ShiftsAddRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShiftsAddRegularIcon({}), 'ShiftsAddRegular');

const ShiftsAvailabilityFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 12.92A7 7 0 0112.92 6 6 6 0 106 12.92zm3.35-8.27c.2.2.2.5 0 .7l-3 3a.5.5 0 01-.7 0l-1.5-1.5a.5.5 0 11.7-.7L6 7.29l2.65-2.64c.2-.2.5-.2.7 0zM13 19a6 6 0 100-12 6 6 0 000 12zm-1.65-8.35L13 12.29l1.65-1.64a.5.5 0 01.7.7L13.71 13l1.64 1.65a.5.5 0 01-.7.7L13 13.71l-1.65 1.64a.5.5 0 01-.7-.7L12.29 13l-1.64-1.65a.5.5 0 01.7-.7z",
    fill: primaryFill
  }));
};

export const ShiftsAvailabilityFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShiftsAvailabilityFilledIcon({}), 'ShiftsAvailabilityFilled');

const ShiftsAvailabilityRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11.92 6.08a5 5 0 10-5.84 5.84c-.05.32-.08.66-.08 1A6 6 0 1112.92 6c-.34 0-.68.03-1 .08zm-.57 4.57a.5.5 0 00-.7.7L12.29 13l-1.64 1.65a.5.5 0 00.7.7L13 13.71l1.65 1.64a.5.5 0 00.7-.7L13.71 13l1.64-1.65a.5.5 0 00-.7-.7L13 12.29l-1.65-1.64zM13 19a6 6 0 100-12 6 6 0 000 12zm0-1a5 5 0 110-10 5 5 0 010 10zM9.35 5.35a.5.5 0 10-.7-.7L6 7.29 4.85 6.15a.5.5 0 10-.7.7l1.5 1.5c.2.2.5.2.7 0l3-3z",
    fill: primaryFill
  }));
};

export const ShiftsAvailabilityRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShiftsAvailabilityRegularIcon({}), 'ShiftsAvailabilityRegular');

const ShiftsCheckmarkFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 6a3 3 0 013-3h8a3 3 0 013 3v8a3 3 0 01-3 3h-3.6a5.48 5.48 0 00-.66-6h2.76a.5.5 0 000-1H10V6.5a.5.5 0 00-1 0v3.76a5.48 5.48 0 00-6-.66V6zm7 8.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.15-1.85a.5.5 0 00-.7 0L4.5 15.29l-.65-.64a.5.5 0 00-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 000-.7z",
    fill: primaryFill
  }));
};

export const ShiftsCheckmarkFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShiftsCheckmarkFilledIcon({}), 'ShiftsCheckmarkFilled');

const ShiftsCheckmarkRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 3a3 3 0 00-3 3v3.6c.32-.16.65-.3 1-.4V6c0-1.1.9-2 2-2h8a2 2 0 012 2v8a2 2 0 01-2 2h-3.2c-.1.35-.24.68-.4 1H14a3 3 0 003-3V6a3 3 0 00-3-3H6zm3 7.26c.27.22.52.47.74.74h2.76a.5.5 0 000-1H10V6.5a.5.5 0 00-1 0v3.76zm1 4.24a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.15-1.85a.5.5 0 00-.7 0L4.5 15.29l-.65-.64a.5.5 0 00-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 000-.7z",
    fill: primaryFill
  }));
};

export const ShiftsCheckmarkRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShiftsCheckmarkRegularIcon({}), 'ShiftsCheckmarkRegular');

const ShiftsDayFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 5.5A2.5 2.5 0 015.5 3h9A2.5 2.5 0 0117 5.5v9a2.5 2.5 0 01-2.5 2.5h-9A2.5 2.5 0 013 14.5v-9zm3.4 2.04a1.82 1.82 0 00-.34.5l-.03.08a.5.5 0 00.94.34l.02-.05.13-.17c.12-.11.3-.24.65-.24.4 0 .64.23.75.54.1.33.03.72-.24.96-.15.15-.34.28-.58.44l-.04.02c-.22.15-.47.31-.7.51A2.52 2.52 0 006 12.5a.5.5 0 00.5.5H9a.5.5 0 000-1H7.07c.1-.32.29-.56.54-.77.18-.15.39-.3.62-.44l.02-.02c.23-.15.5-.33.72-.54.58-.54.71-1.34.5-2A1.74 1.74 0 007.77 7c-.64 0-1.09.26-1.36.54zM11.5 7a.5.5 0 00-.5.5V10a.5.5 0 00.5.5H13v2a.5.5 0 001 0v-5a.5.5 0 00-1 0v2h-1v-2a.5.5 0 00-.5-.5z",
    fill: primaryFill
  }));
};

export const ShiftsDayFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShiftsDayFilledIcon({}), 'ShiftsDayFilled');

const ShiftsDayRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.4 7.54c.28-.28.73-.54 1.37-.54.88 0 1.48.56 1.7 1.23.21.66.08 1.46-.5 2-.23.21-.49.39-.72.54l-.02.02c-.23.15-.44.29-.62.44a1.6 1.6 0 00-.54.77H9a.5.5 0 110 1H6.5a.5.5 0 01-.5-.5c0-.97.44-1.59.96-2.03.23-.2.48-.36.7-.5l.04-.03c.24-.16.43-.3.58-.44a.93.93 0 00.24-.96.75.75 0 00-.75-.54.86.86 0 00-.65.24.82.82 0 00-.15.22.5.5 0 01-.94-.34l.03-.07.07-.14c.05-.1.15-.23.28-.37zM11.5 7c.28 0 .5.22.5.5v2h1v-2a.5.5 0 011 0v5a.5.5 0 01-1 0v-2h-1.5a.5.5 0 01-.5-.5V7.5c0-.28.22-.5.5-.5zm-6-4A2.5 2.5 0 003 5.5v9A2.5 2.5 0 005.5 17h9a2.5 2.5 0 002.5-2.5v-9A2.5 2.5 0 0014.5 3h-9zM4 5.5C4 4.67 4.67 4 5.5 4h9c.83 0 1.5.67 1.5 1.5v9c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 014 14.5v-9z",
    fill: primaryFill
  }));
};

export const ShiftsDayRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShiftsDayRegularIcon({}), 'ShiftsDayRegular');

const ShiftsOpenFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.5 5.75c0-.69.56-1.25 1.25-1.25H7.5a.75.75 0 000-1.5H5.75A2.75 2.75 0 003 5.75v8.5A2.75 2.75 0 005.75 17H7.5a.75.75 0 000-1.5H5.75c-.69 0-1.25-.56-1.25-1.25v-8.5zm8-2.75a.75.75 0 000 1.5h1.75c.69 0 1.25.56 1.25 1.25v8.5c0 .69-.56 1.25-1.25 1.25H12.5a.75.75 0 000 1.5h1.75A2.75 2.75 0 0017 14.25v-8.5A2.75 2.75 0 0014.25 3H12.5zm-2 2.75a.75.75 0 00-1.5 0v4.5c0 .41.34.75.75.75h3.5a.75.75 0 000-1.5H10.5V5.75z",
    fill: primaryFill
  }));
};

export const ShiftsOpenFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShiftsOpenFilledIcon({}), 'ShiftsOpenFilled');

const ShiftsOpenRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 5.5C4 4.67 4.67 4 5.5 4h2a.5.5 0 000-1h-2A2.5 2.5 0 003 5.5v9A2.5 2.5 0 005.5 17h2a.5.5 0 000-1h-2A1.5 1.5 0 014 14.5v-9zM12.5 3a.5.5 0 000 1h2c.83 0 1.5.67 1.5 1.5v9c0 .83-.67 1.5-1.5 1.5h-2a.5.5 0 000 1h2a2.5 2.5 0 002.5-2.5v-9A2.5 2.5 0 0014.5 3h-2zM10 5.5a.5.5 0 00-1 0v5c0 .28.22.5.5.5h4a.5.5 0 000-1H10V5.5z",
    fill: primaryFill
  }));
};

export const ShiftsOpenRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShiftsOpenRegularIcon({}), 'ShiftsOpenRegular');

const ShiftsProhibitedFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 6a3 3 0 013-3h8a3 3 0 013 3v8a3 3 0 01-3 3h-3.6A5.5 5.5 0 003 9.6V6zm8 .5a.5.5 0 00-1 0v3c0 .28.22.5.5.5h2a.5.5 0 000-1H11V6.5zm-10 8a4.5 4.5 0 109 0 4.5 4.5 0 00-9 0zm1 0a3.5 3.5 0 015.6-2.8l-4.9 4.9a3.48 3.48 0 01-.7-2.1zM5.5 18c-.79 0-1.51-.26-2.1-.7l4.9-4.9A3.5 3.5 0 015.5 18z",
    fill: primaryFill
  }));
};

export const ShiftsProhibitedFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShiftsProhibitedFilledIcon({}), 'ShiftsProhibitedFilled');

const ShiftsProhibitedRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 6a3 3 0 013-3h8a3 3 0 013 3v8a3 3 0 01-3 3h-3.6c.16-.32.3-.65.4-1H14a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v3.2c-.35.1-.68.24-1 .4V6zm7.5 0c.28 0 .5.22.5.5V9h1.5a.5.5 0 010 1h-2a.5.5 0 01-.5-.5v-3c0-.28.22-.5.5-.5zM1 14.5a4.5 4.5 0 109 0 4.5 4.5 0 00-9 0zm1 0a3.5 3.5 0 015.6-2.8l-4.9 4.9a3.48 3.48 0 01-.7-2.1zM5.5 18c-.79 0-1.51-.26-2.1-.7l4.9-4.9A3.5 3.5 0 015.5 18z",
    fill: primaryFill
  }));
};

export const ShiftsProhibitedRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShiftsProhibitedRegularIcon({}), 'ShiftsProhibitedRegular');

const ShiftsQuestionMarkFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 3a3 3 0 00-3 3v3.6a5.5 5.5 0 017.4 7.4H14a3 3 0 003-3V6a3 3 0 00-3-3H6zm4.5 3c.28 0 .5.22.5.5V9h2a.5.5 0 010 1h-2.5a.5.5 0 01-.5-.5v-3c0-.28.22-.5.5-.5zm-.5 8.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4.5 1.88a.62.62 0 100 1.25.62.62 0 000-1.25zm0-4.88c-1.05 0-1.86.82-1.85 1.96a.5.5 0 101-.01c0-.58.36-.95.85-.95.47 0 .85.4.85.95 0 .2-.07.32-.36.55l-.27.21c-.51.4-.72.72-.72 1.29a.5.5 0 001 .09v-.16c.02-.14.1-.25.35-.44l.28-.22c.5-.4.72-.73.72-1.32 0-1.1-.82-1.95-1.85-1.95z",
    fill: primaryFill
  }));
};

export const ShiftsQuestionMarkFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShiftsQuestionMarkFilledIcon({}), 'ShiftsQuestionMarkFilled');

const ShiftsQuestionMarkRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 3a3 3 0 00-3 3v3.6c.32-.16.65-.3 1-.4V6c0-1.1.9-2 2-2h8a2 2 0 012 2v8a2 2 0 01-2 2h-3.2c-.1.35-.24.68-.4 1H14a3 3 0 003-3V6a3 3 0 00-3-3H6zm5 3.5a.5.5 0 00-1 0v3c0 .28.22.5.5.5h2a.5.5 0 000-1H11V6.5zm-1 8a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4.5 1.88a.62.62 0 100 1.25.62.62 0 000-1.25zm0-4.88c-1.05 0-1.86.82-1.85 1.96a.5.5 0 101-.01c0-.58.36-.95.85-.95.47 0 .85.4.85.95 0 .2-.07.32-.36.55l-.27.21c-.51.4-.72.72-.72 1.29a.5.5 0 001 .09v-.16c.02-.14.1-.25.35-.44l.28-.22c.5-.4.72-.73.72-1.32 0-1.1-.82-1.95-1.85-1.95z",
    fill: primaryFill
  }));
};

export const ShiftsQuestionMarkRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShiftsQuestionMarkRegularIcon({}), 'ShiftsQuestionMarkRegular');

const ShoppingBagFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 6V4.5a2.42 2.42 0 01.73-1.77A2.43 2.43 0 018.5 2a2.43 2.43 0 011.5.5 2.44 2.44 0 012.48-.3 2.53 2.53 0 011.32 1.33c.13.3.2.63.2.97V6h1a1 1 0 011 1v8a2.95 2.95 0 01-1.47 2.58l-.59-.26-.5-.22-.2-.11-.23-.17-.24-.21-.27-.29A2 2 0 0112 15V6h1V4.5a1.47 1.47 0 00-.44-1.06A1.48 1.48 0 0011.5 3c-.3 0-.58.09-.83.26A2.5 2.5 0 0111 4.5V15a2.95 2.95 0 00.77 2l.3.33.31.27.31.23.31.17H7a3 3 0 01-3-3V7a1 1 0 011-1h1zm1 0h3V4.5a1.47 1.47 0 00-.44-1.06A1.48 1.48 0 008.5 3a1.47 1.47 0 00-1.06.44A1.48 1.48 0 007 4.5V6z",
    fill: primaryFill
  }));
};

export const ShoppingBagFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShoppingBagFilledIcon({}), 'ShoppingBagFilled');

const ShoppingBagRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2.5a2.5 2.5 0 00-4 2V6H5a1 1 0 00-1 1v8a3 3 0 003 3h6.5a2.5 2.5 0 002.5-2.5V7a1 1 0 00-1-1h-1V4.5a2.5 2.5 0 00-4-2zm-3 2a1.5 1.5 0 113 0V6H7V4.5zm3.67-1.25A1.5 1.5 0 0113 4.5V6h-2V4.5c0-.45-.12-.88-.33-1.25zM7 17a2 2 0 01-2-2V7h6v8.5c0 .56.19 1.08.5 1.5H7zm8-1.5a1.5 1.5 0 01-3 0V7h3v8.5z",
    fill: primaryFill
  }));
};

export const ShoppingBagRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShoppingBagRegularIcon({}), 'ShoppingBagRegular');

const ShoppingBagArrowLeftFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 6V4.5a2.42 2.42 0 01.73-1.77A2.43 2.43 0 018.5 2a2.43 2.43 0 011.5.5 2.44 2.44 0 012.48-.3 2.53 2.53 0 011.32 1.33c.13.3.2.63.2.97V6h1a1 1 0 011 1v2.2a5.5 5.5 0 00-4 .4V6h1V4.5a1.47 1.47 0 00-.44-1.06A1.48 1.48 0 0011.5 3c-.3 0-.58.09-.83.26A2.5 2.5 0 0111 4.5v5.76a5.49 5.49 0 00-.74 7.74H7a3 3 0 01-3-3V7a1 1 0 011-1h1zm4 0V4.5a1.47 1.47 0 00-.44-1.06A1.48 1.48 0 008.5 3a1.47 1.47 0 00-1.06.44A1.48 1.48 0 007 4.5V6h3zm9 8.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-6.85-.35a.5.5 0 00-.15.35.5.5 0 00.15.35l2 2a.5.5 0 00.7-.7L13.71 15h2.79a.5.5 0 000-1h-2.8l1.15-1.15a.5.5 0 00-.7-.7l-2 2z",
    fill: primaryFill
  }));
};

export const ShoppingBagArrowLeftFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShoppingBagArrowLeftFilledIcon({}), 'ShoppingBagArrowLeftFilled');

const ShoppingBagArrowLeftRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M15 6a1 1 0 011 1v2.2c-.32-.08-.66-.15-1-.18V7h-3v2.6c-.36.18-.7.4-1 .66V7H5v8a1.98 1.98 0 001.23 1.84c.24.1.5.16.77.16h2.6c.18.36.4.7.66 1H7a3 3 0 01-3-3V7a1 1 0 011-1h1V4.5a2.42 2.42 0 01.73-1.77A2.43 2.43 0 018.5 2a2.43 2.43 0 011.5.5 2.44 2.44 0 012.48-.3 2.53 2.53 0 011.32 1.33c.13.3.2.63.2.97V6h1zm-2-1.5a1.47 1.47 0 00-.44-1.06A1.48 1.48 0 0011.5 3c-.3 0-.58.09-.83.26A2.5 2.5 0 0111 4.5V6h2V4.5zM7 6h3V4.5a1.47 1.47 0 00-.44-1.06A1.48 1.48 0 008.5 3a1.47 1.47 0 00-1.06.44A1.48 1.48 0 007 4.5V6zm7.5 13a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm-2.36-4.85l2-2a.5.5 0 01.71.7L13.71 14h2.79a.5.5 0 010 1h-2.8l1.15 1.15a.5.5 0 01-.7.7l-2-2a.5.5 0 01-.15-.35.5.5 0 01.14-.35z",
    fill: primaryFill
  }));
};

export const ShoppingBagArrowLeftRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShoppingBagArrowLeftRegularIcon({}), 'ShoppingBagArrowLeftRegular');

const ShoppingBagDismissFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 6V4.5a2.42 2.42 0 01.73-1.77A2.43 2.43 0 018.5 2a2.43 2.43 0 011.5.5 2.44 2.44 0 012.48-.3 2.53 2.53 0 011.32 1.33c.13.3.2.63.2.97V6h1a1 1 0 011 1v2.2a5.5 5.5 0 00-4 .4V6h1V4.5a1.47 1.47 0 00-.44-1.06A1.48 1.48 0 0011.5 3c-.3 0-.58.09-.83.26A2.5 2.5 0 0111 4.5v5.76a5.49 5.49 0 00-.74 7.74H7a3 3 0 01-3-3V7a1 1 0 011-1h1zm4 0V4.5a1.47 1.47 0 00-.44-1.06A1.48 1.48 0 008.5 3a1.47 1.47 0 00-1.06.44A1.48 1.48 0 007 4.5V6h3zm9 8.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.65-1.15a.5.5 0 00-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 00-.7.7l1.14 1.15-1.14 1.15a.5.5 0 00.7.7l1.15-1.14 1.15 1.14a.5.5 0 00.7-.7l-1.14-1.15 1.14-1.15z",
    fill: primaryFill
  }));
};

export const ShoppingBagDismissFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShoppingBagDismissFilledIcon({}), 'ShoppingBagDismissFilled');

const ShoppingBagDismissRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2.5a2.5 2.5 0 00-4 2V6H5a1 1 0 00-1 1v8a3 3 0 003 3h3.26a5.5 5.5 0 01-.66-1H7a2 2 0 01-2-2V7h6v3.26c.3-.26.64-.48 1-.66V7h3v2.02c.34.03.68.1 1 .19V7a1 1 0 00-1-1h-1V4.5a2.5 2.5 0 00-4-2zm-3 2a1.5 1.5 0 113 0V6H7V4.5zm3.67-1.25A1.5 1.5 0 0113 4.5V6h-2V4.5c0-.45-.12-.88-.33-1.25zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.65-1.15a.5.5 0 00-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 00-.7.7l1.14 1.15-1.14 1.15a.5.5 0 00.7.7l1.15-1.14 1.15 1.14a.5.5 0 00.7-.7l-1.14-1.15 1.14-1.15z",
    fill: primaryFill
  }));
};

export const ShoppingBagDismissRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShoppingBagDismissRegularIcon({}), 'ShoppingBagDismissRegular');

const ShoppingBagPauseFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 6V4.5a2.42 2.42 0 01.73-1.77A2.43 2.43 0 018.5 2a2.43 2.43 0 011.5.5 2.44 2.44 0 012.48-.3 2.53 2.53 0 011.32 1.33c.13.3.2.63.2.97V6h1a1 1 0 011 1v2.2a5.5 5.5 0 00-4 .4V6h1V4.5a1.47 1.47 0 00-.44-1.06A1.48 1.48 0 0011.5 3c-.3 0-.58.09-.83.26A2.5 2.5 0 0111 4.5v5.76a5.49 5.49 0 00-.74 7.74H7a3 3 0 01-3-3V7a1 1 0 011-1h1zm4 0V4.5a1.47 1.47 0 00-.44-1.06A1.48 1.48 0 008.5 3a1.47 1.47 0 00-1.06.44A1.48 1.48 0 007 4.5V6h3zm9 8.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zM13 12a.5.5 0 00-.5.5v4a.5.5 0 001 0v-4a.5.5 0 00-.5-.5zm3 0a.5.5 0 00-.5.5v4a.5.5 0 001 0v-4a.5.5 0 00-.5-.5z",
    fill: primaryFill
  }));
};

export const ShoppingBagPauseFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShoppingBagPauseFilledIcon({}), 'ShoppingBagPauseFilled');

const ShoppingBagPauseRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2.5a2.5 2.5 0 00-4 2V6H5a1 1 0 00-1 1v8a3 3 0 003 3h3.26a5.5 5.5 0 01-.66-1H7a2 2 0 01-2-2V7h6v3.26c.3-.26.64-.48 1-.66V7h3v2.02c.34.03.68.1 1 .19V7a1 1 0 00-1-1h-1V4.5a2.5 2.5 0 00-4-2zm-3 2a1.5 1.5 0 113 0V6H7V4.5zm3.67-1.25A1.5 1.5 0 0113 4.5V6h-2V4.5c0-.45-.12-.88-.33-1.25zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zM13 12a.5.5 0 00-.5.5v4a.5.5 0 001 0v-4a.5.5 0 00-.5-.5zm3 0a.5.5 0 00-.5.5v4a.5.5 0 001 0v-4a.5.5 0 00-.5-.5z",
    fill: primaryFill
  }));
};

export const ShoppingBagPauseRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShoppingBagPauseRegularIcon({}), 'ShoppingBagPauseRegular');

const ShoppingBagPercentFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 4.5V6H5a1 1 0 00-1 1v8a2.93 2.93 0 00.88 2.13A3 3 0 007 18h3.09a1.5 1.5 0 01.35-1.56l.56-.56v-1.05a3 3 0 010-5.66V4.5a2.48 2.48 0 00-.33-1.24 1.48 1.48 0 012.21.66c.08.18.12.37.12.58V6h-1v3a3 3 0 013 2.88l1-1V7a1 1 0 00-1-1h-1V4.5a2.48 2.48 0 00-4-2A2.54 2.54 0 008.5 2a2.42 2.42 0 00-1.77.73A2.43 2.43 0 006 4.5zm4 0V6H7V4.5a1.48 1.48 0 01.91-1.38 1.48 1.48 0 011.97.8c.08.18.12.37.12.58zm2 9.5a2 2 0 100-4 2 2 0 000 4zm0-3a1 1 0 110 2 1 1 0 010-2zm5 8a2 2 0 100-4 2 2 0 000 4zm0-3a1 1 0 110 2 1 1 0 010-2zm.85-4.15a.5.5 0 00-.7-.7l-6 6a.5.5 0 00.7.7l6-6z",
    fill: primaryFill
  }));
};

export const ShoppingBagPercentFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShoppingBagPercentFilledIcon({}), 'ShoppingBagPercentFilled');

const ShoppingBagPercentRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.5 2c.56 0 1.08.19 1.5.5a2.5 2.5 0 014 2V6h1a1 1 0 011 1v3.88l-1 1V7h-3v2a3 3 0 00-1 .17V7H5v8c0 1.1.9 2 2 2h3.09a1.5 1.5 0 000 1H7a3 3 0 01-3-3V7a1 1 0 011-1h1V4.5A2.5 2.5 0 018.5 2zm0 1C7.67 3 7 3.67 7 4.5V6h3V4.5C10 3.67 9.33 3 8.5 3zm3 0c-.3 0-.6.1-.83.25.2.37.33.8.33 1.25V6h2V4.5c0-.83-.67-1.5-1.5-1.5zm.5 11a2 2 0 100-4 2 2 0 000 4zm0-3a1 1 0 110 2 1 1 0 010-2zm5 8a2 2 0 100-4 2 2 0 000 4zm0-3a1 1 0 110 2 1 1 0 010-2zm.85-4.15a.5.5 0 00-.7-.7l-6 6a.5.5 0 00.7.7l6-6z",
    fill: primaryFill
  }));
};

export const ShoppingBagPercentRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShoppingBagPercentRegularIcon({}), 'ShoppingBagPercentRegular');

const ShoppingBagPlayFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 4.5V6H5a1 1 0 00-1 1v8a2.93 2.93 0 00.88 2.13A3 3 0 007 18h3.26a5.48 5.48 0 01.74-7.74V4.5a2.48 2.48 0 00-.33-1.24 1.48 1.48 0 012.21.66c.08.18.12.37.12.58V6h-1v3.6a5.48 5.48 0 014-.4V7a1 1 0 00-1-1h-1V4.5a2.48 2.48 0 00-4-2A2.54 2.54 0 008.5 2a2.42 2.42 0 00-1.77.73A2.43 2.43 0 006 4.5zM10 6H7V4.5a1.48 1.48 0 01.91-1.38 1.48 1.48 0 011.97.8c.08.18.12.37.12.58V6zm4.5 13a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm-.74-6.55c.1 0 .18.03.26.08l2.3 1.51c.07.05.12.1.16.18a.54.54 0 01-.03.54.46.46 0 01-.13.13l-2.3 1.57a.54.54 0 01-.12.06.45.45 0 01-.32-.02.57.57 0 01-.16-.1.5.5 0 01-.14-.36v-3.08a.51.51 0 01.3-.46.44.44 0 01.18-.05z",
    fill: primaryFill
  }));
};

export const ShoppingBagPlayFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShoppingBagPlayFilledIcon({}), 'ShoppingBagPlayFilled');

const ShoppingBagPlayRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M15 6a1 1 0 011 1v2.2c-.32-.08-.66-.15-1-.18V7h-3v2.6c-.36.18-.7.4-1 .66V7H5v8a1.98 1.98 0 001.23 1.84c.24.1.5.16.77.16h2.6c.18.36.4.7.66 1H7a3 3 0 01-3-3V7a1 1 0 011-1h1V4.5a2.42 2.42 0 01.73-1.77A2.43 2.43 0 018.5 2a2.43 2.43 0 011.5.5 2.44 2.44 0 012.48-.3 2.53 2.53 0 011.32 1.33c.13.3.2.63.2.97V6h1zm-2-1.5a1.47 1.47 0 00-.44-1.06A1.48 1.48 0 0011.5 3c-.3 0-.58.09-.83.26A2.5 2.5 0 0111 4.5V6h2V4.5zM7 6h3V4.5a1.47 1.47 0 00-.44-1.06A1.48 1.48 0 008.5 3a1.47 1.47 0 00-1.06.44A1.48 1.48 0 007 4.5V6zm12 8.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4.98-1.97a.45.45 0 00-.45-.03.5.5 0 00-.15.1.51.51 0 00-.14.36v3.08a.5.5 0 00.14.35.45.45 0 00.52.12.54.54 0 00.09-.05l2.3-1.57a.46.46 0 00.16-.18.54.54 0 000-.49.49.49 0 00-.17-.18l-2.3-1.5z",
    fill: primaryFill
  }));
};

export const ShoppingBagPlayRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShoppingBagPlayRegularIcon({}), 'ShoppingBagPlayRegular');

const ShoppingBagTagFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 6V4.5a2.42 2.42 0 01.73-1.77A2.43 2.43 0 018.5 2a2.43 2.43 0 011.5.5 2.44 2.44 0 012.48-.3 2.53 2.53 0 011.32 1.33c.13.3.2.63.2.97V6h1a1 1 0 011 1v2.6a2.5 2.5 0 00-1.62-.6H12V6h1V4.5a1.47 1.47 0 00-.44-1.06A1.48 1.48 0 0011.5 3c-.3 0-.58.09-.83.26A2.5 2.5 0 0111 4.5v4.55c-1.14.24-2 1.25-2 2.46v2.88c0 .66.26 1.29.72 1.76L11.53 18H7a3 3 0 01-3-3V7a1 1 0 011-1h1zm4 0V4.5a1.47 1.47 0 00-.44-1.06A1.48 1.48 0 008.5 3a1.47 1.47 0 00-1.06.44A1.48 1.48 0 007 4.5V6h3zm.43 9.45a1.51 1.51 0 01-.43-1.06v-2.88c0-.83.68-1.51 1.51-1.51h2.87c.4 0 .8.16 1.07.45l3.11 3.14c.6.6.58 1.57-.02 2.15l-2.95 2.84a1.5 1.5 0 01-2.12-.03l-3.04-3.1zm1.57-2.7a.75.75 0 101.5 0 .75.75 0 00-1.5 0z",
    fill: primaryFill
  }));
};

export const ShoppingBagTagFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShoppingBagTagFilledIcon({}), 'ShoppingBagTagFilled');

const ShoppingBagTagRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2.5a2.5 2.5 0 00-4 2V6H5a1 1 0 00-1 1v8a3 3 0 003 3h4.53l-.98-1H7a2 2 0 01-2-2V7h6v2.05c.16-.03.34-.05.51-.05H12V7h3v2.08c.37.09.7.27 1 .51V7a1 1 0 00-1-1h-1V4.5a2.5 2.5 0 00-4-2zm-3 2a1.5 1.5 0 113 0V6H7V4.5zm3.67-1.25A1.5 1.5 0 0113 4.5V6h-2V4.5c0-.45-.12-.88-.33-1.25zm-.24 12.2a1.51 1.51 0 01-.43-1.06v-2.88c0-.83.68-1.51 1.51-1.51h2.87c.4 0 .8.16 1.07.45l3.11 3.14c.6.6.58 1.57-.02 2.15l-2.95 2.84a1.5 1.5 0 01-2.12-.03l-3.04-3.1zm1.57-2.7a.75.75 0 101.5 0 .75.75 0 00-1.5 0z",
    fill: primaryFill
  }));
};

export const ShoppingBagTagRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShoppingBagTagRegularIcon({}), 'ShoppingBagTagRegular');

const ShortpickFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7 2a1 1 0 00-1 1v2a1 1 0 001 1h.5a.5.5 0 000-1H7V3h.5a.5.5 0 000-1H7zm2.5 0a.5.5 0 000 1h1a.5.5 0 000-1h-1zm3 0a.5.5 0 000 1h.5v2h-.5a.5.5 0 000 1h.5a1 1 0 001-1V3a1 1 0 00-1-1h-.5zm-3 3a.5.5 0 000 1h1a.5.5 0 000-1h-1zm-5 2c.28 0 .5.22.5.5v8c0 .83.67 1.5 1.5 1.5h7c.83 0 1.5-.67 1.5-1.5v-8a.5.5 0 011 0v8a2.5 2.5 0 01-2.5 2.5h-7A2.5 2.5 0 014 15.5v-8c0-.28.22-.5.5-.5zM7 12a1 1 0 00-1 1v2a1 1 0 001 1h6a1 1 0 001-1v-2a1 1 0 00-1-1H7zM6 8a1 1 0 011-1h.5a.5.5 0 010 1H7v2h.5a.5.5 0 010 1H7a1 1 0 01-1-1V8zm3-.5c0-.28.22-.5.5-.5h1a.5.5 0 010 1h-1a.5.5 0 01-.5-.5zm3 0c0-.28.22-.5.5-.5h.5a1 1 0 011 1v2a1 1 0 01-1 1h-.5a.5.5 0 010-1h.5V8h-.5a.5.5 0 01-.5-.5zm-3 3c0-.28.22-.5.5-.5h1a.5.5 0 010 1h-1a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const ShortpickFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShortpickFilledIcon({}), 'ShortpickFilled');

const ShortpickRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7 2a1 1 0 00-1 1v2a1 1 0 001 1h.5a.5.5 0 000-1H7V3h.5a.5.5 0 000-1H7zm2.5 0a.5.5 0 000 1h1a.5.5 0 000-1h-1zm3 0a.5.5 0 000 1h.5v2h-.5a.5.5 0 000 1h.5a1 1 0 001-1V3a1 1 0 00-1-1h-.5zm-3 3a.5.5 0 000 1h1a.5.5 0 000-1h-1zM5 7.5a.5.5 0 00-1 0v8A2.5 2.5 0 006.5 18h7a2.5 2.5 0 002.5-2.5v-8a.5.5 0 00-1 0v8c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 015 15.5v-8zM7 12a1 1 0 00-1 1v2a1 1 0 001 1h6a1 1 0 001-1v-2a1 1 0 00-1-1H7zm0 1h6v2H7v-2zM6 8a1 1 0 011-1h.5a.5.5 0 010 1H7v2h.5a.5.5 0 010 1H7a1 1 0 01-1-1V8zm3-.5c0-.28.22-.5.5-.5h1a.5.5 0 010 1h-1a.5.5 0 01-.5-.5zm3 0c0-.28.22-.5.5-.5h.5a1 1 0 011 1v2a1 1 0 01-1 1h-.5a.5.5 0 010-1h.5V8h-.5a.5.5 0 01-.5-.5zm-3 3c0-.28.22-.5.5-.5h1a.5.5 0 010 1h-1a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const ShortpickRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShortpickRegularIcon({}), 'ShortpickRegular');

const SidebarSearchLtrFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 5.5A2.5 2.5 0 015.5 3h9A2.5 2.5 0 0117 5.5v9a2.5 2.5 0 01-2.5 2.5h-2.59a1.5 1.5 0 00-.35-.56l-2-2A4.49 4.49 0 005.5 8c-.93 0-1.78.28-2.5.76V5.5zm10 1v7a.5.5 0 001 0v-7a.5.5 0 00-1 0zm-4 6c0 .79-.26 1.51-.7 2.1l2.55 2.55a.5.5 0 01-.7.7L7.6 15.3A3.5 3.5 0 119 12.5zm-1 0a2.5 2.5 0 10-5 0 2.5 2.5 0 005 0z",
    fill: primaryFill
  }));
};

export const SidebarSearchLtrFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SidebarSearchLtrFilledIcon({}), 'SidebarSearchLtrFilled');

const SidebarSearchLtrRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 5.5A2.5 2.5 0 015.5 3h9A2.5 2.5 0 0117 5.5v9a2.5 2.5 0 01-2.5 2.5h-2.59a1.5 1.5 0 00-.35-.56l-.44-.44h3.38c.83 0 1.5-.67 1.5-1.5v-9c0-.83-.67-1.5-1.5-1.5h-9C4.67 4 4 4.67 4 5.5v2.76c-.36.12-.7.3-1 .5V5.5zm5.3 9.1a3.5 3.5 0 10-.7.7l2.55 2.55a.5.5 0 00.7-.7L8.3 14.6zm-2.8.4a2.5 2.5 0 110-5 2.5 2.5 0 010 5zm8-9a.5.5 0 00-.5.5v7a.5.5 0 001 0v-7a.5.5 0 00-.5-.5z",
    fill: primaryFill
  }));
};

export const SidebarSearchLtrRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SidebarSearchLtrRegularIcon({}), 'SidebarSearchLtrRegular');

const SidebarSearchRtlFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 5.5A2.5 2.5 0 015.5 3h9A2.5 2.5 0 0117 5.5v7a4.5 4.5 0 10-4.5 4.5h-7A2.5 2.5 0 013 14.5v-9zm3 1v7a.5.5 0 001 0v-7a.5.5 0 00-1 0zm10 6c0 .79-.26 1.51-.7 2.1l2.55 2.55a.5.5 0 01-.7.7L14.6 15.3a3.5 3.5 0 111.4-2.8zm-1 0a2.5 2.5 0 10-5 0 2.5 2.5 0 005 0z",
    fill: primaryFill
  }));
};

export const SidebarSearchRtlFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SidebarSearchRtlFilledIcon({}), 'SidebarSearchRtlFilled');

const SidebarSearchRtlRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 5.5A2.5 2.5 0 015.5 3h9A2.5 2.5 0 0117 5.5v7c0-1.07-.37-2.06-1-2.83V5.5c0-.83-.67-1.5-1.5-1.5h-9C4.67 4 4 4.67 4 5.5v9c0 .83.67 1.5 1.5 1.5h4.17c.77.63 1.76 1 2.83 1h-7A2.5 2.5 0 013 14.5v-9zm3 1a.5.5 0 011 0v7a.5.5 0 01-1 0v-7zm10 6c0 .79-.26 1.51-.7 2.1l2.55 2.55a.5.5 0 01-.7.7L14.6 15.3a3.5 3.5 0 111.4-2.8zm-1 0a2.5 2.5 0 10-5 0 2.5 2.5 0 005 0z",
    fill: primaryFill
  }));
};

export const SidebarSearchRtlRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SidebarSearchRtlRegularIcon({}), 'SidebarSearchRtlRegular');

const SignOutFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11 3.5a.5.5 0 00-.58-.5l-7 1.08a.5.5 0 00-.42.49v10.86c0 .25.18.46.42.5l7 1.07a.5.5 0 00.58-.5V10h5.17l-1 .87a.5.5 0 00.66.76l2-1.75a.5.5 0 000-.76l-2-1.75a.5.5 0 10-.65.76l1 .87H11V3.5zm-2.5 7.75a.75.75 0 110-1.5.75.75 0 010 1.5zm4 4.75H12v-5h1v4.5a.5.5 0 01-.5.5zM12 8V4h.5c.28 0 .5.22.5.5V8h-1z",
    fill: primaryFill
  }));
};

export const SignOutFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SignOutFilledIcon({}), 'SignOutFilled');

const SignOutRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.5 11.25a.75.75 0 100-1.5.75.75 0 000 1.5zM11 3.5a.5.5 0 00-.58-.5l-7 1.08a.5.5 0 00-.42.49v10.86c0 .25.18.46.42.5l7 1.07a.5.5 0 00.58-.5V10h5.17l-1 .87a.5.5 0 00.66.76l2-1.75a.5.5 0 000-.76l-2-1.75a.5.5 0 10-.65.76l1 .87H11V3.5zm-1 .58v11.84L4 15V5l6-.92zM12.5 16H12v-5h1v4.5a.5.5 0 01-.5.5zM12 8V4h.5c.28 0 .5.22.5.5V8h-1z",
    fill: primaryFill
  }));
};

export const SignOutRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SignOutRegularIcon({}), 'SignOutRegular');

const SignatureFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12.02 2.77a2.44 2.44 0 113.46 3.46L14.2 7.5l.08.09a2 2 0 010 2.82l-1.44 1.44a.5.5 0 01-.7-.7l1.44-1.44a1 1 0 000-1.42l-.09-.08-6.65 6.64a.5.5 0 01-.23.14l-4 1a.5.5 0 01-.6-.65l1.26-3.75a.5.5 0 01.12-.2l8.62-8.62zM3.27 16.9c-.02 0-.04-.02-.05-.03l1.35-.34c.53.27 1.18.47 1.93.47.5 0 1.01-.18 1.53-.47.53-.3 1.03-.7 1.53-1.1l.13-.11c.44-.36.9-.74 1.34-1 .47-.27 1.04-.49 1.63-.3.82.28 1.08 1.04 1.32 1.84.05.18.15.36.26.49.11.12.2.15.26.15.19 0 .46-.1.8-.3a9.43 9.43 0 00.93-.62 5.6 5.6 0 011.1-.55h.03l.14.47-.14-.48a.5.5 0 01.28.96 2.74 2.74 0 00-.21.08 4.6 4.6 0 00-.92.54l-.7.46a2.7 2.7 0 01-1.31.44c-.44 0-.78-.23-1-.49a2.33 2.33 0 01-.48-.87c-.26-.87-.41-1.08-.68-1.17-.16-.05-.4-.02-.8.22-.37.21-.77.54-1.23.92l-.12.1c-.5.4-1.06.84-1.66 1.19-.6.34-1.29.6-2.03.6a5.49 5.49 0 01-3.23-1.1z",
    fill: primaryFill
  }));
};

export const SignatureFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SignatureFilledIcon({}), 'SignatureFilled');

const SignatureRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12.02 2.77a2.44 2.44 0 113.46 3.46L14.2 7.5l.08.09a2 2 0 010 2.82l-1.44 1.44a.5.5 0 01-.7-.7l1.44-1.44a1 1 0 000-1.42l-.09-.08-6.65 6.64a.5.5 0 01-.23.14l-4 1a.5.5 0 01-.6-.65l1.26-3.75a.5.5 0 01.12-.2l8.62-8.62zm2.75.7a1.44 1.44 0 00-2.04 0l-8.54 8.55-.93 2.77 2.98-.74 8.53-8.53c.57-.56.57-1.48 0-2.04zM3.22 16.88l.05.03C4 17.44 5.1 18 6.5 18c.74 0 1.42-.26 2.03-.6.6-.35 1.16-.8 1.66-1.2l.12-.1c.46-.37.86-.7 1.23-.91.4-.24.64-.27.8-.22.27.1.42.3.68 1.17.09.3.24.61.47.87.23.26.57.49 1.01.49.47 0 .94-.23 1.3-.44a12.61 12.61 0 00.97-.64 4.6 4.6 0 01.82-.42l.04-.02h.01a.5.5 0 00-.28-.96h-.01l-.02.01a2.35 2.35 0 00-.31.12c-.2.09-.47.22-.8.43l-.33.23c-.19.13-.38.26-.6.39-.33.2-.6.3-.79.3-.06 0-.15-.03-.26-.15-.11-.13-.2-.31-.26-.5-.24-.8-.5-1.55-1.32-1.82-.59-.2-1.16.02-1.63.3-.44.25-.9.63-1.34.99l-.13.1c-.5.41-1 .8-1.53 1.1-.52.3-1.02.48-1.53.48-.75 0-1.4-.2-1.93-.47l-1.35.34zM17.5 15.5l-.14-.48.14.48z",
    fill: primaryFill
  }));
};

export const SignatureRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SignatureRegularIcon({}), 'SignatureRegular');

const SimFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 5a3 3 0 013-3h3.46a3 3 0 012.13.88l2.53 2.53A3 3 0 0116 7.54V15a3 3 0 01-3 3H7a3 3 0 01-3-3V5zm3 5.5v.5h3V9H8.5C7.67 9 7 9.67 7 10.5zM7 12v1.5c0 .83.67 1.5 1.5 1.5H10v-3H7zm4.5 3c.83 0 1.5-.67 1.5-1.5v-3c0-.83-.67-1.5-1.5-1.5H11v6h.5z",
    fill: primaryFill
  }));
};

export const SimFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SimFilledIcon({}), 'SimFilled');

const SimRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.5 9h3c.83 0 1.5.67 1.5 1.5v3c0 .83-.67 1.5-1.5 1.5h-3A1.5 1.5 0 017 13.5v-3C7 9.67 7.67 9 8.5 9zM8 10.5v.5h2v-1H8.5a.5.5 0 00-.5.5zM8 12v1.5c0 .28.22.5.5.5H10v-2H8zm3.5 2a.5.5 0 00.5-.5v-3a.5.5 0 00-.5-.5H11v4h.5zM7 2a3 3 0 00-3 3v10a3 3 0 003 3h6a3 3 0 003-3V7.54a3 3 0 00-.88-2.13L12.6 2.88A3 3 0 0010.46 2H7zM5 5c0-1.1.9-2 2-2h3.46a2 2 0 011.42.59l2.53 2.53A2 2 0 0115 7.54V15a2 2 0 01-2 2H7a2 2 0 01-2-2V5z",
    fill: primaryFill
  }));
};

export const SimRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SimRegularIcon({}), 'SimRegular');

const SkipBack10FilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 5.63V3.75a.75.75 0 00-1.5 0v3.5c0 .41.34.75.75.75h4a.75.75 0 000-1.5H5.23A6.3 6.3 0 0110 4.25c2.4 0 4.53 1.41 5.65 3.54.15.28.43.46.73.46.54 0 .91-.53.67-1.01A7.93 7.93 0 0010 2.75a7.77 7.77 0 00-6 2.88zm4.25 5.12a.75.75 0 00-1.24-.57l-1.75 1.5a.75.75 0 10.98 1.14l.51-.44v3.87a.75.75 0 001.5 0v-5.5zM15 13.5c0 1.93-.63 3.5-2.5 3.5-1.88 0-2.5-1.57-2.5-3.5s.63-3.5 2.5-3.5c1.88 0 2.5 1.57 2.5 3.5zm-1.5 0c0-.85-.15-1.4-.32-1.69a.59.59 0 00-.22-.22.94.94 0 00-.46-.09.94.94 0 00-.46.09.59.59 0 00-.22.22c-.17.3-.32.84-.32 1.69s.15 1.4.32 1.69c.08.12.15.18.22.22.07.04.2.09.46.09s.39-.05.46-.09c.07-.04.14-.1.22-.22.17-.3.32-.84.32-1.69z",
    fill: primaryFill
  }));
};

export const SkipBack10Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SkipBack10FilledIcon({}), 'SkipBack10Filled');

const SkipBack10RegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 3.5a.5.5 0 111 0v2.2a8 8 0 0113.16 1.75.5.5 0 11-.9.44 7 7 0 00-12-.89H7.5a.5.5 0 010 1h-4a.5.5 0 01-.5-.5v-4zm5 7a.5.5 0 00-.78-.42l-1.5 1a.5.5 0 00.56.84l.72-.49v5.07a.5.5 0 001 0v-6zm4.5-.5c-.93 0-1.6.44-2 1.13-.37.65-.5 1.5-.5 2.37 0 .86.13 1.72.5 2.37.4.7 1.07 1.13 2 1.13.94 0 1.6-.44 2-1.13.38-.65.5-1.5.5-2.37 0-.86-.12-1.72-.5-2.37a2.18 2.18 0 00-2-1.13zM11 13.5c0-.8.13-1.44.37-1.87.23-.4.57-.63 1.13-.63.57 0 .9.23 1.13.63.25.43.37 1.08.37 1.87 0 .8-.12 1.44-.37 1.87-.22.4-.56.63-1.13.63-.56 0-.9-.23-1.13-.63A3.87 3.87 0 0111 13.5z",
    fill: primaryFill
  }));
};

export const SkipBack10Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SkipBack10RegularIcon({}), 'SkipBack10Regular');

const SkipForward10FilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M15.73 5.63V3.75a.75.75 0 011.5 0v3.5c0 .41-.33.75-.75.75h-4a.75.75 0 010-1.5h2.03a6.3 6.3 0 00-4.78-2.25 6.45 6.45 0 00-5.65 3.54.83.83 0 01-.73.46c-.54 0-.91-.53-.67-1.01a7.93 7.93 0 017.05-4.49c2.4 0 4.54 1.12 6 2.88zM12.5 17c1.88 0 2.5-1.57 2.5-3.5s-.62-3.5-2.5-3.5c-1.87 0-2.5 1.57-2.5 3.5s.63 3.5 2.5 3.5zm.68-1.81a.59.59 0 01-.22.22.94.94 0 01-.46.09.94.94 0 01-.46-.09.59.59 0 01-.22-.22 3.38 3.38 0 01-.32-1.69c0-.85.15-1.4.32-1.69a.59.59 0 01.22-.22c.07-.04.2-.09.46-.09s.4.05.46.09c.07.04.14.1.22.22.18.3.32.84.32 1.69s-.14 1.4-.32 1.69zm-4.93-4.44a.75.75 0 00-1.24-.57l-1.75 1.5a.75.75 0 10.98 1.14l.51-.44v3.87a.75.75 0 001.5 0v-5.5z",
    fill: primaryFill
  }));
};

export const SkipForward10Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SkipForward10FilledIcon({}), 'SkipForward10Filled');

const SkipForward10RegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 3.5a.5.5 0 00-1 0v2.2A8 8 0 002.84 7.45a.5.5 0 00.9.44A7 7 0 0115.75 7H12.5a.5.5 0 000 1h4a.5.5 0 00.5-.5v-4zm-6.5 7.63c.4-.7 1.07-1.13 2-1.13.94 0 1.6.44 2 1.13.38.65.5 1.5.5 2.37 0 .86-.12 1.72-.5 2.37-.4.7-1.06 1.13-2 1.13-.93 0-1.6-.44-2-1.13-.37-.65-.5-1.5-.5-2.37 0-.86.13-1.72.5-2.37zm.87.5A3.87 3.87 0 0011 13.5c0 .8.13 1.44.37 1.87.23.4.57.63 1.13.63.57 0 .9-.23 1.13-.63.25-.43.37-1.08.37-1.87 0-.8-.12-1.44-.37-1.87-.22-.4-.56-.63-1.13-.63-.56 0-.9.23-1.13.63zM8 10.5a.5.5 0 00-.78-.42l-1.5 1a.5.5 0 00.56.84l.72-.49v5.07a.5.5 0 001 0v-6z",
    fill: primaryFill
  }));
};

export const SkipForward10Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SkipForward10RegularIcon({}), 'SkipForward10Regular');

const SkipForward30FilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M15.73 5.63V3.75a.75.75 0 011.5 0v3.5c0 .41-.33.75-.75.75h-4a.75.75 0 010-1.5h2.03a6.3 6.3 0 00-4.78-2.25 6.45 6.45 0 00-5.65 3.54.83.83 0 01-.73.46c-.54 0-.91-.53-.67-1.01a7.93 7.93 0 017.05-4.49c2.4 0 4.54 1.12 6 2.88zM4.97 10.72a.75.75 0 001.06 1.07v-.01l.07-.06a2.3 2.3 0 011.4-.47c.55 0 .87.15 1.04.3.16.13.22.29.22.43-.01.24-.26.77-1.26.77a.75.75 0 000 1.5c1 0 1.25.53 1.26.77 0 .14-.06.3-.22.44-.17.14-.49.29-1.04.29a2.3 2.3 0 01-1.47-.53.75.75 0 00-1.06 1.06c-.28-.28 0 0 0 0l.02.02a2.03 2.03 0 00.18.16 3.8 3.8 0 002.33.8c.82-.01 1.51-.24 2.01-.66a2.05 2.05 0 00.07-3.1 2.05 2.05 0 00-.07-3.1 3.05 3.05 0 00-2.01-.65 3.8 3.8 0 00-2.5.95l-.02.01zM16 13.5c0 2.07-.62 3.75-2.5 3.75-1.87 0-2.5-1.68-2.5-3.75 0-2.07.63-3.75 2.5-3.75 1.88 0 2.5 1.68 2.5 3.75zm-1.5 0c0-.93-.15-1.56-.35-1.9a.67.67 0 00-.23-.26.8.8 0 00-.42-.09.8.8 0 00-.42.09.67.67 0 00-.23.26c-.2.34-.35.97-.35 1.9 0 .93.15 1.56.35 1.9.08.16.17.23.23.26a.8.8 0 00.42.09.8.8 0 00.42-.09c.06-.03.15-.1.23-.26.2-.34.35-.97.35-1.9z",
    fill: primaryFill
  }));
};

export const SkipForward30Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SkipForward30FilledIcon({}), 'SkipForward30Filled');

const SkipForward30RegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M16.5 3c.28 0 .5.22.5.5v4a.5.5 0 01-.5.5h-4a.5.5 0 010-1h3.25a7 7 0 00-12.01.89.5.5 0 01-.9-.44A8 8 0 0116 5.7V3.5c0-.28.22-.5.5-.5zm-3 7c-.93 0-1.6.44-2 1.13-.37.65-.5 1.5-.5 2.37 0 .86.13 1.72.5 2.37.4.7 1.07 1.13 2 1.13.94 0 1.6-.44 2-1.13.38-.65.5-1.5.5-2.37 0-.86-.12-1.72-.5-2.37a2.18 2.18 0 00-2-1.13zM12 13.5c0-.8.13-1.44.37-1.87.23-.4.57-.63 1.13-.63.57 0 .9.23 1.13.63.25.43.37 1.08.37 1.87 0 .8-.12 1.44-.37 1.87-.22.4-.56.63-1.13.63-.56 0-.9-.23-1.13-.63A3.87 3.87 0 0112 13.5zm-6.85-1.9c.2.2.5.2.7 0a.73.73 0 01.1-.07A2.56 2.56 0 017.5 11c.59 0 .97.16 1.2.35.21.19.3.42.3.64-.02.4-.4 1.01-1.51 1.01a.5.5 0 000 1c1.1 0 1.5.6 1.5 1.01a.8.8 0 01-.3.64c-.22.19-.6.35-1.2.35a2.56 2.56 0 01-1.65-.6.5.5 0 00-.7 0c-.34.33 0 .7 0 .7a3.34 3.34 0 00.18.16A3.56 3.56 0 007.5 17c.78 0 1.4-.21 1.85-.59.44-.37.67-.9.65-1.42a1.89 1.89 0 00-.8-1.49c.5-.37.79-.9.8-1.49a1.8 1.8 0 00-.65-1.42A2.8 2.8 0 007.5 10a3.56 3.56 0 00-2.34.88v.01h-.01a.5.5 0 000 .71zm.7 3.8z",
    fill: primaryFill
  }));
};

export const SkipForward30Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SkipForward30RegularIcon({}), 'SkipForward30Regular');

const SkipForwardTabFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.09 7.97C4.2 6.57 6.07 4.89 8.35 4.4c1.9-.42 4.25-.04 6.86 2.35H12.5a.75.75 0 100 1.5H17c.41 0 .75-.34.75-.75v-4a.75.75 0 00-1.5 0v2.17c-2.92-2.68-5.75-3.28-8.22-2.74-2.76.6-4.9 2.58-6.12 4.1a.75.75 0 001.18.94zm3.41 2.78c-.97 0-1.75.78-1.75 1.75v3c0 .97.78 1.75 1.75 1.75h7c.97 0 1.75-.78 1.75-1.75v-3c0-.97-.78-1.75-1.75-1.75h-7zm-.25 1.75c0-.14.11-.25.25-.25h7c.14 0 .25.11.25.25v3c0 .14-.11.25-.25.25h-7a.25.25 0 01-.25-.25v-3z",
    fill: primaryFill
  }));
};

export const SkipForwardTabFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SkipForwardTabFilledIcon({}), 'SkipForwardTabFilled');

const SkipForwardTabRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.9 7.81C4.01 6.4 5.92 4.66 8.3 4.15c2.1-.46 4.7.03 7.54 2.85H12.5a.5.5 0 000 1H17a.5.5 0 00.5-.5v-4a.5.5 0 10-1 0v2.75c-3.03-2.97-5.92-3.62-8.42-3.08C5.4 3.76 3.31 5.7 2.11 7.2a.5.5 0 00.78.62zM6.5 11c-.83 0-1.5.67-1.5 1.5v3c0 .83.67 1.5 1.5 1.5h7c.83 0 1.5-.67 1.5-1.5v-3c0-.83-.67-1.5-1.5-1.5h-7zM6 12.5c0-.28.22-.5.5-.5h7c.28 0 .5.22.5.5v3a.5.5 0 01-.5.5h-7a.5.5 0 01-.5-.5v-3z",
    fill: primaryFill
  }));
};

export const SkipForwardTabRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SkipForwardTabRegularIcon({}), 'SkipForwardTabRegular');

const SleepFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11.16 2.74a.5.5 0 01.43-.13c3.5.6 6.4 3.67 6.4 7.39a7.5 7.5 0 01-7.5 7.5 7.96 7.96 0 01-6.4-3.21.5.5 0 01.37-.79 6.94 6.94 0 004.69-2.59c1.34-1.65 2.24-4.17 1.85-7.75a.5.5 0 01.16-.42zM3.5 10C4.33 10 5 9.33 5 8.5V4.89l3-.75v1.95A1.5 1.5 0 109 7.5v-4a.5.5 0 00-.62-.49l-4 1A.5.5 0 004 4.5v2.59A1.5 1.5 0 103.5 10z",
    fill: primaryFill
  }));
};

export const SleepFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SleepFilledIcon({}), 'SleepFilled');

const SleepRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11.59 2.61a.5.5 0 00-.59.55c.4 3.58-.5 6.1-1.85 7.75a6.94 6.94 0 01-4.69 2.6.5.5 0 00-.37.78 7.96 7.96 0 006.4 3.21A7.5 7.5 0 0018 10c0-3.72-2.9-6.78-6.4-7.39zm-1.66 8.93c1.43-1.77 2.36-4.34 2.13-7.8A6.65 6.65 0 0117 10a6.5 6.5 0 01-6.5 6.5 7.1 7.1 0 01-5.06-2.14 8.1 8.1 0 004.49-2.82zM3.5 10C4.33 10 5 9.33 5 8.5V4.89l3-.75v1.95A1.5 1.5 0 109 7.5v-4a.5.5 0 00-.62-.49l-4 1A.5.5 0 004 4.5v2.59A1.5 1.5 0 103.5 10z",
    fill: primaryFill
  }));
};

export const SleepRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SleepRegularIcon({}), 'SleepRegular');

const SlideAddFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 6.75A2.75 2.75 0 014.75 4h10.5A2.75 2.75 0 0118 6.75v3.5A5.5 5.5 0 009.2 16H4.76A2.75 2.75 0 012 13.26v-6.5zm17 7.75a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V14h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V15h1.5a.5.5 0 000-1H15v-1.5z",
    fill: primaryFill
  }));
};

export const SlideAddFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SlideAddFilledIcon({}), 'SlideAddFilled');

const SlideAddRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 6.75A2.75 2.75 0 014.75 4h10.5A2.75 2.75 0 0118 6.75v3.5a5.5 5.5 0 00-1-.65V6.75C17 5.78 16.22 5 15.25 5H4.75C3.78 5 3 5.78 3 6.75v6.5c0 .97.78 1.75 1.75 1.75h4.27c.03.34.1.68.19 1H4.75A2.75 2.75 0 012 13.25v-6.5zm17 7.75a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V14h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V15h1.5a.5.5 0 000-1H15v-1.5z",
    fill: primaryFill
  }));
};

export const SlideAddRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SlideAddRegularIcon({}), 'SlideAddRegular');

const SlideArrowRightFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 6.5A2.5 2.5 0 014.5 4h11A2.5 2.5 0 0118 6.5v3.76a5.48 5.48 0 00-5.8-.76H5.5a.5.5 0 000 1h5.23c-.46.43-.84.94-1.13 1.5H5.5a.5.5 0 000 1h3.7a5.5 5.5 0 000 3H4.5A2.5 2.5 0 012 13.5v-7zm3.5.5a.5.5 0 000 1h4a.5.5 0 000-1h-4zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.15.35a.5.5 0 00.15-.35.5.5 0 00-.15-.35l-2-2a.5.5 0 00-.7.7L15.29 14H12.5a.5.5 0 000 1h2.8l-1.15 1.15a.5.5 0 00.7.7l2-2z",
    fill: primaryFill
  }));
};

export const SlideArrowRightFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SlideArrowRightFilledIcon({}), 'SlideArrowRightFilled');

const SlideArrowRightRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 7a.5.5 0 000 1h4a.5.5 0 000-1h-4zm0 2.5a.5.5 0 000 1h5.23c.43-.4.93-.75 1.48-1H5.5zm0 2.5h4.1c-.16.32-.3.65-.4 1H5.5a.5.5 0 010-1zm-1 3h4.52c.03.34.1.68.19 1H4.5A2.5 2.5 0 012 13.5v-7A2.5 2.5 0 014.5 4h11A2.5 2.5 0 0118 6.5v3.76a5.5 5.5 0 00-1-.66V6.5c0-.83-.67-1.5-1.5-1.5h-11C3.67 5 3 5.67 3 6.5v7c0 .83.67 1.5 1.5 1.5zm14.5-.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.15.35a.5.5 0 00.15-.35.5.5 0 00-.15-.35l-2-2a.5.5 0 00-.7.7L15.29 14H12.5a.5.5 0 000 1h2.8l-1.15 1.15a.5.5 0 00.7.7l2-2z",
    fill: primaryFill
  }));
};

export const SlideArrowRightRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SlideArrowRightRegularIcon({}), 'SlideArrowRightRegular');

const SlideEraserFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 6c0-1.1.9-2 2-2h12a2 2 0 012 2v5.07l-.4-.41a2.25 2.25 0 00-3.2 0l-3.74 3.75A2.24 2.24 0 0010 16H4a2 2 0 01-2-2V6zm13.12 5.37a1.25 1.25 0 011.76 0l1.75 1.75c.5.48.5 1.28 0 1.76l-2.57 2.58-3.52-3.52 2.58-2.57zm-3.18 3.17l-.57.58a1.25 1.25 0 000 1.76l1.75 1.75c.48.5 1.28.5 1.76 0l.58-.57-3.52-3.52z",
    fill: primaryFill
  }));
};

export const SlideEraserFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SlideEraserFilledIcon({}), 'SlideEraserFilled');

const SlideEraserRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 4a2 2 0 00-2 2v8c0 1.1.9 2 2 2h6c0-.34.08-.69.23-1H4a1 1 0 01-1-1V6a1 1 0 011-1h12a1 1 0 011 1v4.23c.21.11.41.25.6.43l.4.41V6a2 2 0 00-2-2H4zm11.12 7.37a1.25 1.25 0 011.76 0l1.75 1.75c.5.48.5 1.28 0 1.76l-2.57 2.58-3.52-3.52 2.58-2.57zm-3.18 3.17l-.57.58a1.25 1.25 0 000 1.76l1.75 1.75c.48.5 1.28.5 1.76 0l.58-.57-3.52-3.52z",
    fill: primaryFill
  }));
};

export const SlideEraserRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SlideEraserRegularIcon({}), 'SlideEraserRegular');

const SlideGridFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 7a1 1 0 011-1h3.5a1 1 0 011 1v1.5a1 1 0 01-1 1H5a1 1 0 01-1-1V7zm1 3.5a1 1 0 00-1 1V13a1 1 0 001 1h3.5a1 1 0 001-1v-1.5a1 1 0 00-1-1H5zM10.5 7a1 1 0 011-1H15a1 1 0 011 1v1.5a1 1 0 01-1 1h-3.5a1 1 0 01-1-1V7zm1 3.5a1 1 0 00-1 1V13a1 1 0 001 1H15a1 1 0 001-1v-1.5a1 1 0 00-1-1h-3.5zM2 6c0-1.1.9-2 2-2h12a2 2 0 012 2v8a2 2 0 01-2 2H4a2 2 0 01-2-2V6zm2-1a1 1 0 00-1 1v8a1 1 0 001 1h12a1 1 0 001-1V6a1 1 0 00-1-1H4z",
    fill: primaryFill
  }));
};

export const SlideGridFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SlideGridFilledIcon({}), 'SlideGridFilled');

const SlideGridRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 6a1 1 0 00-1 1v1.5a1 1 0 001 1h3.5a1 1 0 001-1V7a1 1 0 00-1-1H5zm3.5 1v1.5H5V7h3.5zM4 11.5a1 1 0 011-1h3.5a1 1 0 011 1V13a1 1 0 01-1 1H5a1 1 0 01-1-1v-1.5zm1 0V13h3.5v-1.5H5zM11.5 6H15a1 1 0 011 1v1.5a1 1 0 01-1 1h-3.5a1 1 0 01-1-1V7a1 1 0 011-1zM15 7h-3.5v1.5H15V7zm-4.5 4.5a1 1 0 011-1H15a1 1 0 011 1V13a1 1 0 01-1 1h-3.5a1 1 0 01-1-1v-1.5zm1 0V13H15v-1.5h-3.5zM2 6c0-1.1.9-2 2-2h12a2 2 0 012 2v8a2 2 0 01-2 2H4a2 2 0 01-2-2V6zm2-1a1 1 0 00-1 1v8a1 1 0 001 1h12a1 1 0 001-1V6a1 1 0 00-1-1H4z",
    fill: primaryFill
  }));
};

export const SlideGridRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SlideGridRegularIcon({}), 'SlideGridRegular');

const SlideLayoutFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 7h9c.28 0 .5.22.5.5V9H5V7.5c0-.28.22-.5.5-.5zM7 10v3H5.5a.5.5 0 01-.5-.5V10h2zm7.5 3H8v-3h7v2.5a.5.5 0 01-.5.5zm-10-9A2.5 2.5 0 002 6.5v7A2.5 2.5 0 004.5 16h11a2.5 2.5 0 002.5-2.5v-7A2.5 2.5 0 0015.5 4h-11zm10 10h-9A1.5 1.5 0 014 12.5v-5C4 6.67 4.67 6 5.5 6h9c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5z",
    fill: primaryFill
  }));
};

export const SlideLayoutFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SlideLayoutFilledIcon({}), 'SlideLayoutFilled');

const SlideLayoutRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 14A1.5 1.5 0 014 12.5v-5C4 6.67 4.67 6 5.5 6h9c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5h-9zm0-7a.5.5 0 00-.5.5V9h10V7.5a.5.5 0 00-.5-.5h-9zM7 10H5v2.5c0 .28.22.5.5.5H7v-3zm1 3h6.5a.5.5 0 00.5-.5V10H8v3zM2 6.5A2.5 2.5 0 014.5 4h11A2.5 2.5 0 0118 6.5v7a2.5 2.5 0 01-2.5 2.5h-11A2.5 2.5 0 012 13.5v-7zM4.5 5C3.67 5 3 5.67 3 6.5v7c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5h-11z",
    fill: primaryFill
  }));
};

export const SlideLayoutRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SlideLayoutRegularIcon({}), 'SlideLayoutRegular');

const SlideMultipleFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 3a2 2 0 00-2 2v7.5c0 1.1.9 2 2 2V8a3 3 0 013-3h8a2 2 0 00-2-2H4zm3 3a2 2 0 00-2 2v7c0 1.1.9 2 2 2h9a2 2 0 002-2V8a2 2 0 00-2-2H7z",
    fill: primaryFill
  }));
};

export const SlideMultipleFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SlideMultipleFilledIcon({}), 'SlideMultipleFilled');

const SlideMultipleRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 3a2 2 0 00-2 2v7.5c0 1.1.9 2 2 2h1v.5c0 1.1.9 2 2 2h9a2 2 0 002-2V8a2 2 0 00-2-2h-1V5a2 2 0 00-2-2H4zm10 3H7a2 2 0 00-2 2v5.5H4a1 1 0 01-1-1V5a1 1 0 011-1h9a1 1 0 011 1v1zM6 8a1 1 0 011-1h9a1 1 0 011 1v7a1 1 0 01-1 1H7a1 1 0 01-1-1V8z",
    fill: primaryFill
  }));
};

export const SlideMultipleRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SlideMultipleRegularIcon({}), 'SlideMultipleRegular');

const SlideMultipleArrowRightFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 3a2 2 0 00-2 2v7.5c0 1.1.9 2 2 2V8a3 3 0 013-3h8a2 2 0 00-2-2H4zm3 3a2 2 0 00-2 2v7c0 1.1.9 2 2 2h2.6a5.5 5.5 0 018.4-6.74V8a2 2 0 00-2-2H7zm7.5 4a4.5 4.5 0 110 9 4.5 4.5 0 010-9zm2.35 4.85a.5.5 0 00.15-.35.5.5 0 00-.15-.35l-2-2a.5.5 0 00-.7.7L15.29 14H12.5a.5.5 0 000 1h2.8l-1.15 1.15a.5.5 0 00.7.7l2-2z",
    fill: primaryFill
  }));
};

export const SlideMultipleArrowRightFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SlideMultipleArrowRightFilledIcon({}), 'SlideMultipleArrowRightFilled');

const SlideMultipleArrowRightRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 3a2 2 0 00-2 2v7.5c0 1.1.9 2 2 2h1v.5c0 1.1.9 2 2 2h2.6c-.16-.32-.3-.65-.4-1H7a1 1 0 01-1-1V8a1 1 0 011-1h9a1 1 0 011 1v1.6c.36.18.7.4 1 .66V8a2 2 0 00-2-2h-1V5a2 2 0 00-2-2H4zm10 3H7a2 2 0 00-2 2v5.5H4a1 1 0 01-1-1V5a1 1 0 011-1h9a1 1 0 011 1v1zm.5 4a4.5 4.5 0 110 9 4.5 4.5 0 010-9zm2.35 4.85a.5.5 0 00.15-.35.5.5 0 00-.15-.35l-2-2a.5.5 0 00-.7.7L15.29 14H12.5a.5.5 0 000 1h2.8l-1.15 1.15a.5.5 0 00.7.7l2-2z",
    fill: primaryFill
  }));
};

export const SlideMultipleArrowRightRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SlideMultipleArrowRightRegularIcon({}), 'SlideMultipleArrowRightRegular');

const SlideMultipleSearchFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 5.5A2.5 2.5 0 014.5 3h8a2.5 2.5 0 012.45 2H7.5A3.5 3.5 0 004 8.5v.53c-.73.08-1.42.34-2 .73V5.5zm6.56 9.94L10.12 17h5.38a2.5 2.5 0 002.5-2.5v-6A2.5 2.5 0 0015.5 6h-8A2.5 2.5 0 005 8.5v.53a4.5 4.5 0 013.56 6.41zM4.5 17c.79 0 1.51-.26 2.1-.7l2.55 2.55a.5.5 0 00.7-.7L7.3 15.6A3.5 3.5 0 104.5 17zm0-1a2.5 2.5 0 110-5 2.5 2.5 0 010 5z",
    fill: primaryFill
  }));
};

export const SlideMultipleSearchFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SlideMultipleSearchFilledIcon({}), 'SlideMultipleSearchFilled');